import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: Date; output: Date; }
  JSON: { input: any; output: any; }
  StringOrStringArray: { input: string | string[]; output: string | string[]; }
};

export type AcceptResetPasswordOutputObjectType = {
  __typename?: 'AcceptResetPasswordOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddItemSetQuestionQConfigStructureConditionInput = {
  needTotal: Scalars['Int']['input'];
  tagGroups: Array<AddItemSetQuestionQConfigStructureConditionTagGroupInput>;
};

export type AddItemSetQuestionQConfigStructureConditionTagGroupInput = {
  count: Scalars['Int']['input'];
  tagIds: Array<Scalars['String']['input']>;
};

export type AddItemSetQuestionQConfigStructureInput = {
  chapterLevelItemId: Scalars['String']['input'];
  conditions: Array<AddItemSetQuestionQConfigStructureConditionInput>;
  location: AddItemSetQuestionQConfigStructureLocationInput;
  qConfigId: Scalars['String']['input'];
  scorePerQuestion: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type AddItemSetQuestionQConfigStructureLocationInput = {
  locationType: AddItemSetQuestionQConfigStructureLocationType;
  losIds?: InputMaybe<Array<Scalars['String']['input']>>;
  qBankStructureLevelItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum AddItemSetQuestionQConfigStructureLocationType {
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  QbankStructureLevelItem = 'QBANK_STRUCTURE_LEVEL_ITEM'
}

export type AddItemSetQuestionQConfigStructureOutput = {
  __typename?: 'AddItemSetQuestionQConfigStructureOutput';
  qConfig: QConfig;
};

export type AddQConfigStructuresInput = {
  qConfigId: Scalars['String']['input'];
  selectedQBankStructureId: Scalars['String']['input'];
  selectedQBankStructureLevelItemIds: Array<Scalars['String']['input']>;
};

export type AddQConfigStructuresOutput = {
  __typename?: 'AddQConfigStructuresOutput';
  qConfig: QConfig;
};

export enum AddQuestionQConfigStructureLocationType {
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  QbankStructureLevelItem = 'QBANK_STRUCTURE_LEVEL_ITEM'
}

export type AddSingleQuestionQConfigStructureConditionInput = {
  needTotal: Scalars['Int']['input'];
  tagIds: Array<Scalars['String']['input']>;
};

export type AddSingleQuestionQConfigStructureInput = {
  chapterLevelItemId: Scalars['String']['input'];
  conditions: Array<AddSingleQuestionQConfigStructureConditionInput>;
  location: AddSingleQuestionQConfigStructureLocationInput;
  qConfigId: Scalars['String']['input'];
  scorePerQuestion: Scalars['Int']['input'];
};

export type AddSingleQuestionQConfigStructureLocationInput = {
  locationType: AddQuestionQConfigStructureLocationType;
  losIds?: InputMaybe<Array<Scalars['String']['input']>>;
  qBankStructureLevelItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AddSingleQuestionQConfigStructureOutput = {
  __typename?: 'AddSingleQuestionQConfigStructureOutput';
  qConfig: QConfig;
};

export type AppPermission = {
  __typename?: 'AppPermission';
  action: Scalars['String']['output'];
  category: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AppRole = {
  __typename?: 'AppRole';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type AppRoleIdsInput = {
  appRoleIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AppRoleSearchInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AppRoleSearchResult = {
  __typename?: 'AppRoleSearchResult';
  roles: Array<AppRole>;
  total: Scalars['Int']['output'];
};

export type AssignUserAppRoleInput = {
  appRoleId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export type AssignUserAppRoleMutationResponse = {
  __typename?: 'AssignUserAppRoleMutationResponse';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user: Maybe<Array<UserAppRoleView>>;
};

export type AssignUserAppRolesInput = {
  appRoleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AssignUserAppRolesMutationResponse = {
  __typename?: 'AssignUserAppRolesMutationResponse';
  appRoles: Maybe<Array<AppRole>>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum AuditActionType {
  Add = 'ADD',
  Approve = 'APPROVE',
  AutoSync = 'AUTO_SYNC',
  ChangeStatus = 'CHANGE_STATUS',
  Create = 'CREATE',
  Delete = 'DELETE',
  Disable = 'DISABLE',
  Download = 'DOWNLOAD',
  Export = 'EXPORT',
  Grant = 'GRANT',
  Import = 'IMPORT',
  Login = 'LOGIN',
  Logout = 'LOGOUT',
  Reject = 'REJECT',
  Remove = 'REMOVE',
  Revoke = 'REVOKE',
  SendResultToWr = 'SEND_RESULT_TO_WR',
  Submit = 'SUBMIT',
  Update = 'UPDATE',
  Upload = 'UPLOAD',
  View = 'VIEW'
}

export enum AuditLogExecutionResult {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export enum AuditType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type ChangeItemSetQuestionInput = {
  qSetQuestionId: Scalars['String']['input'];
  questionGroupId: Scalars['String']['input'];
};

export type ChangeItemSetQuestionOutput = {
  __typename?: 'ChangeItemSetQuestionOutput';
  qSetQuestions: Array<QSetQuestion>;
};

export type ChangeSingleQuestionInput = {
  qSetQuestionId: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
};

export type ChangeSingleQuestionOutput = {
  __typename?: 'ChangeSingleQuestionOutput';
  qSetQuestion: QSetQuestion;
};

export type ClearSessionOutputObjectType = {
  __typename?: 'ClearSessionOutputObjectType';
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum CommentEntityType {
  ExaminationCourse = 'EXAMINATION_COURSE',
  Other = 'OTHER',
  Qconfig = 'QCONFIG',
  Qset = 'QSET',
  Question = 'QUESTION'
}

export type ConditionTag = {
  __typename?: 'ConditionTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ConditionTagObjectType = {
  __typename?: 'ConditionTagObjectType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum ContentType {
  QbankStructure = 'QBANK_STRUCTURE',
  QbankStructureLevelChapter = 'QBANK_STRUCTURE_LEVEL_CHAPTER',
  QbankStructureLevelCourse = 'QBANK_STRUCTURE_LEVEL_COURSE',
  QbankStructureLevelGroup = 'QBANK_STRUCTURE_LEVEL_GROUP',
  QbankStructureLevelPart = 'QBANK_STRUCTURE_LEVEL_PART',
  QbankStructureLevelSubject = 'QBANK_STRUCTURE_LEVEL_SUBJECT',
  QbankStructureLevelSubTopic = 'QBANK_STRUCTURE_LEVEL_SUB_TOPIC',
  QbankStructureLevelTopic = 'QBANK_STRUCTURE_LEVEL_TOPIC'
}

export type ContentTypeScopeContentVisibilityResult = {
  __typename?: 'ContentTypeScopeContentVisibilityResult';
  contentIds: Array<Scalars['String']['output']>;
  contentType: ContentType;
};

export type ContentVisibility = {
  __typename?: 'ContentVisibility';
  contentId: Scalars['String']['output'];
  contentType: ContentType;
  id: Scalars['String']['output'];
  parentContentId: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type CreateAppRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type CreateAppRoleMutationResponse = {
  __typename?: 'CreateAppRoleMutationResponse';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  newAppRole: AppRole;
  success: Scalars['Boolean']['output'];
};

export type CreateExamCourseCommentInput = {
  content: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  taskId: Scalars['String']['input'];
};

export type CreateExamCourseCommentOutput = {
  __typename?: 'CreateExamCourseCommentOutput';
  comment: ExamCourseCommentOutput;
};

export type CreateExamCourseInput = {
  code: Scalars['String']['input'];
  groupName?: InputMaybe<Scalars['String']['input']>;
  language: ExamCourseLanguage;
  name: Scalars['String']['input'];
  type: ExamCourseType;
};

export type CreateExamCourseOutput = {
  __typename?: 'CreateExamCourseOutput';
  examCourse: ExamCourse;
};

export type CreateInDevelopmentQuestionInput = {
  data: InDevelopmentQuestionInputData;
  qBankStructureLevelItemId: Scalars['String']['input'];
  refQBankStructureId: Scalars['String']['input'];
};

export type CreateItemSetInput = {
  name: Scalars['String']['input'];
  paragraph: Scalars['String']['input'];
  qBankStructureLevelItemId: Scalars['String']['input'];
  refQBankStructureId: Scalars['String']['input'];
  taskDetails?: InputMaybe<TaskDetailsForItemSetCreationInput>;
};

export type CreateLearningObjectiveStatementsInput = {
  chapterLevelItemId: Scalars['String']['input'];
  names: Array<Scalars['String']['input']>;
  qBankStructureId: Scalars['String']['input'];
};

export type CreateOrUpdateQuestionCommentInput = {
  content: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: CommentEntityType;
  taskId: Scalars['String']['input'];
};

export type CreateOrUpdateQuestionVerdictInput = {
  entityId: Scalars['String']['input'];
  entityType: VerdictEntityType;
  taskId: Scalars['String']['input'];
  verdict: Verdict;
};

export type CreateQBankStructureInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupTag?: InputMaybe<QBankStructureGroupTagInput>;
  name: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  type: QBankStructureType;
};

export type CreateQConfigGeneratorConditionsInput = {
  qBankStructureLevelItems: Array<CreateQConfigGeneratorConditionsQBankStructureLevelItemInput>;
  questionTypes: Array<CreateQConfigGeneratorConditionsQuestionTypeInput>;
  tags: Array<CreateQConfigGeneratorConditionsTagInput>;
};

export type CreateQConfigGeneratorConditionsQBankStructureLevelItemInput = {
  needTotal: Scalars['Int']['input'];
  qBankStructureLevelItemId: Scalars['String']['input'];
};

export type CreateQConfigGeneratorConditionsQuestionTypeInput = {
  needTotal: Scalars['Int']['input'];
  type: QConfigQuestionType;
};

export type CreateQConfigGeneratorConditionsTagInput = {
  needTotal: Scalars['Int']['input'];
  tagId: Scalars['String']['input'];
};

export type CreateQConfigGeneratorInput = {
  conditions: CreateQConfigGeneratorConditionsInput;
  examCourseId: Scalars['String']['input'];
  generatorGroupLevel?: InputMaybe<QConfigGeneratorGroupLevel>;
  name: Scalars['String']['input'];
  needTotal: Scalars['Int']['input'];
  totalQuestions: Scalars['Int']['input'];
};

export type CreateQConfigGeneratorOutput = {
  __typename?: 'CreateQConfigGeneratorOutput';
  qConfigGenerator: QConfigGenerator;
};

export type CreateQConfigInput = {
  examCourseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  totalQuestions: Scalars['Float']['input'];
};

export type CreateQConfigOutput = {
  __typename?: 'CreateQConfigOutput';
  qConfig: QConfig;
};

export type CreateQSetsByGeneratorExecutionInput = {
  id: Scalars['String']['input'];
  resultIds: Array<Scalars['String']['input']>;
};

export type CreateQSetsByGeneratorExecutionOutput = {
  __typename?: 'CreateQSetsByGeneratorExecutionOutput';
  qSets: Array<QSet>;
};

export type CreateQuestionCreationTaskInput = {
  assigneeId: Scalars['String']['input'];
  dueDate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  requirement: CreateQuestionCreationTaskRequirementInput;
};

export type CreateQuestionCreationTaskOutput = {
  __typename?: 'CreateQuestionCreationTaskOutput';
  task: Task;
};

export type CreateQuestionCreationTaskRequirementInput = {
  details: Scalars['String']['input'];
  itemSetCondition?: InputMaybe<Array<ItemSetCreationRequirementInput>>;
  qBankStructureId: Scalars['String']['input'];
  requiredQuestionCount: Scalars['Int']['input'];
};

export type CreateQuestionInput = {
  data: QuestionInputData;
  qBankStructureLevelItemId: Scalars['String']['input'];
  refQBankStructureId: Scalars['String']['input'];
};

export type CreateQuestionReviewSubtaskByCreateTask = {
  assigneeId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum CreateQuestionReviewTaskAndSubtasksErrorCode {
  ItemSetMismatch = 'ITEM_SET_MISMATCH',
  QuestionsNotFound = 'QUESTIONS_NOT_FOUND',
  QuestionsNotPreDraft = 'QUESTIONS_NOT_PRE_DRAFT'
}

export type CreateQuestionReviewTaskInput = {
  assigneeId: Scalars['String']['input'];
  assignerId: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['StringOrStringArray']['input']>;
  entityType?: InputMaybe<EntityType>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  ownerId: Scalars['String']['input'];
  subtasks?: InputMaybe<Array<CreateQuestionReviewSubtaskByCreateTask>>;
  workflowCode: WorkflowCode;
};

export type CreateQuestionReviewTaskOutput = {
  __typename?: 'CreateQuestionReviewTaskOutput';
  code: Maybe<CreateQuestionReviewTaskAndSubtasksErrorCode>;
  itemSetMismatches: Array<CreateTaskAndSubtasksItemSetMismatch>;
  message: Scalars['String']['output'];
  subtasks: Array<Task>;
  success: Scalars['Boolean']['output'];
  task: Maybe<Task>;
};

export type CreateSubtaskByCreateTask = {
  assigneeId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTaskAndSubtasksInput = {
  assigneeId: Scalars['String']['input'];
  assignerId: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['StringOrStringArray']['input']>;
  entityType?: InputMaybe<EntityType>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  ownerId: Scalars['String']['input'];
  subtasks?: InputMaybe<Array<CreateSubtaskByCreateTask>>;
  workflowCode: WorkflowCode;
};

export type CreateTaskAndSubtasksItemSetMismatch = {
  __typename?: 'CreateTaskAndSubtasksItemSetMismatch';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  refCode: Scalars['String']['output'];
};

export type CreateTaskAndSubtasksOutput = {
  __typename?: 'CreateTaskAndSubtasksOutput';
  subtasks: Array<Task>;
  task: Task;
};

export type CreateTaskCommentInput = {
  content: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type CreateTaskCommentOutput = {
  __typename?: 'CreateTaskCommentOutput';
  comment: TaskComment;
};

export type DeleteAppRoleInput = {
  appRoleId: Scalars['String']['input'];
};

export type DeleteAppRoleMutationResponse = {
  __typename?: 'DeleteAppRoleMutationResponse';
  appRole: AppRole;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteItemSetSubQuestionInput = {
  itemSetId: Scalars['String']['input'];
  subQuestionId: Scalars['String']['input'];
};

export type DeleteLearningObjectiveStatementInput = {
  chapterLevelItemId: Scalars['String']['input'];
  learningObjectiveStatementId: Scalars['String']['input'];
  qBankStructureId: Scalars['String']['input'];
};

export type DeleteQConfigInput = {
  qConfigId: Scalars['String']['input'];
};

export type DeleteQConfigOutput = {
  __typename?: 'DeleteQConfigOutput';
  qConfig: QConfig;
};

export type DeleteQConfigStructureInput = {
  qConfigId: Scalars['String']['input'];
  qConfigStructureId: Scalars['String']['input'];
};

export type DeleteQConfigStructureOutput = {
  __typename?: 'DeleteQConfigStructureOutput';
  qConfig: QConfig;
};

export type DeleteQSetByIdInput = {
  id: Scalars['String']['input'];
};

export type DeleteQSetByIdOutput = {
  __typename?: 'DeleteQSetByIdOutput';
  message: Scalars['String']['output'];
};

export type DeleteSubtaskInput = {
  subtaskId: Scalars['String']['input'];
};

export type DeleteSubtaskOutput = {
  __typename?: 'DeleteSubtaskOutput';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DisableLearningObjectiveStatementInput = {
  chapterLevelItemId: Scalars['String']['input'];
  learningObjectiveStatementId: Scalars['String']['input'];
  qBankStructureId: Scalars['String']['input'];
};

export type DisableQConfigInput = {
  qConfigId: Scalars['String']['input'];
};

export type DisableQConfigOutput = {
  __typename?: 'DisableQConfigOutput';
  qConfig: QConfig;
};

export type DisableQSetsInput = {
  qSetIds: Array<Scalars['String']['input']>;
};

export type DisableQSetsOutput = {
  __typename?: 'DisableQSetsOutput';
  qSets: Array<QSet>;
};

export type DisabledLearningObjectiveStatementObjectType = {
  __typename?: 'DisabledLearningObjectiveStatementObjectType';
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type DuplicateQBankStructureInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DuplicateQConfigInput = {
  name: Scalars['String']['input'];
  qConfigId: Scalars['String']['input'];
};

export type DuplicateQConfigOutput = {
  __typename?: 'DuplicateQConfigOutput';
  qConfig: QConfig;
};

export type DuplicateQSetInput = {
  qSetId: Scalars['String']['input'];
};

export type DuplicateQSetOutput = {
  __typename?: 'DuplicateQSetOutput';
  qSet: QSet;
};

export type DuplicateQuestionInput = {
  qBankStructureLevelItemId?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
};

/** The EntityType of entityId. */
export enum EntityType {
  ExaminationCourse = 'EXAMINATION_COURSE',
  ExamLocationRoomRequestInfo = 'EXAM_LOCATION_ROOM_REQUEST_INFO',
  Other = 'OTHER',
  ProctorRequest = 'PROCTOR_REQUEST',
  Qconfig = 'QCONFIG',
  Qcontent = 'QCONTENT',
  Qset = 'QSET',
  Question = 'QUESTION',
  QuestionGroup = 'QUESTION_GROUP'
}

export type ExamCourse = {
  __typename?: 'ExamCourse';
  code: Scalars['String']['output'];
  examId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  language: ExamCourseLanguage;
  name: Scalars['String']['output'];
  tagEntities: Maybe<Array<TagEntity>>;
  totalQConfig: Scalars['Int']['output'];
  totalQSet: Scalars['Int']['output'];
  type: ExamCourseType;
};

export type ExamCourseCommentOutput = {
  __typename?: 'ExamCourseCommentOutput';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  entityType: EntityType;
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: RawUser;
  userId: Scalars['String']['output'];
};

export enum ExamCourseLanguage {
  En = 'EN',
  Th = 'TH'
}

export type ExamCourseTask = {
  __typename?: 'ExamCourseTask';
  code: Scalars['String']['output'];
  examId: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  language: ExamCourseLanguage;
  name: Scalars['String']['output'];
  totalQConfig: Scalars['Float']['output'];
  totalQSet: Scalars['Float']['output'];
  type: ExamCourseType;
};

export enum ExamCourseType {
  Main = 'MAIN',
  Mock = 'MOCK'
}

export type ExamCourseVerdictOutput = {
  __typename?: 'ExamCourseVerdictOutput';
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  entityType: EntityType;
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: RawUser;
  userId: Scalars['String']['output'];
  verdict: Verdict;
};

export enum ExamUsageStatus {
  Assigned = 'ASSIGNED',
  Inactive = 'INACTIVE',
  InUse = 'IN_USE',
  Ready = 'READY'
}

/** The type of the entity being reviewed. */
export enum ExaminationEntityType {
  ExaminationCourse = 'EXAMINATION_COURSE',
  ExamLocationRoomRequestInfo = 'EXAM_LOCATION_ROOM_REQUEST_INFO',
  Other = 'OTHER',
  ProctorRequest = 'PROCTOR_REQUEST',
  Qconfig = 'QCONFIG',
  Qcontent = 'QCONTENT',
  Qset = 'QSET',
  Question = 'QUESTION',
  QuestionGroup = 'QUESTION_GROUP'
}

export type ExecuteQSetGeneratorInput = {
  duplicationRate: Scalars['Int']['input'];
  needTotal: Scalars['Int']['input'];
  qConfigId: Scalars['String']['input'];
};

export type ExecuteQSetGeneratorOutput = {
  __typename?: 'ExecuteQSetGeneratorOutput';
  qSetGeneratorExecution: QSetGeneratorExecution;
};

export enum ExportItemSetFormat {
  Docx = 'DOCX',
  Pdf = 'PDF'
}

export type ExportItemSetInput = {
  format: ExportItemSetFormat;
  includeSolution: Scalars['Boolean']['input'];
  questionGroupId: Scalars['String']['input'];
};

export enum ExportQSetFormat {
  Docx = 'DOCX',
  Pdf = 'PDF'
}

export type ExportQSetInput = {
  format: ExportQSetFormat;
  includeSolution: Scalars['Boolean']['input'];
  qSetId: Scalars['String']['input'];
};

export type ExportQSetOutput = {
  __typename?: 'ExportQSetOutput';
  message: Scalars['String']['output'];
};

export type ExportQuestionResult = {
  __typename?: 'ExportQuestionResult';
  message: Scalars['String']['output'];
};

export type ExportSearchResultsInput = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  questionIds: Array<Scalars['String']['input']>;
  searchParams?: InputMaybe<SearchParams>;
  sourceFeature: ExportSearchResultsSourceFeature;
};

export enum ExportSearchResultsSourceFeature {
  SearchByKeyword = 'SEARCH_BY_KEYWORD',
  SearchByQid = 'SEARCH_BY_QID'
}

export enum ExportSingleQuestionFormat {
  Docx = 'DOCX',
  Pdf = 'PDF'
}

export type ExportSingleQuestionInput = {
  format: ExportSingleQuestionFormat;
  includeSolution: Scalars['Boolean']['input'];
  questionId: Scalars['String']['input'];
};

export type ExportTaskQSetInput = {
  format: ExportQSetFormat;
  includeSolution: Scalars['Boolean']['input'];
  qSetId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type FilterConditionInput = {
  /** Field to filter by */
  field: Scalars['String']['input'];
  operator: FilterOperator;
  /** Value to filter by */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum FilterOperator {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  In = 'IN',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  Like = 'LIKE',
  NotEqual = 'NOT_EQUAL',
  NotIn = 'NOT_IN'
}

export enum FilterOperatorEnum {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  In = 'IN',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  Like = 'LIKE',
  NotEqual = 'NOT_EQUAL',
  NotIn = 'NOT_IN'
}

export type GenerateTwoFactorSecretOutputObjectType = {
  __typename?: 'GenerateTwoFactorSecretOutputObjectType';
  email: Scalars['String']['output'];
  issuer: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type GenericResponse = {
  __typename?: 'GenericResponse';
  data: Maybe<Scalars['JSON']['output']>;
  message: Scalars['String']['output'];
  status: GenericResponseStatus;
};

export enum GenericResponseStatus {
  Success = 'SUCCESS'
}

export type GetAppRoleOutputObjectType = {
  __typename?: 'GetAppRoleOutputObjectType';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type GetDisabledLearningObjectiveStatementsByQConfigIdInput = {
  qConfigId: Scalars['String']['input'];
};

export type GetDisabledLearningObjectiveStatementsByQConfigIdOutput = {
  __typename?: 'GetDisabledLearningObjectiveStatementsByQConfigIdOutput';
  disabledLearningObjectiveStatements: Array<DisabledLearningObjectiveStatementObjectType>;
};

export type GetDownloadSignedUrlForExamCourseCommentInput = {
  fileNames: Array<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
};

export type GetDownloadSignedUrlForExamCourseCommentOutput = {
  __typename?: 'GetDownloadSignedUrlForExamCourseCommentOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlForQuestionGroupsInput = {
  questionGroupFileInputs: Array<QuestionGroupFileInput>;
};

export type GetDownloadSignedUrlForQuestionGroupsResult = {
  __typename?: 'GetDownloadSignedUrlForQuestionGroupsResult';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlForQuestionsByQSetIdInput = {
  qSetId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type GetDownloadSignedUrlForQuestionsByQSetIdOutput = {
  __typename?: 'GetDownloadSignedUrlForQuestionsByQSetIdOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlForQuestionsInput = {
  questionFileInputs: Array<QuestionFileInput>;
};

export type GetDownloadSignedUrlForQuestionsResult = {
  __typename?: 'GetDownloadSignedUrlForQuestionsResult';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlForTaskInput = {
  fileNames: Array<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
};

export type GetDownloadSignedUrlForTaskOutput = {
  __typename?: 'GetDownloadSignedUrlForTaskOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlQuestionInput = {
  fileNames: Array<Scalars['String']['input']>;
  questionGroupId?: InputMaybe<Scalars['String']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
};

export type GetDownloadSignedUrlsResult = {
  __typename?: 'GetDownloadSignedUrlsResult';
  signedUrls: Scalars['JSON']['output'];
};

export type GetExamCourseByIdInput = {
  examCourseId: Scalars['String']['input'];
};

export type GetExamCourseByIdOutput = {
  __typename?: 'GetExamCourseByIdOutput';
  examCourse: ExamCourse;
};

export type GetExamCourseCommentsInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  taskId: Scalars['String']['input'];
};

export type GetExamCourseCommentsOutput = {
  __typename?: 'GetExamCourseCommentsOutput';
  comments: Array<ExamCourseCommentOutput>;
  entityId: Scalars['String']['output'];
  entityType: EntityType;
  taskId: Scalars['String']['output'];
};

export type GetExamCourseGroupByIdInput = {
  examCourseGroupId: Scalars['String']['input'];
};

export type GetExamCourseGroupByIdOutput = {
  __typename?: 'GetExamCourseGroupByIdOutput';
  tag: Tag;
};

export type GetExamCourseVerdictInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  taskId: Scalars['String']['input'];
};

export type GetExamCourseVerdictOutput = {
  __typename?: 'GetExamCourseVerdictOutput';
  entityId: Scalars['String']['output'];
  entityType: EntityType;
  taskId: Scalars['String']['output'];
  verdict: ExamCourseVerdictOutput;
};

export type GetItemSetQuestionPropertiesByStatusAndLocationInputType = {
  locationType: ItemSetQuestionPropertiesLocationType;
  qBankStructureId: Scalars['String']['input'];
  status: ItemSetQuestionPropertiesStatus;
};

export type GetItemSetQuestionPropertiesCountByLocationInputType = {
  losIds?: InputMaybe<Array<Scalars['String']['input']>>;
  qBankStructureLevelItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  size: Scalars['Int']['input'];
  type: ItemSetQuestionPropertiesLocationType;
};

export type GetLearningObjectiveStatementByIdInput = {
  id: Scalars['String']['input'];
};

export type GetMyTasksInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type GetMyTasksOutput = {
  __typename?: 'GetMyTasksOutput';
  tasks: Array<Task>;
  total: Scalars['Float']['output'];
};

export type GetQBankStructureLevelItemsByQBankStructureIdOptions = {
  categories?: InputMaybe<Array<QBankStructureLevelCategory>>;
};

export type GetQConfigByIdInput = {
  qConfigId: Scalars['String']['input'];
};

export type GetQConfigByIdOutput = {
  __typename?: 'GetQConfigByIdOutput';
  qConfig: QConfig;
};

export type GetQConfigChapterInput = {
  qConfigId: Scalars['String']['input'];
  qConfigStructureId: Scalars['String']['input'];
};

export type GetQConfigChapterItemSetQuestionPropertiesCountInput = {
  location: AddItemSetQuestionQConfigStructureLocationInput;
  qConfigId: Scalars['String']['input'];
  qConfigStructureId: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};

export type GetQConfigChapterSingleQuestionPropertiesCountInput = {
  location: AddSingleQuestionQConfigStructureLocationInput;
  qConfigId: Scalars['String']['input'];
  qConfigStructureId: Scalars['String']['input'];
};

export type GetQConfigGeneratorByIdInput = {
  id: Scalars['String']['input'];
};

export type GetQConfigGeneratorByIdOutput = {
  __typename?: 'GetQConfigGeneratorByIdOutput';
  qConfigGenerator: QConfigGenerator;
};

export type GetQSetByIdInput = {
  id: Scalars['String']['input'];
};

export type GetQSetByIdOutput = {
  __typename?: 'GetQSetByIdOutput';
  qSet: QSet;
};

export type GetQSetByTaskIdInput = {
  taskId: Scalars['String']['input'];
};

export type GetQSetByTaskIdOutput = {
  __typename?: 'GetQSetByTaskIdOutput';
  qSet: QSet;
};

export type GetQSetGeneratorExecutionByIdInput = {
  id: Scalars['String']['input'];
};

export type GetQSetGeneratorExecutionByIdOutput = {
  __typename?: 'GetQSetGeneratorExecutionByIdOutput';
  qSetGeneratorExecution: QSetGeneratorExecution;
};

export type GetQSetQuestionDownloadSignedUrlsInput = {
  qSetId: Scalars['String']['input'];
  questionFileInputs: Array<QSetQuestionFileInput>;
  questionGroupFileInputs: Array<QSetQuestionGroupFileInput>;
};

export type GetQSetQuestionsByQuestionIdsOutput = {
  __typename?: 'GetQSetQuestionsByQuestionIdsOutput';
  qSetQuestions: Array<QSetQuestion>;
};

export type GetQSetQuestionsByTaskIdInput = {
  taskId: Scalars['String']['input'];
};

export type GetQSetQuestionsByTaskIdOutput = {
  __typename?: 'GetQSetQuestionsByTaskIdOutput';
  qSetQuestions: Array<QSetQuestion>;
};

export type GetQSetSimilaritiesInput = {
  qSetsA: Array<QSetComparisonInput>;
  qSetsB?: InputMaybe<Array<QSetComparisonInput>>;
};

export type GetQSetSimilaritiesOutput = {
  __typename?: 'GetQSetSimilaritiesOutput';
  id: Scalars['String']['output'];
  qSetSimilarityResults: Array<QSetSimilarityResultOutput>;
};

export type GetQSetSimilarityByIdInput = {
  id: Scalars['String']['input'];
  resultId: Scalars['String']['input'];
};

export type GetQSetSimilarityByIdOutput = {
  __typename?: 'GetQSetSimilarityByIdOutput';
  id: Scalars['String']['output'];
  qSetSimilarityResult: QSetSimilarityResultWithQuestionsOutput;
};

export type GetQSetTaskReviewSummaryInput = {
  mainTaskId: Scalars['String']['input'];
  qSetId: Scalars['String']['input'];
  verdicts?: InputMaybe<Array<Verdict>>;
};

export type GetQSetTaskReviewSummaryOutput = {
  __typename?: 'GetQSetTaskReviewSummaryOutput';
  results: Array<QSetTaskReviewSummaryOutput>;
  subTaskIds: Array<Scalars['String']['output']>;
};

export type GetQsetQuestionsByQuestionIdsInput = {
  qSetId: Scalars['String']['input'];
  questionIds: Array<Scalars['String']['input']>;
};

export type GetQuestionCommentsByEntityAndTaskIdInput = {
  entityId: Scalars['String']['input'];
  entityType: CommentEntityType;
  taskId: Scalars['String']['input'];
};

export type GetQuestionGroupsByQBankStructureLevelItemIdInput = {
  qBankStructureLevelItemId: Scalars['String']['input'];
  type?: InputMaybe<QuestionGroupType>;
};

export type GetQuestionUsageByIdOutput = {
  __typename?: 'GetQuestionUsageByIdOutput';
  examCourseCode: Scalars['String']['output'];
  examCourseName: Scalars['String']['output'];
  qConfigRefCode: Scalars['Int']['output'];
  qSetCode: Scalars['String']['output'];
  qSetQuestionId: Scalars['String']['output'];
  qSetQuestionOrder: Scalars['Int']['output'];
  qSetStatus: Scalars['String']['output'];
};

export type GetQuestionVerdictsByEntityAndTaskIdInput = {
  entityId: Scalars['String']['input'];
  entityType: VerdictEntityType;
  taskId: Scalars['String']['input'];
};

export type GetSingleQuestionPropertiesByStatusAndLocationInputType = {
  locationType: SingleQuestionPropertiesLocationType;
  qBankStructureId: Scalars['String']['input'];
  status: SingleQuestionPropertiesStatus;
};

export type GetSingleQuestionPropertiesCountByLocationInput = {
  losIds?: InputMaybe<Array<Scalars['String']['input']>>;
  qBankStructureLevelItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type: SingleQuestionPropertiesLocationType;
};

export type GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationInputType = {
  qBankStructureLevelItemIds: Array<Scalars['String']['input']>;
  status: QuestionStatus;
};

export type GetStepTransitionsByTaskIdInput = {
  taskId: Scalars['String']['input'];
};

export type GetStepTransitionsByTaskIdOutput = {
  __typename?: 'GetStepTransitionsByTaskIdOutput';
  steps: Array<StepTransition>;
};

export type GetTagsByCategoryInput = {
  category: QuestionTagCategory;
};

export type GetTaskByIdInput = {
  taskId: Scalars['String']['input'];
};

export type GetTaskByIdOutput = {
  __typename?: 'GetTaskByIdOutput';
  task: Task;
};

export type GetTaskCommentsInput = {
  taskId: Scalars['String']['input'];
};

export type GetTaskCommentsOutput = {
  __typename?: 'GetTaskCommentsOutput';
  comments: Array<TaskComment>;
  taskId: Scalars['String']['output'];
};

export type GetTaskQuestionVerdictsInput = {
  taskId: Scalars['String']['input'];
};

export type GetTaskReviewResultsInput = {
  taskId: Scalars['String']['input'];
  verdicts?: InputMaybe<Array<Verdict>>;
};

export type GetTaskReviewResultsOutput = {
  __typename?: 'GetTaskReviewResultsOutput';
  results: Array<QSetReviewTaskResultOutput>;
  taskId: Scalars['String']['output'];
};

export type GetTaskVerdictInput = {
  taskId: Scalars['String']['input'];
};

export type GetTaskVerdictOutput = {
  __typename?: 'GetTaskVerdictOutput';
  id: Scalars['String']['output'];
  verdict: Maybe<Verdict>;
};

export type GetTasksByEntityInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityType;
};

export type GetTasksByEntityWithParentOutput = {
  __typename?: 'GetTasksByEntityWithParentOutput';
  entityId: Scalars['String']['output'];
  entityType: EntityType;
  tasks: Array<TaskWithSubtasks>;
};

export type GetUploadSignedUrlForExamCourseCommentInput = {
  contentType: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type GetUploadSignedUrlForExamCourseCommentOutput = {
  __typename?: 'GetUploadSignedUrlForExamCourseCommentOutput';
  signedUrl: Scalars['String']['output'];
  storageObject: StorageObject;
};

export type GetUploadSignedUrlForQuestionCreationTaskInput = {
  contentType: Scalars['String']['input'];
};

export type GetUploadSignedUrlForQuestionCreationTaskOutput = {
  __typename?: 'GetUploadSignedUrlForQuestionCreationTaskOutput';
  contentType: QuestionCreationTaskContentType;
  signedUrl: Scalars['String']['output'];
  storageObject: StorageObject;
};

export type GetUploadSignedUrlForTaskInput = {
  contentType: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type GetUploadSignedUrlForTaskOutput = {
  __typename?: 'GetUploadSignedUrlForTaskOutput';
  signedUrl: Scalars['String']['output'];
  storageObject: StorageObject;
};

export type GetUploadSignedUrlImportQuestionSpreadsheetInput = {
  contentType: Scalars['String']['input'];
  qBankStructureId: Scalars['String']['input'];
};

export type GetUploadSignedUrlQuestionInput = {
  contentType: Scalars['String']['input'];
  questionGroupId?: InputMaybe<Scalars['String']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
};

export type GetUploadSignedUrlResult = {
  __typename?: 'GetUploadSignedUrlResult';
  signedUrl: Scalars['String']['output'];
  storageObject: StorageObject;
};

export type GetUserByIdOutputObjectType = {
  __typename?: 'GetUserByIdOutputObjectType';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  assignedAt: Maybe<Scalars['String']['output']>;
  assignedBy: Maybe<Scalars['JSON']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  status: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type GroupOrderInput = {
  groupOrder: Scalars['Float']['input'];
  questionId: Scalars['String']['input'];
};

export type ImportQuestionSpreadsheetInput = {
  fileName: Scalars['String']['input'];
  qBankStructureId: Scalars['String']['input'];
  type: QuestionImportType;
};

export type ImportQuestionSpreadsheetResult = {
  __typename?: 'ImportQuestionSpreadsheetResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type InDevelopmentQuestionInputData = {
  bIndexValue?: InputMaybe<Scalars['Float']['input']>;
  calculated: Scalars['Boolean']['input'];
  choices: Array<QuestionChoiceInput>;
  cognitiveDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  correctAnswer: QuestionCorrectAnswerInput;
  details: Scalars['String']['input'];
  group: QuestionInputGroup;
  learningObjectiveStatement: Scalars['String']['input'];
  pValue: Scalars['Float']['input'];
  reference: Scalars['String']['input'];
  solution: Scalars['String']['input'];
};

export type ItemSetCondition = {
  __typename?: 'ItemSetCondition';
  needTotal: Scalars['Float']['output'];
  size: Scalars['Float']['output'];
};

export type ItemSetCreation = {
  __typename?: 'ItemSetCreation';
  questionCreationCount: Scalars['Float']['output'];
  questionGroupId: Scalars['String']['output'];
  size: Scalars['Float']['output'];
};

export type ItemSetCreationRequirementInput = {
  needTotal: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type ItemSetQuestionProperties = {
  __typename?: 'ItemSetQuestionProperties';
  tagGroups: Array<TagGroup>;
  totalQuestions: Scalars['Int']['output'];
};

export type ItemSetQuestionPropertiesByLocation = {
  __typename?: 'ItemSetQuestionPropertiesByLocation';
  locationId: Scalars['String']['output'];
  locationType: ItemSetQuestionPropertiesLocationType;
  questionProperties: Array<ItemSetQuestionProperties>;
  size: Scalars['Int']['output'];
};

export enum ItemSetQuestionPropertiesLocationType {
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  QbankStructureLevelItem = 'QBANK_STRUCTURE_LEVEL_ITEM'
}

export enum ItemSetQuestionPropertiesStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type JsonContainsFilterInput = {
  field: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type LearningObjectiveStatement = {
  __typename?: 'LearningObjectiveStatement';
  activeQuestionCount: LearningObjectiveStatementActiveQuestionCountDto;
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  qBankStructureId: Scalars['String']['output'];
  qBankStructureLevelItem: Maybe<QBankStructureLevelItem>;
  qBankStructureLevelItemId: Maybe<Scalars['String']['output']>;
  status: LearningObjectiveStatementStatus;
  tag: Tag;
  tagId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LearningObjectiveStatementActiveQuestionCountDto = {
  __typename?: 'LearningObjectiveStatementActiveQuestionCountDTO';
  itemSet: Scalars['Float']['output'];
  single: Scalars['Float']['output'];
};

export enum LearningObjectiveStatementStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type LearningObjectiveStatementsResult = {
  __typename?: 'LearningObjectiveStatementsResult';
  learningObjectiveStatements: Array<LearningObjectiveStatement>;
  total: Scalars['Float']['output'];
};

export type LoginTwoFactorInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type LoginTwoFactorResponse = {
  __typename?: 'LoginTwoFactorResponse';
  code: Scalars['String']['output'];
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LogoutOutputObjectType = {
  __typename?: 'LogoutOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  assignUserAppRoles: AssignUserAppRolesMutationResponse;
  cvRemoveUsersContentVisibility: RemoveUsersContentVisibilityResult;
  excAddItemSetQuestionQConfigStructure: AddItemSetQuestionQConfigStructureOutput;
  excAddQConfigStructures: AddQConfigStructuresOutput;
  excAddSingleQuestionQConfigStructure: AddSingleQuestionQConfigStructureOutput;
  excChangeItemSetQuestion: ChangeItemSetQuestionOutput;
  excChangeSingleQuestion: ChangeSingleQuestionOutput;
  excCreateExamCourse: CreateExamCourseOutput;
  excCreateExamCourseComment: CreateExamCourseCommentOutput;
  excCreateQConfig: CreateQConfigOutput;
  excCreateQConfigGenerator: CreateQConfigGeneratorOutput;
  excCreateQSetsByGeneratorExecution: CreateQSetsByGeneratorExecutionOutput;
  excDeleteQConfig: DeleteQConfigOutput;
  excDeleteQConfigStructure: DeleteQConfigStructureOutput;
  excDeleteQSetById: DeleteQSetByIdOutput;
  excDisableQConfig: DisableQConfigOutput;
  excDisableQSets: DisableQSetsOutput;
  excDuplicateQConfig: DuplicateQConfigOutput;
  excDuplicateQSet: DuplicateQSetOutput;
  excExecuteQSetGenerator: ExecuteQSetGeneratorOutput;
  excPublishQConfig: PublishQConfigOutput;
  excPublishQSets: GenericResponse;
  excUpdateExamUsageOfQSets: UpdateExamUsageOfQSetsOutput;
  excUpdateItemSetQuestionQConfigStructure: UpdateItemSetQuestionQConfigStructureOutput;
  excUpdateOrCreateExamCourseVerdict: UpdateOrCreateExamCourseVerdictOutput;
  excUpdateQConfigAsDraft: UpdateQConfigAsDraftOutput;
  excUpdateQConfigStructureNames: UpdateQConfigStructureNamesOutput;
  excUpdateQconfigSettingsAsDraft: UpdateQConfigSettingsAsDraftOutput;
  excUpdateSingleQuestionQConfigStructure: UpdateSingleQuestionQConfigStructureOutput;
  qbsArchiveQBankStructure: QBankStructure;
  qbsCreateLearningObjectiveStatements: Array<LearningObjectiveStatement>;
  qbsCreateQBankStructure: QBankStructure;
  qbsDeleteLearningObjectiveStatement: GenericResponse;
  qbsDisableLearningObjectiveStatement: LearningObjectiveStatement;
  qbsDuplicateQBankStructure: QBankStructure;
  qbsPublishQBankStructure: QBankStructure;
  qbsSaveAsDraft: GenericResponse;
  qbsSaveAsUnpublished: GenericResponse;
  qbsUnpublishQBankStructure: QBankStructure;
  qbsUpdateLearningObjectiveStatement: LearningObjectiveStatement;
  qbsUpdateQBankStructureAsArchived: QBankStructure;
  qbsUpdateQBankStructureAsDraft: QBankStructure;
  qbsUpdateQBankStructureAsPublished: QBankStructure;
  qbsUpdateQBankStructureAsUnpublished: QBankStructure;
  qbsUpdateQBankStructureLevelsByQBankStructureId: Array<QBankStructureLevel>;
  qbsUpdateUsersQBankStructureLevelItemContentVisibility: UpdateUsersContentVisibilityResult;
  qctCreateInDevelopmentQuestion: Question;
  qctCreateItemSet: QuestionGroup;
  qctCreateItemSetWorkflow: QuestionGroup;
  qctCreateOrUpdateQuestionComment: QuestionComment;
  qctCreateOrUpdateQuestionVerdict: QuestionVerdict;
  qctCreateQuestion: Question;
  qctDeleteItemSetSubQuestion: QuestionGroup;
  qctDeleteItemSetSubQuestionWorkflow: QuestionGroup;
  qctDisableItemSet: QuestionGroup;
  qctDisableQuestion: Question;
  qctDuplicateQuestion: Question;
  qctExportItemSet: ExportQuestionResult;
  qctExportSearchResults: ExportQuestionResult;
  qctExportSingleQuestion: ExportQuestionResult;
  qctImportQuestionSpreadsheet: ImportQuestionSpreadsheetResult;
  qctPublishItemSet: QuestionGroup;
  qctPublishQuestion: Question;
  qctSaveItemSetAsDraft: QuestionGroup;
  qctSaveItemSetAsDraftWorkflow: QuestionGroup;
  qctSaveItemSetAsUnpublish: QuestionGroup;
  qctSaveQuestionAsDraft: Question;
  qctSaveQuestionAsInDevelopment: Question;
  qctSaveQuestionAsUnpublish: Question;
  qctUnpublishItemSet: QuestionGroup;
  qctUnpublishQuestion: Question;
  suAcceptResetPassword: AcceptResetPasswordOutputObjectType;
  suAssignUserAppRole: AssignUserAppRoleMutationResponse;
  suClearSession: ClearSessionOutputObjectType;
  suCreateAppRole: CreateAppRoleMutationResponse;
  suDeleteAppRole: DeleteAppRoleMutationResponse;
  suGenerateTwoFactorSecret: GenerateTwoFactorSecretOutputObjectType;
  suLoginTwoFactor: LoginTwoFactorResponse;
  suLogout: LogoutOutputObjectType;
  suQuickCreateUser: QuickCreateUserObjectType;
  suResendResetPasswordEmail: ResendResetPasswordEmailOutputObjectType;
  suResendResetPasswordUserLocked: ResendResetPasswordUserLockedOutputObjectType;
  suResetPassword: ResetPasswordOutputObjectType;
  suResetUserTwoFactor: ResetUserTwoFactorOutputObjectType;
  suUnassignUserAppRoles: UnassignUserAppRolesMutationResponse;
  suUnlockUserTwoFactor: UnlockUserTwoFactorOutputObjectType;
  suUpdateAppRole: UpdateAppRoleMutationResponse;
  suUpdateAppRoleAppPermissions: UpdateAppRoleAppPermissionsMutationResponse;
  suUpdateUser: UpdateUserOutputObjectType;
  suUpdateUserStatus: UpdateUserStatusOutputObjectType;
  suVerifyUserTwoFactor: VerifyUserTwoFactorOutputObjectType;
  unassignUserAppRole: AssignUserAppRoleMutationResponse;
  updateUserAppRoleByNames: UpdateUserAppRoleByNameMutationResponse;
  updateUserAppRoles: UpdateUserAppRolesMutationResponse;
  wflCreateQuestionCreationTask: CreateQuestionCreationTaskOutput;
  wflCreateQuestionReviewTask: CreateQuestionReviewTaskOutput;
  wflCreateTaskAndSubtasks: CreateTaskAndSubtasksOutput;
  wflCreateTaskComment: CreateTaskCommentOutput;
  wflDeleteSubtask: DeleteSubtaskOutput;
  wflSubmitQSetReview: SubmitQSetReviewOutput;
  wflSubmitQuestionReview: SubmitQuestionReviewOutput;
  wflUpdateAndCreateSubtasks: UpdateAndCreateSubtasksOutput;
  wflUpdateDueDateTaskAndSubtasks: UpdateTaskOutputObjectType;
  wflUpdateQuestionCreationTask: UpdateQuestionCreationTaskOutputDto;
  wflUpdateSubtasks: UpdateSubtasksOutput;
  wflUpdateTask: UpdateTaskOutputObjectType;
  wflUpdateTaskAndSubtasksAndCreateSubtasks: UpdateTaskAndSubtasksAndCreateSubtasksOutput;
  wflUpdateTaskStatus: UpdateTaskStatusOutput;
};


export type MutationAssignUserAppRolesArgs = {
  data: AssignUserAppRolesInput;
};


export type MutationCvRemoveUsersContentVisibilityArgs = {
  input: RemoveUsersContentVisibilityInput;
};


export type MutationExcAddItemSetQuestionQConfigStructureArgs = {
  addItemSetQuestionQConfigStructureInput: AddItemSetQuestionQConfigStructureInput;
};


export type MutationExcAddQConfigStructuresArgs = {
  addQConfigStructuresInput: AddQConfigStructuresInput;
};


export type MutationExcAddSingleQuestionQConfigStructureArgs = {
  addSingleQuestionQConfigStructureInput: AddSingleQuestionQConfigStructureInput;
};


export type MutationExcChangeItemSetQuestionArgs = {
  changeItemSetQuestionInput: ChangeItemSetQuestionInput;
};


export type MutationExcChangeSingleQuestionArgs = {
  changeSingleQuestionInput: ChangeSingleQuestionInput;
};


export type MutationExcCreateExamCourseArgs = {
  createExamCourseInput: CreateExamCourseInput;
};


export type MutationExcCreateExamCourseCommentArgs = {
  CreateExamCourseCommentInput: CreateExamCourseCommentInput;
};


export type MutationExcCreateQConfigArgs = {
  createQConfigInput: CreateQConfigInput;
};


export type MutationExcCreateQConfigGeneratorArgs = {
  CreateQConfigGeneratorInput: CreateQConfigGeneratorInput;
};


export type MutationExcCreateQSetsByGeneratorExecutionArgs = {
  input: CreateQSetsByGeneratorExecutionInput;
};


export type MutationExcDeleteQConfigArgs = {
  deleteQConfigInput: DeleteQConfigInput;
};


export type MutationExcDeleteQConfigStructureArgs = {
  deleteQConfigStructureInput: DeleteQConfigStructureInput;
};


export type MutationExcDeleteQSetByIdArgs = {
  input: DeleteQSetByIdInput;
};


export type MutationExcDisableQConfigArgs = {
  disableQConfigInput: DisableQConfigInput;
};


export type MutationExcDisableQSetsArgs = {
  input: DisableQSetsInput;
};


export type MutationExcDuplicateQConfigArgs = {
  duplicateQConfigInput: DuplicateQConfigInput;
};


export type MutationExcDuplicateQSetArgs = {
  input: DuplicateQSetInput;
};


export type MutationExcExecuteQSetGeneratorArgs = {
  ExecuteQSetGeneratorInput: ExecuteQSetGeneratorInput;
};


export type MutationExcPublishQConfigArgs = {
  publishQConfigInput: PublishQConfigInput;
};


export type MutationExcPublishQSetsArgs = {
  input: PublishQSetsInput;
};


export type MutationExcUpdateExamUsageOfQSetsArgs = {
  input: UpdateExamUsageOfQSetsInput;
};


export type MutationExcUpdateItemSetQuestionQConfigStructureArgs = {
  updateItemSetQuestionQConfigStructureInput: UpdateItemSetQuestionQConfigStructureInput;
};


export type MutationExcUpdateOrCreateExamCourseVerdictArgs = {
  UpdateOrCreateExamCourseVerdictInput: UpdateOrCreateExamCourseVerdictInput;
};


export type MutationExcUpdateQConfigAsDraftArgs = {
  updateQConfigAsDraftInput: UpdateQConfigAsDraftInput;
};


export type MutationExcUpdateQConfigStructureNamesArgs = {
  updateQConfigStructureNamesInput: UpdateQConfigStructureNamesInput;
};


export type MutationExcUpdateQconfigSettingsAsDraftArgs = {
  updateQConfigSettingsAsDraftInput: UpdateQConfigSettingsAsDraftInput;
};


export type MutationExcUpdateSingleQuestionQConfigStructureArgs = {
  updateSingleQuestionQConfigStructureInput: UpdateSingleQuestionQConfigStructureInput;
};


export type MutationQbsArchiveQBankStructureArgs = {
  id: Scalars['String']['input'];
};


export type MutationQbsCreateLearningObjectiveStatementsArgs = {
  input: CreateLearningObjectiveStatementsInput;
};


export type MutationQbsCreateQBankStructureArgs = {
  input: CreateQBankStructureInput;
};


export type MutationQbsDeleteLearningObjectiveStatementArgs = {
  input: DeleteLearningObjectiveStatementInput;
};


export type MutationQbsDisableLearningObjectiveStatementArgs = {
  input: DisableLearningObjectiveStatementInput;
};


export type MutationQbsDuplicateQBankStructureArgs = {
  input: DuplicateQBankStructureInput;
};


export type MutationQbsPublishQBankStructureArgs = {
  id: Scalars['String']['input'];
};


export type MutationQbsSaveAsDraftArgs = {
  input: SaveAsInput;
};


export type MutationQbsSaveAsUnpublishedArgs = {
  input: SaveAsInput;
};


export type MutationQbsUnpublishQBankStructureArgs = {
  id: Scalars['String']['input'];
};


export type MutationQbsUpdateLearningObjectiveStatementArgs = {
  input: UpdateLearningObjectiveStatementInput;
};


export type MutationQbsUpdateQBankStructureAsArchivedArgs = {
  input: UpdateQBankStructureAsArchivedInput;
};


export type MutationQbsUpdateQBankStructureAsDraftArgs = {
  input: UpdateQBankStructureAsDraftInput;
};


export type MutationQbsUpdateQBankStructureAsPublishedArgs = {
  input: UpdateQBankStructureAsPublishedInput;
};


export type MutationQbsUpdateQBankStructureAsUnpublishedArgs = {
  input: UpdateQBankStructureAsUnpublishedInput;
};


export type MutationQbsUpdateQBankStructureLevelsByQBankStructureIdArgs = {
  input: UpdateQBankStructureLevelsByQBankStructureIdInput;
};


export type MutationQbsUpdateUsersQBankStructureLevelItemContentVisibilityArgs = {
  input: UpdateUsersContentVisibilityInput;
};


export type MutationQctCreateInDevelopmentQuestionArgs = {
  input: CreateInDevelopmentQuestionInput;
  taskId: Scalars['String']['input'];
};


export type MutationQctCreateItemSetArgs = {
  input: CreateItemSetInput;
};


export type MutationQctCreateItemSetWorkflowArgs = {
  input: CreateItemSetInput;
};


export type MutationQctCreateOrUpdateQuestionCommentArgs = {
  input: CreateOrUpdateQuestionCommentInput;
};


export type MutationQctCreateOrUpdateQuestionVerdictArgs = {
  input: CreateOrUpdateQuestionVerdictInput;
};


export type MutationQctCreateQuestionArgs = {
  input: CreateQuestionInput;
};


export type MutationQctDeleteItemSetSubQuestionArgs = {
  input: DeleteItemSetSubQuestionInput;
};


export type MutationQctDeleteItemSetSubQuestionWorkflowArgs = {
  input: DeleteItemSetSubQuestionInput;
  taskId: Scalars['String']['input'];
};


export type MutationQctDisableItemSetArgs = {
  id: Scalars['String']['input'];
};


export type MutationQctDisableQuestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationQctDuplicateQuestionArgs = {
  input: DuplicateQuestionInput;
};


export type MutationQctExportItemSetArgs = {
  input: ExportItemSetInput;
};


export type MutationQctExportSearchResultsArgs = {
  input: ExportSearchResultsInput;
};


export type MutationQctExportSingleQuestionArgs = {
  input: ExportSingleQuestionInput;
};


export type MutationQctImportQuestionSpreadsheetArgs = {
  input: ImportQuestionSpreadsheetInput;
};


export type MutationQctPublishItemSetArgs = {
  id: Scalars['String']['input'];
};


export type MutationQctPublishQuestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationQctSaveItemSetAsDraftArgs = {
  input: SaveItemSetAsDraftInput;
};


export type MutationQctSaveItemSetAsDraftWorkflowArgs = {
  input: SaveItemSetAsDraftInput;
  taskId: Scalars['String']['input'];
};


export type MutationQctSaveItemSetAsUnpublishArgs = {
  input: SaveItemSetAsUnpublishInput;
};


export type MutationQctSaveQuestionAsDraftArgs = {
  input: SaveQuestionAsDraftInput;
};


export type MutationQctSaveQuestionAsInDevelopmentArgs = {
  input: SaveQuestionAsDraftInput;
  taskId: Scalars['String']['input'];
};


export type MutationQctSaveQuestionAsUnpublishArgs = {
  input: SaveQuestionAsUnpublishInput;
};


export type MutationQctUnpublishItemSetArgs = {
  id: Scalars['String']['input'];
};


export type MutationQctUnpublishQuestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationSuAcceptResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSuAssignUserAppRoleArgs = {
  data: AssignUserAppRoleInput;
};


export type MutationSuCreateAppRoleArgs = {
  data: CreateAppRoleInput;
};


export type MutationSuDeleteAppRoleArgs = {
  data: DeleteAppRoleInput;
};


export type MutationSuLoginTwoFactorArgs = {
  LoginTwoFactorInput: LoginTwoFactorInput;
};


export type MutationSuQuickCreateUserArgs = {
  appRoleIds: InputMaybe<AppRoleIdsInput>;
  quickCreateInput: QuickCreateInput;
};


export type MutationSuResendResetPasswordEmailArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSuResendResetPasswordUserLockedArgs = {
  email: Scalars['String']['input'];
};


export type MutationSuResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationSuResetUserTwoFactorArgs = {
  data: ResetUserTwoFactorInput;
};


export type MutationSuUnassignUserAppRolesArgs = {
  data: UnassignUserAppRolesInput;
};


export type MutationSuUnlockUserTwoFactorArgs = {
  data: UnlockUserTwoFactorInput;
};


export type MutationSuUpdateAppRoleArgs = {
  data: UpdateAppRoleInput;
};


export type MutationSuUpdateAppRoleAppPermissionsArgs = {
  appPermissionIds: Array<Scalars['String']['input']>;
  appRoleId: Scalars['String']['input'];
};


export type MutationSuUpdateUserArgs = {
  data: UpdateUserInput;
  userId: Scalars['String']['input'];
};


export type MutationSuUpdateUserStatusArgs = {
  data: UpdateUserStatusInput;
};


export type MutationSuVerifyUserTwoFactorArgs = {
  input: VerifyUserTwoFactorInput;
};


export type MutationUnassignUserAppRoleArgs = {
  data: UnassignUserAppRoleInput;
};


export type MutationUpdateUserAppRoleByNamesArgs = {
  data: UpdateUserAppRoleByNamesInput;
};


export type MutationUpdateUserAppRolesArgs = {
  data: UpdateUserAppRolesInput;
};


export type MutationWflCreateQuestionCreationTaskArgs = {
  createQuestionCreationTaskInput: CreateQuestionCreationTaskInput;
};


export type MutationWflCreateQuestionReviewTaskArgs = {
  createQuestionReviewTaskInput: CreateQuestionReviewTaskInput;
};


export type MutationWflCreateTaskAndSubtasksArgs = {
  createTaskAndSubtasksInput: CreateTaskAndSubtasksInput;
};


export type MutationWflCreateTaskCommentArgs = {
  createTaskCommentInputType: CreateTaskCommentInput;
};


export type MutationWflDeleteSubtaskArgs = {
  deleteSubtaskInput: DeleteSubtaskInput;
};


export type MutationWflSubmitQSetReviewArgs = {
  submitQSetReviewInput: SubmitQSetReviewInput;
};


export type MutationWflSubmitQuestionReviewArgs = {
  submitQuestionReviewInput: SubmitQuestionReviewInput;
};


export type MutationWflUpdateAndCreateSubtasksArgs = {
  updateAndCreateSubtasksInput: UpdateAndCreateSubtasksInput;
};


export type MutationWflUpdateDueDateTaskAndSubtasksArgs = {
  updateDueDateTaskAndSubtasksInput: UpdateDueDateTaskAndSubtasksInput;
};


export type MutationWflUpdateQuestionCreationTaskArgs = {
  updateQuestionCreationTaskInput: UpdateQuestionCreationTaskInput;
};


export type MutationWflUpdateSubtasksArgs = {
  updateSubtasksInput: UpdateSubtasksInput;
};


export type MutationWflUpdateTaskArgs = {
  updateTaskInput: UpdateTaskInput;
};


export type MutationWflUpdateTaskAndSubtasksAndCreateSubtasksArgs = {
  updateTaskAndSubtasksAndCreateSubtasksInput: UpdateTaskAndSubtasksAndCreateSubtasksInput;
};


export type MutationWflUpdateTaskStatusArgs = {
  updateTaskStatusInput: UpdateTaskStatusInput;
};

export enum OperatorType {
  And = 'AND',
  Or = 'OR'
}

export type OrderInput = {
  /** Field to order by */
  field: Scalars['String']['input'];
  type: OrderType;
};

export enum OrderType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PageInput = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PagingInput = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PassingCriteriaInput = {
  type: QConfigPassingCriteriaType;
  value: Scalars['Int']['input'];
};

export type PublishQConfigInput = {
  qConfigId: Scalars['String']['input'];
};

export type PublishQConfigOutput = {
  __typename?: 'PublishQConfigOutput';
  qConfig: QConfig;
};

export type PublishQSetsInput = {
  qSetIds: Array<Scalars['String']['input']>;
};

export type QBankStructure = {
  __typename?: 'QBankStructure';
  code: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  groupTag: Maybe<Tag>;
  groupTagId: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  remark: Maybe<Scalars['String']['output']>;
  status: QBankStructureStatus;
  type: QBankStructureType;
  updatedAt: Scalars['DateTime']['output'];
};

export type QBankStructureAuditLog = {
  __typename?: 'QBankStructureAuditLog';
  action: AuditActionType;
  actionTime: Scalars['DateTime']['output'];
  auditType: AuditType;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  executionInput: Scalars['String']['output'];
  executionMethod: Scalars['String']['output'];
  executionOutput: Scalars['String']['output'];
  executionResult: AuditLogExecutionResult;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifiers: Array<QBankStructureAuditLogIdentifier>;
  type: QBankStructureAuditLogType;
  userId: Scalars['String']['output'];
  userRoles: Array<Scalars['String']['output']>;
  userType: UserType;
};

export type QBankStructureAuditLogFilterConditionInput = {
  field: Scalars['String']['input'];
  operator: FilterOperatorEnum;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type QBankStructureAuditLogIdentifier = {
  __typename?: 'QBankStructureAuditLogIdentifier';
  identifierId: Scalars['String']['output'];
  identifierType: QBankStructureAuditLogIdentifierType;
};

export enum QBankStructureAuditLogIdentifierType {
  LosId = 'LOS_ID',
  QbankStructureId = 'QBANK_STRUCTURE_ID',
  UserId = 'USER_ID'
}

export type QBankStructureAuditLogOrderInput = {
  field: Scalars['String']['input'];
  type: QBankStructureAuditLogOrderType;
};

export enum QBankStructureAuditLogOrderType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type QBankStructureAuditLogPagingInput = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type QBankStructureAuditLogSearchFilterInput = {
  conditions?: InputMaybe<Array<QBankStructureAuditLogFilterConditionInput>>;
  searchText?: InputMaybe<QBankStructureAuditLogSearchTextInput>;
};

export type QBankStructureAuditLogSearchTextInput = {
  fields: Array<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export enum QBankStructureAuditLogType {
  Los = 'LOS',
  QbankStructure = 'QBANK_STRUCTURE',
  QbankStructureLevel = 'QBANK_STRUCTURE_LEVEL',
  QbankStructureLevelItem = 'QBANK_STRUCTURE_LEVEL_ITEM',
  Setting = 'SETTING'
}

export type QBankStructureGroupTagInput = {
  name: Scalars['String']['input'];
};

export type QBankStructureLevel = {
  __typename?: 'QBankStructureLevel';
  category: QBankStructureLevelCategory;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  qBankStructureId: Scalars['String']['output'];
};

export enum QBankStructureLevelCategory {
  Chapter = 'CHAPTER',
  Course = 'COURSE',
  Group = 'GROUP',
  Part = 'PART',
  Subject = 'SUBJECT',
  SubTopic = 'SUB_TOPIC',
  Topic = 'TOPIC'
}

export type QBankStructureLevelItem = {
  __typename?: 'QBankStructureLevelItem';
  id: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  parentLevelItemId: Maybe<Scalars['String']['output']>;
  qBankStructureId: Scalars['String']['output'];
  qBankStructureLevel: Maybe<QBankStructureLevel>;
  qBankStructureLevelId: Scalars['String']['output'];
  qId: Maybe<Scalars['String']['output']>;
  tag: Maybe<Tag>;
  tagId: Maybe<Scalars['String']['output']>;
};

export type QBankStructureLevelItemCategory = {
  categories?: InputMaybe<Array<QBankStructureLevelCategory>>;
};

export type QBankStructureLevelItemPartSubject = {
  __typename?: 'QBankStructureLevelItemPartSubject';
  id: Scalars['String']['output'];
  isVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  parentLevelItemId: Maybe<Scalars['String']['output']>;
  qBankStructureId: Scalars['String']['output'];
  qBankStructureLevelId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type QBankStructureLevelItemsAbility = {
  __typename?: 'QBankStructureLevelItemsAbility';
  id: Scalars['String']['output'];
  isChildrenAddable: Scalars['Boolean']['output'];
};

export enum QBankStructureStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type QBankStructureTask = {
  __typename?: 'QBankStructureTask';
  code: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum QBankStructureType {
  Main = 'MAIN',
  Mock = 'MOCK'
}

export enum QBankStructureValidationCase {
  MissingLastLevelItem = 'MISSING_LAST_LEVEL_ITEM',
  MissingNameInInformationItem = 'MISSING_NAME_IN_INFORMATION_ITEM'
}

export type QBankStructuresResult = {
  __typename?: 'QBankStructuresResult';
  qBankStructures: Array<QBankStructure>;
  total: Scalars['Int']['output'];
};

export type QConfig = {
  __typename?: 'QConfig';
  code: Scalars['Float']['output'];
  examCourse: ExamCourse;
  examCourseId: Scalars['String']['output'];
  fullScore: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  lastPublishedAt: Maybe<Scalars['DateTime']['output']>;
  lastPublishedBy: Maybe<Scalars['String']['output']>;
  metadata: QConfigMetadata;
  name: Scalars['String']['output'];
  passingCriteria: Maybe<QConfigPassingCriteria>;
  qConfigGeneratorResultId: Maybe<Scalars['String']['output']>;
  randomType: Maybe<QConfigRandomType>;
  status: QConfigStatus;
  structures: Array<QConfigStructure>;
  timeLimit: Maybe<QConfigTimeLimit>;
  totalQuestions: Scalars['Int']['output'];
  type: QConfigType;
  updatedAt: Scalars['DateTime']['output'];
};

export type QConfigAuditLog = {
  __typename?: 'QConfigAuditLog';
  action: AuditActionType;
  actionTime: Scalars['DateTime']['output'];
  auditType: AuditType;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  executionInput: Scalars['String']['output'];
  executionMethod: Scalars['String']['output'];
  executionOutput: Scalars['String']['output'];
  executionResult: AuditLogExecutionResult;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifiers: Array<QConfigAuditLogIdentifier>;
  type: QConfigAuditLogType;
  userId: Scalars['String']['output'];
  userRoles: Array<Scalars['String']['output']>;
  userType: UserType;
};

export type QConfigAuditLogIdentifier = {
  __typename?: 'QConfigAuditLogIdentifier';
  identifierId: Scalars['String']['output'];
  identifierType: QConfigAuditLogIdentifierType;
};

export enum QConfigAuditLogIdentifierType {
  ExaminationCourseId = 'EXAMINATION_COURSE_ID',
  QconfigId = 'QCONFIG_ID',
  QconfigStructureId = 'QCONFIG_STRUCTURE_ID'
}

export enum QConfigAuditLogType {
  Qconfig = 'QCONFIG',
  QconfigStructure = 'QCONFIG_STRUCTURE'
}

export type QConfigChapterItemSetQuestionProperties = {
  __typename?: 'QConfigChapterItemSetQuestionProperties';
  tagGroups: Array<QConfigChapterQuestionTagGroup>;
  totalQuestions: Scalars['Int']['output'];
};

export type QConfigChapterQuestionTag = {
  __typename?: 'QConfigChapterQuestionTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QConfigChapterQuestionTagGroup = {
  __typename?: 'QConfigChapterQuestionTagGroup';
  count: Scalars['Int']['output'];
  tags: Array<QConfigChapterQuestionTag>;
};

export type QConfigChapterSingleQuestionProperties = {
  __typename?: 'QConfigChapterSingleQuestionProperties';
  tags: Array<QConfigChapterQuestionTag>;
  totalQuestions: Scalars['Int']['output'];
};

export type QConfigCondition = {
  __typename?: 'QConfigCondition';
  questionTypes: Array<QConfigMetadataConditionQuestionType>;
  tags: Array<QConfigConditionTag>;
};

export type QConfigConditionTag = {
  __typename?: 'QConfigConditionTag';
  needTotal: Scalars['Float']['output'];
  tag: ConditionTag;
};

export type QConfigGenerator = {
  __typename?: 'QConfigGenerator';
  code: Scalars['String']['output'];
  examCourseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  latestExecution: QConfigGeneratorExecution;
  metadata: QConfigGeneratorMetadata;
  name: Scalars['String']['output'];
  needTotal: Scalars['Int']['output'];
  qBankStructureIds: Array<Scalars['String']['output']>;
  /** The generator QBank structures in saved order. Deleted structures are skipped. Null, with a field error, when the caller lacks the QBank structure view permission. */
  qBankStructures: Maybe<Array<QBankStructure>>;
  totalQuestions: Scalars['Int']['output'];
};

export type QConfigGeneratorCondition = {
  __typename?: 'QConfigGeneratorCondition';
  qBankStructureLevelItems: Array<QConfigGeneratorConditionsQBankStructureLevelItem>;
  questionTypes: Array<QConfigGeneratorConditionsQuestionType>;
  tags: Array<QConfigGeneratorConditionsTag>;
};

export type QConfigGeneratorConditionsQBankStructureLevelItem = {
  __typename?: 'QConfigGeneratorConditionsQBankStructureLevelItem';
  needTotal: Scalars['Int']['output'];
  qBankStructureLevelItemId: Scalars['String']['output'];
};

export type QConfigGeneratorConditionsQuestionType = {
  __typename?: 'QConfigGeneratorConditionsQuestionType';
  needTotal: Scalars['Int']['output'];
  type: QConfigQuestionType;
};

export type QConfigGeneratorConditionsTag = {
  __typename?: 'QConfigGeneratorConditionsTag';
  needTotal: Scalars['Int']['output'];
  tag: QConfigGeneratorConditionsTagTagObjectType;
};

export type QConfigGeneratorConditionsTagTagObjectType = {
  __typename?: 'QConfigGeneratorConditionsTagTagObjectType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QConfigGeneratorExecution = {
  __typename?: 'QConfigGeneratorExecution';
  createdAt: Scalars['DateTime']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  needTotal: Scalars['Int']['output'];
  qConfigGeneratorId: Scalars['String']['output'];
  results: Array<QConfigGeneratorExecutionResult>;
  round: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: QConfigGeneratorExecutionStatus;
  totalResults: Scalars['Int']['output'];
};

export type QConfigGeneratorExecutionResult = {
  __typename?: 'QConfigGeneratorExecutionResult';
  id: Scalars['String']['output'];
  qConfig: Maybe<QConfig>;
  qConfigGeneratorExecutionId: Scalars['String']['output'];
};

export enum QConfigGeneratorExecutionStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum QConfigGeneratorGroupLevel {
  Chapter = 'CHAPTER',
  Subject = 'SUBJECT'
}

export type QConfigGeneratorMetadata = {
  __typename?: 'QConfigGeneratorMetadata';
  conditions: QConfigGeneratorCondition;
  generatorGroupLevel: QConfigGeneratorGroupLevel;
  qBankStructureIds: Maybe<Array<Scalars['String']['output']>>;
};

export type QConfigMetadata = {
  __typename?: 'QConfigMetadata';
  conditions: Maybe<QConfigCondition>;
  passingCriteria: Maybe<QConfigPassingCriteria>;
  randomConfig: Maybe<QConfigRandomConfig>;
  timeLimit: Maybe<QConfigTimeLimit>;
};

export type QConfigMetadataConditionQuestionType = {
  __typename?: 'QConfigMetadataConditionQuestionType';
  needTotal: Scalars['Float']['output'];
  type: QConfigQuestionType;
};

export type QConfigPassingCriteria = {
  __typename?: 'QConfigPassingCriteria';
  type: QConfigPassingCriteriaType;
  value: Scalars['Int']['output'];
};

export enum QConfigPassingCriteriaType {
  Percent = 'PERCENT',
  Score = 'SCORE'
}

export enum QConfigQuestionType {
  ItemSet = 'ITEM_SET',
  Single = 'SINGLE'
}

export type QConfigRandomConfig = {
  __typename?: 'QConfigRandomConfig';
  groupBy: Maybe<QConfigRandomGroupBy>;
  type: QConfigRandomConfigType;
};

export enum QConfigRandomConfigType {
  Fixed = 'FIXED',
  Random = 'RANDOM'
}

export enum QConfigRandomGroupBy {
  Hierarchy = 'HIERARCHY',
  Part = 'PART'
}

export enum QConfigRandomType {
  AllRandom = 'ALL_RANDOM',
  Fixed = 'FIXED',
  RandomByHierarchy = 'RANDOM_BY_HIERARCHY',
  RandomByPart = 'RANDOM_BY_PART'
}

export enum QConfigStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type QConfigStructure = {
  __typename?: 'QConfigStructure';
  category: Maybe<QConfigStructureCategory>;
  chapterLevelItemId: Maybe<Scalars['String']['output']>;
  conditions: Array<QConfigStructureCondition>;
  id: Scalars['String']['output'];
  learningObjectiveStatements: Maybe<Array<LearningObjectiveStatement>>;
  /** The chapter level item and all its descendants, as a flat list. Empty unless this structure is a QConfig chapter. Null, with a field error, when the caller lacks the QBank structure view permission. */
  levelItemSubtree: Maybe<Array<QBankStructureLevelItem>>;
  name: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  parentId: Maybe<Scalars['String']['output']>;
  parentRefId: Maybe<Scalars['String']['output']>;
  passingCriteria: Maybe<QConfigStructurePassingCriteria>;
  qConfigId: Scalars['String']['output'];
  refCode: Maybe<Scalars['String']['output']>;
  refId: Maybe<Scalars['String']['output']>;
  refSource: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  size: Maybe<Scalars['Int']['output']>;
  totalQuestions: Scalars['Int']['output'];
  type: QConfigStructureType;
};

export enum QConfigStructureCategory {
  AllSubTopic = 'ALL_SUB_TOPIC',
  Chapter = 'CHAPTER',
  Course = 'COURSE',
  Group = 'GROUP',
  ItemSet = 'ITEM_SET',
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  NonSpecificTopic = 'NON_SPECIFIC_TOPIC',
  Part = 'PART',
  Single = 'SINGLE',
  Subject = 'SUBJECT',
  SubTopic = 'SUB_TOPIC',
  Topic = 'TOPIC'
}

export type QConfigStructureCondition = QConfigStructureConditionMultiTagGroup | QConfigStructureConditionSingleTagGroup;

export type QConfigStructureConditionMultiTagGroup = {
  __typename?: 'QConfigStructureConditionMultiTagGroup';
  needTotal: Scalars['Int']['output'];
  tagGroups: Array<QConfigStructureConditionTagGroup>;
  type: QConfigStructureConditionType;
};

export type QConfigStructureConditionMultiTagGroupObjectType = {
  __typename?: 'QConfigStructureConditionMultiTagGroupObjectType';
  needTotal: Scalars['Float']['output'];
  tagGroups: Array<QConfigStructureConditionTagGroupObjectType>;
  type: Scalars['String']['output'];
};

export type QConfigStructureConditionObjectType = QConfigStructureConditionMultiTagGroupObjectType | QConfigStructureConditionSingleTagGroupObjectType;

export type QConfigStructureConditionSingleTagGroup = {
  __typename?: 'QConfigStructureConditionSingleTagGroup';
  needTotal: Scalars['Int']['output'];
  tags: Array<ConditionTag>;
  type: QConfigStructureConditionType;
};

export type QConfigStructureConditionSingleTagGroupObjectType = {
  __typename?: 'QConfigStructureConditionSingleTagGroupObjectType';
  needTotal: Scalars['Float']['output'];
  tags: Array<ConditionTagObjectType>;
  type: Scalars['String']['output'];
};

export type QConfigStructureConditionTagGroup = {
  __typename?: 'QConfigStructureConditionTagGroup';
  count: Scalars['Int']['output'];
  tags: Array<ConditionTag>;
};

export type QConfigStructureConditionTagGroupObjectType = {
  __typename?: 'QConfigStructureConditionTagGroupObjectType';
  count: Scalars['Float']['output'];
  tags: Array<ConditionTagObjectType>;
};

export enum QConfigStructureConditionType {
  MultiTagGroup = 'MULTI_TAG_GROUP',
  SingleTagGroup = 'SINGLE_TAG_GROUP'
}

export type QConfigStructureNameInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type QConfigStructurePassingCriteria = {
  __typename?: 'QConfigStructurePassingCriteria';
  type: QConfigPassingCriteriaType;
  value: Scalars['Int']['output'];
};

export type QConfigStructurePassingCriteriaObjectType = {
  __typename?: 'QConfigStructurePassingCriteriaObjectType';
  type: QConfigPassingCriteriaType;
  value: Scalars['Float']['output'];
};

export type QConfigStructureSnapShot = {
  __typename?: 'QConfigStructureSnapShot';
  category: Maybe<QConfigStructureCategory>;
  chapterLevelItemId: Maybe<Scalars['String']['output']>;
  conditions: Array<QConfigStructureCondition>;
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  parentId: Maybe<Scalars['String']['output']>;
  parentRefId: Maybe<Scalars['String']['output']>;
  passingCriteria: Maybe<QConfigStructurePassingCriteria>;
  qConfigId: Scalars['String']['output'];
  refCode: Maybe<Scalars['String']['output']>;
  refId: Maybe<Scalars['String']['output']>;
  refSource: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  size: Maybe<Scalars['Int']['output']>;
  totalQuestions: Scalars['Int']['output'];
  type: QConfigStructureType;
};

export enum QConfigStructureType {
  QuestionType = 'QUESTION_TYPE',
  QBankStructure = 'Q_BANK_STRUCTURE',
  QBankStructureLevelItem = 'Q_BANK_STRUCTURE_LEVEL_ITEM',
  QConfig = 'Q_CONFIG',
  Tag = 'TAG'
}

export type QConfigStructuresTask = {
  __typename?: 'QConfigStructuresTask';
  category: Maybe<QConfigStructureCategory>;
  conditions: Array<QConfigStructureConditionObjectType>;
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  parentId: Maybe<Scalars['String']['output']>;
  parentRefId: Maybe<Scalars['String']['output']>;
  passingCriteria: Maybe<QConfigStructurePassingCriteriaObjectType>;
  refCode: Maybe<Scalars['String']['output']>;
  refId: Maybe<Scalars['String']['output']>;
  refSource: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  size: Maybe<Scalars['Float']['output']>;
  totalQuestions: Scalars['Float']['output'];
  type: QConfigStructureType;
};

export type QConfigTask = {
  __typename?: 'QConfigTask';
  code: Scalars['Int']['output'];
  fullScore: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  metadata: QConfigTaskMetadata;
  structures: Array<QConfigStructuresTask>;
  totalQuestions: Scalars['Float']['output'];
};

export type QConfigTaskMetadata = {
  __typename?: 'QConfigTaskMetadata';
  conditions: Maybe<QConfigTaskMetadataCondition>;
  passingCriteria: Maybe<QConfigTaskMetadataPassingCriteria>;
  randomConfig: Maybe<QConfigTaskMetadataRandomConfig>;
  timeLimit: Maybe<QConfigTaskMetadataTimeLimit>;
};

export type QConfigTaskMetadataCondition = {
  __typename?: 'QConfigTaskMetadataCondition';
  questionTypes: Array<QConfigTaskMetadataConditionQuestion>;
  tags: Array<QConfigTaskMetadataConditionTag>;
};

export type QConfigTaskMetadataConditionQuestion = {
  __typename?: 'QConfigTaskMetadataConditionQuestion';
  needTotal: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type QConfigTaskMetadataConditionTag = {
  __typename?: 'QConfigTaskMetadataConditionTag';
  needTotal: Scalars['Float']['output'];
  tag: TaskQConfigConditionTag;
};

export type QConfigTaskMetadataPassingCriteria = {
  __typename?: 'QConfigTaskMetadataPassingCriteria';
  type: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type QConfigTaskMetadataRandomConfig = {
  __typename?: 'QConfigTaskMetadataRandomConfig';
  groupBy: Maybe<QConfigRandomGroupBy>;
  type: QConfigRandomConfigType;
};

export type QConfigTaskMetadataTimeLimit = {
  __typename?: 'QConfigTaskMetadataTimeLimit';
  total: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  values: Array<QConfigTaskMetadataTimeLimitValue>;
};

export type QConfigTaskMetadataTimeLimitValue = {
  __typename?: 'QConfigTaskMetadataTimeLimitValue';
  order: Scalars['Float']['output'];
  qConfigStructureIds: Maybe<Array<Scalars['String']['output']>>;
  value: Scalars['Float']['output'];
};

export type QConfigTimeLimit = {
  __typename?: 'QConfigTimeLimit';
  total: Maybe<Scalars['Int']['output']>;
  type: QConfigTimeLimitType;
  values: Array<QConfigTimeLimitValue>;
};

export enum QConfigTimeLimitType {
  All = 'ALL',
  ByStructure = 'BY_STRUCTURE'
}

export type QConfigTimeLimitValue = {
  __typename?: 'QConfigTimeLimitValue';
  order: Scalars['Int']['output'];
  qConfigStructureIds: Maybe<Array<Scalars['String']['output']>>;
  value: Scalars['Int']['output'];
};

export enum QConfigType {
  Manual = 'MANUAL',
  ManualOptimized = 'MANUAL_OPTIMIZED',
  Optimized = 'OPTIMIZED'
}

export type QContentAuditLogFilterConditionInput = {
  field: Scalars['String']['input'];
  operator: FilterOperatorEnum;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type QContentAuditLogIdentifier = {
  __typename?: 'QContentAuditLogIdentifier';
  identifierId: Scalars['String']['output'];
  identifierType: QContentAuditLogIdentifierType;
};

export enum QContentAuditLogIdentifierType {
  QbankStructureId = 'QBANK_STRUCTURE_ID',
  QcontentId = 'QCONTENT_ID',
  QuestionGroupId = 'QUESTION_GROUP_ID'
}

export type QContentAuditLogObjectType = {
  __typename?: 'QContentAuditLogObjectType';
  action: AuditActionType;
  actionTime: Scalars['DateTime']['output'];
  auditType: AuditType;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  executionInput: Scalars['String']['output'];
  executionMethod: Scalars['String']['output'];
  executionOutput: Scalars['String']['output'];
  executionResult: AuditLogExecutionResult;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifiers: Array<QContentAuditLogIdentifier>;
  type: QContentAuditLogType;
  userId: Scalars['String']['output'];
  userRoles: Array<Scalars['String']['output']>;
  userType: UserType;
};

export type QContentAuditLogOrderInput = {
  field: Scalars['String']['input'];
  type: QContentAuditLogOrderType;
};

export enum QContentAuditLogOrderType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type QContentAuditLogPagingInput = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type QContentAuditLogSearchFilterInput = {
  conditions?: InputMaybe<Array<QContentAuditLogFilterConditionInput>>;
  searchText?: InputMaybe<QContentAuditLogSearchTextInput>;
};

export type QContentAuditLogSearchTextInput = {
  fields: Array<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export enum QContentAuditLogType {
  Question = 'QUESTION',
  QuestionGroup = 'QUESTION_GROUP'
}

export type QSet = {
  __typename?: 'QSet';
  assignees: Array<RawUser>;
  code: Scalars['String']['output'];
  conditions: Maybe<QSetConditions>;
  disabledAt: Maybe<Scalars['DateTime']['output']>;
  disabledBy: Maybe<Scalars['String']['output']>;
  duplicationRate: Scalars['Float']['output'];
  examCourseId: Scalars['String']['output'];
  examUsageStatus: Maybe<ExamUsageStatus>;
  id: Scalars['String']['output'];
  lastPublishedAt: Maybe<Scalars['DateTime']['output']>;
  lastPublishedBy: Maybe<Scalars['String']['output']>;
  lastReviewedAt: Maybe<Scalars['DateTime']['output']>;
  metadata: Maybe<QSetMetadata>;
  pAvgValue: Scalars['Float']['output'];
  qConfig: QConfig;
  qConfigId: Scalars['String']['output'];
  qSetGeneratorExecutionId: Maybe<Scalars['String']['output']>;
  qSetGeneratorExecutionResultId: Maybe<Scalars['String']['output']>;
  qSetGeneratorId: Maybe<Scalars['String']['output']>;
  status: QSetStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type QSetAuditLog = {
  __typename?: 'QSetAuditLog';
  action: AuditActionType;
  actionTime: Scalars['DateTime']['output'];
  auditType: AuditType;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  executionInput: Scalars['String']['output'];
  executionMethod: Scalars['String']['output'];
  executionOutput: Scalars['String']['output'];
  executionResult: AuditLogExecutionResult;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifiers: Array<QSetAuditLogIdentifier>;
  type: QSetAuditLogType;
  userId: Scalars['String']['output'];
  userRoles: Array<Scalars['String']['output']>;
  userType: UserType;
};

export type QSetAuditLogIdentifier = {
  __typename?: 'QSetAuditLogIdentifier';
  identifierId: Scalars['String']['output'];
  identifierType: QSetAuditLogIdentifierType;
};

export enum QSetAuditLogIdentifierType {
  ExaminationCourseId = 'EXAMINATION_COURSE_ID',
  QsetId = 'QSET_ID',
  QsetQuestionId = 'QSET_QUESTION_ID'
}

export enum QSetAuditLogType {
  Qset = 'QSET'
}

export type QSetComparisonInput = {
  code: Scalars['String']['input'];
  id: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
};

export enum QSetConditionQuestionType {
  ItemSet = 'ITEM_SET',
  Single = 'SINGLE'
}

export type QSetConditionTag = {
  __typename?: 'QSetConditionTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QSetConditions = {
  __typename?: 'QSetConditions';
  averagePValue: Scalars['Float']['output'];
  questionTypes: Array<QSetConditionsQuestionType>;
  tags: Array<QSetConditionsTags>;
};

export type QSetConditionsQuestionType = {
  __typename?: 'QSetConditionsQuestionType';
  count: Scalars['Int']['output'];
  type: QSetConditionQuestionType;
};

export type QSetConditionsTags = {
  __typename?: 'QSetConditionsTags';
  count: Scalars['Int']['output'];
  tag: QSetConditionTag;
};

export type QSetGenerator = {
  __typename?: 'QSetGenerator';
  code: Scalars['String']['output'];
  duplicationRate: Scalars['Float']['output'];
  examCourseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  needTotal: Scalars['Int']['output'];
  qConfig: QConfig;
  qConfigId: Scalars['String']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type QSetGeneratorExecution = {
  __typename?: 'QSetGeneratorExecution';
  endedAt: Maybe<Scalars['DateTime']['output']>;
  generator: QSetGenerator;
  id: Scalars['String']['output'];
  qSetGeneratorId: Scalars['String']['output'];
  results: Array<QSetGeneratorExecutionResult>;
  round: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: QSetGeneratorExecutionStatus;
};

export type QSetGeneratorExecutionResult = {
  __typename?: 'QSetGeneratorExecutionResult';
  averageDuplicationRate: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  criteriaResult: QSetGeneratorExecutionResultCriteriaResult;
  id: Scalars['String']['output'];
  isSelected: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pAvgValue: Scalars['Float']['output'];
  qSetGeneratorExecutionId: Scalars['String']['output'];
  questionDetails: Array<QuestionDetailsResult>;
};

export enum QSetGeneratorExecutionResultCriteriaResult {
  Failed = 'FAILED',
  Passed = 'PASSED'
}

export enum QSetGeneratorExecutionStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type QSetMetadata = {
  __typename?: 'QSetMetadata';
  assigneeIds: Maybe<Array<Scalars['String']['output']>>;
  passingCriteria: Maybe<QSetPassingCriteria>;
  qConfigStructureParts: Maybe<Array<QConfigStructureSnapShot>>;
  qConfigStructures: Maybe<Array<QConfigStructureSnapShot>>;
  randomType: Maybe<QConfigRandomType>;
};

export type QSetPassingCriteria = {
  __typename?: 'QSetPassingCriteria';
  byStructure: Array<QSetPassingCriteriaByStructure>;
  total: Scalars['Int']['output'];
};

export type QSetPassingCriteriaByStructure = {
  __typename?: 'QSetPassingCriteriaByStructure';
  qConfigStructureId: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type QSetQuestion = {
  __typename?: 'QSetQuestion';
  groupOrder: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  metadata: QSetQuestionMetadata;
  order: Scalars['Float']['output'];
  qSet: QSet;
  qSetId: Scalars['String']['output'];
  question: Maybe<Question>;
  questionGroup: Maybe<QuestionGroup>;
  questionGroupId: Scalars['String']['output'];
  questionGroupType: QSetQuestionGroupType;
  questionId: Scalars['String']['output'];
  questionRefCode: Scalars['String']['output'];
  questionSnapshot: Maybe<QSetQuestionSnapshot>;
  score: Scalars['Float']['output'];
};

export type QSetQuestionDownloadSignedUrls = {
  __typename?: 'QSetQuestionDownloadSignedUrls';
  /** questionGroupId → fileName → signed URL */
  questionGroupSignedUrls: Scalars['JSON']['output'];
  /** questionId → fileName → signed URL */
  questionSignedUrls: Scalars['JSON']['output'];
};

export type QSetQuestionFileInput = {
  fileNames: Array<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
};

export type QSetQuestionGroupFileInput = {
  fileNames: Array<Scalars['String']['input']>;
  questionGroupId: Scalars['String']['input'];
};

export type QSetQuestionGroupSnapshot = {
  __typename?: 'QSetQuestionGroupSnapshot';
  id: Scalars['String']['output'];
  metadata: Maybe<QSetQuestionGroupSnapshotMetadata>;
  name: Scalars['String']['output'];
  qSetId: Scalars['String']['output'];
  questionGroupId: Scalars['String']['output'];
  refCode: Scalars['String']['output'];
  refQBankStructureId: Scalars['String']['output'];
  size: Maybe<Scalars['Float']['output']>;
  type: QSetQuestionGroupSnapshotType;
};

export type QSetQuestionGroupSnapshotMetadata = {
  __typename?: 'QSetQuestionGroupSnapshotMetadata';
  paragraph: Maybe<Scalars['String']['output']>;
};

export enum QSetQuestionGroupSnapshotType {
  ItemSet = 'ITEM_SET',
  LotOfQuestion = 'LOT_OF_QUESTION',
  Single = 'SINGLE'
}

/** Question Group Type */
export enum QSetQuestionGroupType {
  ItemSet = 'ITEM_SET',
  LotOfQuestion = 'LOT_OF_QUESTION',
  Single = 'SINGLE'
}

export type QSetQuestionMetadata = {
  __typename?: 'QSetQuestionMetadata';
  qConfigStructures: Array<QSetQuestionQConfigStructure>;
};

export type QSetQuestionQConfigStructure = {
  __typename?: 'QSetQuestionQConfigStructure';
  category: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum QSetQuestionQuestionSnapshotOwnerType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export enum QSetQuestionQuestionSnapshotSolutionType {
  Html = 'HTML'
}

export enum QSetQuestionQuestionSnapshotType {
  MultipleChoice = 'MULTIPLE_CHOICE'
}

export type QSetQuestionSnapshot = {
  __typename?: 'QSetQuestionSnapshot';
  bIndexValue: Maybe<Scalars['Float']['output']>;
  correctAnswer: QuestionSnapshotCorrectAnswer;
  createdBy: Scalars['String']['output'];
  details: Scalars['String']['output'];
  groupOrder: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  lastPublishedAt: Scalars['DateTime']['output'];
  lastPublishedBy: Scalars['String']['output'];
  metadata: QSetQuestionSnapshotMetadata;
  pValue: Scalars['Float']['output'];
  qSetQuestionId: Scalars['String']['output'];
  questionGroup: Maybe<QSetQuestionGroupSnapshot>;
  questionGroupSnapshotId: Scalars['String']['output'];
  refCode: Scalars['String']['output'];
  refQBankStructureId: Scalars['String']['output'];
  solution: QSetQuestionSnapshotSolution;
  tags: Array<QSetQuestionSnapshotTag>;
  type: QSetQuestionQuestionSnapshotType;
};

export type QSetQuestionSnapshotChoice = {
  __typename?: 'QSetQuestionSnapshotChoice';
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type QSetQuestionSnapshotMetadata = {
  __typename?: 'QSetQuestionSnapshotMetadata';
  audit1: Maybe<Scalars['String']['output']>;
  audit2: Maybe<Scalars['String']['output']>;
  audit3: Maybe<Scalars['String']['output']>;
  choices: Array<QSetQuestionSnapshotChoice>;
  owner: Maybe<QSetQuestionSnapshotOwner>;
  questionStructures: Array<QuestionSnapshotStructure>;
  reference: Scalars['String']['output'];
  tags: Array<QSetQuestionSnapshotTag>;
};

export type QSetQuestionSnapshotOwner = {
  __typename?: 'QSetQuestionSnapshotOwner';
  type: QSetQuestionQuestionSnapshotOwnerType;
  value: Maybe<Scalars['String']['output']>;
};

export type QSetQuestionSnapshotSolution = {
  __typename?: 'QSetQuestionSnapshotSolution';
  type: QSetQuestionQuestionSnapshotSolutionType;
  value: Scalars['String']['output'];
};

export type QSetQuestionSnapshotTag = {
  __typename?: 'QSetQuestionSnapshotTag';
  category: QSetQuestionSnapshotTagCategory;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum QSetQuestionSnapshotTagCategory {
  Calculation = 'CALCULATION',
  CognitiveDomain = 'COGNITIVE_DOMAIN',
  Difficulty = 'DIFFICULTY',
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  QbankStructureLevel = 'QBANK_STRUCTURE_LEVEL'
}

export type QSetReviewCommentOutput = {
  __typename?: 'QSetReviewCommentOutput';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  entityType: ExaminationEntityType;
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: RawUser;
  userId: Scalars['String']['output'];
};

export type QSetReviewQuestionOutput = {
  __typename?: 'QSetReviewQuestionOutput';
  groupOrder: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  qSetId: Scalars['String']['output'];
  questionGroupId: Scalars['String']['output'];
  questionGroupType: QSetQuestionGroupType;
  questionId: Scalars['String']['output'];
  questionRefCode: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type QSetReviewTaskResultOutput = {
  __typename?: 'QSetReviewTaskResultOutput';
  comment: Maybe<QSetReviewCommentOutput>;
  question: QSetReviewQuestionOutput;
  totalComments: Scalars['Float']['output'];
  verdict: Maybe<QSetReviewVerdictOutput>;
};

export type QSetReviewVerdictOutput = {
  __typename?: 'QSetReviewVerdictOutput';
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  entityType: ExaminationEntityType;
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  verdict: Maybe<Verdict>;
};

export type QSetSimilarityResultOutput = {
  __typename?: 'QSetSimilarityResultOutput';
  duplicatedQuestionIds: Array<Scalars['String']['output']>;
  duplicationCount: Scalars['Float']['output'];
  duplicationRate: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  qSetA: Scalars['String']['output'];
  qSetACode: Scalars['String']['output'];
  qSetAUpdatedAt: Scalars['DateTime']['output'];
  qSetB: Scalars['String']['output'];
  qSetBCode: Scalars['String']['output'];
  qSetBUpdatedAt: Scalars['DateTime']['output'];
  totalQuestions: Scalars['Float']['output'];
};

export type QSetSimilarityResultWithQuestionsOutput = {
  __typename?: 'QSetSimilarityResultWithQuestionsOutput';
  duplicatedQuestionIds: Array<Scalars['String']['output']>;
  duplicatedQuestions: Array<QSetQuestion>;
  duplicationCount: Scalars['Float']['output'];
  duplicationRate: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  qSetA: Scalars['String']['output'];
  qSetACode: Scalars['String']['output'];
  qSetAUpdatedAt: Scalars['DateTime']['output'];
  qSetB: Scalars['String']['output'];
  qSetBCode: Scalars['String']['output'];
  qSetBUpdatedAt: Scalars['DateTime']['output'];
  totalQuestions: Scalars['Float']['output'];
};

export enum QSetStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  InReview = 'IN_REVIEW',
  Published = 'PUBLISHED',
  Reviewed = 'REVIEWED',
  Unpublished = 'UNPUBLISHED'
}

export type QSetTask = {
  __typename?: 'QSetTask';
  code: Scalars['String']['output'];
  duplicationRate: Scalars['Float']['output'];
  examCourse: ExamCourseTask;
  examCourseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastPublishedAt: Maybe<Scalars['DateTime']['output']>;
  lastPublishedBy: Maybe<Scalars['String']['output']>;
  pAvgValue: Scalars['Float']['output'];
  qConfig: QConfigTask;
  qConfigId: Scalars['String']['output'];
  qSetGeneratorExecutionId: Maybe<Scalars['String']['output']>;
  qSetGeneratorExecutionResultId: Maybe<Scalars['String']['output']>;
  qSetGeneratorId: Maybe<Scalars['String']['output']>;
  status: QSetTaskStatus;
};

export type QSetTaskReviewSummaryOutput = {
  __typename?: 'QSetTaskReviewSummaryOutput';
  comments: Array<QSetReviewCommentOutput>;
  question: QSetReviewQuestionOutput;
  totalComments: Scalars['Float']['output'];
  verdicts: Array<QSetReviewVerdictOutput>;
};

export enum QSetTaskStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  InReview = 'IN_REVIEW',
  Published = 'PUBLISHED',
  Reviewed = 'REVIEWED',
  Unpublished = 'UNPUBLISHED'
}

export type Query = {
  __typename?: 'Query';
  UsBoGetTokenStatus: UsBoGetTokenStatusResponse;
  UsBoSearchUsersWithAppRoleFilters: UsBoUserSearchResult;
  UsBoUser: UsBoUser;
  UsBoUsers: UsBoUserSearchResult;
  cvSearchUsersContentVisibility: UsersDataContentVisibilityResult;
  excExportQSet: ExportQSetOutput;
  excExportTaskQSet: ExportQSetOutput;
  excGetDisabledLearningObjectiveStatementsByQConfigId: GetDisabledLearningObjectiveStatementsByQConfigIdOutput;
  excGetDownloadSignedUrlForExamCourseComment: GetDownloadSignedUrlForExamCourseCommentOutput;
  excGetDownloadSignedUrlForQuestionsByQSetId: GetDownloadSignedUrlForQuestionsByQSetIdOutput;
  excGetExamCourseById: GetExamCourseByIdOutput;
  excGetExamCourseComments: GetExamCourseCommentsOutput;
  excGetExamCourseGroupById: GetExamCourseGroupByIdOutput;
  excGetExamCourseVerdict: GetExamCourseVerdictOutput;
  excGetQConfigById: GetQConfigByIdOutput;
  excGetQConfigChapter: QConfigStructure;
  excGetQConfigChapterItemSetQuestionPropertiesCount: Array<QConfigChapterItemSetQuestionProperties>;
  excGetQConfigChapterSingleQuestionPropertiesCount: Array<QConfigChapterSingleQuestionProperties>;
  excGetQConfigGeneratorById: GetQConfigGeneratorByIdOutput;
  excGetQSetById: GetQSetByIdOutput;
  excGetQSetByTaskId: GetQSetByTaskIdOutput;
  excGetQSetGeneratorExecutionById: GetQSetGeneratorExecutionByIdOutput;
  excGetQSetQuestionDownloadSignedUrls: QSetQuestionDownloadSignedUrls;
  excGetQSetQuestionsByQuestionIds: GetQSetQuestionsByQuestionIdsOutput;
  excGetQSetQuestionsByTaskId: GetQSetQuestionsByTaskIdOutput;
  excGetQSetSimilarities: GetQSetSimilaritiesOutput;
  excGetQSetSimilarityWithQuestionsById: GetQSetSimilarityByIdOutput;
  excGetUploadSignedUrlForExamCourseComment: GetUploadSignedUrlForExamCourseCommentOutput;
  excRandomPreviewQuestionsByTaskId: RandomPreviewQuestionsByTaskIdOutput;
  excSearchExamCourseGroupsByName: SearchExamCourseGroupsByNameOutput;
  excSearchExamCourses: SearchExamCoursesOutput;
  excSearchQConfigAuditLog: SearchQConfigAuditLogOutput;
  excSearchQConfigGenerators: SearchQConfigGeneratorsOutput;
  excSearchQConfigs: SearchQConfigsOutput;
  excSearchQSetAuditLog: SearchQSetAuditLogOutput;
  excSearchQSetQuestions: SearchQSetQuestionsOutput;
  excSearchQSets: SearchQSetsOutput;
  excSearchTaskQSetQuestions: SearchQSetQuestionsOutput;
  getAppPermissions: Array<AppPermission>;
  getAppRoleAppPermissions: Array<AppPermission>;
  getAppRoles: AppRoleSearchResult;
  getMyProfile: UsUser;
  getUserAppRoleView: UserAppRoleViewSearchResult;
  qbsGetLearningObjectiveStatementById: LearningObjectiveStatement;
  qbsGetQBankStructureById: QBankStructure;
  qbsGetQBankStructureGroupTagById: Tag;
  qbsGetQBankStructureLevelItemChildrenById: Array<QBankStructureLevelItem>;
  qbsGetQBankStructureLevelItemsAbilityByQBankStructureId: Array<QBankStructureLevelItemsAbility>;
  qbsGetQBankStructureLevelItemsByQBankStructureId: Array<QBankStructureLevelItem>;
  qbsGetQBankStructureLevelItemsByQBankStructureIdAndUserId: Array<QBankStructureLevelItemPartSubject>;
  qbsGetQBankStructureLevelsByQBankStructureId: Array<QBankStructureLevel>;
  qbsGetQBankStructuresByIds: Array<QBankStructure>;
  qbsGetTagsByCategory: Array<Tag>;
  qbsGetTaskQBankStructureLevelItemsByQBankStructureId: Array<QBankStructureLevelItem>;
  qbsGetTaskQBankStructureLevelsByQBankStructureId: Array<QBankStructureLevel>;
  qbsSearchLearningObjectiveStatements: LearningObjectiveStatementsResult;
  qbsSearchQBankStructureAuditLogs: SearchQBankStructureAuditLogOutput;
  qbsSearchQBankStructureGroupTags: TagResult;
  qbsSearchQBankStructures: QBankStructuresResult;
  qbsSearchTags: TagResult;
  qbsSearchTaskLearningObjectiveStatements: LearningObjectiveStatementsResult;
  qbsSearchTaskTags: TagResult;
  qbsValidateQBankStructureBeforePublish: Array<ValidateQBankStructureResult>;
  qctGetDownloadSignedUrlForQuestionGroups: GetDownloadSignedUrlForQuestionGroupsResult;
  qctGetDownloadSignedUrlForQuestions: GetDownloadSignedUrlForQuestionsResult;
  qctGetDownloadSignedUrlForTaskQuestion: GetDownloadSignedUrlsResult;
  qctGetDownloadSignedUrlForTaskQuestionGroups: GetDownloadSignedUrlForQuestionGroupsResult;
  qctGetDownloadSignedUrlForTaskQuestions: GetDownloadSignedUrlForQuestionsResult;
  qctGetDownloadSignedUrlQuestion: GetDownloadSignedUrlsResult;
  qctGetItemSetQuestionPropertiesByStatusAndLocation: Array<ItemSetQuestionPropertiesByLocation>;
  qctGetItemSetQuestionPropertiesCountByLocation: Array<ItemSetQuestionProperties>;
  qctGetQuestionById: Question;
  qctGetQuestionCommentsByEntityAndTaskId: Array<QuestionComment>;
  qctGetQuestionGroupById: QuestionGroup;
  qctGetQuestionGroupsByQBankStructureLevelItemId: Array<QuestionGroup>;
  qctGetQuestionUsageById: Array<GetQuestionUsageByIdOutput>;
  qctGetQuestionVerdictsByEntityAndTaskId: Array<QuestionVerdict>;
  qctGetQuestionVerdictsByTaskId: Array<QuestionVerdict>;
  qctGetSingleQuestionPropertiesByStatusAndLocation: Array<SingleQuestionPropertiesByLocation>;
  qctGetSingleQuestionPropertiesCountByLocation: Array<SingleQuestionProperties>;
  qctGetSingleQuestionQuestionGroupPropertiesByStatusAndLocation: Array<SingleQuestionQuestionGroupPropertiesByLocation>;
  qctGetTaskQuestionById: Question;
  qctGetTaskQuestionGroupById: QuestionGroup;
  qctGetTaskQuestionGroupByIds: Array<QuestionGroup>;
  qctGetTaskQuestionVerdicts: Array<QuestionVerdict>;
  qctGetTaskQuestionsByIds: Array<Question>;
  qctGetUploadSignedUrlForTaskQuestion: GetUploadSignedUrlResult;
  qctGetUploadSignedUrlImportQuestionSpreadsheet: GetUploadSignedUrlResult;
  qctGetUploadSignedUrlQuestion: GetUploadSignedUrlResult;
  qctSearchQContentAuditLogs: SearchQContentAuditLogOutput;
  qctSearchQuestionGroups: QuestionGroupsResult;
  qctSearchQuestions: QuestionsResult;
  qctSearchQuestionsByKeyword: QuestionKeywordSearchResultDto;
  qctSearchQuestionsByQIds: SearchQuestionsByQIdsResultDto;
  qctSearchQuestionsInLearningObjectiveStatement: QuestionsResult;
  suGetAppRole: GetAppRoleOutputObjectType;
  suUser: GetUserByIdOutputObjectType;
  validateToken: ValidateTokenResult;
  wflGetDownloadSignedUrlForTask: GetDownloadSignedUrlForTaskOutput;
  wflGetMyTasks: GetMyTasksOutput;
  wflGetQSetTaskReviewSummary: GetQSetTaskReviewSummaryOutput;
  wflGetStepTransitionsByTaskId: GetStepTransitionsByTaskIdOutput;
  wflGetTaskById: GetTaskByIdOutput;
  wflGetTaskComments: GetTaskCommentsOutput;
  wflGetTaskReviewResults: GetTaskReviewResultsOutput;
  wflGetTaskVerdict: GetTaskVerdictOutput;
  wflGetTasksByEntityWithParent: GetTasksByEntityWithParentOutput;
  wflGetUploadSignedUrlForQuestionCreationTask: GetUploadSignedUrlForQuestionCreationTaskOutput;
  wflGetUploadSignedUrlForTask: GetUploadSignedUrlForTaskOutput;
  wflSearchMyTasks: SearchMyTasksOutput;
  wflSearchOwnedAndAssignedTasks: SearchOwnedAndAssignedTasksOutput;
};


export type QueryUsBoSearchUsersWithAppRoleFiltersArgs = {
  appRoleIds: InputMaybe<Array<Scalars['String']['input']>>;
  appRoleNames: InputMaybe<Array<Scalars['String']['input']>>;
  excludeAppRoleIds: InputMaybe<Array<Scalars['String']['input']>>;
  excludeFields: InputMaybe<UsBoUserExcludeFieldsInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search?: InputMaybe<UsBoUserSearchInput>;
};


export type QueryUsBoUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUsBoUsersArgs = {
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search: InputMaybe<UsBoUserSearchInput>;
};


export type QueryCvSearchUsersContentVisibilityArgs = {
  input: SearchUsersContentVisibilityInput;
};


export type QueryExcExportQSetArgs = {
  input: ExportQSetInput;
};


export type QueryExcExportTaskQSetArgs = {
  input: ExportTaskQSetInput;
};


export type QueryExcGetDisabledLearningObjectiveStatementsByQConfigIdArgs = {
  GetDisabledLearningObjectiveStatementsByQConfigIdInput: GetDisabledLearningObjectiveStatementsByQConfigIdInput;
};


export type QueryExcGetDownloadSignedUrlForExamCourseCommentArgs = {
  GetDownloadSignedUrlForExamCourseCommentInput: GetDownloadSignedUrlForExamCourseCommentInput;
};


export type QueryExcGetDownloadSignedUrlForQuestionsByQSetIdArgs = {
  input: GetDownloadSignedUrlForQuestionsByQSetIdInput;
};


export type QueryExcGetExamCourseByIdArgs = {
  getExamCourseByIdInput: GetExamCourseByIdInput;
};


export type QueryExcGetExamCourseCommentsArgs = {
  GetExamCourseCommentsInput: GetExamCourseCommentsInput;
};


export type QueryExcGetExamCourseGroupByIdArgs = {
  getExamCourseGroupByIdInput: GetExamCourseGroupByIdInput;
};


export type QueryExcGetExamCourseVerdictArgs = {
  GetExamCourseVerdictInput: GetExamCourseVerdictInput;
};


export type QueryExcGetQConfigByIdArgs = {
  getQConfigByIdInput: GetQConfigByIdInput;
};


export type QueryExcGetQConfigChapterArgs = {
  GetQConfigChapterInput: GetQConfigChapterInput;
};


export type QueryExcGetQConfigChapterItemSetQuestionPropertiesCountArgs = {
  GetQConfigChapterItemSetQuestionPropertiesCountInput: GetQConfigChapterItemSetQuestionPropertiesCountInput;
};


export type QueryExcGetQConfigChapterSingleQuestionPropertiesCountArgs = {
  GetQConfigChapterSingleQuestionPropertiesCountInput: GetQConfigChapterSingleQuestionPropertiesCountInput;
};


export type QueryExcGetQConfigGeneratorByIdArgs = {
  getQConfigGeneratorByIdInput: GetQConfigGeneratorByIdInput;
};


export type QueryExcGetQSetByIdArgs = {
  input: GetQSetByIdInput;
};


export type QueryExcGetQSetByTaskIdArgs = {
  input: GetQSetByTaskIdInput;
};


export type QueryExcGetQSetGeneratorExecutionByIdArgs = {
  GetQSetGeneratorExecutionByIdInput: GetQSetGeneratorExecutionByIdInput;
};


export type QueryExcGetQSetQuestionDownloadSignedUrlsArgs = {
  input: GetQSetQuestionDownloadSignedUrlsInput;
};


export type QueryExcGetQSetQuestionsByQuestionIdsArgs = {
  input: GetQsetQuestionsByQuestionIdsInput;
};


export type QueryExcGetQSetQuestionsByTaskIdArgs = {
  input: GetQSetQuestionsByTaskIdInput;
};


export type QueryExcGetQSetSimilaritiesArgs = {
  input: GetQSetSimilaritiesInput;
};


export type QueryExcGetQSetSimilarityWithQuestionsByIdArgs = {
  input: GetQSetSimilarityByIdInput;
};


export type QueryExcGetUploadSignedUrlForExamCourseCommentArgs = {
  GetUploadSignedUrlForExamCourseCommentInput: GetUploadSignedUrlForExamCourseCommentInput;
};


export type QueryExcRandomPreviewQuestionsByTaskIdArgs = {
  input: RandomPreviewQuestionsByTaskIdInput;
};


export type QueryExcSearchExamCourseGroupsByNameArgs = {
  searchExamCourseGroupsByNameInput: SearchExamCourseGroupsByNameInput;
};


export type QueryExcSearchExamCoursesArgs = {
  searchExamCoursesInput: SearchExamCoursesInput;
};


export type QueryExcSearchQConfigAuditLogArgs = {
  SearchQConfigAuditLogInput: SearchQConfigAuditLogInput;
};


export type QueryExcSearchQConfigGeneratorsArgs = {
  searchQConfigGeneratorsInput: SearchQConfigGeneratorsInput;
};


export type QueryExcSearchQConfigsArgs = {
  searchQConfigsInput: SearchQConfigsInput;
};


export type QueryExcSearchQSetAuditLogArgs = {
  SearchQSetAuditLogInput: SearchQSetAuditLogInput;
};


export type QueryExcSearchQSetQuestionsArgs = {
  input: SearchQSetQuestionsInput;
};


export type QueryExcSearchQSetsArgs = {
  searchQSetsInput: SearchQSetsInput;
};


export type QueryExcSearchTaskQSetQuestionsArgs = {
  input: SearchQSetQuestionsInputWithTaskIdInput;
};


export type QueryGetAppRoleAppPermissionsArgs = {
  appRoleId: Scalars['String']['input'];
};


export type QueryGetAppRolesArgs = {
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search: InputMaybe<AppRoleSearchInput>;
};


export type QueryGetUserAppRoleViewArgs = {
  appRoleId: InputMaybe<Scalars['String']['input']>;
  invertRoleFilter?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search?: InputMaybe<SearchInput>;
};


export type QueryQbsGetLearningObjectiveStatementByIdArgs = {
  input: GetLearningObjectiveStatementByIdInput;
};


export type QueryQbsGetQBankStructureByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryQbsGetQBankStructureGroupTagByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryQbsGetQBankStructureLevelItemChildrenByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryQbsGetQBankStructureLevelItemsAbilityByQBankStructureIdArgs = {
  qBankStructureId: Scalars['String']['input'];
};


export type QueryQbsGetQBankStructureLevelItemsByQBankStructureIdArgs = {
  options: InputMaybe<GetQBankStructureLevelItemsByQBankStructureIdOptions>;
  qBankStructureId: Scalars['String']['input'];
};


export type QueryQbsGetQBankStructureLevelItemsByQBankStructureIdAndUserIdArgs = {
  options: InputMaybe<QBankStructureLevelItemCategory>;
  qBankStructureId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryQbsGetQBankStructureLevelsByQBankStructureIdArgs = {
  qBankStructureId: Scalars['String']['input'];
};


export type QueryQbsGetQBankStructuresByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryQbsGetTagsByCategoryArgs = {
  getTagsByCategoryInput: GetTagsByCategoryInput;
};


export type QueryQbsGetTaskQBankStructureLevelItemsByQBankStructureIdArgs = {
  options: InputMaybe<GetQBankStructureLevelItemsByQBankStructureIdOptions>;
  qBankStructureId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type QueryQbsGetTaskQBankStructureLevelsByQBankStructureIdArgs = {
  qBankStructureId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type QueryQbsSearchLearningObjectiveStatementsArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search?: SearchLearningObjectiveStatementsInput;
};


export type QueryQbsSearchQBankStructureAuditLogsArgs = {
  input: SearchQBankStructureAuditLogsInputType;
};


export type QueryQbsSearchQBankStructureGroupTagsArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search?: SearchQBankStructureGroupTagInput;
};


export type QueryQbsSearchQBankStructuresArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search?: SearchQBankStructureInput;
};


export type QueryQbsSearchTagsArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search?: SearchTagsInput;
};


export type QueryQbsSearchTaskLearningObjectiveStatementsArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search?: SearchLearningObjectiveStatementsInput;
  taskId: Scalars['String']['input'];
};


export type QueryQbsSearchTaskTagsArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search: SearchTaskTagsInput;
  taskId: Scalars['String']['input'];
};


export type QueryQbsValidateQBankStructureBeforePublishArgs = {
  input: ValidateQBankStructureBeforePublishInput;
};


export type QueryQctGetDownloadSignedUrlForQuestionGroupsArgs = {
  input: GetDownloadSignedUrlForQuestionGroupsInput;
};


export type QueryQctGetDownloadSignedUrlForQuestionsArgs = {
  input: GetDownloadSignedUrlForQuestionsInput;
};


export type QueryQctGetDownloadSignedUrlForTaskQuestionArgs = {
  input: GetDownloadSignedUrlQuestionInput;
  taskId: Scalars['String']['input'];
};


export type QueryQctGetDownloadSignedUrlForTaskQuestionGroupsArgs = {
  input: GetDownloadSignedUrlForQuestionGroupsInput;
  taskId: Scalars['String']['input'];
};


export type QueryQctGetDownloadSignedUrlForTaskQuestionsArgs = {
  input: GetDownloadSignedUrlForQuestionsInput;
  taskId: Scalars['String']['input'];
};


export type QueryQctGetDownloadSignedUrlQuestionArgs = {
  input: GetDownloadSignedUrlQuestionInput;
};


export type QueryQctGetItemSetQuestionPropertiesByStatusAndLocationArgs = {
  input: GetItemSetQuestionPropertiesByStatusAndLocationInputType;
};


export type QueryQctGetItemSetQuestionPropertiesCountByLocationArgs = {
  input: GetItemSetQuestionPropertiesCountByLocationInputType;
};


export type QueryQctGetQuestionByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryQctGetQuestionCommentsByEntityAndTaskIdArgs = {
  input: GetQuestionCommentsByEntityAndTaskIdInput;
};


export type QueryQctGetQuestionGroupByIdArgs = {
  questionGroupId: Scalars['String']['input'];
};


export type QueryQctGetQuestionGroupsByQBankStructureLevelItemIdArgs = {
  input: GetQuestionGroupsByQBankStructureLevelItemIdInput;
};


export type QueryQctGetQuestionUsageByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryQctGetQuestionVerdictsByEntityAndTaskIdArgs = {
  input: GetQuestionVerdictsByEntityAndTaskIdInput;
};


export type QueryQctGetQuestionVerdictsByTaskIdArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryQctGetSingleQuestionPropertiesByStatusAndLocationArgs = {
  input: GetSingleQuestionPropertiesByStatusAndLocationInputType;
};


export type QueryQctGetSingleQuestionPropertiesCountByLocationArgs = {
  input: GetSingleQuestionPropertiesCountByLocationInput;
};


export type QueryQctGetSingleQuestionQuestionGroupPropertiesByStatusAndLocationArgs = {
  input: GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationInputType;
};


export type QueryQctGetTaskQuestionByIdArgs = {
  id: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type QueryQctGetTaskQuestionGroupByIdArgs = {
  questionGroupId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type QueryQctGetTaskQuestionGroupByIdsArgs = {
  questionGroupIds: Array<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
};


export type QueryQctGetTaskQuestionVerdictsArgs = {
  input: GetTaskQuestionVerdictsInput;
};


export type QueryQctGetTaskQuestionsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
  taskId: Scalars['String']['input'];
};


export type QueryQctGetUploadSignedUrlForTaskQuestionArgs = {
  input: GetUploadSignedUrlQuestionInput;
  taskId: Scalars['String']['input'];
};


export type QueryQctGetUploadSignedUrlImportQuestionSpreadsheetArgs = {
  input: GetUploadSignedUrlImportQuestionSpreadsheetInput;
};


export type QueryQctGetUploadSignedUrlQuestionArgs = {
  input: GetUploadSignedUrlQuestionInput;
};


export type QueryQctSearchQContentAuditLogsArgs = {
  input: SearchQContentAuditLogsInputType;
};


export type QueryQctSearchQuestionGroupsArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search?: SearchQuestionGroupsInput;
};


export type QueryQctSearchQuestionsArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search?: SearchQuestionsInput;
};


export type QueryQctSearchQuestionsByKeywordArgs = {
  input: SearchQuestionsByKeywordInput;
  paging?: PageInput;
};


export type QueryQctSearchQuestionsByQIdsArgs = {
  input: SearchQuestionsByQIdsInput;
  paging?: PageInput;
};


export type QueryQctSearchQuestionsInLearningObjectiveStatementArgs = {
  order?: OrderInput;
  paging?: PageInput;
  search: SearchQuestionsInLearningObjectiveStatementInput;
};


export type QuerySuGetAppRoleArgs = {
  appRoleId: Scalars['String']['input'];
};


export type QuerySuUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryValidateTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryWflGetDownloadSignedUrlForTaskArgs = {
  input: GetDownloadSignedUrlForTaskInput;
};


export type QueryWflGetMyTasksArgs = {
  getMyTasksInput: GetMyTasksInput;
};


export type QueryWflGetQSetTaskReviewSummaryArgs = {
  getQSetTaskReviewSummaryInput: GetQSetTaskReviewSummaryInput;
};


export type QueryWflGetStepTransitionsByTaskIdArgs = {
  getStepTransitionsByTaskIdInput: GetStepTransitionsByTaskIdInput;
};


export type QueryWflGetTaskByIdArgs = {
  getTaskByIdInput: GetTaskByIdInput;
};


export type QueryWflGetTaskCommentsArgs = {
  getTaskCommentsInputType: GetTaskCommentsInput;
};


export type QueryWflGetTaskReviewResultsArgs = {
  getTaskReviewResultsInput: GetTaskReviewResultsInput;
};


export type QueryWflGetTaskVerdictArgs = {
  getTaskVerdictInput: GetTaskVerdictInput;
};


export type QueryWflGetTasksByEntityWithParentArgs = {
  getTasksByEntityWithParentInput: GetTasksByEntityInput;
};


export type QueryWflGetUploadSignedUrlForQuestionCreationTaskArgs = {
  input: GetUploadSignedUrlForQuestionCreationTaskInput;
};


export type QueryWflGetUploadSignedUrlForTaskArgs = {
  input: GetUploadSignedUrlForTaskInput;
};


export type QueryWflSearchMyTasksArgs = {
  searchMyTasksInput: SearchMyTasksInput;
};


export type QueryWflSearchOwnedAndAssignedTasksArgs = {
  searchOwnedAndAssignedTasksInput: SearchOwnedAndAssignedTasksInput;
};

export type Question = {
  __typename?: 'Question';
  bIndexValue: Maybe<Scalars['Float']['output']>;
  correctAnswer: QuestionCorrectAnswer;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  details: Scalars['String']['output'];
  disabledAt: Maybe<Scalars['DateTime']['output']>;
  disabledBy: Maybe<Scalars['String']['output']>;
  groupOrder: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  lastPublishedAt: Maybe<Scalars['DateTime']['output']>;
  lastPublishedBy: Maybe<Scalars['String']['output']>;
  lastUnpublishedAt: Maybe<Scalars['DateTime']['output']>;
  lastUnpublishedBy: Maybe<Scalars['String']['output']>;
  learningObjectiveStatement: Maybe<LearningObjectiveStatement>;
  metadata: QuestionMetadata;
  pInitial: Maybe<Scalars['Float']['output']>;
  pType: Maybe<QuestionPType>;
  pValue: Maybe<Scalars['Float']['output']>;
  questionGroup: Maybe<QuestionGroup>;
  questionGroupId: Scalars['String']['output'];
  questionStructures: Maybe<Array<QuestionStructure>>;
  refCode: Scalars['String']['output'];
  refQBankStructureId: Scalars['String']['output'];
  refQuestion: Maybe<Question>;
  refQuestionId: Maybe<Scalars['String']['output']>;
  solution: Maybe<QuestionSolution>;
  status: QuestionStatus;
  tagIds: Maybe<Array<Scalars['String']['output']>>;
  tags: Array<Tag>;
  taskComments: Array<QuestionComment>;
  taskVerdicts: Array<QuestionVerdict>;
  type: QuestionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestionChoice = {
  __typename?: 'QuestionChoice';
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type QuestionChoiceInput = {
  label: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuestionComment = {
  __typename?: 'QuestionComment';
  content: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  entityType: CommentEntityType;
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type QuestionCorrectAnswer = {
  __typename?: 'QuestionCorrectAnswer';
  value: Scalars['String']['output'];
};

export type QuestionCorrectAnswerInput = {
  value: Scalars['String']['input'];
};

export enum QuestionCreationTaskContentType {
  Gif = 'gif',
  Jpeg = 'jpeg',
  Png = 'png',
  Webp = 'webp'
}

export type QuestionDetailsResult = {
  __typename?: 'QuestionDetailsResult';
  groupOrder: Scalars['Int']['output'];
  metadata: Scalars['JSON']['output'];
  order: Scalars['Int']['output'];
  pValue: Scalars['Float']['output'];
  questionGroupId: Scalars['String']['output'];
  questionGroupType: QSetQuestionGroupType;
  questionId: Scalars['String']['output'];
  questionRefCode: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type QuestionFileInput = {
  fileNames: Array<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
};

export type QuestionGroup = {
  __typename?: 'QuestionGroup';
  disabledAt: Maybe<Scalars['DateTime']['output']>;
  disabledBy: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastPublishedAt: Maybe<Scalars['DateTime']['output']>;
  lastPublishedBy: Maybe<Scalars['String']['output']>;
  lastUnpublishedAt: Maybe<Scalars['DateTime']['output']>;
  lastUnpublishedBy: Maybe<Scalars['String']['output']>;
  metadata: Maybe<QuestionGroupMetadata>;
  name: Scalars['String']['output'];
  questionStructures: Array<QuestionStructure>;
  questions: Maybe<Array<Question>>;
  refCode: Scalars['String']['output'];
  refQBankStructureId: Scalars['String']['output'];
  size: Maybe<Scalars['Int']['output']>;
  status: QuestionGroupStatus;
  totalQuestions: Scalars['Float']['output'];
  type: QuestionGroupType;
  updatedAt: Scalars['DateTime']['output'];
};

export type QuestionGroupFileInput = {
  fileNames: Array<Scalars['String']['input']>;
  questionGroupId: Scalars['String']['input'];
};

export type QuestionGroupMetadata = {
  __typename?: 'QuestionGroupMetadata';
  paragraph: Maybe<Scalars['String']['output']>;
};

export enum QuestionGroupStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  InDevelopment = 'IN_DEVELOPMENT',
  InReview = 'IN_REVIEW',
  Na = 'NA',
  PreDraft = 'PRE_DRAFT',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export enum QuestionGroupType {
  ItemSet = 'ITEM_SET',
  LotOfQuestion = 'LOT_OF_QUESTION',
  Single = 'SINGLE'
}

export type QuestionGroupsResult = {
  __typename?: 'QuestionGroupsResult';
  questionGroups: Array<QuestionGroup>;
  total: Scalars['Float']['output'];
};

export enum QuestionImportType {
  ItemSet = 'ITEM_SET',
  SingleAndLoq = 'SINGLE_AND_LOQ'
}

export type QuestionInputData = {
  audit1?: InputMaybe<Scalars['String']['input']>;
  audit2?: InputMaybe<Scalars['String']['input']>;
  audit3?: InputMaybe<Scalars['String']['input']>;
  bIndexValue?: InputMaybe<Scalars['Float']['input']>;
  calculated?: InputMaybe<Scalars['Boolean']['input']>;
  choices: Array<QuestionChoiceInput>;
  cognitiveDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  correctAnswer: QuestionCorrectAnswerInput;
  details: Scalars['String']['input'];
  group: QuestionInputGroup;
  learningObjectiveStatement?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  pInitial?: InputMaybe<Scalars['Float']['input']>;
  pStats?: InputMaybe<Array<QuestionPStatInputData>>;
  pType?: InputMaybe<QuestionPType>;
  pValue?: InputMaybe<Scalars['Float']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionInputGroup = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type: QuestionGroupType;
};

export type QuestionKeywordSearchItemDto = {
  __typename?: 'QuestionKeywordSearchItemDTO';
  bIndexValue: Maybe<Scalars['Float']['output']>;
  correctAnswer: QuestionSearchCorrectAnswerDto;
  createdBy: Scalars['String']['output'];
  details: Scalars['String']['output'];
  groupOrder: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  lastPublishedAt: Maybe<Scalars['String']['output']>;
  lastPublishedBy: Maybe<Scalars['String']['output']>;
  locationIds: Array<Scalars['String']['output']>;
  metadata: QuestionSearchMetadataDto;
  pValue: Maybe<Scalars['Float']['output']>;
  questionGroup: Maybe<QuestionSearchGroupDto>;
  questionGroupId: Scalars['String']['output'];
  refCode: Scalars['String']['output'];
  refQBankStructureId: Scalars['String']['output'];
  solution: Maybe<QuestionSearchSolutionDto>;
  status: Scalars['String']['output'];
  tags: Array<QuestionSearchTagDto>;
  type: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['String']['output']>;
};

export type QuestionKeywordSearchResultDto = {
  __typename?: 'QuestionKeywordSearchResultDTO';
  items: Array<QuestionKeywordSearchItemDto>;
  total: Scalars['Int']['output'];
};

export type QuestionMetadata = {
  __typename?: 'QuestionMetadata';
  audit1: Maybe<Scalars['String']['output']>;
  audit2: Maybe<Scalars['String']['output']>;
  audit3: Maybe<Scalars['String']['output']>;
  choices: Array<QuestionChoice>;
  owner: Maybe<QuestionOwner>;
  pStats: Maybe<Array<QuestionPStats>>;
  reference: Maybe<Scalars['String']['output']>;
};

export type QuestionOwner = {
  __typename?: 'QuestionOwner';
  type: QuestionOwnerType;
  value: Maybe<Scalars['String']['output']>;
};

export enum QuestionOwnerType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type QuestionPStatInputData = {
  calculatedAt: Scalars['DateTime']['input'];
  firstUsedAt?: InputMaybe<Scalars['DateTime']['input']>;
  pValue: Scalars['Float']['input'];
  sampleSize: Scalars['Float']['input'];
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy: Scalars['String']['input'];
  updatedUserFullName: Scalars['String']['input'];
};

export type QuestionPStats = {
  __typename?: 'QuestionPStats';
  calculatedAt: Scalars['DateTime']['output'];
  firstUsedAt: Maybe<Scalars['DateTime']['output']>;
  pValue: Scalars['Float']['output'];
  sampleSize: Scalars['Float']['output'];
  selected: Maybe<Scalars['Boolean']['output']>;
  updatedBy: Scalars['String']['output'];
  updatedUserFullName: Scalars['String']['output'];
};

export enum QuestionPType {
  PInitial = 'P_INITIAL',
  PStat = 'P_STAT'
}

export type QuestionSearchChoiceDto = {
  __typename?: 'QuestionSearchChoiceDTO';
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export type QuestionSearchCorrectAnswerDto = {
  __typename?: 'QuestionSearchCorrectAnswerDTO';
  value: Maybe<Scalars['String']['output']>;
};

export enum QuestionSearchField {
  Choices = 'CHOICES',
  Paragraph = 'PARAGRAPH',
  Question = 'QUESTION',
  Reference = 'REFERENCE',
  Solution = 'SOLUTION'
}

export type QuestionSearchGroupDto = {
  __typename?: 'QuestionSearchGroupDTO';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paragraph: Maybe<Scalars['String']['output']>;
  size: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type QuestionSearchMetadataDto = {
  __typename?: 'QuestionSearchMetadataDTO';
  audit1: Maybe<Scalars['String']['output']>;
  audit2: Maybe<Scalars['String']['output']>;
  audit3: Maybe<Scalars['String']['output']>;
  choices: Array<QuestionSearchChoiceDto>;
  firstPublishedAt: Maybe<Scalars['String']['output']>;
  owner: Maybe<QuestionSearchOwnerDto>;
  reference: Maybe<Scalars['String']['output']>;
};

export type QuestionSearchOwnerDto = {
  __typename?: 'QuestionSearchOwnerDTO';
  type: Scalars['String']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type QuestionSearchSolutionDto = {
  __typename?: 'QuestionSearchSolutionDTO';
  type: Scalars['String']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type QuestionSearchTagDto = {
  __typename?: 'QuestionSearchTagDTO';
  category: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type QuestionSnapshotCorrectAnswer = {
  __typename?: 'QuestionSnapshotCorrectAnswer';
  value: Scalars['String']['output'];
};

export type QuestionSnapshotStructure = {
  __typename?: 'QuestionSnapshotStructure';
  entityId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  refLevelItemId: Scalars['String']['output'];
  refSource: Scalars['String']['output'];
};

export type QuestionSolution = {
  __typename?: 'QuestionSolution';
  type: Maybe<QuestionSolutionType>;
  value: Maybe<Scalars['String']['output']>;
};

export enum QuestionSolutionType {
  Html = 'HTML'
}

export enum QuestionStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  InDevelopment = 'IN_DEVELOPMENT',
  InReview = 'IN_REVIEW',
  PreDraft = 'PRE_DRAFT',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type QuestionStructure = {
  __typename?: 'QuestionStructure';
  entityId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  levelItem: Maybe<QBankStructureLevelItem>;
  refLevelItemId: Scalars['String']['output'];
  refSource: Scalars['String']['output'];
};

export type QuestionTag = {
  __typename?: 'QuestionTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum QuestionTagCategory {
  Calculation = 'CALCULATION',
  CognitiveDomain = 'COGNITIVE_DOMAIN',
  Difficulty = 'DIFFICULTY'
}

export enum QuestionType {
  MultipleChoice = 'MULTIPLE_CHOICE'
}

export type QuestionVerdict = {
  __typename?: 'QuestionVerdict';
  entityId: Scalars['String']['output'];
  entityType: VerdictEntityType;
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  verdict: Verdict;
};

export type QuestionsResult = {
  __typename?: 'QuestionsResult';
  questions: Array<Question>;
  total: Scalars['Float']['output'];
};

export type QuickCreateInput = {
  blockedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QuickCreateUserObjectType = {
  __typename?: 'QuickCreateUserObjectType';
  appRolesResponse: AssignUserAppRolesMutationResponse;
  code: Scalars['String']['output'];
  createdUser: UserAppRoleView;
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RandomPreviewQuestionsByTaskIdInput = {
  options?: InputMaybe<RandomPreviewQuestionsByTaskIdInputOptions>;
  taskId: Scalars['String']['input'];
};

export type RandomPreviewQuestionsByTaskIdInputOptions = {
  isRandom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RandomPreviewQuestionsByTaskIdOutput = {
  __typename?: 'RandomPreviewQuestionsByTaskIdOutput';
  randomPreviewQuestionIds: Array<Scalars['String']['output']>;
};

export type RawUser = {
  __typename?: 'RawUser';
  appPermissions: Array<Scalars['String']['output']>;
  appRoles: Array<Scalars['String']['output']>;
  blockedUntil: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  expireAt: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['String']['output']>;
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  isPassportUser: Scalars['Boolean']['output'];
  isPasswordCreatedByUser: Scalars['Boolean']['output'];
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type RemoveUsersContentVisibilityInput = {
  contentId: Scalars['String']['input'];
  contentType: ContentType;
  parentContentId?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<Scalars['String']['input']>;
};

export type RemoveUsersContentVisibilityResult = {
  __typename?: 'RemoveUsersContentVisibilityResult';
  removedContentVisibilities: Array<ContentVisibility>;
  total: Scalars['Int']['output'];
};

export type ResendResetPasswordEmailOutputObjectType = {
  __typename?: 'ResendResetPasswordEmailOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResendResetPasswordUserLockedOutputObjectType = {
  __typename?: 'ResendResetPasswordUserLockedOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordOutputObjectType = {
  __typename?: 'ResetPasswordOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResetUserTwoFactorInput = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ResetUserTwoFactorOutputObjectType = {
  __typename?: 'ResetUserTwoFactorOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user: UserAppRoleView;
};

export type SetUser = {
  __typename?: 'SETUser';
  appPermissions: Array<Scalars['String']['output']>;
  appRoles: Array<Scalars['String']['output']>;
  blockedUntil: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  expireAt: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['String']['output']>;
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  isPassportUser: Scalars['Boolean']['output'];
  isPasswordCreatedByUser: Scalars['Boolean']['output'];
  lastLoginAt: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SaveAsInput = {
  levelItems: Array<SaveAsLevelItemInput>;
  qBankStructureId: Scalars['String']['input'];
};

export type SaveAsLevelItemInput = {
  id: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  parentLevelItemId?: InputMaybe<Scalars['String']['input']>;
  qBankStructureLevelId: Scalars['String']['input'];
  tag?: InputMaybe<SaveAsTagInput>;
};

export type SaveAsTagInput = {
  name: Scalars['String']['input'];
};

export type SaveItemSetAsDraftInput = {
  groupOrders?: InputMaybe<Array<GroupOrderInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  paragraph?: InputMaybe<Scalars['String']['input']>;
  questionGroupId: Scalars['String']['input'];
};

export type SaveItemSetAsUnpublishInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  paragraph?: InputMaybe<Scalars['String']['input']>;
};

export type SaveQuestionAsDraftInput = {
  data: QuestionInputData;
  id: Scalars['String']['input'];
  qBankStructureLevelItemId: Scalars['String']['input'];
};

export type SaveQuestionAsUnpublishInput = {
  data: QuestionInputData;
  id: Scalars['String']['input'];
};

export type SearchExamCourseGroupsByNameInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SearchExamCourseGroupsByNameOutput = {
  __typename?: 'SearchExamCourseGroupsByNameOutput';
  tags: Array<Tag>;
};

export type SearchExamCoursesInput = {
  filter?: InputMaybe<SearchFilterInput>;
  groupTagId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchExamCoursesOutput = {
  __typename?: 'SearchExamCoursesOutput';
  examCourses: Array<ExamCourse>;
  total: Scalars['Float']['output'];
};

export type SearchFilterInput = {
  conditions?: InputMaybe<Array<FilterConditionInput>>;
  searchText?: InputMaybe<SearchTextInput>;
};

export type SearchInput = {
  operator: OperatorType;
  value: Scalars['String']['input'];
};

export type SearchLearningObjectiveStatementsInput = {
  chapterLevelItemId?: InputMaybe<Scalars['String']['input']>;
  qBankStructureId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LearningObjectiveStatementStatus>;
};

export type SearchMyTasksFilterInput = {
  status: TaskStatus;
};

export type SearchMyTasksInput = {
  filter: SearchMyTasksFilterInput;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchMyTasksOutput = {
  __typename?: 'SearchMyTasksOutput';
  tasks: Array<Task>;
  total: Scalars['Float']['output'];
};

export type SearchOwnedAndAssignedTasksInput = {
  currentWorkflowStepCode?: InputMaybe<Array<WorkflowStepCode>>;
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
  workflowCode?: InputMaybe<WorkflowCode>;
};

export type SearchOwnedAndAssignedTasksOutput = {
  __typename?: 'SearchOwnedAndAssignedTasksOutput';
  tasks: Array<Task>;
  total: Scalars['Float']['output'];
};

export type SearchParams = {
  keyword: Scalars['String']['input'];
  matchFields: Array<QuestionSearchField>;
  qBankStructureCodes: Array<Scalars['String']['input']>;
  questionStatuses: Array<QuestionStatus>;
};

export type SearchQBankStructureAuditLogOutput = {
  __typename?: 'SearchQBankStructureAuditLogOutput';
  qBankStructureAuditLogs: Array<QBankStructureAuditLog>;
  total: Scalars['Float']['output'];
};

export type SearchQBankStructureAuditLogsInputType = {
  filter?: InputMaybe<QBankStructureAuditLogSearchFilterInput>;
  order?: InputMaybe<QBankStructureAuditLogOrderInput>;
  paging?: InputMaybe<QBankStructureAuditLogPagingInput>;
  qBankStructureId: Scalars['String']['input'];
};

export type SearchQBankStructureGroupTagInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SearchQBankStructureInput = {
  groupTagId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<QBankStructureStatus>>;
  type?: InputMaybe<Array<QBankStructureType>>;
};

export type SearchQConfigAuditLogInput = {
  filter?: InputMaybe<SearchFilterInput>;
  jsonContainsFilter?: InputMaybe<JsonContainsFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchQConfigAuditLogOutput = {
  __typename?: 'SearchQConfigAuditLogOutput';
  qConfigAuditLogs: Array<QConfigAuditLog>;
  total: Scalars['Float']['output'];
};

export type SearchQConfigGeneratorsInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchQConfigGeneratorsOutput = {
  __typename?: 'SearchQConfigGeneratorsOutput';
  qConfigGenerators: Array<QConfigGenerator>;
  total: Scalars['Int']['output'];
};

export type SearchQConfigsInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchQConfigsOutput = {
  __typename?: 'SearchQConfigsOutput';
  qConfigs: Array<QConfig>;
  total: Scalars['Float']['output'];
};

export type SearchQContentAuditLogOutput = {
  __typename?: 'SearchQContentAuditLogOutput';
  qContentAuditLogs: Array<QContentAuditLogObjectType>;
  total: Scalars['Float']['output'];
};

export type SearchQContentAuditLogsInputType = {
  filter?: InputMaybe<QContentAuditLogSearchFilterInput>;
  order?: InputMaybe<QContentAuditLogOrderInput>;
  paging?: InputMaybe<QContentAuditLogPagingInput>;
  questionGroupId?: InputMaybe<Scalars['String']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
};

export type SearchQSetAuditLogInput = {
  filter?: InputMaybe<SearchFilterInput>;
  jsonContainsFilter?: InputMaybe<JsonContainsFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchQSetAuditLogOutput = {
  __typename?: 'SearchQSetAuditLogOutput';
  qSetAuditLogs: Array<QSetAuditLog>;
  total: Scalars['Float']['output'];
};

export type SearchQSetQuestionsInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchQSetQuestionsInputWithTaskIdInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
  qSetId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type SearchQSetQuestionsOutput = {
  __typename?: 'SearchQSetQuestionsOutput';
  qSetQuestions: Array<QSetQuestion>;
  total: Scalars['Float']['output'];
};

export type SearchQSetsInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchQSetsOutput = {
  __typename?: 'SearchQSetsOutput';
  qSets: Array<QSet>;
  total: Scalars['Int']['output'];
};

export type SearchQuestionGroupsInput = {
  levelItemId?: InputMaybe<Scalars['String']['input']>;
  questionGroupType?: InputMaybe<Array<QuestionGroupType>>;
  questionRefCode?: InputMaybe<Array<Scalars['String']['input']>>;
  refCode?: InputMaybe<Array<Scalars['String']['input']>>;
  refQBankStructureId?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<QuestionGroupStatus>>;
};

export type SearchQuestionsByKeywordInput = {
  fields?: InputMaybe<Array<QuestionSearchField>>;
  keyword: Scalars['String']['input'];
  refQBankStructureIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<QuestionStatus>>;
};

export type SearchQuestionsByQIdsInput = {
  qIds: Array<Scalars['String']['input']>;
};

export type SearchQuestionsByQIdsResultDto = {
  __typename?: 'SearchQuestionsByQIdsResultDTO';
  /** Input QIDs that matched at least one question. */
  foundQIds: Array<Scalars['String']['output']>;
  items: Array<QuestionKeywordSearchItemDto>;
  /** Input QIDs with no matching question (render as red chips). */
  notFoundQIds: Array<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type SearchQuestionsInLearningObjectiveStatementInput = {
  learningObjectiveStatementId: Scalars['String']['input'];
};

export type SearchQuestionsInput = {
  levelItemId?: InputMaybe<Scalars['String']['input']>;
  questionGroupName?: InputMaybe<Scalars['String']['input']>;
  questionGroupType?: InputMaybe<Array<QuestionGroupType>>;
  refCode?: InputMaybe<Array<Scalars['String']['input']>>;
  refQBankStructureId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<QuestionStatus>>;
};

export type SearchTagsInput = {
  category?: InputMaybe<TagCategory>;
};

export type SearchTaskTagsInput = {
  category: QuestionTagCategory;
};

export type SearchTextInput = {
  /** Fields to search in */
  fields: Array<Scalars['String']['input']>;
  /** Search text */
  value: Scalars['String']['input'];
};

export type SearchUsersContentVisibilityInput = {
  contentId: Scalars['String']['input'];
  contentType: ContentType;
  isInvertUserFilter?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  parentContentId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withUserDetails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SingleQuestionProperties = {
  __typename?: 'SingleQuestionProperties';
  tags: Array<QuestionTag>;
  totalQuestions: Scalars['Int']['output'];
};

export type SingleQuestionPropertiesByLocation = {
  __typename?: 'SingleQuestionPropertiesByLocation';
  locationId: Scalars['String']['output'];
  locationType: SingleQuestionPropertiesLocationType;
  questionProperties: Array<SingleQuestionProperties>;
};

export enum SingleQuestionPropertiesLocationType {
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  QbankStructureLevelItem = 'QBANK_STRUCTURE_LEVEL_ITEM'
}

export enum SingleQuestionPropertiesStatus {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type SingleQuestionQuestionGroupProperties = {
  __typename?: 'SingleQuestionQuestionGroupProperties';
  questionGroupType: QuestionGroupType;
  questionProperties: Array<SingleQuestionProperties>;
  totalQuestionGroups: Scalars['Int']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type SingleQuestionQuestionGroupPropertiesByLocation = {
  __typename?: 'SingleQuestionQuestionGroupPropertiesByLocation';
  locationId: Scalars['String']['output'];
  locationType: SingleQuestionPropertiesLocationType;
  questionGroupProperties: Array<SingleQuestionQuestionGroupProperties>;
};

export type StepTransition = {
  __typename?: 'StepTransition';
  appPermissionIds: Maybe<Array<Scalars['String']['output']>>;
  condition: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type StorageObject = {
  __typename?: 'StorageObject';
  bucket: Scalars['String']['output'];
  fileName: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  provider: StorageProvider;
};

export enum StorageProvider {
  GcloudStorage = 'GCLOUD_STORAGE'
}

export type StructureCriteriaInput = {
  passingCriteria?: InputMaybe<PassingCriteriaInput>;
  structureId: Scalars['String']['input'];
};

export enum SubmitQSetReviewErrorCode {
  MissingVerdict = 'MISSING_VERDICT',
  TaskOverdue = 'TASK_OVERDUE'
}

export type SubmitQSetReviewInput = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  taskId: Scalars['String']['input'];
};

export type SubmitQSetReviewOutput = {
  __typename?: 'SubmitQSetReviewOutput';
  code: Maybe<SubmitQSetReviewErrorCode>;
  message: Scalars['String']['output'];
  missingQuestionVerdictCount: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
  task: Task;
};

export enum SubmitQuestionReviewErrorCode {
  MissingVerdict = 'MISSING_VERDICT',
  TaskOverdue = 'TASK_OVERDUE'
}

export type SubmitQuestionReviewInput = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  taskId: Scalars['String']['input'];
};

export type SubmitQuestionReviewOutput = {
  __typename?: 'SubmitQuestionReviewOutput';
  code: Maybe<SubmitQuestionReviewErrorCode>;
  message: Scalars['String']['output'];
  missingQuestionVerdictCount: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
  task: Task;
};

export type Tag = {
  __typename?: 'Tag';
  category: TagCategory;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Maybe<Scalars['String']['output']>;
};

export enum TagCategory {
  Calculation = 'CALCULATION',
  CognitiveDomain = 'COGNITIVE_DOMAIN',
  Difficulty = 'DIFFICULTY',
  ExamCourseGroup = 'EXAM_COURSE_GROUP',
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  QbankStructureGroup = 'QBANK_STRUCTURE_GROUP',
  QbankStructureLevel = 'QBANK_STRUCTURE_LEVEL'
}

export type TagEntity = {
  __typename?: 'TagEntity';
  entityId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  tag: Tag;
  tagId: Scalars['String']['output'];
};

export type TagGroup = {
  __typename?: 'TagGroup';
  count: Scalars['Int']['output'];
  tags: Array<QuestionTag>;
};

export type TagResult = {
  __typename?: 'TagResult';
  tags: Array<Tag>;
  total: Scalars['Int']['output'];
};

export type Task = {
  __typename?: 'Task';
  actorId: Maybe<Scalars['String']['output']>;
  assignedAt: Scalars['DateTime']['output'];
  assignee: RawUser;
  assigneeId: Scalars['String']['output'];
  assigner: RawUser;
  assignerId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  completedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentWorkflowStep: WorkflowStep;
  currentWorkflowStepId: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  metadata: TaskMetadata;
  name: Maybe<Scalars['String']['output']>;
  owner: RawUser;
  ownerId: Scalars['String']['output'];
  parentId: Maybe<Scalars['String']['output']>;
  parentTask: Maybe<Task>;
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: TaskStatus;
  submittedAt: Maybe<Scalars['DateTime']['output']>;
  subtaskCount: Scalars['Float']['output'];
  subtasks: Array<Task>;
  taskEntities: Array<TaskEntity>;
  updatedAt: Scalars['DateTime']['output'];
  workflowId: Scalars['String']['output'];
};

export type TaskComment = {
  __typename?: 'TaskComment';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: RawUser;
  userId: Scalars['String']['output'];
};

export type TaskDetailsForItemSetCreationInput = {
  targetSize: Scalars['Float']['input'];
  taskId: Scalars['String']['input'];
};

export type TaskEntity = {
  __typename?: 'TaskEntity';
  entityId: Scalars['String']['output'];
  entityType: EntityType;
  id: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
};

export type TaskMetadata = TaskMetadataWithAdditionalData | TaskMetadataWithExamCourse | TaskMetadataWithQSet | TaskMetadataWithQuestionCreation | TaskMetadataWithQuestionReviewed | TaskMetadataWithReviewQuestion;

export type TaskMetadataWithAdditionalData = {
  __typename?: 'TaskMetadataWithAdditionalData';
  additionalData: Scalars['JSON']['output'];
};

export type TaskMetadataWithExamCourse = {
  __typename?: 'TaskMetadataWithExamCourse';
  examCourse: ExamCourseTask;
  subtaskEntityQuantity: Scalars['Float']['output'];
};

export type TaskMetadataWithQSet = {
  __typename?: 'TaskMetadataWithQSet';
  qSet: QSetTask;
};

export type TaskMetadataWithQuestionCreation = {
  __typename?: 'TaskMetadataWithQuestionCreation';
  details: Maybe<Scalars['String']['output']>;
  itemSetCondition: Maybe<Array<ItemSetCondition>>;
  itemSetCreation: Maybe<Array<ItemSetCreation>>;
  qBankStructure: Maybe<QBankStructureTask>;
  questionCreationCount: Scalars['Float']['output'];
  requiredQuestionCount: Maybe<Scalars['Float']['output']>;
};

export type TaskMetadataWithQuestionReviewed = {
  __typename?: 'TaskMetadataWithQuestionReviewed';
  reviewedQuestionCount: Scalars['Int']['output'];
};

export type TaskMetadataWithReviewQuestion = {
  __typename?: 'TaskMetadataWithReviewQuestion';
  qBankStructure: Maybe<QBankStructureTask>;
  questionQuantity: Scalars['Int']['output'];
  subtaskEntityQuantity: Scalars['Float']['output'];
};

export type TaskQConfigConditionTag = {
  __typename?: 'TaskQConfigConditionTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum TaskStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Todo = 'TODO'
}

export type TaskWithSubtasks = {
  __typename?: 'TaskWithSubtasks';
  actorId: Maybe<Scalars['String']['output']>;
  assignedAt: Scalars['DateTime']['output'];
  assignee: RawUser;
  assigneeId: Scalars['String']['output'];
  assigner: RawUser;
  assignerId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  completedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentWorkflowStep: WorkflowStep;
  currentWorkflowStepId: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  metadata: TaskMetadata;
  name: Maybe<Scalars['String']['output']>;
  owner: RawUser;
  ownerId: Scalars['String']['output'];
  parentId: Maybe<Scalars['String']['output']>;
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: TaskStatus;
  submittedAt: Maybe<Scalars['DateTime']['output']>;
  subtasks: Array<TaskWithSubtasks>;
  updatedAt: Scalars['DateTime']['output'];
  workflowId: Scalars['String']['output'];
};

export type TimeLimitInput = {
  type: QConfigTimeLimitType;
  values: Array<TimeLimitValueInput>;
};

export type TimeLimitValueInput = {
  order: Scalars['Int']['input'];
  qConfigStructureIds?: InputMaybe<Array<Scalars['String']['input']>>;
  value: Scalars['Int']['input'];
};

export type TokenStatus = {
  __typename?: 'TokenStatus';
  email: Maybe<Scalars['String']['output']>;
  scopes: Maybe<Array<Scalars['String']['output']>>;
  ttl: Maybe<Scalars['Float']['output']>;
  twoFactorStatus: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type UnassignUserAppRoleInput = {
  appRoleId: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UnassignUserAppRolesInput = {
  appRoleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UnassignUserAppRolesMutationResponse = {
  __typename?: 'UnassignUserAppRolesMutationResponse';
  appRoles: Array<AppRole>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UnlockUserTwoFactorInput = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UnlockUserTwoFactorOutputObjectType = {
  __typename?: 'UnlockUserTwoFactorOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user: UserAppRoleView;
};

export type UpdateAndCreateSubtasks = {
  assigneeId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['DateTime']['input'];
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EntityType>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAndCreateSubtasksInput = {
  mainTaskId: Scalars['String']['input'];
  subtasks: Array<UpdateAndCreateSubtasks>;
  workflowCode: WorkflowCode;
};

export type UpdateAndCreateSubtasksOutput = {
  __typename?: 'UpdateAndCreateSubtasksOutput';
  subtasks: Array<Task>;
};

export type UpdateAppRoleAppPermissionsMutationResponse = {
  __typename?: 'UpdateAppRoleAppPermissionsMutationResponse';
  appPermission: Array<AppPermission>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateAppRoleInput = {
  appRoleId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateAppRoleMutationResponse = {
  __typename?: 'UpdateAppRoleMutationResponse';
  appRole: AppRole;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateContentVisibilityInputObject = {
  contentId: Scalars['String']['input'];
  contentType: ContentType;
  parentContentId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContentVisibilityObject = {
  __typename?: 'UpdateContentVisibilityObject';
  contentId: Scalars['String']['output'];
  contentType: ContentType;
  parentContentId: Maybe<Scalars['String']['output']>;
};

export type UpdateDueDateTaskAndSubtasksInput = {
  dueDate: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
};

export type UpdateExamUsageOfQSetsInput = {
  qSetIds: Array<Scalars['String']['input']>;
  toExamUsageStatus: ExamUsageStatus;
};

export type UpdateExamUsageOfQSetsOutput = {
  __typename?: 'UpdateExamUsageOfQSetsOutput';
  qSets: Array<QSet>;
};

export type UpdateItemSetQuestionQConfigStructureConditionInput = {
  needTotal: Scalars['Int']['input'];
  tagGroups: Array<UpdateItemSetQuestionQConfigStructureConditionTagGroupInput>;
};

export type UpdateItemSetQuestionQConfigStructureConditionTagGroupInput = {
  count: Scalars['Int']['input'];
  tagIds: Array<Scalars['String']['input']>;
};

export type UpdateItemSetQuestionQConfigStructureInput = {
  conditions: Array<UpdateItemSetQuestionQConfigStructureConditionInput>;
  id: Scalars['String']['input'];
  location: UpdateItemSetQuestionQConfigStructureLocationInput;
  scorePerQuestion: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type UpdateItemSetQuestionQConfigStructureLocationInput = {
  locationType: UpdateQuestionQConfigStructureLocationTypeInput;
  losIds?: InputMaybe<Array<Scalars['String']['input']>>;
  qBankStructureLevelItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateItemSetQuestionQConfigStructureOutput = {
  __typename?: 'UpdateItemSetQuestionQConfigStructureOutput';
  qConfig: QConfig;
};

export type UpdateLearningObjectiveStatementInput = {
  chapterLevelItemId: Scalars['String']['input'];
  learningObjectiveStatementId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  qBankStructureId: Scalars['String']['input'];
};

export type UpdateOrCreateExamCourseVerdictInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  taskId: Scalars['String']['input'];
  verdict: Verdict;
};

export type UpdateOrCreateExamCourseVerdictOutput = {
  __typename?: 'UpdateOrCreateExamCourseVerdictOutput';
  verdict: ExamCourseVerdictOutput;
};

export type UpdateQBankStructureAsArchivedInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupTag?: InputMaybe<QBankStructureGroupTagInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQBankStructureAsDraftInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupTag?: InputMaybe<QBankStructureGroupTagInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QBankStructureType>;
};

export type UpdateQBankStructureAsPublishedInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupTag?: InputMaybe<QBankStructureGroupTagInput>;
  id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQBankStructureAsUnpublishedInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupTag?: InputMaybe<QBankStructureGroupTagInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQBankStructureLevelInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type UpdateQBankStructureLevelsByQBankStructureIdInput = {
  qBankStructureId: Scalars['String']['input'];
  qBankStructureLevels: Array<UpdateQBankStructureLevelInput>;
};

export type UpdateQConfigAsDraftInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  qConfigId: Scalars['String']['input'];
  totalQuestions?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateQConfigAsDraftOutput = {
  __typename?: 'UpdateQConfigAsDraftOutput';
  qConfig: QConfig;
};

export type UpdateQConfigSettingsAsDraftInput = {
  passingCriteria?: InputMaybe<PassingCriteriaInput>;
  qConfigId: Scalars['String']['input'];
  randomType?: InputMaybe<QConfigRandomType>;
  structurePassingCriteria?: InputMaybe<Array<StructureCriteriaInput>>;
  timeLimit?: InputMaybe<TimeLimitInput>;
};

export type UpdateQConfigSettingsAsDraftOutput = {
  __typename?: 'UpdateQConfigSettingsAsDraftOutput';
  qConfig: QConfig;
};

export type UpdateQConfigStructureNamesInput = {
  qConfigId: Scalars['String']['input'];
  structures: Array<QConfigStructureNameInput>;
};

export type UpdateQConfigStructureNamesOutput = {
  __typename?: 'UpdateQConfigStructureNamesOutput';
  qConfigStructures: Array<QConfigStructure>;
};

export type UpdateQuestionCreationTaskInput = {
  assigneeId: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type UpdateQuestionCreationTaskOutputDto = {
  __typename?: 'UpdateQuestionCreationTaskOutputDTO';
  task: Task;
};

export enum UpdateQuestionQConfigStructureLocationTypeInput {
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  QbankStructureLevelItem = 'QBANK_STRUCTURE_LEVEL_ITEM'
}

export type UpdateSingleQuestionQConfigStructureConditionInput = {
  needTotal: Scalars['Int']['input'];
  tagIds: Array<Scalars['String']['input']>;
};

export type UpdateSingleQuestionQConfigStructureInput = {
  conditions: Array<UpdateSingleQuestionQConfigStructureConditionInput>;
  id: Scalars['String']['input'];
  location: UpdateSingleQuestionQConfigStructureLocationInput;
  scorePerQuestion: Scalars['Int']['input'];
};

export type UpdateSingleQuestionQConfigStructureLocationInput = {
  locationType: UpdateQuestionQConfigStructureLocationTypeInput;
  losIds?: InputMaybe<Array<Scalars['String']['input']>>;
  qBankStructureLevelItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSingleQuestionQConfigStructureOutput = {
  __typename?: 'UpdateSingleQuestionQConfigStructureOutput';
  qConfig: QConfig;
};

export type UpdateSubtaskInput = {
  assigneeId: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  id: Scalars['String']['input'];
};

export type UpdateSubtasksAndCreateSubtasks = {
  assigneeId: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubtasksInput = {
  mainTaskId: Scalars['String']['input'];
  subtasks: Array<UpdateSubtaskInput>;
};

export type UpdateSubtasksOutput = {
  __typename?: 'UpdateSubtasksOutput';
  tasks: Array<Task>;
};

export type UpdateTaskAndSubtasksAndCreateSubtasksInput = {
  mainTaskId: Scalars['String']['input'];
  subtasks: Array<UpdateSubtasksAndCreateSubtasks>;
  taskAssigneeId: Scalars['String']['input'];
  taskDueDate: Scalars['DateTime']['input'];
  taskName: Scalars['String']['input'];
  workflowCode: WorkflowCode;
};

export type UpdateTaskAndSubtasksAndCreateSubtasksOutput = {
  __typename?: 'UpdateTaskAndSubtasksAndCreateSubtasksOutput';
  subtasks: Array<Task>;
  task: Task;
};

export type UpdateTaskInput = {
  assigneeId: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateTaskOutputObjectType = {
  __typename?: 'UpdateTaskOutputObjectType';
  task: Task;
};

export type UpdateTaskStatusAuditorsInput = {
  audit1?: InputMaybe<Scalars['String']['input']>;
  audit2?: InputMaybe<Scalars['String']['input']>;
  audit3?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaskStatusInput = {
  metadata?: InputMaybe<UpdateTaskStatusMetadataInput>;
  taskId: Scalars['String']['input'];
  workflowStepId: Scalars['String']['input'];
};

export type UpdateTaskStatusMetadataInput = {
  questions?: InputMaybe<Array<UpdateTaskStatusQuestionInput>>;
};

export type UpdateTaskStatusOutput = {
  __typename?: 'UpdateTaskStatusOutput';
  task: Task;
};

export type UpdateTaskStatusQuestionInput = {
  auditors?: InputMaybe<UpdateTaskStatusAuditorsInput>;
  id: Scalars['String']['input'];
  status: QuestionStatus;
};

export type UpdateUserAppRoleByNameMutationResponse = {
  __typename?: 'UpdateUserAppRoleByNameMutationResponse';
  appRoles: Maybe<Array<AppRole>>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserAppRoleByNamesInput = {
  appRoleNames: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateUserAppRolesInput = {
  appRoleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateUserAppRolesMutationResponse = {
  __typename?: 'UpdateUserAppRolesMutationResponse';
  appRoles: Maybe<Array<AppRole>>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserInput = {
  appRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  organizationInfo?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateUserOutputObjectType = {
  __typename?: 'UpdateUserOutputObjectType';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  assignedAt: Maybe<Scalars['String']['output']>;
  assignedBy: Maybe<Scalars['JSON']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  status: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type UpdateUserStatusInput = {
  status: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateUserStatusOutputObjectType = {
  __typename?: 'UpdateUserStatusOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedUser: UserAppRoleView;
};

export type UpdateUsersContentVisibilityInput = {
  courseId: Scalars['String']['input'];
  qbankStructureId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
  visibleContent: Array<UpdateContentVisibilityInputObject>;
};

export type UpdateUsersContentVisibilityResult = {
  __typename?: 'UpdateUsersContentVisibilityResult';
  courseId: Scalars['String']['output'];
  qbankStructureId: Scalars['String']['output'];
  userIds: Array<Scalars['String']['output']>;
  visibleContent: Array<UpdateContentVisibilityObject>;
};

export type UsBoGetTokenStatusResponse = {
  __typename?: 'UsBoGetTokenStatusResponse';
  result: TokenStatus;
};

export type UsBoUser = {
  __typename?: 'UsBoUser';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  appPermissions: Array<Scalars['String']['output']>;
  appRoles: Array<Scalars['String']['output']>;
  blockedUntil: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  expireAt: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  isDisabled: Maybe<Scalars['Boolean']['output']>;
  isPassportUser: Scalars['Boolean']['output'];
  isPasswordCreatedByUser: Maybe<Scalars['Boolean']['output']>;
  isVerified: Maybe<Scalars['Boolean']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  newEmail: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['String']['output']>;
  organizationInfo: Maybe<Scalars['JSON']['output']>;
  realm: Maybe<Scalars['String']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  teamIds: Array<Scalars['String']['output']>;
  twoFactorStatus: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type UsBoUserExcludeFieldsInput = {
  additional1?: InputMaybe<Array<Scalars['String']['input']>>;
  additional2?: InputMaybe<Array<Scalars['String']['input']>>;
  additional3?: InputMaybe<Array<Scalars['String']['input']>>;
  additional4?: InputMaybe<Array<Scalars['String']['input']>>;
  additional5?: InputMaybe<Array<Scalars['String']['input']>>;
  additional6?: InputMaybe<Array<Scalars['String']['input']>>;
  additional7?: InputMaybe<Array<Scalars['String']['input']>>;
  additional8?: InputMaybe<Array<Scalars['String']['input']>>;
  additional9?: InputMaybe<Array<Scalars['String']['input']>>;
  additional10?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  firstname?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['String']['input']>>;
  lastname?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceId?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UsBoUserSearchInput = {
  additional1?: InputMaybe<Scalars['String']['input']>;
  additional2?: InputMaybe<Scalars['String']['input']>;
  additional3?: InputMaybe<Scalars['String']['input']>;
  additional4?: InputMaybe<Scalars['String']['input']>;
  additional5?: InputMaybe<Scalars['String']['input']>;
  additional6?: InputMaybe<Scalars['String']['input']>;
  additional7?: InputMaybe<Scalars['String']['input']>;
  additional8?: InputMaybe<Scalars['String']['input']>;
  additional9?: InputMaybe<Scalars['String']['input']>;
  additional10?: InputMaybe<Scalars['String']['input']>;
  blockedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsBoUserSearchResult = {
  __typename?: 'UsBoUserSearchResult';
  total: Scalars['Int']['output'];
  users: Array<UsBoUser>;
};

export type UsUser = {
  __typename?: 'UsUser';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  appPermissions: Array<Scalars['String']['output']>;
  appRoles: Array<Scalars['String']['output']>;
  blockedUntil: Maybe<Scalars['DateTime']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  expireAt: Maybe<Scalars['DateTime']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['String']['output']>;
  isAdmin: Maybe<Scalars['Boolean']['output']>;
  isDisabled: Maybe<Scalars['Boolean']['output']>;
  isPassportUser: Scalars['Boolean']['output'];
  isPasswordCreatedByUser: Maybe<Scalars['Boolean']['output']>;
  isVerified: Maybe<Scalars['Boolean']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  newEmail: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['String']['output']>;
  organizationInfo: Maybe<Scalars['JSON']['output']>;
  realm: Maybe<Scalars['String']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  teamIds: Array<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type UserAppRoleView = {
  __typename?: 'UserAppRoleView';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  assignedAt: Maybe<Scalars['String']['output']>;
  assignedBy: Maybe<Scalars['JSON']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  status: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type UserAppRoleViewSearchResult = {
  __typename?: 'UserAppRoleViewSearchResult';
  total: Scalars['Int']['output'];
  users: Array<UserAppRoleView>;
};

export enum UserType {
  ClientUser = 'CLIENT_USER',
  UserApi = 'USER_API'
}

export type UsersDataContentVisibilityResult = {
  __typename?: 'UsersDataContentVisibilityResult';
  contentId: Scalars['String']['output'];
  contentType: ContentType;
  parentContentId: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
  users: Array<SetUser>;
};

export type ValidateIssue = {
  __typename?: 'ValidateIssue';
  details: Maybe<Scalars['String']['output']>;
  levelItemId: Maybe<Scalars['String']['output']>;
};

export type ValidateQBankStructureBeforePublishInput = {
  id: Scalars['String']['input'];
  levelItems: Array<SaveAsLevelItemInput>;
};

export type ValidateQBankStructureResult = {
  __typename?: 'ValidateQBankStructureResult';
  case: QBankStructureValidationCase;
  issues: Array<ValidateIssue>;
  passed: Scalars['Boolean']['output'];
};

export type ValidateTokenResult = {
  __typename?: 'ValidateTokenResult';
  description: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
};

/** The verdict of the content. */
export enum Verdict {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  NeedsRework = 'NEEDS_REWORK',
  Rejected = 'REJECTED'
}

export enum VerdictEntityType {
  ExaminationCourse = 'EXAMINATION_COURSE',
  Other = 'OTHER',
  Qconfig = 'QCONFIG',
  Qset = 'QSET',
  Question = 'QUESTION'
}

export type VerifyUserTwoFactorInput = {
  code: Scalars['String']['input'];
};

export type VerifyUserTwoFactorOutputObjectType = {
  __typename?: 'VerifyUserTwoFactorOutputObjectType';
  code: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum WorkflowCode {
  ExamLocationRequest = 'EXAM_LOCATION_REQUEST',
  ProctorRequest = 'PROCTOR_REQUEST',
  QuestionCreation = 'QUESTION_CREATION',
  QuestionReview = 'QUESTION_REVIEW',
  ReviewQSet = 'REVIEW_Q_SET'
}

export type WorkflowStep = {
  __typename?: 'WorkflowStep';
  code: WorkflowStepCode;
  consequences: Maybe<Scalars['JSON']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isTerminal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: TaskStatus;
  stepTransitions: Array<StepTransition>;
  workflowCode: WorkflowCode;
};

export enum WorkflowStepCode {
  ExamLocationRequestApproved = 'EXAM_LOCATION_REQUEST_APPROVED',
  ExamLocationRequestInReview_1 = 'EXAM_LOCATION_REQUEST_IN_REVIEW_1',
  ExamLocationRequestInReview_2 = 'EXAM_LOCATION_REQUEST_IN_REVIEW_2',
  ExamLocationRequestRejected = 'EXAM_LOCATION_REQUEST_REJECTED',
  ProctorRequestApproved = 'PROCTOR_REQUEST_APPROVED',
  ProctorRequestInReview_1 = 'PROCTOR_REQUEST_IN_REVIEW_1',
  ProctorRequestInReview_2 = 'PROCTOR_REQUEST_IN_REVIEW_2',
  ProctorRequestRejected = 'PROCTOR_REQUEST_REJECTED',
  QuestionCreationDone = 'QUESTION_CREATION_DONE',
  QuestionCreationInProgress = 'QUESTION_CREATION_IN_PROGRESS',
  QuestionCreationTodo = 'QUESTION_CREATION_TODO',
  QuestionReviewDone = 'QUESTION_REVIEW_DONE',
  QuestionReviewInReview = 'QUESTION_REVIEW_IN_REVIEW',
  QuestionReviewReviewed = 'QUESTION_REVIEW_REVIEWED',
  QuestionReviewTodo = 'QUESTION_REVIEW_TODO',
  ReviewQsetDone = 'REVIEW_QSET_DONE',
  ReviewQsetInReview = 'REVIEW_QSET_IN_REVIEW',
  ReviewQsetReviewed = 'REVIEW_QSET_REVIEWED',
  ReviewQsetTodo = 'REVIEW_QSET_TODO'
}

export type RemoveUsersContentVisibilityMutationVariables = Exact<{
  input: RemoveUsersContentVisibilityInput;
}>;


export type RemoveUsersContentVisibilityMutation = { __typename?: 'Mutation', cvRemoveUsersContentVisibility: { __typename?: 'RemoveUsersContentVisibilityResult', total: number, removedContentVisibilities: Array<{ __typename?: 'ContentVisibility', contentId: string, userId: string }> } };

export type SearchUsersContentVisibilityQueryVariables = Exact<{
  input: SearchUsersContentVisibilityInput;
}>;


export type SearchUsersContentVisibilityQuery = { __typename?: 'Query', cvSearchUsersContentVisibility: { __typename?: 'UsersDataContentVisibilityResult', total: number, users: Array<{ __typename?: 'SETUser', firstname: string, lastname: string, email: string, image: string | null, appRoles: Array<string>, status: string | null, id: string, invitationExpireAt: string | null }> } };

export type CreateExamCourseMutationVariables = Exact<{
  createExamCourseInput: CreateExamCourseInput;
}>;


export type CreateExamCourseMutation = { __typename?: 'Mutation', excCreateExamCourse: { __typename?: 'CreateExamCourseOutput', examCourse: { __typename?: 'ExamCourse', id: string } } };

export type SearchExamCoursesQueryVariables = Exact<{
  searchExamCoursesInput: SearchExamCoursesInput;
}>;


export type SearchExamCoursesQuery = { __typename?: 'Query', excSearchExamCourses: { __typename?: 'SearchExamCoursesOutput', total: number, examCourses: Array<{ __typename?: 'ExamCourse', id: string, code: string, examId: number, name: string, type: ExamCourseType, language: ExamCourseLanguage, totalQConfig: number, totalQSet: number, tagEntities: Array<{ __typename?: 'TagEntity', tag: { __typename?: 'Tag', name: string, category: TagCategory } }> | null }> } };

export type GetExamCourseByIdQueryVariables = Exact<{
  getExamCourseByIdInput: GetExamCourseByIdInput;
}>;


export type GetExamCourseByIdQuery = { __typename?: 'Query', excGetExamCourseById: { __typename?: 'GetExamCourseByIdOutput', examCourse: { __typename?: 'ExamCourse', id: string, name: string, code: string, type: ExamCourseType, language: ExamCourseLanguage } } };

export type SearchExamCourseGroupsQueryVariables = Exact<{
  searchExamCourseGroupsByNameInput: SearchExamCourseGroupsByNameInput;
}>;


export type SearchExamCourseGroupsQuery = { __typename?: 'Query', excSearchExamCourseGroupsByName: { __typename?: 'SearchExamCourseGroupsByNameOutput', tags: Array<{ __typename?: 'Tag', id: string, name: string }> } };

export type GetExamCourseGroupByIdQueryVariables = Exact<{
  getExamCourseGroupByIdInput: GetExamCourseGroupByIdInput;
}>;


export type GetExamCourseGroupByIdQuery = { __typename?: 'Query', excGetExamCourseGroupById: { __typename?: 'GetExamCourseGroupByIdOutput', tag: { __typename?: 'Tag', id: string, name: string } } };

export type DeleteQConfigStructureMutationVariables = Exact<{
  deleteQConfigStructureInput: DeleteQConfigStructureInput;
}>;


export type DeleteQConfigStructureMutation = { __typename?: 'Mutation', excDeleteQConfigStructure: { __typename?: 'DeleteQConfigStructureOutput', qConfig: { __typename?: 'QConfig', id: string } } };

export type QConfigDetailsFragment = { __typename?: 'QConfig', id: string, name: string, code: number, type: QConfigType, status: QConfigStatus, randomType: QConfigRandomType | null, totalQuestions: number, fullScore: number, lastPublishedAt: Date | null, updatedAt: Date, passingCriteria: { __typename?: 'QConfigPassingCriteria', type: QConfigPassingCriteriaType, value: number } | null, timeLimit: { __typename?: 'QConfigTimeLimit', type: QConfigTimeLimitType, values: Array<{ __typename?: 'QConfigTimeLimitValue', qConfigStructureIds: Array<string> | null, value: number, order: number }> } | null, structures: Array<{ __typename?: 'QConfigStructure', id: string, name: string | null, type: QConfigStructureType, category: QConfigStructureCategory | null, refCode: string | null, refId: string | null, parentId: string | null, order: number, size: number | null, score: number, totalQuestions: number, conditions: Array<{ __typename?: 'QConfigStructureConditionMultiTagGroup', type: QConfigStructureConditionType, needTotal: number, tagGroups: Array<{ __typename?: 'QConfigStructureConditionTagGroup', count: number, tags: Array<{ __typename?: 'ConditionTag', id: string, name: string }> }> } | { __typename?: 'QConfigStructureConditionSingleTagGroup', needTotal: number, type: QConfigStructureConditionType, tags: Array<{ __typename?: 'ConditionTag', id: string, name: string }> }>, passingCriteria: { __typename?: 'QConfigStructurePassingCriteria', type: QConfigPassingCriteriaType, value: number } | null }>, metadata: { __typename?: 'QConfigMetadata', conditions: { __typename?: 'QConfigCondition', questionTypes: Array<{ __typename?: 'QConfigMetadataConditionQuestionType', type: QConfigQuestionType, needTotal: number }>, tags: Array<{ __typename?: 'QConfigConditionTag', needTotal: number, tag: { __typename?: 'ConditionTag', id: string, name: string } }> } | null } };

export type SearchQConfigsQueryVariables = Exact<{
  searchQConfigsInput: SearchQConfigsInput;
}>;


export type SearchQConfigsQuery = { __typename?: 'Query', excSearchQConfigs: { __typename?: 'SearchQConfigsOutput', total: number, qConfigs: Array<{ __typename?: 'QConfig', id: string, name: string, code: number, type: QConfigType, status: QConfigStatus, updatedAt: Date }> } };

export type GetQConfigByIdQueryVariables = Exact<{
  getQConfigByIdInput: GetQConfigByIdInput;
}>;


export type GetQConfigByIdQuery = { __typename?: 'Query', excGetQConfigById: { __typename?: 'GetQConfigByIdOutput', qConfig: { __typename?: 'QConfig', id: string, name: string, code: number, type: QConfigType, status: QConfigStatus, randomType: QConfigRandomType | null, totalQuestions: number, fullScore: number, lastPublishedAt: Date | null, updatedAt: Date, passingCriteria: { __typename?: 'QConfigPassingCriteria', type: QConfigPassingCriteriaType, value: number } | null, timeLimit: { __typename?: 'QConfigTimeLimit', type: QConfigTimeLimitType, values: Array<{ __typename?: 'QConfigTimeLimitValue', qConfigStructureIds: Array<string> | null, value: number, order: number }> } | null, structures: Array<{ __typename?: 'QConfigStructure', id: string, name: string | null, type: QConfigStructureType, category: QConfigStructureCategory | null, refCode: string | null, refId: string | null, parentId: string | null, order: number, size: number | null, score: number, totalQuestions: number, conditions: Array<{ __typename?: 'QConfigStructureConditionMultiTagGroup', type: QConfigStructureConditionType, needTotal: number, tagGroups: Array<{ __typename?: 'QConfigStructureConditionTagGroup', count: number, tags: Array<{ __typename?: 'ConditionTag', id: string, name: string }> }> } | { __typename?: 'QConfigStructureConditionSingleTagGroup', needTotal: number, type: QConfigStructureConditionType, tags: Array<{ __typename?: 'ConditionTag', id: string, name: string }> }>, passingCriteria: { __typename?: 'QConfigStructurePassingCriteria', type: QConfigPassingCriteriaType, value: number } | null }>, metadata: { __typename?: 'QConfigMetadata', conditions: { __typename?: 'QConfigCondition', questionTypes: Array<{ __typename?: 'QConfigMetadataConditionQuestionType', type: QConfigQuestionType, needTotal: number }>, tags: Array<{ __typename?: 'QConfigConditionTag', needTotal: number, tag: { __typename?: 'ConditionTag', id: string, name: string } }> } | null } } } };

export type GetQConfigChapterSingleQuestionPropertiesCountQueryVariables = Exact<{
  input: GetQConfigChapterSingleQuestionPropertiesCountInput;
}>;


export type GetQConfigChapterSingleQuestionPropertiesCountQuery = { __typename?: 'Query', excGetQConfigChapterSingleQuestionPropertiesCount: Array<{ __typename?: 'QConfigChapterSingleQuestionProperties', totalQuestions: number, tags: Array<{ __typename?: 'QConfigChapterQuestionTag', id: string, name: string }> }> };

export type GetQConfigChapterItemSetQuestionPropertiesCountQueryVariables = Exact<{
  input: GetQConfigChapterItemSetQuestionPropertiesCountInput;
}>;


export type GetQConfigChapterItemSetQuestionPropertiesCountQuery = { __typename?: 'Query', excGetQConfigChapterItemSetQuestionPropertiesCount: Array<{ __typename?: 'QConfigChapterItemSetQuestionProperties', totalQuestions: number, tagGroups: Array<{ __typename?: 'QConfigChapterQuestionTagGroup', count: number, tags: Array<{ __typename?: 'QConfigChapterQuestionTag', id: string, name: string }> }> }> };

export type CreateQConfigMutationVariables = Exact<{
  createQConfigInput: CreateQConfigInput;
}>;


export type CreateQConfigMutation = { __typename?: 'Mutation', excCreateQConfig: { __typename?: 'CreateQConfigOutput', qConfig: { __typename?: 'QConfig', id: string, name: string, code: number, type: QConfigType, status: QConfigStatus, randomType: QConfigRandomType | null, totalQuestions: number, fullScore: number, lastPublishedAt: Date | null, updatedAt: Date, passingCriteria: { __typename?: 'QConfigPassingCriteria', type: QConfigPassingCriteriaType, value: number } | null, timeLimit: { __typename?: 'QConfigTimeLimit', type: QConfigTimeLimitType, values: Array<{ __typename?: 'QConfigTimeLimitValue', qConfigStructureIds: Array<string> | null, value: number, order: number }> } | null, structures: Array<{ __typename?: 'QConfigStructure', id: string, name: string | null, type: QConfigStructureType, category: QConfigStructureCategory | null, refCode: string | null, refId: string | null, parentId: string | null, order: number, size: number | null, score: number, totalQuestions: number, conditions: Array<{ __typename?: 'QConfigStructureConditionMultiTagGroup', type: QConfigStructureConditionType, needTotal: number, tagGroups: Array<{ __typename?: 'QConfigStructureConditionTagGroup', count: number, tags: Array<{ __typename?: 'ConditionTag', id: string, name: string }> }> } | { __typename?: 'QConfigStructureConditionSingleTagGroup', needTotal: number, type: QConfigStructureConditionType, tags: Array<{ __typename?: 'ConditionTag', id: string, name: string }> }>, passingCriteria: { __typename?: 'QConfigStructurePassingCriteria', type: QConfigPassingCriteriaType, value: number } | null }>, metadata: { __typename?: 'QConfigMetadata', conditions: { __typename?: 'QConfigCondition', questionTypes: Array<{ __typename?: 'QConfigMetadataConditionQuestionType', type: QConfigQuestionType, needTotal: number }>, tags: Array<{ __typename?: 'QConfigConditionTag', needTotal: number, tag: { __typename?: 'ConditionTag', id: string, name: string } }> } | null } } } };

export type AddQConfigStructuresMutationVariables = Exact<{
  addQConfigStructuresInput: AddQConfigStructuresInput;
}>;


export type AddQConfigStructuresMutation = { __typename?: 'Mutation', excAddQConfigStructures: { __typename?: 'AddQConfigStructuresOutput', qConfig: { __typename?: 'QConfig', id: string, name: string, code: number, type: QConfigType, status: QConfigStatus, randomType: QConfigRandomType | null, totalQuestions: number, fullScore: number, lastPublishedAt: Date | null, updatedAt: Date, passingCriteria: { __typename?: 'QConfigPassingCriteria', type: QConfigPassingCriteriaType, value: number } | null, timeLimit: { __typename?: 'QConfigTimeLimit', type: QConfigTimeLimitType, values: Array<{ __typename?: 'QConfigTimeLimitValue', qConfigStructureIds: Array<string> | null, value: number, order: number }> } | null, structures: Array<{ __typename?: 'QConfigStructure', id: string, name: string | null, type: QConfigStructureType, category: QConfigStructureCategory | null, refCode: string | null, refId: string | null, parentId: string | null, order: number, size: number | null, score: number, totalQuestions: number, conditions: Array<{ __typename?: 'QConfigStructureConditionMultiTagGroup', type: QConfigStructureConditionType, needTotal: number, tagGroups: Array<{ __typename?: 'QConfigStructureConditionTagGroup', count: number, tags: Array<{ __typename?: 'ConditionTag', id: string, name: string }> }> } | { __typename?: 'QConfigStructureConditionSingleTagGroup', needTotal: number, type: QConfigStructureConditionType, tags: Array<{ __typename?: 'ConditionTag', id: string, name: string }> }>, passingCriteria: { __typename?: 'QConfigStructurePassingCriteria', type: QConfigPassingCriteriaType, value: number } | null }>, metadata: { __typename?: 'QConfigMetadata', conditions: { __typename?: 'QConfigCondition', questionTypes: Array<{ __typename?: 'QConfigMetadataConditionQuestionType', type: QConfigQuestionType, needTotal: number }>, tags: Array<{ __typename?: 'QConfigConditionTag', needTotal: number, tag: { __typename?: 'ConditionTag', id: string, name: string } }> } | null } } } };

export type PublishQConfigMutationVariables = Exact<{
  publishQConfigInput: PublishQConfigInput;
}>;


export type PublishQConfigMutation = { __typename?: 'Mutation', excPublishQConfig: { __typename?: 'PublishQConfigOutput', qConfig: { __typename?: 'QConfig', id: string, name: string, code: number, type: QConfigType, status: QConfigStatus, randomType: QConfigRandomType | null, totalQuestions: number, fullScore: number, lastPublishedAt: Date | null, updatedAt: Date, passingCriteria: { __typename?: 'QConfigPassingCriteria', type: QConfigPassingCriteriaType, value: number } | null, timeLimit: { __typename?: 'QConfigTimeLimit', type: QConfigTimeLimitType, values: Array<{ __typename?: 'QConfigTimeLimitValue', qConfigStructureIds: Array<string> | null, value: number, order: number }> } | null, structures: Array<{ __typename?: 'QConfigStructure', id: string, name: string | null, type: QConfigStructureType, category: QConfigStructureCategory | null, refCode: string | null, refId: string | null, parentId: string | null, order: number, size: number | null, score: number, totalQuestions: number, conditions: Array<{ __typename?: 'QConfigStructureConditionMultiTagGroup', type: QConfigStructureConditionType, needTotal: number, tagGroups: Array<{ __typename?: 'QConfigStructureConditionTagGroup', count: number, tags: Array<{ __typename?: 'ConditionTag', id: string, name: string }> }> } | { __typename?: 'QConfigStructureConditionSingleTagGroup', needTotal: number, type: QConfigStructureConditionType, tags: Array<{ __typename?: 'ConditionTag', id: string, name: string }> }>, passingCriteria: { __typename?: 'QConfigStructurePassingCriteria', type: QConfigPassingCriteriaType, value: number } | null }>, metadata: { __typename?: 'QConfigMetadata', conditions: { __typename?: 'QConfigCondition', questionTypes: Array<{ __typename?: 'QConfigMetadataConditionQuestionType', type: QConfigQuestionType, needTotal: number }>, tags: Array<{ __typename?: 'QConfigConditionTag', needTotal: number, tag: { __typename?: 'ConditionTag', id: string, name: string } }> } | null } } } };

export type UpdateQConfigStructureNamesMutationVariables = Exact<{
  updateQConfigStructureNamesInput: UpdateQConfigStructureNamesInput;
}>;


export type UpdateQConfigStructureNamesMutation = { __typename?: 'Mutation', excUpdateQConfigStructureNames: { __typename?: 'UpdateQConfigStructureNamesOutput', qConfigStructures: Array<{ __typename?: 'QConfigStructure', id: string, name: string | null }> } };

export type UpdateQconfigSettingsAsDraftMutationVariables = Exact<{
  updateQConfigSettingsAsDraftInput: UpdateQConfigSettingsAsDraftInput;
}>;


export type UpdateQconfigSettingsAsDraftMutation = { __typename?: 'Mutation', excUpdateQconfigSettingsAsDraft: { __typename?: 'UpdateQConfigSettingsAsDraftOutput', qConfig: { __typename?: 'QConfig', id: string } } };

export type AddSingleQuestionQConfigStructureMutationVariables = Exact<{
  addSingleQuestionQConfigStructureInput: AddSingleQuestionQConfigStructureInput;
}>;


export type AddSingleQuestionQConfigStructureMutation = { __typename?: 'Mutation', excAddSingleQuestionQConfigStructure: { __typename?: 'AddSingleQuestionQConfigStructureOutput', qConfig: { __typename?: 'QConfig', id: string } } };

export type AddItemSetQuestionQConfigStructureMutationVariables = Exact<{
  addItemSetQuestionQConfigStructureInput: AddItemSetQuestionQConfigStructureInput;
}>;


export type AddItemSetQuestionQConfigStructureMutation = { __typename?: 'Mutation', excAddItemSetQuestionQConfigStructure: { __typename?: 'AddItemSetQuestionQConfigStructureOutput', qConfig: { __typename?: 'QConfig', id: string } } };

export type DuplicateQConfigMutationVariables = Exact<{
  duplicateQConfigInput: DuplicateQConfigInput;
}>;


export type DuplicateQConfigMutation = { __typename?: 'Mutation', excDuplicateQConfig: { __typename?: 'DuplicateQConfigOutput', qConfig: { __typename?: 'QConfig', id: string } } };

export type DisableQConfigMutationVariables = Exact<{
  disableQConfigInput: DisableQConfigInput;
}>;


export type DisableQConfigMutation = { __typename?: 'Mutation', excDisableQConfig: { __typename?: 'DisableQConfigOutput', qConfig: { __typename?: 'QConfig', id: string } } };

export type UpdateSingleQuestionQConfigStructureMutationVariables = Exact<{
  updateSingleQuestionQConfigStructureInput: UpdateSingleQuestionQConfigStructureInput;
}>;


export type UpdateSingleQuestionQConfigStructureMutation = { __typename?: 'Mutation', excUpdateSingleQuestionQConfigStructure: { __typename?: 'UpdateSingleQuestionQConfigStructureOutput', qConfig: { __typename?: 'QConfig', id: string } } };

export type UpdateItemSetQuestionQConfigStructureMutationVariables = Exact<{
  input: UpdateItemSetQuestionQConfigStructureInput;
}>;


export type UpdateItemSetQuestionQConfigStructureMutation = { __typename?: 'Mutation', excUpdateItemSetQuestionQConfigStructure: { __typename?: 'UpdateItemSetQuestionQConfigStructureOutput', qConfig: { __typename?: 'QConfig', id: string } } };

export type UpdateQConfigAsDraftMutationVariables = Exact<{
  updateQConfigAsDraftInput: UpdateQConfigAsDraftInput;
}>;


export type UpdateQConfigAsDraftMutation = { __typename?: 'Mutation', excUpdateQConfigAsDraft: { __typename?: 'UpdateQConfigAsDraftOutput', qConfig: { __typename?: 'QConfig', id: string } } };

export type SearchQConfigGeneratorsQueryVariables = Exact<{
  searchQConfigGeneratorsInput: SearchQConfigGeneratorsInput;
}>;


export type SearchQConfigGeneratorsQuery = { __typename?: 'Query', excSearchQConfigGenerators: { __typename?: 'SearchQConfigGeneratorsOutput', total: number, qConfigGenerators: Array<{ __typename?: 'QConfigGenerator', id: string, examCourseId: string, name: string, code: string, totalQuestions: number, needTotal: number, latestExecution: { __typename?: 'QConfigGeneratorExecution', id: string, qConfigGeneratorId: string, round: number, status: QConfigGeneratorExecutionStatus, metadata: any, startedAt: Date | null, endedAt: Date | null, needTotal: number, totalResults: number, createdAt: Date } }> } };

export type CreateQConfigGeneratorMutationVariables = Exact<{
  createQConfigGeneratorInput: CreateQConfigGeneratorInput;
}>;


export type CreateQConfigGeneratorMutation = { __typename?: 'Mutation', excCreateQConfigGenerator: { __typename?: 'CreateQConfigGeneratorOutput', qConfigGenerator: { __typename?: 'QConfigGenerator', id: string } } };

export type DeleteQConfigMutationVariables = Exact<{
  deleteQConfigInput: DeleteQConfigInput;
}>;


export type DeleteQConfigMutation = { __typename?: 'Mutation', excDeleteQConfig: { __typename?: 'DeleteQConfigOutput', qConfig: { __typename?: 'QConfig', id: string } } };

export type GetQConfigGeneratorByIdQueryVariables = Exact<{
  getQConfigGeneratorByIdInput: GetQConfigGeneratorByIdInput;
}>;


export type GetQConfigGeneratorByIdQuery = { __typename?: 'Query', excGetQConfigGeneratorById: { __typename?: 'GetQConfigGeneratorByIdOutput', qConfigGenerator: { __typename?: 'QConfigGenerator', id: string, name: string, code: string, totalQuestions: number, needTotal: number, metadata: { __typename?: 'QConfigGeneratorMetadata', conditions: { __typename?: 'QConfigGeneratorCondition', questionTypes: Array<{ __typename?: 'QConfigGeneratorConditionsQuestionType', type: QConfigQuestionType, needTotal: number }>, tags: Array<{ __typename?: 'QConfigGeneratorConditionsTag', needTotal: number, tag: { __typename?: 'QConfigGeneratorConditionsTagTagObjectType', id: string, name: string } }> } }, qBankStructures: Array<{ __typename?: 'QBankStructure', id: string, code: number, name: string }> | null, latestExecution: { __typename?: 'QConfigGeneratorExecution', id: string, status: QConfigGeneratorExecutionStatus, needTotal: number, totalResults: number, createdAt: Date, results: Array<{ __typename?: 'QConfigGeneratorExecutionResult', id: string, qConfig: { __typename?: 'QConfig', id: string, name: string, code: number } | null }> } } } };

export type SearchQConfigActivityLogQueryVariables = Exact<{
  searchQConfigActivityLogInput: SearchQConfigAuditLogInput;
}>;


export type SearchQConfigActivityLogQuery = { __typename?: 'Query', excSearchQConfigAuditLog: { __typename?: 'SearchQConfigAuditLogOutput', total: number, qConfigAuditLogs: Array<{ __typename?: 'QConfigAuditLog', id: string, action: AuditActionType, detail: string, actionTime: Date, fullName: string }> } };

export type GetDisabledLosInQConfigQueryVariables = Exact<{
  getDisabledLearningObjectiveStatementsByQConfigIdInput: GetDisabledLearningObjectiveStatementsByQConfigIdInput;
}>;


export type GetDisabledLosInQConfigQuery = { __typename?: 'Query', excGetDisabledLearningObjectiveStatementsByQConfigId: { __typename?: 'GetDisabledLearningObjectiveStatementsByQConfigIdOutput', disabledLearningObjectiveStatements: Array<{ __typename?: 'DisabledLearningObjectiveStatementObjectType', id: string, name: string | null }> } };

export type GetLosByQConfigStructureQueryVariables = Exact<{
  input: GetQConfigChapterInput;
}>;


export type GetLosByQConfigStructureQuery = { __typename?: 'Query', excGetQConfigChapter: { __typename?: 'QConfigStructure', id: string, learningObjectiveStatements: Array<{ __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } }> | null } };

export type GetLevelItemSubtreeByQConfigStructureQueryVariables = Exact<{
  input: GetQConfigChapterInput;
}>;


export type GetLevelItemSubtreeByQConfigStructureQuery = { __typename?: 'Query', excGetQConfigChapter: { __typename?: 'QConfigStructure', id: string, levelItemSubtree: Array<{ __typename?: 'QBankStructureLevelItem', id: string, parentLevelItemId: string | null, order: number, qBankStructureLevelId: string, tag: { __typename?: 'Tag', id: string, name: string } | null, level: { __typename?: 'QBankStructureLevel', id: string, level: number, category: QBankStructureLevelCategory, enabled: boolean } | null }> | null } };

export type SearchQSetsQueryVariables = Exact<{
  searchQSetsInput: SearchQSetsInput;
}>;


export type SearchQSetsQuery = { __typename?: 'Query', excSearchQSets: { __typename?: 'SearchQSetsOutput', total: number, qSets: Array<{ __typename?: 'QSet', id: string, examCourseId: string, qConfigId: string, code: string, status: QSetStatus, updatedAt: Date, qConfig: { __typename?: 'QConfig', id: string, name: string, code: number, totalQuestions: number, timeLimit: { __typename?: 'QConfigTimeLimit', total: number | null } | null } }> } };

export type GetDraftQSetsQueryVariables = Exact<{
  searchQSetsInput: SearchQSetsInput;
}>;


export type GetDraftQSetsQuery = { __typename?: 'Query', excSearchQSets: { __typename?: 'SearchQSetsOutput', total: number, qSets: Array<{ __typename?: 'QSet', id: string, code: string, status: QSetStatus, updatedAt: Date, qConfig: { __typename?: 'QConfig', id: string, name: string, code: number } }> } };

export type GetPublishedQSetsQueryVariables = Exact<{
  searchQSetsInput: SearchQSetsInput;
}>;


export type GetPublishedQSetsQuery = { __typename?: 'Query', excSearchQSets: { __typename?: 'SearchQSetsOutput', total: number, qSets: Array<{ __typename?: 'QSet', id: string, code: string, status: QSetStatus, updatedAt: Date, lastPublishedAt: Date | null, examUsageStatus: ExamUsageStatus | null, qConfig: { __typename?: 'QConfig', id: string, name: string, code: number } }> } };

export type GetInReviewQSetsQueryVariables = Exact<{
  searchQSetsInput: SearchQSetsInput;
}>;


export type GetInReviewQSetsQuery = { __typename?: 'Query', excSearchQSets: { __typename?: 'SearchQSetsOutput', total: number, qSets: Array<{ __typename?: 'QSet', id: string, code: string, status: QSetStatus, updatedAt: Date, lastPublishedAt: Date | null, lastReviewedAt: Date | null, qConfig: { __typename?: 'QConfig', id: string, name: string, code: number }, assignees: Array<{ __typename?: 'RawUser', firstname: string, lastname: string }> }> } };

export type GetReviewedQSetsQueryVariables = Exact<{
  searchQSetsInput: SearchQSetsInput;
}>;


export type GetReviewedQSetsQuery = { __typename?: 'Query', excSearchQSets: { __typename?: 'SearchQSetsOutput', total: number, qSets: Array<{ __typename?: 'QSet', id: string, code: string, status: QSetStatus, updatedAt: Date, lastPublishedAt: Date | null, lastReviewedAt: Date | null, qConfig: { __typename?: 'QConfig', id: string, name: string, code: number }, assignees: Array<{ __typename?: 'RawUser', firstname: string, lastname: string }> }> } };

export type GetDisabledQSetsQueryVariables = Exact<{
  searchQSetsInput: SearchQSetsInput;
}>;


export type GetDisabledQSetsQuery = { __typename?: 'Query', excSearchQSets: { __typename?: 'SearchQSetsOutput', total: number, qSets: Array<{ __typename?: 'QSet', id: string, code: string, status: QSetStatus, disabledAt: Date | null, qConfig: { __typename?: 'QConfig', id: string, name: string, code: number } }> } };

export type GetQSetByIdQueryVariables = Exact<{
  input: GetQSetByIdInput;
}>;


export type GetQSetByIdQuery = { __typename?: 'Query', excGetQSetById: { __typename?: 'GetQSetByIdOutput', qSet: { __typename?: 'QSet', id: string, code: string, status: QSetStatus, examCourseId: string, pAvgValue: number, conditions: { __typename?: 'QSetConditions', averagePValue: number, tags: Array<{ __typename?: 'QSetConditionsTags', count: number, tag: { __typename?: 'QSetConditionTag', id: string, name: string } }>, questionTypes: Array<{ __typename?: 'QSetConditionsQuestionType', type: QSetConditionQuestionType, count: number }> } | null, qConfig: { __typename?: 'QConfig', fullScore: number, totalQuestions: number, randomType: QConfigRandomType | null, examCourse: { __typename?: 'ExamCourse', name: string }, metadata: { __typename?: 'QConfigMetadata', conditions: { __typename?: 'QConfigCondition', questionTypes: Array<{ __typename?: 'QConfigMetadataConditionQuestionType', type: QConfigQuestionType, needTotal: number }>, tags: Array<{ __typename?: 'QConfigConditionTag', needTotal: number, tag: { __typename?: 'ConditionTag', name: string } }> } | null }, passingCriteria: { __typename?: 'QConfigPassingCriteria', value: number, type: QConfigPassingCriteriaType } | null, structures: Array<{ __typename?: 'QConfigStructure', id: string, name: string | null, category: QConfigStructureCategory | null, type: QConfigStructureType, score: number, totalQuestions: number, passingCriteria: { __typename?: 'QConfigStructurePassingCriteria', value: number, type: QConfigPassingCriteriaType } | null }>, timeLimit: { __typename?: 'QConfigTimeLimit', type: QConfigTimeLimitType, total: number | null, values: Array<{ __typename?: 'QConfigTimeLimitValue', qConfigStructureIds: Array<string> | null, value: number, order: number }> } | null } } } };

export type SearchQSetQuestionsQueryVariables = Exact<{
  input: SearchQSetQuestionsInput;
}>;


export type SearchQSetQuestionsQuery = { __typename?: 'Query', excSearchQSetQuestions: { __typename?: 'SearchQSetQuestionsOutput', total: number, qSetQuestions: Array<{ __typename?: 'QSetQuestion', id: string, questionId: string, questionGroupId: string, questionRefCode: string, order: number, question: { __typename?: 'Question', id: string, type: QuestionType, details: string, refCode: string, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, metadata: { __typename?: 'QuestionMetadata', reference: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }> }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, questionGroup: { __typename?: 'QuestionGroup', id: string, type: QuestionGroupType, size: number | null, refCode: string, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null } | null }> } };

export type GetQSetGeneratorExecutionByIdQueryVariables = Exact<{
  input: GetQSetGeneratorExecutionByIdInput;
}>;


export type GetQSetGeneratorExecutionByIdQuery = { __typename?: 'Query', excGetQSetGeneratorExecutionById: { __typename?: 'GetQSetGeneratorExecutionByIdOutput', qSetGeneratorExecution: { __typename?: 'QSetGeneratorExecution', id: string, generator: { __typename?: 'QSetGenerator', id: string, code: string, needTotal: number, duplicationRate: number, totalQuestions: number, qConfig: { __typename?: 'QConfig', id: string, name: string, code: number } }, results: Array<{ __typename?: 'QSetGeneratorExecutionResult', id: string, name: string, code: string, criteriaResult: QSetGeneratorExecutionResultCriteriaResult, averageDuplicationRate: number }> } } };

export type ExecuteQSetGeneratorMutationVariables = Exact<{
  executeQSetGeneratorInput: ExecuteQSetGeneratorInput;
}>;


export type ExecuteQSetGeneratorMutation = { __typename?: 'Mutation', excExecuteQSetGenerator: { __typename?: 'ExecuteQSetGeneratorOutput', qSetGeneratorExecution: { __typename?: 'QSetGeneratorExecution', id: string, qSetGeneratorId: string, round: number, status: QSetGeneratorExecutionStatus, startedAt: Date | null, endedAt: Date | null } } };

export type CreateQSetsByGeneratorExecutionMutationVariables = Exact<{
  input: CreateQSetsByGeneratorExecutionInput;
}>;


export type CreateQSetsByGeneratorExecutionMutation = { __typename?: 'Mutation', excCreateQSetsByGeneratorExecution: { __typename?: 'CreateQSetsByGeneratorExecutionOutput', qSets: Array<{ __typename?: 'QSet', id: string }> } };

export type GetQuestionToChangeByIdQueryVariables = Exact<{
  qctGetQuestionById: Scalars['String']['input'];
}>;


export type GetQuestionToChangeByIdQuery = { __typename?: 'Query', qctGetQuestionById: { __typename?: 'Question', id: string, refCode: string, refQBankStructureId: string, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, questionGroup: { __typename?: 'QuestionGroup', id: string, type: QuestionGroupType } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', id: string, levelItem: { __typename?: 'QBankStructureLevelItem', id: string, parentLevelItemId: string | null, tag: { __typename?: 'Tag', id: string, name: string } | null, qBankStructureLevel: { __typename?: 'QBankStructureLevel', category: QBankStructureLevelCategory } | null } | null }> | null } };

export type GetTopicAndSubTopicByChapterIdQueryVariables = Exact<{
  qbsGetQBankStructureLevelItemChildrenById: Scalars['String']['input'];
}>;


export type GetTopicAndSubTopicByChapterIdQuery = { __typename?: 'Query', qbsGetQBankStructureLevelItemChildrenById: Array<{ __typename?: 'QBankStructureLevelItem', id: string, parentLevelItemId: string | null, tag: { __typename?: 'Tag', id: string, name: string } | null, qBankStructureLevel: { __typename?: 'QBankStructureLevel', category: QBankStructureLevelCategory } | null }> };

export type SearchQuestionsToChangeQueryVariables = Exact<{
  search: SearchQuestionsInput;
  paging: PageInput;
  order: OrderInput;
}>;


export type SearchQuestionsToChangeQuery = { __typename?: 'Query', qctSearchQuestions: { __typename?: 'QuestionsResult', total: number, questions: Array<{ __typename?: 'Question', id: string, refCode: string, refQBankStructureId: string, tags: Array<{ __typename?: 'Tag', name: string, category: TagCategory }> }> } };

export type GetUsedQSetQuestionsByQuestionIdsQueryVariables = Exact<{
  input: GetQsetQuestionsByQuestionIdsInput;
}>;


export type GetUsedQSetQuestionsByQuestionIdsQuery = { __typename?: 'Query', excGetQSetQuestionsByQuestionIds: { __typename?: 'GetQSetQuestionsByQuestionIdsOutput', qSetQuestions: Array<{ __typename?: 'QSetQuestion', questionId: string, order: number }> } };

export type ChangeSingleQuestionMutationVariables = Exact<{
  changeSingleQuestionInput: ChangeSingleQuestionInput;
}>;


export type ChangeSingleQuestionMutation = { __typename?: 'Mutation', excChangeSingleQuestion: { __typename?: 'ChangeSingleQuestionOutput', qSetQuestion: { __typename?: 'QSetQuestion', questionRefCode: string, order: number } } };

export type ChangeItemSetQuestionMutationVariables = Exact<{
  changeItemSetQuestionInput: ChangeItemSetQuestionInput;
}>;


export type ChangeItemSetQuestionMutation = { __typename?: 'Mutation', excChangeItemSetQuestion: { __typename?: 'ChangeItemSetQuestionOutput', qSetQuestions: Array<{ __typename?: 'QSetQuestion', id: string, questionRefCode: string, order: number }> } };

export type ExecuteQSetCheckSimilarityQueryVariables = Exact<{
  input: GetQSetSimilaritiesInput;
}>;


export type ExecuteQSetCheckSimilarityQuery = { __typename?: 'Query', excGetQSetSimilarities: { __typename?: 'GetQSetSimilaritiesOutput', id: string, qSetSimilarityResults: Array<{ __typename?: 'QSetSimilarityResultOutput', id: string, qSetACode: string, qSetBCode: string, duplicationRate: number, duplicationCount: number, duplicatedQuestionIds: Array<string>, totalQuestions: number }> } };

export type GetQSetSimilarityWithQuestionsByIdQueryVariables = Exact<{
  input: GetQSetSimilarityByIdInput;
}>;


export type GetQSetSimilarityWithQuestionsByIdQuery = { __typename?: 'Query', excGetQSetSimilarityWithQuestionsById: { __typename?: 'GetQSetSimilarityByIdOutput', qSetSimilarityResult: { __typename?: 'QSetSimilarityResultWithQuestionsOutput', qSetA: string, qSetACode: string, qSetBCode: string, duplicatedQuestions: Array<{ __typename?: 'QSetQuestion', id: string, questionId: string, questionGroupId: string, questionRefCode: string, order: number, question: { __typename?: 'Question', id: string, type: QuestionType, details: string, refCode: string, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, metadata: { __typename?: 'QuestionMetadata', reference: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }> }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, questionGroup: { __typename?: 'QuestionGroup', id: string, type: QuestionGroupType, size: number | null, refCode: string, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null } | null }> } } };

export type DuplicateQSetMutationVariables = Exact<{
  input: DuplicateQSetInput;
}>;


export type DuplicateQSetMutation = { __typename?: 'Mutation', excDuplicateQSet: { __typename?: 'DuplicateQSetOutput', qSet: { __typename?: 'QSet', id: string, examCourseId: string } } };

export type SearchQSetQuestionsSnapshotQueryVariables = Exact<{
  input: SearchQSetQuestionsInput;
}>;


export type SearchQSetQuestionsSnapshotQuery = { __typename?: 'Query', excSearchQSetQuestions: { __typename?: 'SearchQSetQuestionsOutput', total: number, qSetQuestions: Array<{ __typename?: 'QSetQuestion', id: string, questionId: string, questionGroupId: string, questionRefCode: string, order: number, questionSnapshot: { __typename?: 'QSetQuestionSnapshot', id: string, type: QSetQuestionQuestionSnapshotType, details: string, refCode: string, tags: Array<{ __typename?: 'QSetQuestionSnapshotTag', id: string, name: string, category: QSetQuestionSnapshotTagCategory }>, metadata: { __typename?: 'QSetQuestionSnapshotMetadata', reference: string, choices: Array<{ __typename?: 'QSetQuestionSnapshotChoice', label: string, order: number, value: string }> }, correctAnswer: { __typename?: 'QuestionSnapshotCorrectAnswer', value: string }, questionGroup: { __typename?: 'QSetQuestionGroupSnapshot', id: string, type: QSetQuestionGroupSnapshotType, size: number | null, refCode: string, metadata: { __typename?: 'QSetQuestionGroupSnapshotMetadata', paragraph: string | null } | null } | null, solution: { __typename?: 'QSetQuestionSnapshotSolution', type: QSetQuestionQuestionSnapshotSolutionType, value: string } } | null }> } };

export type ExportQSetQueryVariables = Exact<{
  input: ExportQSetInput;
}>;


export type ExportQSetQuery = { __typename?: 'Query', excExportQSet: { __typename?: 'ExportQSetOutput', message: string } };

export type ExportTaskQSetQueryVariables = Exact<{
  input: ExportTaskQSetInput;
}>;


export type ExportTaskQSetQuery = { __typename?: 'Query', excExportTaskQSet: { __typename?: 'ExportQSetOutput', message: string } };

export type PublishQSetsMutationVariables = Exact<{
  input: PublishQSetsInput;
}>;


export type PublishQSetsMutation = { __typename?: 'Mutation', excPublishQSets: { __typename?: 'GenericResponse', data: any | null } };

export type DeleteQSetByIdMutationVariables = Exact<{
  input: DeleteQSetByIdInput;
}>;


export type DeleteQSetByIdMutation = { __typename?: 'Mutation', excDeleteQSetById: { __typename?: 'DeleteQSetByIdOutput', message: string } };

export type UpdateExamUsageOfQSetsMutationVariables = Exact<{
  input: UpdateExamUsageOfQSetsInput;
}>;


export type UpdateExamUsageOfQSetsMutation = { __typename?: 'Mutation', excUpdateExamUsageOfQSets: { __typename?: 'UpdateExamUsageOfQSetsOutput', qSets: Array<{ __typename?: 'QSet', id: string, examUsageStatus: ExamUsageStatus | null }> } };

export type DisableQSetsMutationVariables = Exact<{
  input: DisableQSetsInput;
}>;


export type DisableQSetsMutation = { __typename?: 'Mutation', excDisableQSets: { __typename?: 'DisableQSetsOutput', qSets: Array<{ __typename?: 'QSet', id: string }> } };

export type GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables = Exact<{
  input: GetDownloadSignedUrlForQuestionsByQSetIdInput;
}>;


export type GetDownloadSignedUrlForQuestionsByQSetIdQuery = { __typename?: 'Query', excGetDownloadSignedUrlForQuestionsByQSetId: { __typename?: 'GetDownloadSignedUrlForQuestionsByQSetIdOutput', signedUrls: any } };

export type GetQSetByTaskIdQueryVariables = Exact<{
  input: GetQSetByTaskIdInput;
}>;


export type GetQSetByTaskIdQuery = { __typename?: 'Query', excGetQSetByTaskId: { __typename?: 'GetQSetByTaskIdOutput', qSet: { __typename?: 'QSet', id: string, code: string, examCourseId: string, qConfigId: string, status: QSetStatus, updatedAt: Date, assignees: Array<{ __typename?: 'RawUser', id: string }>, conditions: { __typename?: 'QSetConditions', averagePValue: number, tags: Array<{ __typename?: 'QSetConditionsTags', count: number, tag: { __typename?: 'QSetConditionTag', id: string, name: string } }>, questionTypes: Array<{ __typename?: 'QSetConditionsQuestionType', type: QSetConditionQuestionType, count: number }> } | null } } };

export type SearchQSetAuditLogsQueryVariables = Exact<{
  searchQSetAuditLogInput: SearchQSetAuditLogInput;
}>;


export type SearchQSetAuditLogsQuery = { __typename?: 'Query', excSearchQSetAuditLog: { __typename?: 'SearchQSetAuditLogOutput', total: number, qSetAuditLogs: Array<{ __typename?: 'QSetAuditLog', id: string, action: AuditActionType, fullName: string, detail: string, actionTime: Date }> } };

export type GetQSetQuestionDownloadSignedUrlsQueryVariables = Exact<{
  input: GetQSetQuestionDownloadSignedUrlsInput;
}>;


export type GetQSetQuestionDownloadSignedUrlsQuery = { __typename?: 'Query', excGetQSetQuestionDownloadSignedUrls: { __typename?: 'QSetQuestionDownloadSignedUrls', questionSignedUrls: any, questionGroupSignedUrls: any } };

export type SearchLearningObjectiveStatementsQueryVariables = Exact<{
  search: SearchLearningObjectiveStatementsInput;
  paging: PageInput;
  order: OrderInput;
}>;


export type SearchLearningObjectiveStatementsQuery = { __typename?: 'Query', qbsSearchLearningObjectiveStatements: { __typename?: 'LearningObjectiveStatementsResult', total: number, learningObjectiveStatements: Array<{ __typename?: 'LearningObjectiveStatement', id: string, qBankStructureId: string, qBankStructureLevelItemId: string | null, tagId: string, status: LearningObjectiveStatementStatus, createdAt: Date, updatedAt: Date, enabled: boolean, tag: { __typename?: 'Tag', id: string, name: string }, activeQuestionCount: { __typename?: 'LearningObjectiveStatementActiveQuestionCountDTO', single: number, itemSet: number } }> } };

export type GetLearningObjectiveStatementByIdQueryVariables = Exact<{
  input: GetLearningObjectiveStatementByIdInput;
}>;


export type GetLearningObjectiveStatementByIdQuery = { __typename?: 'Query', qbsGetLearningObjectiveStatementById: { __typename?: 'LearningObjectiveStatement', id: string, createdAt: Date, updatedAt: Date, qBankStructureId: string, tag: { __typename?: 'Tag', id: string, name: string }, qBankStructureLevelItem: { __typename?: 'QBankStructureLevelItem', id: string, tag: { __typename?: 'Tag', name: string } | null } | null } };

export type CreateLearningObjectiveStatementsMutationVariables = Exact<{
  input: CreateLearningObjectiveStatementsInput;
}>;


export type CreateLearningObjectiveStatementsMutation = { __typename?: 'Mutation', qbsCreateLearningObjectiveStatements: Array<{ __typename?: 'LearningObjectiveStatement', id: string, qBankStructureId: string, qBankStructureLevelItemId: string | null, tagId: string, createdAt: Date, updatedAt: Date, tag: { __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null } }> };

export type UpdateLearningObjectiveStatementMutationVariables = Exact<{
  input: UpdateLearningObjectiveStatementInput;
}>;


export type UpdateLearningObjectiveStatementMutation = { __typename?: 'Mutation', qbsUpdateLearningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string } };

export type DeleteLearningObjectiveStatementsMutationVariables = Exact<{
  input: DeleteLearningObjectiveStatementInput;
}>;


export type DeleteLearningObjectiveStatementsMutation = { __typename?: 'Mutation', qbsDeleteLearningObjectiveStatement: { __typename?: 'GenericResponse', data: any | null } };

export type DisableLearningObjectiveStatementMutationVariables = Exact<{
  input: DisableLearningObjectiveStatementInput;
}>;


export type DisableLearningObjectiveStatementMutation = { __typename?: 'Mutation', qbsDisableLearningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string } };

export type GetQBankStructureLevelItemsByQBankStructureIdQueryVariables = Exact<{
  qBankStructureId: Scalars['String']['input'];
  options: InputMaybe<GetQBankStructureLevelItemsByQBankStructureIdOptions>;
}>;


export type GetQBankStructureLevelItemsByQBankStructureIdQuery = { __typename?: 'Query', qbsGetQBankStructureLevelItemsByQBankStructureId: Array<{ __typename?: 'QBankStructureLevelItem', id: string, qBankStructureId: string, tagId: string | null, parentLevelItemId: string | null, order: number, qBankStructureLevelId: string, tag: { __typename?: 'Tag', id: string, name: string } | null }> };

export type GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryVariables = Exact<{
  qBankStructureId: Scalars['String']['input'];
  options: InputMaybe<GetQBankStructureLevelItemsByQBankStructureIdOptions>;
}>;


export type GetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery = { __typename?: 'Query', qbsGetQBankStructureLevelItemsByQBankStructureId: Array<{ __typename?: 'QBankStructureLevelItem', id: string, qBankStructureId: string, tagId: string | null, parentLevelItemId: string | null, order: number, qBankStructureLevelId: string, qId: string | null, tag: { __typename?: 'Tag', id: string, name: string } | null }> };

export type GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryVariables = Exact<{
  qBankStructureId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  options: InputMaybe<QBankStructureLevelItemCategory>;
}>;


export type GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery = { __typename?: 'Query', qbsGetQBankStructureLevelItemsByQBankStructureIdAndUserId: Array<{ __typename?: 'QBankStructureLevelItemPartSubject', id: string, qBankStructureId: string, name: string, parentLevelItemId: string | null, order: number, qBankStructureLevelId: string, type: string, isVisible: boolean }> };

export type GetQBankStructureLevelItemChildrenByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetQBankStructureLevelItemChildrenByIdQuery = { __typename?: 'Query', qbsGetQBankStructureLevelItemChildrenById: Array<{ __typename?: 'QBankStructureLevelItem', id: string, parentLevelItemId: string | null, order: number, qBankStructureLevelId: string, tag: { __typename?: 'Tag', id: string, name: string } | null }> };

export type GetQBankStructureLevelsByQBankStructureIdQueryVariables = Exact<{
  qBankStructureId: Scalars['String']['input'];
}>;


export type GetQBankStructureLevelsByQBankStructureIdQuery = { __typename?: 'Query', qbsGetQBankStructureLevelsByQBankStructureId: Array<{ __typename?: 'QBankStructureLevel', id: string, level: number, category: QBankStructureLevelCategory, enabled: boolean }> };

export type UpdateQBankStructureLevelsByQBankStructureIdMutationVariables = Exact<{
  input: UpdateQBankStructureLevelsByQBankStructureIdInput;
}>;


export type UpdateQBankStructureLevelsByQBankStructureIdMutation = { __typename?: 'Mutation', qbsUpdateQBankStructureLevelsByQBankStructureId: Array<{ __typename?: 'QBankStructureLevel', qBankStructureId: string, level: number, id: string, enabled: boolean, category: QBankStructureLevelCategory }> };

export type GetQBankStructuresByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetQBankStructuresByIdsQuery = { __typename?: 'Query', qbsGetQBankStructuresByIds: Array<{ __typename?: 'QBankStructure', id: string, name: string, code: number }> };

export type UpdateUserToQBankStructureMutationVariables = Exact<{
  input: UpdateUsersContentVisibilityInput;
}>;


export type UpdateUserToQBankStructureMutation = { __typename?: 'Mutation', qbsUpdateUsersQBankStructureLevelItemContentVisibility: { __typename?: 'UpdateUsersContentVisibilityResult', userIds: Array<string>, qbankStructureId: string, courseId: string, visibleContent: Array<{ __typename?: 'UpdateContentVisibilityObject', contentId: string, contentType: ContentType, parentContentId: string | null }> } };

export type QBankStructureFragment = { __typename?: 'QBankStructure', id: string, name: string, code: number, status: QBankStructureStatus, type: QBankStructureType, description: string | null, remark: string | null, createdAt: Date, updatedAt: Date, createdBy: string, groupTag: { __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null } | null };

export type SearchQBankStructuresQueryVariables = Exact<{
  search: SearchQBankStructureInput;
  paging: PageInput;
  order: OrderInput;
}>;


export type SearchQBankStructuresQuery = { __typename?: 'Query', qbsSearchQBankStructures: { __typename?: 'QBankStructuresResult', total: number, qBankStructures: Array<{ __typename?: 'QBankStructure', id: string, name: string, code: number, status: QBankStructureStatus, type: QBankStructureType, description: string | null, remark: string | null, createdAt: Date, updatedAt: Date, createdBy: string, groupTag: { __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null } | null }> } };

export type GetQBankStructureByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetQBankStructureByIdQuery = { __typename?: 'Query', qbsGetQBankStructureById: { __typename?: 'QBankStructure', id: string, name: string, code: number, status: QBankStructureStatus, type: QBankStructureType, description: string | null, remark: string | null, createdAt: Date, updatedAt: Date, createdBy: string, groupTag: { __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null } | null } };

export type CreateQBankStructureMutationVariables = Exact<{
  input: CreateQBankStructureInput;
}>;


export type CreateQBankStructureMutation = { __typename?: 'Mutation', qbsCreateQBankStructure: { __typename?: 'QBankStructure', id: string, name: string, code: number, status: QBankStructureStatus, type: QBankStructureType, description: string | null, remark: string | null, createdAt: Date, updatedAt: Date, createdBy: string, groupTag: { __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null } | null } };

export type DuplicateQBankStructureMutationVariables = Exact<{
  input: DuplicateQBankStructureInput;
}>;


export type DuplicateQBankStructureMutation = { __typename?: 'Mutation', qbsDuplicateQBankStructure: { __typename?: 'QBankStructure', id: string, name: string, code: number, status: QBankStructureStatus, type: QBankStructureType, description: string | null, remark: string | null, createdAt: Date, updatedAt: Date, createdBy: string, groupTag: { __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null } | null } };

export type PublishQBankStructureMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PublishQBankStructureMutation = { __typename?: 'Mutation', qbsPublishQBankStructure: { __typename?: 'QBankStructure', id: string, name: string, code: number, status: QBankStructureStatus, type: QBankStructureType, description: string | null, remark: string | null, createdAt: Date, updatedAt: Date, createdBy: string, groupTag: { __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null } | null } };

export type UnpublishQBankStructureMutationVariables = Exact<{
  unpublishQBankStructureId: Scalars['String']['input'];
}>;


export type UnpublishQBankStructureMutation = { __typename?: 'Mutation', qbsUnpublishQBankStructure: { __typename?: 'QBankStructure', id: string, name: string, code: number, status: QBankStructureStatus, type: QBankStructureType, description: string | null, remark: string | null, createdAt: Date, updatedAt: Date, createdBy: string, groupTag: { __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null } | null } };

export type ArchiveQBankStructureMutationVariables = Exact<{
  archiveQBankStructureId: Scalars['String']['input'];
}>;


export type ArchiveQBankStructureMutation = { __typename?: 'Mutation', qbsArchiveQBankStructure: { __typename?: 'QBankStructure', id: string, name: string, code: number, status: QBankStructureStatus, type: QBankStructureType, description: string | null, remark: string | null, createdAt: Date, updatedAt: Date, createdBy: string, groupTag: { __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null } | null } };

export type UpdateQBankStructureAsDraftMutationVariables = Exact<{
  input: UpdateQBankStructureAsDraftInput;
}>;


export type UpdateQBankStructureAsDraftMutation = { __typename?: 'Mutation', qbsUpdateQBankStructureAsDraft: { __typename?: 'QBankStructure', id: string, name: string, code: number, status: QBankStructureStatus, type: QBankStructureType, description: string | null, remark: string | null, createdAt: Date, updatedAt: Date, createdBy: string, groupTag: { __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null } | null } };

export type UpdateQBankStructureAsPublishedMutationVariables = Exact<{
  input: UpdateQBankStructureAsPublishedInput;
}>;


export type UpdateQBankStructureAsPublishedMutation = { __typename?: 'Mutation', qbsUpdateQBankStructureAsPublished: { __typename?: 'QBankStructure', id: string, name: string, code: number, status: QBankStructureStatus, type: QBankStructureType, description: string | null, remark: string | null, createdAt: Date, updatedAt: Date, createdBy: string, groupTag: { __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null } | null } };

export type UpdateQBankStructureAsUnpublishedMutationVariables = Exact<{
  input: UpdateQBankStructureAsUnpublishedInput;
}>;


export type UpdateQBankStructureAsUnpublishedMutation = { __typename?: 'Mutation', qbsUpdateQBankStructureAsUnpublished: { __typename?: 'QBankStructure', id: string, name: string, code: number, status: QBankStructureStatus, type: QBankStructureType, description: string | null, remark: string | null, createdAt: Date, updatedAt: Date, createdBy: string, groupTag: { __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null } | null } };

export type UpdateQBankStructureAsArchivedMutationVariables = Exact<{
  input: UpdateQBankStructureAsArchivedInput;
}>;


export type UpdateQBankStructureAsArchivedMutation = { __typename?: 'Mutation', qbsUpdateQBankStructureAsArchived: { __typename?: 'QBankStructure', id: string, name: string, code: number, status: QBankStructureStatus, type: QBankStructureType, description: string | null, remark: string | null, createdAt: Date, updatedAt: Date, createdBy: string, groupTag: { __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null } | null } };

export type SaveQBankStructureAsDraftMutationVariables = Exact<{
  input: SaveAsInput;
}>;


export type SaveQBankStructureAsDraftMutation = { __typename?: 'Mutation', qbsSaveAsDraft: { __typename?: 'GenericResponse', data: any | null, message: string, status: GenericResponseStatus } };

export type SaveAsUnpublishedMutationVariables = Exact<{
  input: SaveAsInput;
}>;


export type SaveAsUnpublishedMutation = { __typename?: 'Mutation', qbsSaveAsUnpublished: { __typename?: 'GenericResponse', data: any | null, message: string, status: GenericResponseStatus } };

export type ValidateQBankStructureBeforePublishQueryVariables = Exact<{
  input: ValidateQBankStructureBeforePublishInput;
}>;


export type ValidateQBankStructureBeforePublishQuery = { __typename?: 'Query', qbsValidateQBankStructureBeforePublish: Array<{ __typename?: 'ValidateQBankStructureResult', case: QBankStructureValidationCase, passed: boolean, issues: Array<{ __typename?: 'ValidateIssue', details: string | null, levelItemId: string | null }> }> };

export type SearchQBankStructureGroupTagsQueryVariables = Exact<{
  search: SearchQBankStructureGroupTagInput;
  paging: PageInput;
  order: OrderInput;
}>;


export type SearchQBankStructureGroupTagsQuery = { __typename?: 'Query', qbsSearchQBankStructureGroupTags: { __typename?: 'TagResult', total: number, tags: Array<{ __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null }> } };

export type GetQBankStructureGroupTagByIdQueryVariables = Exact<{
  qbsGetQBankStructureGroupTagById: Scalars['String']['input'];
}>;


export type GetQBankStructureGroupTagByIdQuery = { __typename?: 'Query', qbsGetQBankStructureGroupTagById: { __typename?: 'Tag', id: string, name: string, slug: string | null, category: TagCategory, description: string | null } };

export type GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryVariables = Exact<{
  qBankStructureId: Scalars['String']['input'];
}>;


export type GetQBankStructureLevelItemsAbilityByQBankStructureIdQuery = { __typename?: 'Query', qbsGetQBankStructureLevelItemsAbilityByQBankStructureId: Array<{ __typename?: 'QBankStructureLevelItemsAbility', id: string, isChildrenAddable: boolean }> };

export type QbsSearchQBankStructureAuditLogsQueryVariables = Exact<{
  input: SearchQBankStructureAuditLogsInputType;
}>;


export type QbsSearchQBankStructureAuditLogsQuery = { __typename?: 'Query', qbsSearchQBankStructureAuditLogs: { __typename?: 'SearchQBankStructureAuditLogOutput', total: number, qBankStructureAuditLogs: Array<{ __typename?: 'QBankStructureAuditLog', id: string, action: AuditActionType, actionTime: Date, detail: string, fullName: string }> } };

export type SearchTagsQueryVariables = Exact<{
  search: SearchTagsInput;
  paging: PageInput;
  order: OrderInput;
}>;


export type SearchTagsQuery = { __typename?: 'Query', qbsSearchTags: { __typename?: 'TagResult', tags: Array<{ __typename?: 'Tag', id: string, name: string }> } };

export type SearchTagsByCategoryQueryVariables = Exact<{
  search: SearchTagsInput;
  order: OrderInput;
}>;


export type SearchTagsByCategoryQuery = { __typename?: 'Query', qbsSearchTags: { __typename?: 'TagResult', tags: Array<{ __typename?: 'Tag', name: string, id: string }> } };

export type GetTagsByCategoryQueryVariables = Exact<{
  input: GetTagsByCategoryInput;
}>;


export type GetTagsByCategoryQuery = { __typename?: 'Query', qbsGetTagsByCategory: Array<{ __typename?: 'Tag', id: string, name: string, slug: string | null, description: string | null, category: TagCategory }> };

export type QuestionFragment = { __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null };

export type QuestionGroupFragment = { __typename?: 'QuestionGroup', id: string, name: string, updatedAt: Date, type: QuestionGroupType, refCode: string, status: QuestionGroupStatus, totalQuestions: number, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }>, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null };

export type GetUploadSignedUrlForQuestionQueryVariables = Exact<{
  input: GetUploadSignedUrlQuestionInput;
}>;


export type GetUploadSignedUrlForQuestionQuery = { __typename?: 'Query', qctGetUploadSignedUrlQuestion: { __typename?: 'GetUploadSignedUrlResult', signedUrl: string, storageObject: { __typename?: 'StorageObject', fileName: string | null } } };

export type GetDownloadSignedUrlForQuestionQueryVariables = Exact<{
  input: GetDownloadSignedUrlQuestionInput;
}>;


export type GetDownloadSignedUrlForQuestionQuery = { __typename?: 'Query', qctGetDownloadSignedUrlQuestion: { __typename?: 'GetDownloadSignedUrlsResult', signedUrls: any } };

export type SearchQuestionsQueryVariables = Exact<{
  search: SearchQuestionsInput;
  paging: PageInput;
  order: OrderInput;
}>;


export type SearchQuestionsQuery = { __typename?: 'Query', qctSearchQuestions: { __typename?: 'QuestionsResult', total: number, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> } };

export type CreateQuestionMutationVariables = Exact<{
  input: CreateQuestionInput;
}>;


export type CreateQuestionMutation = { __typename?: 'Mutation', qctCreateQuestion: { __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null } };

export type SaveQuestionAsDraftMutationVariables = Exact<{
  input: SaveQuestionAsDraftInput;
}>;


export type SaveQuestionAsDraftMutation = { __typename?: 'Mutation', qctSaveQuestionAsDraft: { __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null } };

export type SaveQuestionAsUnpublishedMutationVariables = Exact<{
  input: SaveQuestionAsUnpublishInput;
}>;


export type SaveQuestionAsUnpublishedMutation = { __typename?: 'Mutation', qctSaveQuestionAsUnpublish: { __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null } };

export type GetUploadSignedUrlImportQuestionSpreadsheetQueryVariables = Exact<{
  input: GetUploadSignedUrlImportQuestionSpreadsheetInput;
}>;


export type GetUploadSignedUrlImportQuestionSpreadsheetQuery = { __typename?: 'Query', qctGetUploadSignedUrlImportQuestionSpreadsheet: { __typename?: 'GetUploadSignedUrlResult', signedUrl: string, storageObject: { __typename?: 'StorageObject', fileName: string | null } } };

export type ImportQuestionSpreadsheetMutationVariables = Exact<{
  input: ImportQuestionSpreadsheetInput;
}>;


export type ImportQuestionSpreadsheetMutation = { __typename?: 'Mutation', qctImportQuestionSpreadsheet: { __typename?: 'ImportQuestionSpreadsheetResult', success: boolean, message: string } };

export type ExportSingleQuestionMutationVariables = Exact<{
  input: ExportSingleQuestionInput;
}>;


export type ExportSingleQuestionMutation = { __typename?: 'Mutation', qctExportSingleQuestion: { __typename?: 'ExportQuestionResult', message: string } };

export type GetQuestionByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetQuestionByIdQuery = { __typename?: 'Query', qctGetQuestionById: { __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null } };

export type GetQuestionGroupsByQBankStructureLevelItemIdQueryVariables = Exact<{
  input: GetQuestionGroupsByQBankStructureLevelItemIdInput;
}>;


export type GetQuestionGroupsByQBankStructureLevelItemIdQuery = { __typename?: 'Query', qctGetQuestionGroupsByQBankStructureLevelItemId: Array<{ __typename?: 'QuestionGroup', id: string, name: string, updatedAt: Date, type: QuestionGroupType, refCode: string, status: QuestionGroupStatus, totalQuestions: number, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }>, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null }> };

export type GetQuestionGroupByIdQueryVariables = Exact<{
  questionGroupId: Scalars['String']['input'];
}>;


export type GetQuestionGroupByIdQuery = { __typename?: 'Query', qctGetQuestionGroupById: { __typename?: 'QuestionGroup', id: string, name: string, updatedAt: Date, type: QuestionGroupType, refCode: string, status: QuestionGroupStatus, totalQuestions: number, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }>, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } };

export type CreateItemSetQuestionGroupMutationVariables = Exact<{
  input: CreateItemSetInput;
}>;


export type CreateItemSetQuestionGroupMutation = { __typename?: 'Mutation', qctCreateItemSet: { __typename?: 'QuestionGroup', id: string, name: string, updatedAt: Date, type: QuestionGroupType, refCode: string, status: QuestionGroupStatus, totalQuestions: number, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }>, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } };

export type DuplicateQuestionMutationVariables = Exact<{
  input: DuplicateQuestionInput;
}>;


export type DuplicateQuestionMutation = { __typename?: 'Mutation', qctDuplicateQuestion: { __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null } };

export type PublishQuestionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PublishQuestionMutation = { __typename?: 'Mutation', qctPublishQuestion: { __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null } };

export type PublishItemSetMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PublishItemSetMutation = { __typename?: 'Mutation', qctPublishItemSet: { __typename?: 'QuestionGroup', id: string, name: string, updatedAt: Date, type: QuestionGroupType, refCode: string, status: QuestionGroupStatus, totalQuestions: number, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }>, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } };

export type SearchQuestionGroupsQueryVariables = Exact<{
  search: SearchQuestionGroupsInput;
  paging: PageInput;
  order: OrderInput;
}>;


export type SearchQuestionGroupsQuery = { __typename?: 'Query', qctSearchQuestionGroups: { __typename?: 'QuestionGroupsResult', total: number, questionGroups: Array<{ __typename?: 'QuestionGroup', id: string, name: string, updatedAt: Date, type: QuestionGroupType, refCode: string, status: QuestionGroupStatus, totalQuestions: number, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }>, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null }> } };

export type SearchItemSetQuestionsInLocationQueryVariables = Exact<{
  search: SearchQuestionGroupsInput;
  paging: PageInput;
  order: OrderInput;
}>;


export type SearchItemSetQuestionsInLocationQuery = { __typename?: 'Query', qctSearchQuestionGroups: { __typename?: 'QuestionGroupsResult', total: number, questionGroups: Array<{ __typename?: 'QuestionGroup', id: string, name: string, totalQuestions: number, status: QuestionGroupStatus, refCode: string }> } };

export type SaveItemSetAsDraftMutationVariables = Exact<{
  input: SaveItemSetAsDraftInput;
}>;


export type SaveItemSetAsDraftMutation = { __typename?: 'Mutation', qctSaveItemSetAsDraft: { __typename?: 'QuestionGroup', id: string, name: string, updatedAt: Date, type: QuestionGroupType, refCode: string, status: QuestionGroupStatus, totalQuestions: number, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }>, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } };

export type GetDownloadSignedUrlForQuestionsQueryVariables = Exact<{
  input: GetDownloadSignedUrlForQuestionsInput;
}>;


export type GetDownloadSignedUrlForQuestionsQuery = { __typename?: 'Query', qctGetDownloadSignedUrlForQuestions: { __typename?: 'GetDownloadSignedUrlForQuestionsResult', signedUrls: any } };

export type GetDownloadSignedUrlForQuestionGroupsQueryVariables = Exact<{
  input: GetDownloadSignedUrlForQuestionGroupsInput;
}>;


export type GetDownloadSignedUrlForQuestionGroupsQuery = { __typename?: 'Query', qctGetDownloadSignedUrlForQuestionGroups: { __typename?: 'GetDownloadSignedUrlForQuestionGroupsResult', signedUrls: any } };

export type ExportItemSetMutationVariables = Exact<{
  input: ExportItemSetInput;
}>;


export type ExportItemSetMutation = { __typename?: 'Mutation', qctExportItemSet: { __typename?: 'ExportQuestionResult', message: string } };

export type PendingQuestionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PendingQuestionMutation = { __typename?: 'Mutation', qctUnpublishQuestion: { __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null } };

export type DisableQuestionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DisableQuestionMutation = { __typename?: 'Mutation', qctDisableQuestion: { __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null } };

export type SaveItemSetAsUnpublishedMutationVariables = Exact<{
  input: SaveItemSetAsUnpublishInput;
}>;


export type SaveItemSetAsUnpublishedMutation = { __typename?: 'Mutation', qctSaveItemSetAsUnpublish: { __typename?: 'QuestionGroup', id: string, name: string, updatedAt: Date, type: QuestionGroupType, refCode: string, status: QuestionGroupStatus, totalQuestions: number, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }>, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } };

export type PendingItemSetMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PendingItemSetMutation = { __typename?: 'Mutation', qctUnpublishItemSet: { __typename?: 'QuestionGroup', id: string, name: string, updatedAt: Date, type: QuestionGroupType, refCode: string, status: QuestionGroupStatus, totalQuestions: number, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }>, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } };

export type DisableItemSetMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DisableItemSetMutation = { __typename?: 'Mutation', qctDisableItemSet: { __typename?: 'QuestionGroup', id: string, name: string, updatedAt: Date, type: QuestionGroupType, refCode: string, status: QuestionGroupStatus, totalQuestions: number, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }>, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } };

export type DeleteItemSetSubQuestionMutationVariables = Exact<{
  input: DeleteItemSetSubQuestionInput;
}>;


export type DeleteItemSetSubQuestionMutation = { __typename?: 'Mutation', qctDeleteItemSetSubQuestion: { __typename?: 'QuestionGroup', id: string, name: string, updatedAt: Date, type: QuestionGroupType, refCode: string, status: QuestionGroupStatus, totalQuestions: number, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }>, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } };

export type GetSingleQuestionPropertiesByStatusAndLocationQueryVariables = Exact<{
  input: GetSingleQuestionPropertiesByStatusAndLocationInputType;
}>;


export type GetSingleQuestionPropertiesByStatusAndLocationQuery = { __typename?: 'Query', qctGetSingleQuestionPropertiesByStatusAndLocation: Array<{ __typename?: 'SingleQuestionPropertiesByLocation', locationType: SingleQuestionPropertiesLocationType, locationId: string, questionProperties: Array<{ __typename?: 'SingleQuestionProperties', totalQuestions: number, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string }> }> }> };

export type GetItemSetQuestionPropertiesByStatusAndLocationQueryVariables = Exact<{
  input: GetItemSetQuestionPropertiesByStatusAndLocationInputType;
}>;


export type GetItemSetQuestionPropertiesByStatusAndLocationQuery = { __typename?: 'Query', qctGetItemSetQuestionPropertiesByStatusAndLocation: Array<{ __typename?: 'ItemSetQuestionPropertiesByLocation', locationType: ItemSetQuestionPropertiesLocationType, locationId: string, size: number, questionProperties: Array<{ __typename?: 'ItemSetQuestionProperties', totalQuestions: number, tagGroups: Array<{ __typename?: 'TagGroup', count: number, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string }> }> }> }> };

export type GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryVariables = Exact<{
  input: GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationInputType;
}>;


export type GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery = { __typename?: 'Query', qctGetSingleQuestionQuestionGroupPropertiesByStatusAndLocation: Array<{ __typename?: 'SingleQuestionQuestionGroupPropertiesByLocation', locationType: SingleQuestionPropertiesLocationType, locationId: string, questionGroupProperties: Array<{ __typename?: 'SingleQuestionQuestionGroupProperties', questionGroupType: QuestionGroupType, totalQuestionGroups: number, totalQuestions: number, questionProperties: Array<{ __typename?: 'SingleQuestionProperties', totalQuestions: number, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string }> }> }> }> };

export type SearchQContentAuditLogsQueryVariables = Exact<{
  input: SearchQContentAuditLogsInputType;
}>;


export type SearchQContentAuditLogsQuery = { __typename?: 'Query', qctSearchQContentAuditLogs: { __typename?: 'SearchQContentAuditLogOutput', total: number, qContentAuditLogs: Array<{ __typename?: 'QContentAuditLogObjectType', id: string, action: AuditActionType, fullName: string, detail: string, actionTime: Date }> } };

export type GetQuestionUsageByIdQueryVariables = Exact<{
  questionId: Scalars['String']['input'];
}>;


export type GetQuestionUsageByIdQuery = { __typename?: 'Query', qctGetQuestionUsageById: Array<{ __typename?: 'GetQuestionUsageByIdOutput', qSetQuestionId: string, qSetQuestionOrder: number, qSetCode: string, qSetStatus: string, examCourseCode: string, examCourseName: string, qConfigRefCode: number }> };

export type SearchQuestionsByLosQueryVariables = Exact<{
  search: SearchQuestionsInLearningObjectiveStatementInput;
  order: OrderInput;
  paging: PageInput;
}>;


export type SearchQuestionsByLosQuery = { __typename?: 'Query', qctSearchQuestionsInLearningObjectiveStatement: { __typename?: 'QuestionsResult', total: number, questions: Array<{ __typename?: 'Question', id: string, refCode: string, status: QuestionStatus, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, type: QuestionGroupType } | null }> } };

export type SearchQuestionsByKeywordQueryVariables = Exact<{
  input: SearchQuestionsByKeywordInput;
  paging: PageInput;
}>;


export type SearchQuestionsByKeywordQuery = { __typename?: 'Query', qctSearchQuestionsByKeyword: { __typename?: 'QuestionKeywordSearchResultDTO', total: number, items: Array<{ __typename?: 'QuestionKeywordSearchItemDTO', id: string, refCode: string, details: string, type: string, status: string, pValue: number | null, bIndexValue: number | null, questionGroupId: string, groupOrder: number | null, refQBankStructureId: string, createdBy: string, lastPublishedBy: string | null, lastPublishedAt: string | null, locationIds: Array<string>, updatedAt: string | null, metadata: { __typename?: 'QuestionSearchMetadataDTO', reference: string | null, firstPublishedAt: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionSearchChoiceDTO', label: string, order: number, value: number }>, owner: { __typename?: 'QuestionSearchOwnerDTO', type: string, value: string | null } | null }, correctAnswer: { __typename?: 'QuestionSearchCorrectAnswerDTO', value: string | null }, solution: { __typename?: 'QuestionSearchSolutionDTO', type: string, value: string | null } | null, questionGroup: { __typename?: 'QuestionSearchGroupDTO', id: string, name: string, type: string, status: string, paragraph: string | null, size: number | null } | null, tags: Array<{ __typename?: 'QuestionSearchTagDTO', id: string, name: string | null, category: string | null }> }> } };

export type SearchQuestionsByQIdsQueryVariables = Exact<{
  input: SearchQuestionsByQIdsInput;
  paging: PageInput;
}>;


export type SearchQuestionsByQIdsQuery = { __typename?: 'Query', qctSearchQuestionsByQIds: { __typename?: 'SearchQuestionsByQIdsResultDTO', total: number, foundQIds: Array<string>, notFoundQIds: Array<string>, items: Array<{ __typename?: 'QuestionKeywordSearchItemDTO', id: string, refCode: string, details: string, type: string, status: string, pValue: number | null, bIndexValue: number | null, questionGroupId: string, groupOrder: number | null, refQBankStructureId: string, createdBy: string, lastPublishedBy: string | null, lastPublishedAt: string | null, locationIds: Array<string>, updatedAt: string | null, metadata: { __typename?: 'QuestionSearchMetadataDTO', reference: string | null, firstPublishedAt: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionSearchChoiceDTO', label: string, order: number, value: number }>, owner: { __typename?: 'QuestionSearchOwnerDTO', type: string, value: string | null } | null }, correctAnswer: { __typename?: 'QuestionSearchCorrectAnswerDTO', value: string | null }, solution: { __typename?: 'QuestionSearchSolutionDTO', type: string, value: string | null } | null, questionGroup: { __typename?: 'QuestionSearchGroupDTO', id: string, name: string, type: string, status: string, paragraph: string | null, size: number | null } | null, tags: Array<{ __typename?: 'QuestionSearchTagDTO', id: string, name: string | null, category: string | null }> }> } };

export type ExportSearchResultsMutationVariables = Exact<{
  input: ExportSearchResultsInput;
}>;


export type ExportSearchResultsMutation = { __typename?: 'Mutation', qctExportSearchResults: { __typename?: 'ExportQuestionResult', message: string } };

export type GetAppPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppPermissionsQuery = { __typename?: 'Query', getAppPermissions: Array<{ __typename?: 'AppPermission', id: string }> };

export type GetAppRoleAppPermissionsQueryVariables = Exact<{
  appRoleId: Scalars['String']['input'];
}>;


export type GetAppRoleAppPermissionsQuery = { __typename?: 'Query', getAppRoleAppPermissions: Array<{ __typename?: 'AppPermission', id: string }> };

export type UpdateAppRoleAppPermissionsMutationVariables = Exact<{
  appPermissionIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  updateAppRoleAppPermissionsAppRoleId: Scalars['String']['input'];
}>;


export type UpdateAppRoleAppPermissionsMutation = { __typename?: 'Mutation', suUpdateAppRoleAppPermissions: { __typename?: 'UpdateAppRoleAppPermissionsMutationResponse', code: string, message: string | null, success: boolean } };

export type CreateAppRoleMutationVariables = Exact<{
  data: CreateAppRoleInput;
}>;


export type CreateAppRoleMutation = { __typename?: 'Mutation', suCreateAppRole: { __typename?: 'CreateAppRoleMutationResponse', code: string, success: boolean, message: string | null, details: any | null, newAppRole: { __typename?: 'AppRole', name: string, description: string | null, id: string } } };

export type UpdateAppRoleMutationVariables = Exact<{
  data: UpdateAppRoleInput;
}>;


export type UpdateAppRoleMutation = { __typename?: 'Mutation', suUpdateAppRole: { __typename?: 'UpdateAppRoleMutationResponse', code: string, success: boolean, message: string | null, details: any | null, appRole: { __typename?: 'AppRole', id: string, name: string, description: string | null } } };

export type DeleteAppRoleMutationVariables = Exact<{
  data: DeleteAppRoleInput;
}>;


export type DeleteAppRoleMutation = { __typename?: 'Mutation', suDeleteAppRole: { __typename?: 'DeleteAppRoleMutationResponse', code: string, success: boolean, message: string | null } };

export type GetAppRoleQueryVariables = Exact<{
  appRoleId: Scalars['String']['input'];
}>;


export type GetAppRoleQuery = { __typename?: 'Query', suGetAppRole: { __typename?: 'GetAppRoleOutputObjectType', id: string, name: string, description: string | null } };

export type GetAppRolesQueryVariables = Exact<{
  order: InputMaybe<OrderInput>;
  paging: InputMaybe<PageInput>;
  search: InputMaybe<AppRoleSearchInput>;
}>;


export type GetAppRolesQuery = { __typename?: 'Query', getAppRoles: { __typename?: 'AppRoleSearchResult', total: number, roles: Array<{ __typename?: 'AppRole', name: string, id: string, description: string | null }> } };

export type SearchUserAppRoleViewQueryVariables = Exact<{
  appRoleId: InputMaybe<Scalars['String']['input']>;
  invertRoleFilter: InputMaybe<Scalars['Boolean']['input']>;
  order: InputMaybe<OrderInput>;
  paging: InputMaybe<PageInput>;
  search: InputMaybe<SearchInput>;
}>;


export type SearchUserAppRoleViewQuery = { __typename?: 'Query', getUserAppRoleView: { __typename?: 'UserAppRoleViewSearchResult', total: number, users: Array<{ __typename?: 'UserAppRoleView', firstname: string, lastname: string, email: string | null, id: string, lastLoginAt: string | null, status: string | null, invitationExpireAt: string | null }> } };

export type AssignUserAppRoleMutationVariables = Exact<{
  data: AssignUserAppRoleInput;
}>;


export type AssignUserAppRoleMutation = { __typename?: 'Mutation', suAssignUserAppRole: { __typename?: 'AssignUserAppRoleMutationResponse', success: boolean, message: string | null, code: string } };

export type UnassignUserAppRoleMutationVariables = Exact<{
  data: UnassignUserAppRoleInput;
}>;


export type UnassignUserAppRoleMutation = { __typename?: 'Mutation', unassignUserAppRole: { __typename?: 'AssignUserAppRoleMutationResponse', success: boolean, message: string | null, code: string } };

export type AssignUserAppRolesMutationVariables = Exact<{
  data: AssignUserAppRolesInput;
}>;


export type AssignUserAppRolesMutation = { __typename?: 'Mutation', assignUserAppRoles: { __typename?: 'AssignUserAppRolesMutationResponse', code: string, success: boolean, message: string | null } };

export type UnassignUserAppRolesMutationVariables = Exact<{
  data: UnassignUserAppRolesInput;
}>;


export type UnassignUserAppRolesMutation = { __typename?: 'Mutation', suUnassignUserAppRoles: { __typename?: 'UnassignUserAppRolesMutationResponse', success: boolean, message: string | null, code: string, details: any | null, appRoles: Array<{ __typename?: 'AppRole', name: string, level: number | null, id: string, description: string | null }> } };

export type UsBoUserFragment = { __typename?: 'UsBoUser', id: string, firstname: string, lastname: string, email: string | null, appRoles: Array<string>, lastLoginAt: string | null, status: string | null, createdAt: string | null, updatedAt: string | null, updatedBy: string | null, invitationExpireAt: string | null };

export type SearchUserListQueryVariables = Exact<{
  order: InputMaybe<OrderInput>;
  paging: InputMaybe<PageInput>;
  search: InputMaybe<UsBoUserSearchInput>;
}>;


export type SearchUserListQuery = { __typename?: 'Query', UsBoUsers: { __typename?: 'UsBoUserSearchResult', total: number, users: Array<{ __typename?: 'UsBoUser', id: string, appRoles: Array<string>, status: string | null, email: string | null, firstname: string, lastname: string, lastLoginAt: string | null, invitationExpireAt: string | null }> } };

export type SearchUsersByAppRoleFiltersQueryVariables = Exact<{
  appRoleNames: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  order: InputMaybe<OrderInput>;
  paging: InputMaybe<PageInput>;
  search: InputMaybe<UsBoUserSearchInput>;
}>;


export type SearchUsersByAppRoleFiltersQuery = { __typename?: 'Query', UsBoSearchUsersWithAppRoleFilters: { __typename?: 'UsBoUserSearchResult', total: number, users: Array<{ __typename?: 'UsBoUser', id: string, firstname: string, lastname: string, email: string | null, appRoles: Array<string>, lastLoginAt: string | null, status: string | null, createdAt: string | null, updatedAt: string | null, updatedBy: string | null, invitationExpireAt: string | null }> } };

export type GetUserProfileQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserProfileQuery = { __typename?: 'Query', UsBoUser: { __typename?: 'UsBoUser', id: string, firstname: string, lastname: string, email: string | null, appRoles: Array<string>, lastLoginAt: string | null, status: string | null, createdAt: string | null, updatedAt: string | null, updatedBy: string | null, invitationExpireAt: string | null } };

export type CreateIndividualUserMutationVariables = Exact<{
  quickCreateInput: QuickCreateInput;
  appRoleIds: InputMaybe<AppRoleIdsInput>;
}>;


export type CreateIndividualUserMutation = { __typename?: 'Mutation', suQuickCreateUser: { __typename?: 'QuickCreateUserObjectType', success: boolean, message: string | null, createdUser: { __typename?: 'UserAppRoleView', id: string }, appRolesResponse: { __typename?: 'AssignUserAppRolesMutationResponse', code: string, success: boolean, message: string | null, appRoles: Array<{ __typename?: 'AppRole', id: string }> | null } } };

export type AcceptResetPasswordMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type AcceptResetPasswordMutation = { __typename?: 'Mutation', suAcceptResetPassword: { __typename?: 'AcceptResetPasswordOutputObjectType', success: boolean, message: string | null } };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', suResetPassword: { __typename?: 'ResetPasswordOutputObjectType', code: string, success: boolean, message: string | null, details: any | null } };

export type ResendResetPasswordEmailMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ResendResetPasswordEmailMutation = { __typename?: 'Mutation', suResendResetPasswordEmail: { __typename?: 'ResendResetPasswordEmailOutputObjectType', success: boolean, message: string | null } };

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  data: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', suUpdateUser: { __typename?: 'UpdateUserOutputObjectType', id: string, firstname: string, lastname: string, email: string | null, lastLoginAt: string | null, status: string | null, createdAt: string | null, invitationExpireAt: string | null } };

export type UpdateUserAppRolesMutationVariables = Exact<{
  data: UpdateUserAppRolesInput;
}>;


export type UpdateUserAppRolesMutation = { __typename?: 'Mutation', updateUserAppRoles: { __typename?: 'UpdateUserAppRolesMutationResponse', code: string, success: boolean, message: string | null } };

export type UpdateUserAppRoleByNamesMutationVariables = Exact<{
  data: UpdateUserAppRoleByNamesInput;
}>;


export type UpdateUserAppRoleByNamesMutation = { __typename?: 'Mutation', updateUserAppRoleByNames: { __typename?: 'UpdateUserAppRoleByNameMutationResponse', code: string, success: boolean, message: string | null } };

export type UserUpdateStatusMutationVariables = Exact<{
  data: UpdateUserStatusInput;
}>;


export type UserUpdateStatusMutation = { __typename?: 'Mutation', suUpdateUserStatus: { __typename?: 'UpdateUserStatusOutputObjectType', code: string, success: boolean, message: string | null } };

export type ValidateTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ValidateTokenQuery = { __typename?: 'Query', validateToken: { __typename?: 'ValidateTokenResult', description: string | null, isValid: boolean } };

export type GetReviewQSetSubtaskDetailsByIdQueryVariables = Exact<{
  getTaskByIdInput: GetTaskByIdInput;
}>;


export type GetReviewQSetSubtaskDetailsByIdQuery = { __typename?: 'Query', wflGetTaskById: { __typename?: 'GetTaskByIdOutput', task: { __typename?: 'Task', ownerId: string, assignerId: string, status: TaskStatus, dueDate: Date | null, name: string | null, id: string, workflowId: string, currentWorkflowStepId: string, code: string, updatedAt: Date, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string }, currentWorkflowStep: { __typename?: 'WorkflowStep', workflowCode: WorkflowCode, code: WorkflowStepCode, name: string }, parentTask: { __typename?: 'Task', ownerId: string, name: string | null } | null, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string }, metadata: { __typename?: 'TaskMetadataWithAdditionalData' } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet', qSet: { __typename?: 'QSetTask', id: string, code: string, pAvgValue: number, status: QSetTaskStatus, examCourse: { __typename?: 'ExamCourseTask', code: string, examId: number, name: string }, qConfig: { __typename?: 'QConfigTask', fullScore: number, totalQuestions: number, metadata: { __typename?: 'QConfigTaskMetadata', conditions: { __typename?: 'QConfigTaskMetadataCondition', questionTypes: Array<{ __typename?: 'QConfigTaskMetadataConditionQuestion', type: string, needTotal: number }>, tags: Array<{ __typename?: 'QConfigTaskMetadataConditionTag', needTotal: number, tag: { __typename?: 'TaskQConfigConditionTag', id: string, name: string } }> } | null, timeLimit: { __typename?: 'QConfigTaskMetadataTimeLimit', type: string, total: number | null, values: Array<{ __typename?: 'QConfigTaskMetadataTimeLimitValue', order: number, value: number, qConfigStructureIds: Array<string> | null }> } | null, passingCriteria: { __typename?: 'QConfigTaskMetadataPassingCriteria', type: string, value: number } | null, randomConfig: { __typename?: 'QConfigTaskMetadataRandomConfig', type: QConfigRandomConfigType, groupBy: QConfigRandomGroupBy | null } | null }, structures: Array<{ __typename?: 'QConfigStructuresTask', id: string, score: number, name: string | null, order: number, category: QConfigStructureCategory | null, totalQuestions: number, type: QConfigStructureType, passingCriteria: { __typename?: 'QConfigStructurePassingCriteriaObjectType', value: number, type: QConfigPassingCriteriaType } | null }> } } } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion' } } } };

export type GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryVariables = Exact<{
  getTaskByIdInput: GetTaskByIdInput;
}>;


export type GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery = { __typename?: 'Query', wflGetTaskById: { __typename?: 'GetTaskByIdOutput', task: { __typename?: 'Task', metadata: { __typename?: 'TaskMetadataWithAdditionalData' } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet', qSet: { __typename?: 'QSetTask', qConfig: { __typename?: 'QConfigTask', metadata: { __typename?: 'QConfigTaskMetadata', timeLimit: { __typename?: 'QConfigTaskMetadataTimeLimit', type: string, values: Array<{ __typename?: 'QConfigTaskMetadataTimeLimitValue', order: number, value: number, qConfigStructureIds: Array<string> | null }> } | null, randomConfig: { __typename?: 'QConfigTaskMetadataRandomConfig', type: QConfigRandomConfigType, groupBy: QConfigRandomGroupBy | null } | null } } } } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion' } } } };

export type GetDownloadSignedUrlForExamCourseCommentQueryVariables = Exact<{
  getDownloadSignedUrlForExamCourseCommentInput: GetDownloadSignedUrlForExamCourseCommentInput;
}>;


export type GetDownloadSignedUrlForExamCourseCommentQuery = { __typename?: 'Query', excGetDownloadSignedUrlForExamCourseComment: { __typename?: 'GetDownloadSignedUrlForExamCourseCommentOutput', signedUrls: any } };

export type GetUploadSignedUrlForExamCourseCommentQueryVariables = Exact<{
  getUploadSignedUrlForExamCourseCommentInput: GetUploadSignedUrlForExamCourseCommentInput;
}>;


export type GetUploadSignedUrlForExamCourseCommentQuery = { __typename?: 'Query', excGetUploadSignedUrlForExamCourseComment: { __typename?: 'GetUploadSignedUrlForExamCourseCommentOutput', signedUrl: string, storageObject: { __typename?: 'StorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null } } };

export type SubmitQSetReviewMutationVariables = Exact<{
  submitQSetReviewInput: SubmitQSetReviewInput;
}>;


export type SubmitQSetReviewMutation = { __typename?: 'Mutation', wflSubmitQSetReview: { __typename?: 'SubmitQSetReviewOutput', success: boolean, message: string, code: SubmitQSetReviewErrorCode | null, missingQuestionVerdictCount: number } };

export type QuestionForQuestionCreationListFragment = { __typename?: 'Question', id: string, questionStructures: Array<{ __typename?: 'QuestionStructure', id: string, levelItem: { __typename?: 'QBankStructureLevelItem', id: string, parentLevelItemId: string | null, tag: { __typename?: 'Tag', id: string, name: string } | null, qBankStructureLevel: { __typename?: 'QBankStructureLevel', id: string, category: QBankStructureLevelCategory } | null } | null }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, type: QuestionGroupType } | null, tags: Array<{ __typename?: 'Tag', name: string, category: TagCategory }> };

export type GetQBankStructureLevelsForQuestionCreationQueryVariables = Exact<{
  qBankStructureId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
}>;


export type GetQBankStructureLevelsForQuestionCreationQuery = { __typename?: 'Query', qbsGetTaskQBankStructureLevelsByQBankStructureId: Array<{ __typename?: 'QBankStructureLevel', id: string, level: number, category: QBankStructureLevelCategory, enabled: boolean }> };

export type GetQBankStructureLevelItemsForQuestionCreationQueryVariables = Exact<{
  qBankStructureId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
}>;


export type GetQBankStructureLevelItemsForQuestionCreationQuery = { __typename?: 'Query', qbsGetTaskQBankStructureLevelItemsByQBankStructureId: Array<{ __typename?: 'QBankStructureLevelItem', id: string, qBankStructureId: string, tagId: string | null, parentLevelItemId: string | null, order: number, qBankStructureLevelId: string, tag: { __typename?: 'Tag', id: string, name: string } | null }> };

export type SearchTaskLearningObjectiveStatementsQueryVariables = Exact<{
  taskId: Scalars['String']['input'];
  search: SearchLearningObjectiveStatementsInput;
  paging: PageInput;
  order: OrderInput;
}>;


export type SearchTaskLearningObjectiveStatementsQuery = { __typename?: 'Query', qbsSearchTaskLearningObjectiveStatements: { __typename?: 'LearningObjectiveStatementsResult', total: number, learningObjectiveStatements: Array<{ __typename?: 'LearningObjectiveStatement', id: string, qBankStructureId: string, qBankStructureLevelItemId: string | null, tagId: string, updatedAt: Date, tag: { __typename?: 'Tag', id: string, name: string } }> } };

export type SearchTaskTagsQueryVariables = Exact<{
  taskId: Scalars['String']['input'];
  search: SearchTaskTagsInput;
  paging: PageInput;
  order: OrderInput;
}>;


export type SearchTaskTagsQuery = { __typename?: 'Query', qbsSearchTaskTags: { __typename?: 'TagResult', tags: Array<{ __typename?: 'Tag', name: string, id: string }> } };

export type CreateInDevelopmentQuestionMutationVariables = Exact<{
  input: CreateInDevelopmentQuestionInput;
  taskId: Scalars['String']['input'];
}>;


export type CreateInDevelopmentQuestionMutation = { __typename?: 'Mutation', qctCreateInDevelopmentQuestion: { __typename?: 'Question', id: string } };

export type SaveInDevelopmentQuestionMutationVariables = Exact<{
  input: SaveQuestionAsDraftInput;
  taskId: Scalars['String']['input'];
}>;


export type SaveInDevelopmentQuestionMutation = { __typename?: 'Mutation', qctSaveQuestionAsInDevelopment: { __typename?: 'Question', id: string } };

export type GetQuestionsByIdAndQuestionCreationTaskIdQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  taskId: Scalars['String']['input'];
}>;


export type GetQuestionsByIdAndQuestionCreationTaskIdQuery = { __typename?: 'Query', qctGetTaskQuestionsByIds: Array<{ __typename?: 'Question', id: string, questionStructures: Array<{ __typename?: 'QuestionStructure', id: string, levelItem: { __typename?: 'QBankStructureLevelItem', id: string, parentLevelItemId: string | null, tag: { __typename?: 'Tag', id: string, name: string } | null, qBankStructureLevel: { __typename?: 'QBankStructureLevel', id: string, category: QBankStructureLevelCategory } | null } | null }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, type: QuestionGroupType } | null, tags: Array<{ __typename?: 'Tag', name: string, category: TagCategory }> }> };

export type GetCreatingQuestionByIdQueryVariables = Exact<{
  taskId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type GetCreatingQuestionByIdQuery = { __typename?: 'Query', qctGetTaskQuestionById: { __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null } };

export type CreateItemSetWorkflowMutationVariables = Exact<{
  input: CreateItemSetInput;
}>;


export type CreateItemSetWorkflowMutation = { __typename?: 'Mutation', qctCreateItemSetWorkflow: { __typename?: 'QuestionGroup', id: string, questions: Array<{ __typename?: 'Question', questionGroupId: string }> | null } };

export type GetTaskQuestionGroupByIdQueryVariables = Exact<{
  questionGroupId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
}>;


export type GetTaskQuestionGroupByIdQuery = { __typename?: 'Query', qctGetTaskQuestionGroupById: { __typename?: 'QuestionGroup', id: string, name: string, updatedAt: Date, type: QuestionGroupType, refCode: string, status: QuestionGroupStatus, totalQuestions: number, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }>, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } };

export type SaveItemSetAsDraftWorkflowMutationVariables = Exact<{
  input: SaveItemSetAsDraftInput;
  taskId: Scalars['String']['input'];
}>;


export type SaveItemSetAsDraftWorkflowMutation = { __typename?: 'Mutation', qctSaveItemSetAsDraftWorkflow: { __typename?: 'QuestionGroup', id: string } };

export type GetTaskQuestionGroupByIdsQueryVariables = Exact<{
  questionGroupIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  taskId: Scalars['String']['input'];
}>;


export type GetTaskQuestionGroupByIdsQuery = { __typename?: 'Query', qctGetTaskQuestionGroupByIds: Array<{ __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType, size: number | null, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, questionStructures: Array<{ __typename?: 'QuestionStructure', id: string, refLevelItemId: string, entityId: string, entityName: string, refSource: string, levelItem: { __typename?: 'QBankStructureLevelItem', id: string, qBankStructureId: string, tagId: string | null, parentLevelItemId: string | null, order: number, qBankStructureLevelId: string, qId: string | null, tag: { __typename?: 'Tag', id: string, name: string, slug: string | null, description: string | null, category: TagCategory } | null, qBankStructureLevel: { __typename?: 'QBankStructureLevel', id: string, qBankStructureId: string, level: number, category: QBankStructureLevelCategory, enabled: boolean } | null } | null }> | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> | null }> };

export type DeleteItemSetSubQuestionWorkflowMutationVariables = Exact<{
  input: DeleteItemSetSubQuestionInput;
  taskId: Scalars['String']['input'];
}>;


export type DeleteItemSetSubQuestionWorkflowMutation = { __typename?: 'Mutation', qctDeleteItemSetSubQuestionWorkflow: { __typename?: 'QuestionGroup', id: string, name: string, updatedAt: Date, type: QuestionGroupType, refCode: string, status: QuestionGroupStatus, totalQuestions: number, questions: Array<{ __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, refCode: string, type: QuestionGroupType } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null }> | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }>, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } };

export type QuestionReviewTaskDetailFragment = { __typename?: 'Task', id: string, code: string, name: string | null, status: TaskStatus, dueDate: Date | null, updatedAt: Date, description: string | null, assigneeId: string, assignerId: string, ownerId: string, subtaskCount: number, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, assigner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, taskEntities: Array<{ __typename?: 'TaskEntity', entityId: string, entityType: EntityType }>, metadata: { __typename?: 'TaskMetadataWithAdditionalData', additionalData: any } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', subtaskEntityQuantity: number, questionQuantity: number, qBankStructure: { __typename?: 'QBankStructureTask', id: string, name: string, code: number } | null }, currentWorkflowStep: { __typename?: 'WorkflowStep', id: string, name: string, code: WorkflowStepCode, workflowCode: WorkflowCode } };

export type QuestionReviewTaskFragment = { __typename?: 'Task', id: string, code: string, name: string | null, status: TaskStatus, dueDate: Date | null, updatedAt: Date, description: string | null, assigneeId: string, assignerId: string, ownerId: string, subtaskCount: number, parentTask: { __typename?: 'Task', id: string, code: string, name: string | null, status: TaskStatus, dueDate: Date | null, updatedAt: Date, description: string | null, assigneeId: string, assignerId: string, ownerId: string, subtaskCount: number, subtasks: Array<{ __typename?: 'Task', id: string, code: string, name: string | null, status: TaskStatus, dueDate: Date | null, updatedAt: Date, description: string | null, assigneeId: string, assignerId: string, ownerId: string, subtaskCount: number, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, assigner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, taskEntities: Array<{ __typename?: 'TaskEntity', entityId: string, entityType: EntityType }>, metadata: { __typename?: 'TaskMetadataWithAdditionalData', additionalData: any } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', subtaskEntityQuantity: number, questionQuantity: number, qBankStructure: { __typename?: 'QBankStructureTask', id: string, name: string, code: number } | null }, currentWorkflowStep: { __typename?: 'WorkflowStep', id: string, name: string, code: WorkflowStepCode, workflowCode: WorkflowCode } }>, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, assigner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, taskEntities: Array<{ __typename?: 'TaskEntity', entityId: string, entityType: EntityType }>, metadata: { __typename?: 'TaskMetadataWithAdditionalData', additionalData: any } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', subtaskEntityQuantity: number, questionQuantity: number, qBankStructure: { __typename?: 'QBankStructureTask', id: string, name: string, code: number } | null }, currentWorkflowStep: { __typename?: 'WorkflowStep', id: string, name: string, code: WorkflowStepCode, workflowCode: WorkflowCode } } | null, subtasks: Array<{ __typename?: 'Task', id: string, code: string, name: string | null, status: TaskStatus, dueDate: Date | null, updatedAt: Date, description: string | null, assigneeId: string, assignerId: string, ownerId: string, subtaskCount: number, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, assigner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, taskEntities: Array<{ __typename?: 'TaskEntity', entityId: string, entityType: EntityType }>, metadata: { __typename?: 'TaskMetadataWithAdditionalData', additionalData: any } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', subtaskEntityQuantity: number, questionQuantity: number, qBankStructure: { __typename?: 'QBankStructureTask', id: string, name: string, code: number } | null }, currentWorkflowStep: { __typename?: 'WorkflowStep', id: string, name: string, code: WorkflowStepCode, workflowCode: WorkflowCode } }>, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, assigner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, taskEntities: Array<{ __typename?: 'TaskEntity', entityId: string, entityType: EntityType }>, metadata: { __typename?: 'TaskMetadataWithAdditionalData', additionalData: any } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', subtaskEntityQuantity: number, questionQuantity: number, qBankStructure: { __typename?: 'QBankStructureTask', id: string, name: string, code: number } | null }, currentWorkflowStep: { __typename?: 'WorkflowStep', id: string, name: string, code: WorkflowStepCode, workflowCode: WorkflowCode } };

export type QuestionForQuestionReviewListFragment = { __typename?: 'Question', id: string, refCode: string, status: QuestionStatus, updatedAt: Date, refQBankStructureId: string, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, type: QuestionGroupType, totalQuestions: number, refCode: string, questions: Array<{ __typename?: 'Question', id: string }> | null } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, metadata: { __typename?: 'QuestionMetadata', owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null }, questionStructures: Array<{ __typename?: 'QuestionStructure', id: string, levelItem: { __typename?: 'QBankStructureLevelItem', id: string, parentLevelItemId: string | null, tag: { __typename?: 'Tag', id: string, name: string } | null, qBankStructureLevel: { __typename?: 'QBankStructureLevel', id: string, category: QBankStructureLevelCategory } | null } | null }> | null, taskVerdicts: Array<{ __typename?: 'QuestionVerdict', id: string, entityType: VerdictEntityType, entityId: string, taskId: string, userId: string, verdict: Verdict }> };

export type GetQuestionReviewTaskByIdQueryVariables = Exact<{
  input: GetTaskByIdInput;
}>;


export type GetQuestionReviewTaskByIdQuery = { __typename?: 'Query', wflGetTaskById: { __typename?: 'GetTaskByIdOutput', task: { __typename?: 'Task', id: string, code: string, name: string | null, status: TaskStatus, dueDate: Date | null, updatedAt: Date, description: string | null, assigneeId: string, assignerId: string, ownerId: string, subtaskCount: number, parentTask: { __typename?: 'Task', id: string, code: string, name: string | null, status: TaskStatus, dueDate: Date | null, updatedAt: Date, description: string | null, assigneeId: string, assignerId: string, ownerId: string, subtaskCount: number, subtasks: Array<{ __typename?: 'Task', id: string, code: string, name: string | null, status: TaskStatus, dueDate: Date | null, updatedAt: Date, description: string | null, assigneeId: string, assignerId: string, ownerId: string, subtaskCount: number, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, assigner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, taskEntities: Array<{ __typename?: 'TaskEntity', entityId: string, entityType: EntityType }>, metadata: { __typename?: 'TaskMetadataWithAdditionalData', additionalData: any } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', subtaskEntityQuantity: number, questionQuantity: number, qBankStructure: { __typename?: 'QBankStructureTask', id: string, name: string, code: number } | null }, currentWorkflowStep: { __typename?: 'WorkflowStep', id: string, name: string, code: WorkflowStepCode, workflowCode: WorkflowCode } }>, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, assigner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, taskEntities: Array<{ __typename?: 'TaskEntity', entityId: string, entityType: EntityType }>, metadata: { __typename?: 'TaskMetadataWithAdditionalData', additionalData: any } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', subtaskEntityQuantity: number, questionQuantity: number, qBankStructure: { __typename?: 'QBankStructureTask', id: string, name: string, code: number } | null }, currentWorkflowStep: { __typename?: 'WorkflowStep', id: string, name: string, code: WorkflowStepCode, workflowCode: WorkflowCode } } | null, subtasks: Array<{ __typename?: 'Task', id: string, code: string, name: string | null, status: TaskStatus, dueDate: Date | null, updatedAt: Date, description: string | null, assigneeId: string, assignerId: string, ownerId: string, subtaskCount: number, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, assigner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, taskEntities: Array<{ __typename?: 'TaskEntity', entityId: string, entityType: EntityType }>, metadata: { __typename?: 'TaskMetadataWithAdditionalData', additionalData: any } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', subtaskEntityQuantity: number, questionQuantity: number, qBankStructure: { __typename?: 'QBankStructureTask', id: string, name: string, code: number } | null }, currentWorkflowStep: { __typename?: 'WorkflowStep', id: string, name: string, code: WorkflowStepCode, workflowCode: WorkflowCode } }>, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, assigner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, taskEntities: Array<{ __typename?: 'TaskEntity', entityId: string, entityType: EntityType }>, metadata: { __typename?: 'TaskMetadataWithAdditionalData', additionalData: any } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', subtaskEntityQuantity: number, questionQuantity: number, qBankStructure: { __typename?: 'QBankStructureTask', id: string, name: string, code: number } | null }, currentWorkflowStep: { __typename?: 'WorkflowStep', id: string, name: string, code: WorkflowStepCode, workflowCode: WorkflowCode } } } };

export type SearchOwnedQuestionReviewTasksQueryVariables = Exact<{
  input: SearchOwnedAndAssignedTasksInput;
}>;


export type SearchOwnedQuestionReviewTasksQuery = { __typename?: 'Query', wflSearchOwnedAndAssignedTasks: { __typename?: 'SearchOwnedAndAssignedTasksOutput', total: number, tasks: Array<{ __typename?: 'Task', id: string, code: string, name: string | null, status: TaskStatus, dueDate: Date | null, updatedAt: Date, description: string | null, assigneeId: string, assignerId: string, ownerId: string, subtaskCount: number, parentTask: { __typename?: 'Task', id: string, code: string, name: string | null, status: TaskStatus, dueDate: Date | null, updatedAt: Date, description: string | null, assigneeId: string, assignerId: string, ownerId: string, subtaskCount: number, subtasks: Array<{ __typename?: 'Task', id: string, code: string, name: string | null, status: TaskStatus, dueDate: Date | null, updatedAt: Date, description: string | null, assigneeId: string, assignerId: string, ownerId: string, subtaskCount: number, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, assigner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, taskEntities: Array<{ __typename?: 'TaskEntity', entityId: string, entityType: EntityType }>, metadata: { __typename?: 'TaskMetadataWithAdditionalData', additionalData: any } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', subtaskEntityQuantity: number, questionQuantity: number, qBankStructure: { __typename?: 'QBankStructureTask', id: string, name: string, code: number } | null }, currentWorkflowStep: { __typename?: 'WorkflowStep', id: string, name: string, code: WorkflowStepCode, workflowCode: WorkflowCode } }>, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, assigner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, taskEntities: Array<{ __typename?: 'TaskEntity', entityId: string, entityType: EntityType }>, metadata: { __typename?: 'TaskMetadataWithAdditionalData', additionalData: any } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', subtaskEntityQuantity: number, questionQuantity: number, qBankStructure: { __typename?: 'QBankStructureTask', id: string, name: string, code: number } | null }, currentWorkflowStep: { __typename?: 'WorkflowStep', id: string, name: string, code: WorkflowStepCode, workflowCode: WorkflowCode } } | null, subtasks: Array<{ __typename?: 'Task', id: string, code: string, name: string | null, status: TaskStatus, dueDate: Date | null, updatedAt: Date, description: string | null, assigneeId: string, assignerId: string, ownerId: string, subtaskCount: number, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, assigner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, taskEntities: Array<{ __typename?: 'TaskEntity', entityId: string, entityType: EntityType }>, metadata: { __typename?: 'TaskMetadataWithAdditionalData', additionalData: any } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', subtaskEntityQuantity: number, questionQuantity: number, qBankStructure: { __typename?: 'QBankStructureTask', id: string, name: string, code: number } | null }, currentWorkflowStep: { __typename?: 'WorkflowStep', id: string, name: string, code: WorkflowStepCode, workflowCode: WorkflowCode } }>, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, assigner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string }, taskEntities: Array<{ __typename?: 'TaskEntity', entityId: string, entityType: EntityType }>, metadata: { __typename?: 'TaskMetadataWithAdditionalData', additionalData: any } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', subtaskEntityQuantity: number, questionQuantity: number, qBankStructure: { __typename?: 'QBankStructureTask', id: string, name: string, code: number } | null }, currentWorkflowStep: { __typename?: 'WorkflowStep', id: string, name: string, code: WorkflowStepCode, workflowCode: WorkflowCode } }> } };

export type SearchQuestionsForQuestionReviewTaskQueryVariables = Exact<{
  search: SearchQuestionsInput;
  paging: PageInput;
}>;


export type SearchQuestionsForQuestionReviewTaskQuery = { __typename?: 'Query', qctSearchQuestions: { __typename?: 'QuestionsResult', total: number, questions: Array<{ __typename?: 'Question', id: string, refCode: string, status: QuestionStatus, updatedAt: Date, refQBankStructureId: string, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, type: QuestionGroupType, totalQuestions: number, refCode: string, questions: Array<{ __typename?: 'Question', id: string }> | null } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, metadata: { __typename?: 'QuestionMetadata', owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null }, questionStructures: Array<{ __typename?: 'QuestionStructure', id: string, levelItem: { __typename?: 'QBankStructureLevelItem', id: string, parentLevelItemId: string | null, tag: { __typename?: 'Tag', id: string, name: string } | null, qBankStructureLevel: { __typename?: 'QBankStructureLevel', id: string, category: QBankStructureLevelCategory } | null } | null }> | null, taskVerdicts: Array<{ __typename?: 'QuestionVerdict', id: string, entityType: VerdictEntityType, entityId: string, taskId: string, userId: string, verdict: Verdict }> }> } };

export type GetQuestionsByIdAndQuestionReviewTaskIdQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  taskId: Scalars['String']['input'];
}>;


export type GetQuestionsByIdAndQuestionReviewTaskIdQuery = { __typename?: 'Query', qctGetTaskQuestionsByIds: Array<{ __typename?: 'Question', id: string, refCode: string, status: QuestionStatus, updatedAt: Date, refQBankStructureId: string, questionGroup: { __typename?: 'QuestionGroup', id: string, name: string, type: QuestionGroupType, totalQuestions: number, refCode: string, questions: Array<{ __typename?: 'Question', id: string }> | null } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, metadata: { __typename?: 'QuestionMetadata', owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null }, questionStructures: Array<{ __typename?: 'QuestionStructure', id: string, levelItem: { __typename?: 'QBankStructureLevelItem', id: string, parentLevelItemId: string | null, tag: { __typename?: 'Tag', id: string, name: string } | null, qBankStructureLevel: { __typename?: 'QBankStructureLevel', id: string, category: QBankStructureLevelCategory } | null } | null }> | null, taskVerdicts: Array<{ __typename?: 'QuestionVerdict', id: string, entityType: VerdictEntityType, entityId: string, taskId: string, userId: string, verdict: Verdict }> }> };

export type GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
}>;


export type GetQuestionDetailsByIdAndQuestionReviewTaskIdQuery = { __typename?: 'Query', qctGetTaskQuestionById: { __typename?: 'Question', id: string, type: QuestionType, refCode: string, status: QuestionStatus, pValue: number | null, updatedAt: Date, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, metadata: { __typename?: 'QuestionMetadata', reference: string | null, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }> }, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', id: string, name: string } } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, questionStructures: Array<{ __typename?: 'QuestionStructure', id: string, levelItem: { __typename?: 'QBankStructureLevelItem', id: string, parentLevelItemId: string | null, qBankStructureId: string, tag: { __typename?: 'Tag', id: string, name: string } | null, qBankStructureLevel: { __typename?: 'QBankStructureLevel', id: string, level: number, category: QBankStructureLevelCategory } | null } | null }> | null, taskComments: Array<{ __typename?: 'QuestionComment', id: string, taskId: string, userId: string, entityType: CommentEntityType, entityId: string, content: string }>, taskVerdicts: Array<{ __typename?: 'QuestionVerdict', id: string, taskId: string, userId: string, entityType: VerdictEntityType, entityId: string, verdict: Verdict }> } };

export type GetStepTransitionsByQuestionReviewTaskIdQueryVariables = Exact<{
  input: GetStepTransitionsByTaskIdInput;
}>;


export type GetStepTransitionsByQuestionReviewTaskIdQuery = { __typename?: 'Query', wflGetStepTransitionsByTaskId: { __typename?: 'GetStepTransitionsByTaskIdOutput', steps: Array<{ __typename?: 'StepTransition', id: string, type: string, condition: any, name: string, role: Array<string> }> } };

export type CreateQuestionCommentOnQuestionReviewTaskMutationVariables = Exact<{
  input: CreateOrUpdateQuestionCommentInput;
}>;


export type CreateQuestionCommentOnQuestionReviewTaskMutation = { __typename?: 'Mutation', qctCreateOrUpdateQuestionComment: { __typename?: 'QuestionComment', id: string, entityType: CommentEntityType, entityId: string, taskId: string, userId: string, content: string } };

export type CreateOrUpdateVerdictOnQuestionReviewTaskMutationVariables = Exact<{
  input: CreateOrUpdateQuestionVerdictInput;
}>;


export type CreateOrUpdateVerdictOnQuestionReviewTaskMutation = { __typename?: 'Mutation', qctCreateOrUpdateQuestionVerdict: { __typename?: 'QuestionVerdict', id: string, entityType: VerdictEntityType, entityId: string, taskId: string, userId: string, verdict: Verdict } };

export type CreateQuestionReviewTaskMutationVariables = Exact<{
  input: CreateQuestionReviewTaskInput;
}>;


export type CreateQuestionReviewTaskMutation = { __typename?: 'Mutation', wflCreateQuestionReviewTask: { __typename?: 'CreateQuestionReviewTaskOutput', success: boolean, message: string, code: CreateQuestionReviewTaskAndSubtasksErrorCode | null, task: { __typename?: 'Task', id: string } | null, itemSetMismatches: Array<{ __typename?: 'CreateTaskAndSubtasksItemSetMismatch', id: string, refCode: string, name: string }> } };

export type UpdateQuestionReviewTaskStatusMutationVariables = Exact<{
  input: UpdateTaskStatusInput;
}>;


export type UpdateQuestionReviewTaskStatusMutation = { __typename?: 'Mutation', wflUpdateTaskStatus: { __typename?: 'UpdateTaskStatusOutput', task: { __typename?: 'Task', id: string } } };

export type UpdateAndCreateQuestionReviewSubtasksMutationVariables = Exact<{
  input: UpdateAndCreateSubtasksInput;
}>;


export type UpdateAndCreateQuestionReviewSubtasksMutation = { __typename?: 'Mutation', wflUpdateAndCreateSubtasks: { __typename?: 'UpdateAndCreateSubtasksOutput', subtasks: Array<{ __typename?: 'Task', id: string }> } };

export type GetTaskQuestionByIdQueryVariables = Exact<{
  qctGetTaskQuestionByIdId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
}>;


export type GetTaskQuestionByIdQuery = { __typename?: 'Query', qctGetTaskQuestionById: { __typename?: 'Question', id: string, details: string, groupOrder: number | null, updatedAt: Date, refCode: string, refQBankStructureId: string, status: QuestionStatus, pValue: number | null, pType: QuestionPType | null, pInitial: number | null, bIndexValue: number | null, questionGroup: { __typename?: 'QuestionGroup', id: string, type: QuestionGroupType, name: string, refCode: string, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } | null, metadata: { __typename?: 'QuestionMetadata', reference: string | null, audit1: string | null, audit2: string | null, audit3: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }>, owner: { __typename?: 'QuestionOwner', type: QuestionOwnerType, value: string | null } | null, pStats: Array<{ __typename?: 'QuestionPStats', selected: boolean | null, firstUsedAt: Date | null, pValue: number, sampleSize: number, calculatedAt: Date, updatedBy: string, updatedUserFullName: string }> | null }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, refQuestion: { __typename?: 'Question', id: string, refCode: string } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null, questionStructures: Array<{ __typename?: 'QuestionStructure', refLevelItemId: string }> | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', id: string, tag: { __typename?: 'Tag', name: string } } | null } };

export type CreateOrUpdateQuestionVerdictMutationVariables = Exact<{
  input: CreateOrUpdateQuestionVerdictInput;
}>;


export type CreateOrUpdateQuestionVerdictMutation = { __typename?: 'Mutation', qctCreateOrUpdateQuestionVerdict: { __typename?: 'QuestionVerdict', id: string, taskId: string } };

export type CreateOrUpdateQuestionVerdictAndCreateCommentMutationVariables = Exact<{
  verdictInput: CreateOrUpdateQuestionVerdictInput;
  commentInput: CreateOrUpdateQuestionCommentInput;
}>;


export type CreateOrUpdateQuestionVerdictAndCreateCommentMutation = { __typename?: 'Mutation', qctCreateOrUpdateQuestionVerdict: { __typename?: 'QuestionVerdict', id: string, entityId: string, taskId: string, entityType: VerdictEntityType }, qctCreateOrUpdateQuestionComment: { __typename?: 'QuestionComment', id: string, entityId: string, taskId: string, entityType: CommentEntityType } };

export type GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryVariables = Exact<{
  commentInput: GetQuestionCommentsByEntityAndTaskIdInput;
  verdictInput: GetQuestionVerdictsByEntityAndTaskIdInput;
}>;


export type GetQuestionCommentsAndVerdictByEntityAndTaskIdQuery = { __typename?: 'Query', qctGetQuestionCommentsByEntityAndTaskId: Array<{ __typename?: 'QuestionComment', id: string, entityId: string, entityType: CommentEntityType, taskId: string, userId: string, content: string }>, qctGetQuestionVerdictsByEntityAndTaskId: Array<{ __typename?: 'QuestionVerdict', userId: string, taskId: string, entityId: string, entityType: VerdictEntityType, id: string, verdict: Verdict }> };

export type GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryVariables = Exact<{
  input: GetTaskByIdInput;
}>;


export type GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery = { __typename?: 'Query', wflGetTaskById: { __typename?: 'GetTaskByIdOutput', task: { __typename?: 'Task', id: string, assigneeId: string, ownerId: string, currentWorkflowStep: { __typename?: 'WorkflowStep', code: WorkflowStepCode, stepTransitions: Array<{ __typename?: 'StepTransition', id: string }> } } } };

export type GetQuestionVerdictsByEntityAndTaskIdQueryVariables = Exact<{
  input: GetQuestionVerdictsByEntityAndTaskIdInput;
}>;


export type GetQuestionVerdictsByEntityAndTaskIdQuery = { __typename?: 'Query', qctGetQuestionVerdictsByEntityAndTaskId: Array<{ __typename?: 'QuestionVerdict', verdict: Verdict, userId: string, taskId: string, id: string }> };

export type GetQuestionCommentsByEntityAndTaskIdQueryVariables = Exact<{
  input: GetQuestionCommentsByEntityAndTaskIdInput;
}>;


export type GetQuestionCommentsByEntityAndTaskIdQuery = { __typename?: 'Query', qctGetQuestionCommentsByEntityAndTaskId: Array<{ __typename?: 'QuestionComment', userId: string, taskId: string, id: string, content: string }> };

export type GetQBankStructureLevelsForQuestionReviewQueryVariables = Exact<{
  qBankStructureId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
}>;


export type GetQBankStructureLevelsForQuestionReviewQuery = { __typename?: 'Query', qbsGetTaskQBankStructureLevelsByQBankStructureId: Array<{ __typename?: 'QBankStructureLevel', id: string, level: number, category: QBankStructureLevelCategory, enabled: boolean }> };

export type GetQBankStructureLevelItemsForQuestionReviewQueryVariables = Exact<{
  qBankStructureId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
}>;


export type GetQBankStructureLevelItemsForQuestionReviewQuery = { __typename?: 'Query', qbsGetTaskQBankStructureLevelItemsByQBankStructureId: Array<{ __typename?: 'QBankStructureLevelItem', id: string, qBankStructureId: string, tagId: string | null, parentLevelItemId: string | null, order: number, qBankStructureLevelId: string, tag: { __typename?: 'Tag', id: string, name: string } | null }> };

export type SubmitQuestionReviewMutationVariables = Exact<{
  submitQuestionReviewInput: SubmitQuestionReviewInput;
}>;


export type SubmitQuestionReviewMutation = { __typename?: 'Mutation', wflSubmitQuestionReview: { __typename?: 'SubmitQuestionReviewOutput', success: boolean, message: string, code: SubmitQuestionReviewErrorCode | null, missingQuestionVerdictCount: number } };

export type GetTaskQuestionVerdictsQueryVariables = Exact<{
  input: GetTaskQuestionVerdictsInput;
}>;


export type GetTaskQuestionVerdictsQuery = { __typename?: 'Query', qctGetTaskQuestionVerdicts: Array<{ __typename?: 'QuestionVerdict', id: string, entityType: VerdictEntityType, entityId: string, taskId: string, userId: string, verdict: Verdict }> };

export type GetMyTasksQueryVariables = Exact<{
  getMyTasksInput: GetMyTasksInput;
}>;


export type GetMyTasksQuery = { __typename?: 'Query', wflGetMyTasks: { __typename?: 'GetMyTasksOutput', total: number, tasks: Array<{ __typename?: 'Task', id: string, code: string, updatedAt: Date, dueDate: Date | null, name: string | null, status: TaskStatus, assigner: { __typename?: 'RawUser', firstname: string, lastname: string, email: string }, parentTask: { __typename?: 'Task', id: string, name: string | null } | null, currentWorkflowStep: { __typename?: 'WorkflowStep', workflowCode: WorkflowCode, code: WorkflowStepCode, name: string } }> } };

export type CreateTaskAndSubtasksMutationVariables = Exact<{
  createTaskAndSubtasksInput: CreateTaskAndSubtasksInput;
}>;


export type CreateTaskAndSubtasksMutation = { __typename?: 'Mutation', wflCreateTaskAndSubtasks: { __typename?: 'CreateTaskAndSubtasksOutput', task: { __typename?: 'Task', id: string }, subtasks: Array<{ __typename?: 'Task', id: string }> } };

export type GetSubTaskByIdQueryVariables = Exact<{
  getTaskByIdInput: GetTaskByIdInput;
}>;


export type GetSubTaskByIdQuery = { __typename?: 'Query', wflGetTaskById: { __typename?: 'GetTaskByIdOutput', task: { __typename?: 'Task', id: string, name: string | null, createdAt: Date, updatedAt: Date, dueDate: Date | null, code: string, status: TaskStatus, assignedAt: Date, submittedAt: Date | null, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } } } };

export type GetTaskByIdQueryVariables = Exact<{
  getTaskByIdInput: GetTaskByIdInput;
}>;


export type GetTaskByIdQuery = { __typename?: 'Query', wflGetTaskById: { __typename?: 'GetTaskByIdOutput', task: { __typename?: 'Task', id: string, name: string | null, createdAt: Date, updatedAt: Date, dueDate: Date | null, code: string, status: TaskStatus, ownerId: string, assignerId: string, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string }, metadata: { __typename?: 'TaskMetadataWithAdditionalData' } | { __typename?: 'TaskMetadataWithExamCourse', examCourse: { __typename?: 'ExamCourseTask', id: string, code: string, examId: number, name: string, totalQSet: number, totalQConfig: number } } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion' }, currentWorkflowStep: { __typename?: 'WorkflowStep', workflowCode: WorkflowCode, code: WorkflowStepCode, name: string }, owner: { __typename?: 'RawUser', firstname: string, lastname: string }, subtasks: Array<{ __typename?: 'Task', id: string, dueDate: Date | null, code: string, status: TaskStatus, submittedAt: Date | null, updatedAt: Date, createdAt: Date, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string }, currentWorkflowStep: { __typename?: 'WorkflowStep', workflowCode: WorkflowCode, code: WorkflowStepCode, name: string }, metadata: { __typename?: 'TaskMetadataWithAdditionalData' } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet', qSet: { __typename?: 'QSetTask', id: string, code: string, qSetGeneratorExecutionResultId: string | null, pAvgValue: number, examCourseId: string, qConfig: { __typename?: 'QConfigTask', code: number, totalQuestions: number, metadata: { __typename?: 'QConfigTaskMetadata', timeLimit: { __typename?: 'QConfigTaskMetadataTimeLimit', values: Array<{ __typename?: 'QConfigTaskMetadataTimeLimitValue', value: number, order: number, qConfigStructureIds: Array<string> | null }> } | null } } } } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion' } }> } } };

export type SearchOwnedAndAssignedTasksQueryVariables = Exact<{
  searchOwnedAndAssignedTasksInput: SearchOwnedAndAssignedTasksInput;
}>;


export type SearchOwnedAndAssignedTasksQuery = { __typename?: 'Query', wflSearchOwnedAndAssignedTasks: { __typename?: 'SearchOwnedAndAssignedTasksOutput', total: number, tasks: Array<{ __typename?: 'Task', id: string, dueDate: Date | null, name: string | null, status: TaskStatus, code: string, updatedAt: Date, subtaskCount: number, assignee: { __typename?: 'RawUser', firstname: string, lastname: string, email: string }, assigner: { __typename?: 'RawUser', firstname: string, lastname: string, email: string }, taskEntities: Array<{ __typename?: 'TaskEntity', entityId: string, entityType: EntityType }>, parentTask: { __typename?: 'Task', name: string | null } | null, currentWorkflowStep: { __typename?: 'WorkflowStep', workflowCode: WorkflowCode, code: WorkflowStepCode, name: string }, metadata: { __typename?: 'TaskMetadataWithAdditionalData' } | { __typename?: 'TaskMetadataWithExamCourse', subtaskEntityQuantity: number, examCourse: { __typename?: 'ExamCourseTask', code: string, name: string } } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation', requiredQuestionCount: number | null, qBankStructure: { __typename?: 'QBankStructureTask', name: string, id: string, code: number } | null } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', questionQuantity: number, qBankStructure: { __typename?: 'QBankStructureTask', code: number } | null }, subtasks: Array<{ __typename?: 'Task', dueDate: Date | null, assignee: { __typename?: 'RawUser', firstname: string, lastname: string, email: string } }> }> } };

export type UpdateTaskStatusMutationVariables = Exact<{
  updateTaskStatusInput: UpdateTaskStatusInput;
}>;


export type UpdateTaskStatusMutation = { __typename?: 'Mutation', wflUpdateTaskStatus: { __typename?: 'UpdateTaskStatusOutput', task: { __typename?: 'Task', id: string, status: TaskStatus } } };

export type GetStepTransitionsByTaskIdQueryVariables = Exact<{
  getStepTransitionsByTaskIdInput: GetStepTransitionsByTaskIdInput;
}>;


export type GetStepTransitionsByTaskIdQuery = { __typename?: 'Query', wflGetStepTransitionsByTaskId: { __typename?: 'GetStepTransitionsByTaskIdOutput', steps: Array<{ __typename?: 'StepTransition', id: string, name: string }> } };

export type UpdateTaskStatusByIdMutationVariables = Exact<{
  updateTaskStatusInput: UpdateTaskStatusInput;
}>;


export type UpdateTaskStatusByIdMutation = { __typename?: 'Mutation', wflUpdateTaskStatus: { __typename?: 'UpdateTaskStatusOutput', task: { __typename?: 'Task', id: string, currentWorkflowStepId: string } } };

export type GetTaskDueDateByIdQueryVariables = Exact<{
  getTaskByIdInput: GetTaskByIdInput;
}>;


export type GetTaskDueDateByIdQuery = { __typename?: 'Query', wflGetTaskById: { __typename?: 'GetTaskByIdOutput', task: { __typename?: 'Task', id: string, dueDate: Date | null } } };

export type GetExamCourseCommentsQueryVariables = Exact<{
  getExamCourseCommentsInput: GetExamCourseCommentsInput;
}>;


export type GetExamCourseCommentsQuery = { __typename?: 'Query', excGetExamCourseComments: { __typename?: 'GetExamCourseCommentsOutput', taskId: string, entityId: string, entityType: EntityType, comments: Array<{ __typename?: 'ExamCourseCommentOutput', id: string, taskId: string, userId: string, entityId: string, entityType: EntityType, content: string, createdAt: Date, updatedAt: Date, user: { __typename?: 'RawUser', firstname: string, lastname: string, email: string, image: string | null } }> } };

export type SendExamCourseCommentMutationVariables = Exact<{
  createExamCourseCommentInput: CreateExamCourseCommentInput;
}>;


export type SendExamCourseCommentMutation = { __typename?: 'Mutation', excCreateExamCourseComment: { __typename?: 'CreateExamCourseCommentOutput', comment: { __typename?: 'ExamCourseCommentOutput', id: string, taskId: string, userId: string, entityId: string, entityType: EntityType, content: string, createdAt: Date, updatedAt: Date } } };

export type GetTaskCommentsQueryVariables = Exact<{
  getTaskCommentsInputType: GetTaskCommentsInput;
}>;


export type GetTaskCommentsQuery = { __typename?: 'Query', wflGetTaskComments: { __typename?: 'GetTaskCommentsOutput', taskId: string, comments: Array<{ __typename?: 'TaskComment', id: string, taskId: string, content: string, createdAt: Date, updatedAt: Date, user: { __typename?: 'RawUser', firstname: string, lastname: string, email: string, image: string | null } }> } };

export type SendTaskCommentMutationVariables = Exact<{
  createTaskCommentInputType: CreateTaskCommentInput;
}>;


export type SendTaskCommentMutation = { __typename?: 'Mutation', wflCreateTaskComment: { __typename?: 'CreateTaskCommentOutput', comment: { __typename?: 'TaskComment', id: string, taskId: string, content: string, createdAt: Date, updatedAt: Date, user: { __typename?: 'RawUser', firstname: string, lastname: string, image: string | null } } } };

export type UpdateSubtaskMutationVariables = Exact<{
  updateSubtasksInput: UpdateSubtasksInput;
}>;


export type UpdateSubtaskMutation = { __typename?: 'Mutation', wflUpdateSubtasks: { __typename?: 'UpdateSubtasksOutput', tasks: Array<{ __typename?: 'Task', id: string }> } };

export type UpdateTaskAndSubtasksAndCreateSubtasksMutationVariables = Exact<{
  updateTaskAndSubtasksAndCreateSubtasksInput: UpdateTaskAndSubtasksAndCreateSubtasksInput;
}>;


export type UpdateTaskAndSubtasksAndCreateSubtasksMutation = { __typename?: 'Mutation', wflUpdateTaskAndSubtasksAndCreateSubtasks: { __typename?: 'UpdateTaskAndSubtasksAndCreateSubtasksOutput', task: { __typename?: 'Task', id: string } } };

export type UpdateAndCreateSubtasksMutationVariables = Exact<{
  updateAndCreateSubtasksInput: UpdateAndCreateSubtasksInput;
}>;


export type UpdateAndCreateSubtasksMutation = { __typename?: 'Mutation', wflUpdateAndCreateSubtasks: { __typename?: 'UpdateAndCreateSubtasksOutput', subtasks: Array<{ __typename?: 'Task', id: string }> } };

export type UpdateTaskMutationVariables = Exact<{
  updateTaskInput: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', wflUpdateTask: { __typename?: 'UpdateTaskOutputObjectType', task: { __typename?: 'Task', id: string } } };

export type ExamCourseVerdictOutputFragment = { __typename?: 'ExamCourseVerdictOutput', id: string, taskId: string, userId: string, entityId: string, entityType: EntityType, verdict: Verdict, createdAt: Date, updatedAt: Date, user: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, image: string | null, username: string, email: string, emailVerified: boolean | null, isPassportUser: boolean, isPasswordCreatedByUser: boolean, lastLoginAt: string | null, roles: Array<string>, appRoles: Array<string>, appPermissions: Array<string>, status: string | null } };

export type UpdateOrCreateExamCourseVerdictMutationVariables = Exact<{
  updateOrCreateExamCourseVerdictInput: UpdateOrCreateExamCourseVerdictInput;
}>;


export type UpdateOrCreateExamCourseVerdictMutation = { __typename?: 'Mutation', excUpdateOrCreateExamCourseVerdict: { __typename?: 'UpdateOrCreateExamCourseVerdictOutput', verdict: { __typename?: 'ExamCourseVerdictOutput', id: string, taskId: string, userId: string, entityId: string, entityType: EntityType, verdict: Verdict, createdAt: Date, updatedAt: Date, user: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, image: string | null, username: string, email: string, emailVerified: boolean | null, isPassportUser: boolean, isPasswordCreatedByUser: boolean, lastLoginAt: string | null, roles: Array<string>, appRoles: Array<string>, appPermissions: Array<string>, status: string | null } } } };

export type GetExamCourseVerdictQueryVariables = Exact<{
  getExamCourseVerdictInput: GetExamCourseVerdictInput;
}>;


export type GetExamCourseVerdictQuery = { __typename?: 'Query', excGetExamCourseVerdict: { __typename?: 'GetExamCourseVerdictOutput', taskId: string, entityId: string, entityType: EntityType, verdict: { __typename?: 'ExamCourseVerdictOutput', id: string, taskId: string, userId: string, entityId: string, entityType: EntityType, verdict: Verdict, createdAt: Date, updatedAt: Date, user: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, image: string | null, username: string, email: string, emailVerified: boolean | null, isPassportUser: boolean, isPasswordCreatedByUser: boolean, lastLoginAt: string | null, roles: Array<string>, appRoles: Array<string>, appPermissions: Array<string>, status: string | null } } } };

export type GetTaskVerdictQueryVariables = Exact<{
  getTaskVerdictInput: GetTaskVerdictInput;
}>;


export type GetTaskVerdictQuery = { __typename?: 'Query', wflGetTaskVerdict: { __typename?: 'GetTaskVerdictOutput', verdict: Verdict | null } };

export type GetQSetTaskReviewResultsVerdictQueryVariables = Exact<{
  getQSetTaskReviewResultsInput: GetTaskReviewResultsInput;
}>;


export type GetQSetTaskReviewResultsVerdictQuery = { __typename?: 'Query', wflGetTaskReviewResults: { __typename?: 'GetTaskReviewResultsOutput', taskId: string, results: Array<{ __typename?: 'QSetReviewTaskResultOutput', totalComments: number, verdict: { __typename?: 'QSetReviewVerdictOutput', id: string, taskId: string, userId: string, entityId: string, entityType: ExaminationEntityType, verdict: Verdict | null, createdAt: Date, updatedAt: Date } | null, comment: { __typename?: 'QSetReviewCommentOutput', id: string, taskId: string, userId: string, entityId: string, entityType: ExaminationEntityType, content: string, createdAt: Date, updatedAt: Date } | null, question: { __typename?: 'QSetReviewQuestionOutput', id: string, qSetId: string, questionId: string, questionRefCode: string, questionGroupId: string, questionGroupType: QSetQuestionGroupType, order: number, groupOrder: number, score: number } }> } };

export type GetQSetTaskReviewSummaryQueryVariables = Exact<{
  getQSetTaskReviewSummaryInput: GetQSetTaskReviewSummaryInput;
}>;


export type GetQSetTaskReviewSummaryQuery = { __typename?: 'Query', wflGetQSetTaskReviewSummary: { __typename?: 'GetQSetTaskReviewSummaryOutput', subTaskIds: Array<string>, results: Array<{ __typename?: 'QSetTaskReviewSummaryOutput', totalComments: number, verdicts: Array<{ __typename?: 'QSetReviewVerdictOutput', id: string, taskId: string, userId: string, entityId: string, entityType: ExaminationEntityType, verdict: Verdict | null, createdAt: Date, updatedAt: Date }>, question: { __typename?: 'QSetReviewQuestionOutput', id: string, qSetId: string, questionId: string, questionRefCode: string, questionGroupId: string, questionGroupType: QSetQuestionGroupType, order: number, groupOrder: number, score: number }, comments: Array<{ __typename?: 'QSetReviewCommentOutput', id: string, taskId: string, userId: string, entityId: string, entityType: ExaminationEntityType, content: string, createdAt: Date, updatedAt: Date, user: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } }> }> } };

export type SearchTaskReviewedQSetQuestionsQueryVariables = Exact<{
  input: SearchQSetQuestionsInputWithTaskIdInput;
}>;


export type SearchTaskReviewedQSetQuestionsQuery = { __typename?: 'Query', excSearchTaskQSetQuestions: { __typename?: 'SearchQSetQuestionsOutput', qSetQuestions: Array<{ __typename?: 'QSetQuestion', id: string, qSetId: string, questionId: string, questionGroupId: string, questionRefCode: string, order: number, score: number, question: { __typename?: 'Question', id: string, type: QuestionType, details: string, refCode: string, tags: Array<{ __typename?: 'Tag', id: string, name: string, category: TagCategory }>, metadata: { __typename?: 'QuestionMetadata', reference: string | null, choices: Array<{ __typename?: 'QuestionChoice', label: string, order: number, value: string }> }, correctAnswer: { __typename?: 'QuestionCorrectAnswer', value: string }, questionGroup: { __typename?: 'QuestionGroup', type: QuestionGroupType, size: number | null, refCode: string, metadata: { __typename?: 'QuestionGroupMetadata', paragraph: string | null } | null } | null, learningObjectiveStatement: { __typename?: 'LearningObjectiveStatement', tag: { __typename?: 'Tag', name: string, id: string } } | null, solution: { __typename?: 'QuestionSolution', type: QuestionSolutionType | null, value: string | null } | null } | null }> } };

export type GetTasksByEntityWithParentQueryVariables = Exact<{
  getTasksByEntityWithParentInput: GetTasksByEntityInput;
}>;


export type GetTasksByEntityWithParentQuery = { __typename?: 'Query', wflGetTasksByEntityWithParent: { __typename?: 'GetTasksByEntityWithParentOutput', entityId: string, entityType: EntityType, tasks: Array<{ __typename?: 'TaskWithSubtasks', id: string, name: string | null, status: TaskStatus, assignedAt: Date, owner: { __typename?: 'RawUser', firstname: string, lastname: string }, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string }, subtasks: Array<{ __typename?: 'TaskWithSubtasks', id: string, ownerId: string, assignerId: string, assignedAt: Date, updatedAt: Date, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } }> }> } };

export type GetQuestionCreationTaskByIdQueryVariables = Exact<{
  getTaskByIdInput: GetTaskByIdInput;
}>;


export type GetQuestionCreationTaskByIdQuery = { __typename?: 'Query', wflGetTaskById: { __typename?: 'GetTaskByIdOutput', task: { __typename?: 'Task', id: string, name: string | null, createdAt: Date, updatedAt: Date, dueDate: Date | null, code: string, status: TaskStatus, ownerId: string, assignerId: string, assignee: { __typename?: 'RawUser', id: string, firstname: string, lastname: string }, owner: { __typename?: 'RawUser', id: string, firstname: string, lastname: string }, currentWorkflowStep: { __typename?: 'WorkflowStep', workflowCode: WorkflowCode, code: WorkflowStepCode, name: string }, taskEntities: Array<{ __typename?: 'TaskEntity', id: string, taskId: string, entityId: string, entityType: EntityType }>, metadata: { __typename?: 'TaskMetadataWithAdditionalData' } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation', details: string | null, questionCreationCount: number, requiredQuestionCount: number | null, qBankStructure: { __typename?: 'QBankStructureTask', name: string, id: string, code: number } | null, itemSetCondition: Array<{ __typename?: 'ItemSetCondition', size: number, needTotal: number }> | null, itemSetCreation: Array<{ __typename?: 'ItemSetCreation', size: number, questionGroupId: string, questionCreationCount: number }> | null } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion' } } } };

export type GetTaskCommonInfoQueryVariables = Exact<{
  getTaskByIdInput: GetTaskByIdInput;
}>;


export type GetTaskCommonInfoQuery = { __typename?: 'Query', wflGetTaskById: { __typename?: 'GetTaskByIdOutput', task: { __typename?: 'Task', id: string, ownerId: string, assignerId: string, assignee: { __typename?: 'RawUser', id: string }, currentWorkflowStep: { __typename?: 'WorkflowStep', workflowCode: WorkflowCode, code: WorkflowStepCode, name: string } } } };

export type GetDownloadSignedUrlForTaskQuestionQueryVariables = Exact<{
  input: GetDownloadSignedUrlQuestionInput;
  taskId: Scalars['String']['input'];
}>;


export type GetDownloadSignedUrlForTaskQuestionQuery = { __typename?: 'Query', qctGetDownloadSignedUrlForTaskQuestion: { __typename?: 'GetDownloadSignedUrlsResult', signedUrls: any } };

export type GetUploadSignedUrlForQuestionCreationTaskQueryVariables = Exact<{
  input: GetUploadSignedUrlForTaskInput;
}>;


export type GetUploadSignedUrlForQuestionCreationTaskQuery = { __typename?: 'Query', wflGetUploadSignedUrlForTask: { __typename?: 'GetUploadSignedUrlForTaskOutput', signedUrl: string, storageObject: { __typename?: 'StorageObject', fileName: string | null } } };

export type GetUploadSignedUrlForTaskQuestionQueryVariables = Exact<{
  input: GetUploadSignedUrlQuestionInput;
  taskId: Scalars['String']['input'];
}>;


export type GetUploadSignedUrlForTaskQuestionQuery = { __typename?: 'Query', qctGetUploadSignedUrlForTaskQuestion: { __typename?: 'GetUploadSignedUrlResult', signedUrl: string, storageObject: { __typename?: 'StorageObject', fileName: string | null } } };

export type GetDownloadSignedUrlForQuestionCreationTaskQueryVariables = Exact<{
  input: GetDownloadSignedUrlForTaskInput;
}>;


export type GetDownloadSignedUrlForQuestionCreationTaskQuery = { __typename?: 'Query', wflGetDownloadSignedUrlForTask: { __typename?: 'GetDownloadSignedUrlForTaskOutput', signedUrls: any } };

export type UpdateQuestionCreationTaskMutationVariables = Exact<{
  updateQuestionCreationTaskInput: UpdateQuestionCreationTaskInput;
}>;


export type UpdateQuestionCreationTaskMutation = { __typename?: 'Mutation', wflUpdateQuestionCreationTask: { __typename?: 'UpdateQuestionCreationTaskOutputDTO', task: { __typename?: 'Task', id: string } } };

export type FinishQuestionCreationTaskMutationVariables = Exact<{
  finishQuestionCreationTaskInput: UpdateTaskStatusInput;
}>;


export type FinishQuestionCreationTaskMutation = { __typename?: 'Mutation', wflUpdateTaskStatus: { __typename?: 'UpdateTaskStatusOutput', task: { __typename?: 'Task', id: string, status: TaskStatus } } };

export type DeleteSubtaskMutationVariables = Exact<{
  deleteSubtaskInput: DeleteSubtaskInput;
}>;


export type DeleteSubtaskMutation = { __typename?: 'Mutation', wflDeleteSubtask: { __typename?: 'DeleteSubtaskOutput', success: boolean, message: string } };

export type UpdateDueDateTaskAndSubtasksMutationVariables = Exact<{
  updateDueDateTaskAndSubtasksInput: UpdateDueDateTaskAndSubtasksInput;
}>;


export type UpdateDueDateTaskAndSubtasksMutation = { __typename?: 'Mutation', wflUpdateDueDateTaskAndSubtasks: { __typename?: 'UpdateTaskOutputObjectType', task: { __typename?: 'Task', id: string, dueDate: Date | null, subtasks: Array<{ __typename?: 'Task', id: string, dueDate: Date | null }> } } };

export type SearchMyTasksQueryVariables = Exact<{
  searchMyTasksInput: SearchMyTasksInput;
}>;


export type SearchMyTasksQuery = { __typename?: 'Query', wflSearchMyTasks: { __typename?: 'SearchMyTasksOutput', total: number, tasks: Array<{ __typename?: 'Task', subtaskCount: number, status: TaskStatus, code: string, name: string | null, id: string, dueDate: Date | null, completedAt: Date | null, currentWorkflowStep: { __typename?: 'WorkflowStep', workflowCode: WorkflowCode, code: WorkflowStepCode }, subtasks: Array<{ __typename?: 'Task', id: string, currentWorkflowStep: { __typename?: 'WorkflowStep', code: WorkflowStepCode } }>, parentTask: { __typename?: 'Task', name: string | null, code: string, metadata: { __typename?: 'TaskMetadataWithAdditionalData' } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation' } | { __typename?: 'TaskMetadataWithQuestionReviewed' } | { __typename?: 'TaskMetadataWithReviewQuestion', questionQuantity: number } } | null, metadata: { __typename?: 'TaskMetadataWithAdditionalData' } | { __typename?: 'TaskMetadataWithExamCourse' } | { __typename?: 'TaskMetadataWithQSet' } | { __typename?: 'TaskMetadataWithQuestionCreation', requiredQuestionCount: number | null, questionCreationCount: number, itemSetCondition: Array<{ __typename?: 'ItemSetCondition', size: number, needTotal: number }> | null, itemSetCreation: Array<{ __typename?: 'ItemSetCreation', questionCreationCount: number, size: number, questionGroupId: string }> | null } | { __typename?: 'TaskMetadataWithQuestionReviewed', reviewedQuestionCount: number } | { __typename?: 'TaskMetadataWithReviewQuestion', questionQuantity: number } }> } };

export type GetUploadSignedUrlForCreateQuestionCreationTaskQueryVariables = Exact<{
  input: GetUploadSignedUrlForQuestionCreationTaskInput;
}>;


export type GetUploadSignedUrlForCreateQuestionCreationTaskQuery = { __typename?: 'Query', wflGetUploadSignedUrlForQuestionCreationTask: { __typename?: 'GetUploadSignedUrlForQuestionCreationTaskOutput', signedUrl: string, contentType: QuestionCreationTaskContentType, storageObject: { __typename?: 'StorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null } } };

export type CreateQuestionCreationTaskMutationVariables = Exact<{
  createQuestionCreationTaskInput: CreateQuestionCreationTaskInput;
}>;


export type CreateQuestionCreationTaskMutation = { __typename?: 'Mutation', wflCreateQuestionCreationTask: { __typename?: 'CreateQuestionCreationTaskOutput', task: { __typename?: 'Task', id: string } } };

export const QConfigDetailsFragmentDoc = gql`
    fragment QConfigDetails on QConfig {
  id
  name
  code
  type
  status
  randomType
  totalQuestions
  fullScore
  lastPublishedAt
  updatedAt
  passingCriteria {
    type
    value
  }
  timeLimit {
    type
    values {
      qConfigStructureIds
      value
      order
    }
  }
  structures {
    id
    name
    type
    category
    refCode
    refId
    parentId
    order
    size
    score
    totalQuestions
    conditions {
      ... on QConfigStructureConditionSingleTagGroup {
        tags {
          id
          name
        }
        needTotal
        type
      }
      ... on QConfigStructureConditionMultiTagGroup {
        type
        tagGroups {
          tags {
            id
            name
          }
          count
        }
        needTotal
      }
    }
    passingCriteria {
      type
      value
    }
  }
  metadata {
    conditions {
      questionTypes {
        type
        needTotal
      }
      tags {
        tag {
          id
          name
        }
        needTotal
      }
    }
  }
}
    `;
export const QBankStructureFragmentDoc = gql`
    fragment QBankStructure on QBankStructure {
  id
  name
  code
  status
  type
  description
  remark
  createdAt
  updatedAt
  createdBy
  groupTag {
    id
    name
    slug
    category
    description
  }
}
    `;
export const QuestionFragmentDoc = gql`
    fragment Question on Question {
  id
  details
  metadata {
    choices {
      label
      order
      value
    }
  }
  correctAnswer {
    value
  }
  tags {
    id
    name
    category
  }
  details
  groupOrder
  updatedAt
  refCode
  refQBankStructureId
  refQuestion {
    id
    refCode
  }
  status
  updatedAt
  metadata {
    choices {
      label
      order
      value
    }
    reference
    owner {
      type
      value
    }
    pStats {
      selected
      firstUsedAt
      pValue
      sampleSize
      calculatedAt
      updatedBy
      updatedUserFullName
    }
    audit1
    audit2
    audit3
  }
  correctAnswer {
    value
  }
  solution {
    type
    value
  }
  pValue
  pType
  pInitial
  bIndexValue
  questionStructures {
    refLevelItemId
  }
  questionGroup {
    id
    name
    refCode
    type
  }
  learningObjectiveStatement {
    id
    tag {
      name
    }
  }
}
    `;
export const QuestionGroupFragmentDoc = gql`
    fragment QuestionGroup on QuestionGroup {
  id
  name
  updatedAt
  questions {
    ...Question
  }
  questionStructures {
    refLevelItemId
  }
  type
  metadata {
    paragraph
  }
  questionStructures {
    refLevelItemId
  }
  type
  refCode
  status
  totalQuestions
}
    ${QuestionFragmentDoc}`;
export const UsBoUserFragmentDoc = gql`
    fragment UsBoUser on UsBoUser {
  id
  firstname
  lastname
  email
  appRoles
  lastLoginAt
  status
  createdAt
  updatedAt
  updatedBy
  invitationExpireAt
}
    `;
export const QuestionForQuestionCreationListFragmentDoc = gql`
    fragment QuestionForQuestionCreationList on Question {
  id
  questionStructures {
    id
    levelItem {
      id
      parentLevelItemId
      tag {
        id
        name
      }
      qBankStructureLevel {
        id
        category
      }
    }
  }
  questionGroup {
    id
    type
  }
  tags {
    name
    category
  }
}
    `;
export const QuestionReviewTaskDetailFragmentDoc = gql`
    fragment QuestionReviewTaskDetail on Task {
  id
  code
  name
  status
  dueDate
  updatedAt
  description
  assigneeId
  assignerId
  ownerId
  assignee {
    id
    firstname
    lastname
    email
  }
  assigner {
    id
    firstname
    lastname
    email
  }
  owner {
    id
    firstname
    lastname
    email
  }
  subtaskCount
  taskEntities {
    entityId
    entityType
  }
  metadata {
    ... on TaskMetadataWithReviewQuestion {
      subtaskEntityQuantity
      questionQuantity
      qBankStructure {
        id
        name
        code
      }
    }
    ... on TaskMetadataWithAdditionalData {
      additionalData
    }
  }
  currentWorkflowStep {
    id
    name
    code
    workflowCode
  }
}
    `;
export const QuestionReviewTaskFragmentDoc = gql`
    fragment QuestionReviewTask on Task {
  ...QuestionReviewTaskDetail
  parentTask {
    ...QuestionReviewTaskDetail
    subtasks {
      ...QuestionReviewTaskDetail
    }
  }
  subtasks {
    ...QuestionReviewTaskDetail
  }
}
    ${QuestionReviewTaskDetailFragmentDoc}`;
export const QuestionForQuestionReviewListFragmentDoc = gql`
    fragment QuestionForQuestionReviewList on Question {
  id
  refCode
  status
  updatedAt
  refQBankStructureId
  questionGroup {
    id
    name
    type
    questions {
      id
    }
  }
  tags {
    id
    name
    category
  }
  metadata {
    owner {
      type
      value
    }
  }
  questionStructures {
    id
    levelItem {
      id
      parentLevelItemId
      tag {
        id
        name
      }
      qBankStructureLevel {
        id
        category
      }
    }
  }
  taskVerdicts {
    id
    entityType
    entityId
    taskId
    userId
    verdict
  }
  questionGroup {
    name
    type
    totalQuestions
    refCode
  }
}
    `;
export const ExamCourseVerdictOutputFragmentDoc = gql`
    fragment ExamCourseVerdictOutput on ExamCourseVerdictOutput {
  id
  taskId
  userId
  entityId
  entityType
  verdict
  createdAt
  updatedAt
  user {
    id
    firstname
    lastname
    image
    username
    email
    emailVerified
    isPassportUser
    isPasswordCreatedByUser
    lastLoginAt
    roles
    appRoles
    appPermissions
    status
  }
}
    `;
export const RemoveUsersContentVisibilityDocument = gql`
    mutation removeUsersContentVisibility($input: RemoveUsersContentVisibilityInput!) {
  cvRemoveUsersContentVisibility(input: $input) {
    removedContentVisibilities {
      contentId
      userId
    }
    total
  }
}
    `;
export type RemoveUsersContentVisibilityMutationFn = Apollo.MutationFunction<RemoveUsersContentVisibilityMutation, RemoveUsersContentVisibilityMutationVariables>;

/**
 * __useRemoveUsersContentVisibilityMutation__
 *
 * To run a mutation, you first call `useRemoveUsersContentVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUsersContentVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUsersContentVisibilityMutation, { data, loading, error }] = useRemoveUsersContentVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUsersContentVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUsersContentVisibilityMutation, RemoveUsersContentVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUsersContentVisibilityMutation, RemoveUsersContentVisibilityMutationVariables>(RemoveUsersContentVisibilityDocument, options);
      }
export type RemoveUsersContentVisibilityMutationHookResult = ReturnType<typeof useRemoveUsersContentVisibilityMutation>;
export type RemoveUsersContentVisibilityMutationResult = Apollo.MutationResult<RemoveUsersContentVisibilityMutation>;
export type RemoveUsersContentVisibilityMutationOptions = Apollo.BaseMutationOptions<RemoveUsersContentVisibilityMutation, RemoveUsersContentVisibilityMutationVariables>;
export const SearchUsersContentVisibilityDocument = gql`
    query searchUsersContentVisibility($input: SearchUsersContentVisibilityInput!) {
  cvSearchUsersContentVisibility(input: $input) {
    users {
      firstname
      lastname
      email
      image
      appRoles
      status
      id
      invitationExpireAt
    }
    total
  }
}
    `;

/**
 * __useSearchUsersContentVisibilityQuery__
 *
 * To run a query within a React component, call `useSearchUsersContentVisibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersContentVisibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersContentVisibilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchUsersContentVisibilityQuery(baseOptions: Apollo.QueryHookOptions<SearchUsersContentVisibilityQuery, SearchUsersContentVisibilityQueryVariables> & ({ variables: SearchUsersContentVisibilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersContentVisibilityQuery, SearchUsersContentVisibilityQueryVariables>(SearchUsersContentVisibilityDocument, options);
      }
export function useSearchUsersContentVisibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersContentVisibilityQuery, SearchUsersContentVisibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersContentVisibilityQuery, SearchUsersContentVisibilityQueryVariables>(SearchUsersContentVisibilityDocument, options);
        }
// @ts-ignore
export function useSearchUsersContentVisibilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUsersContentVisibilityQuery, SearchUsersContentVisibilityQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUsersContentVisibilityQuery, SearchUsersContentVisibilityQueryVariables>;
export function useSearchUsersContentVisibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersContentVisibilityQuery, SearchUsersContentVisibilityQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUsersContentVisibilityQuery | undefined, SearchUsersContentVisibilityQueryVariables>;
export function useSearchUsersContentVisibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersContentVisibilityQuery, SearchUsersContentVisibilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUsersContentVisibilityQuery, SearchUsersContentVisibilityQueryVariables>(SearchUsersContentVisibilityDocument, options);
        }
export type SearchUsersContentVisibilityQueryHookResult = ReturnType<typeof useSearchUsersContentVisibilityQuery>;
export type SearchUsersContentVisibilityLazyQueryHookResult = ReturnType<typeof useSearchUsersContentVisibilityLazyQuery>;
export type SearchUsersContentVisibilitySuspenseQueryHookResult = ReturnType<typeof useSearchUsersContentVisibilitySuspenseQuery>;
export type SearchUsersContentVisibilityQueryResult = Apollo.QueryResult<SearchUsersContentVisibilityQuery, SearchUsersContentVisibilityQueryVariables>;
export const CreateExamCourseDocument = gql`
    mutation createExamCourse($createExamCourseInput: CreateExamCourseInput!) {
  excCreateExamCourse(createExamCourseInput: $createExamCourseInput) {
    examCourse {
      id
    }
  }
}
    `;
export type CreateExamCourseMutationFn = Apollo.MutationFunction<CreateExamCourseMutation, CreateExamCourseMutationVariables>;

/**
 * __useCreateExamCourseMutation__
 *
 * To run a mutation, you first call `useCreateExamCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExamCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExamCourseMutation, { data, loading, error }] = useCreateExamCourseMutation({
 *   variables: {
 *      createExamCourseInput: // value for 'createExamCourseInput'
 *   },
 * });
 */
export function useCreateExamCourseMutation(baseOptions?: Apollo.MutationHookOptions<CreateExamCourseMutation, CreateExamCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExamCourseMutation, CreateExamCourseMutationVariables>(CreateExamCourseDocument, options);
      }
export type CreateExamCourseMutationHookResult = ReturnType<typeof useCreateExamCourseMutation>;
export type CreateExamCourseMutationResult = Apollo.MutationResult<CreateExamCourseMutation>;
export type CreateExamCourseMutationOptions = Apollo.BaseMutationOptions<CreateExamCourseMutation, CreateExamCourseMutationVariables>;
export const SearchExamCoursesDocument = gql`
    query searchExamCourses($searchExamCoursesInput: SearchExamCoursesInput!) {
  excSearchExamCourses(searchExamCoursesInput: $searchExamCoursesInput) {
    examCourses {
      id
      code
      examId
      name
      type
      language
      totalQConfig
      totalQSet
      tagEntities {
        tag {
          name
          category
        }
      }
    }
    total
  }
}
    `;

/**
 * __useSearchExamCoursesQuery__
 *
 * To run a query within a React component, call `useSearchExamCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamCoursesQuery({
 *   variables: {
 *      searchExamCoursesInput: // value for 'searchExamCoursesInput'
 *   },
 * });
 */
export function useSearchExamCoursesQuery(baseOptions: Apollo.QueryHookOptions<SearchExamCoursesQuery, SearchExamCoursesQueryVariables> & ({ variables: SearchExamCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>(SearchExamCoursesDocument, options);
      }
export function useSearchExamCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>(SearchExamCoursesDocument, options);
        }
// @ts-ignore
export function useSearchExamCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>;
export function useSearchExamCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<SearchExamCoursesQuery | undefined, SearchExamCoursesQueryVariables>;
export function useSearchExamCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>(SearchExamCoursesDocument, options);
        }
export type SearchExamCoursesQueryHookResult = ReturnType<typeof useSearchExamCoursesQuery>;
export type SearchExamCoursesLazyQueryHookResult = ReturnType<typeof useSearchExamCoursesLazyQuery>;
export type SearchExamCoursesSuspenseQueryHookResult = ReturnType<typeof useSearchExamCoursesSuspenseQuery>;
export type SearchExamCoursesQueryResult = Apollo.QueryResult<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>;
export const GetExamCourseByIdDocument = gql`
    query getExamCourseById($getExamCourseByIdInput: GetExamCourseByIdInput!) {
  excGetExamCourseById(getExamCourseByIdInput: $getExamCourseByIdInput) {
    examCourse {
      id
      name
      code
      type
      language
    }
  }
}
    `;

/**
 * __useGetExamCourseByIdQuery__
 *
 * To run a query within a React component, call `useGetExamCourseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCourseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCourseByIdQuery({
 *   variables: {
 *      getExamCourseByIdInput: // value for 'getExamCourseByIdInput'
 *   },
 * });
 */
export function useGetExamCourseByIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamCourseByIdQuery, GetExamCourseByIdQueryVariables> & ({ variables: GetExamCourseByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCourseByIdQuery, GetExamCourseByIdQueryVariables>(GetExamCourseByIdDocument, options);
      }
export function useGetExamCourseByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCourseByIdQuery, GetExamCourseByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCourseByIdQuery, GetExamCourseByIdQueryVariables>(GetExamCourseByIdDocument, options);
        }
// @ts-ignore
export function useGetExamCourseByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExamCourseByIdQuery, GetExamCourseByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetExamCourseByIdQuery, GetExamCourseByIdQueryVariables>;
export function useGetExamCourseByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCourseByIdQuery, GetExamCourseByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetExamCourseByIdQuery | undefined, GetExamCourseByIdQueryVariables>;
export function useGetExamCourseByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCourseByIdQuery, GetExamCourseByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCourseByIdQuery, GetExamCourseByIdQueryVariables>(GetExamCourseByIdDocument, options);
        }
export type GetExamCourseByIdQueryHookResult = ReturnType<typeof useGetExamCourseByIdQuery>;
export type GetExamCourseByIdLazyQueryHookResult = ReturnType<typeof useGetExamCourseByIdLazyQuery>;
export type GetExamCourseByIdSuspenseQueryHookResult = ReturnType<typeof useGetExamCourseByIdSuspenseQuery>;
export type GetExamCourseByIdQueryResult = Apollo.QueryResult<GetExamCourseByIdQuery, GetExamCourseByIdQueryVariables>;
export const SearchExamCourseGroupsDocument = gql`
    query searchExamCourseGroups($searchExamCourseGroupsByNameInput: SearchExamCourseGroupsByNameInput!) {
  excSearchExamCourseGroupsByName(
    searchExamCourseGroupsByNameInput: $searchExamCourseGroupsByNameInput
  ) {
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useSearchExamCourseGroupsQuery__
 *
 * To run a query within a React component, call `useSearchExamCourseGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamCourseGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamCourseGroupsQuery({
 *   variables: {
 *      searchExamCourseGroupsByNameInput: // value for 'searchExamCourseGroupsByNameInput'
 *   },
 * });
 */
export function useSearchExamCourseGroupsQuery(baseOptions: Apollo.QueryHookOptions<SearchExamCourseGroupsQuery, SearchExamCourseGroupsQueryVariables> & ({ variables: SearchExamCourseGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamCourseGroupsQuery, SearchExamCourseGroupsQueryVariables>(SearchExamCourseGroupsDocument, options);
      }
export function useSearchExamCourseGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamCourseGroupsQuery, SearchExamCourseGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamCourseGroupsQuery, SearchExamCourseGroupsQueryVariables>(SearchExamCourseGroupsDocument, options);
        }
// @ts-ignore
export function useSearchExamCourseGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchExamCourseGroupsQuery, SearchExamCourseGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchExamCourseGroupsQuery, SearchExamCourseGroupsQueryVariables>;
export function useSearchExamCourseGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamCourseGroupsQuery, SearchExamCourseGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchExamCourseGroupsQuery | undefined, SearchExamCourseGroupsQueryVariables>;
export function useSearchExamCourseGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamCourseGroupsQuery, SearchExamCourseGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamCourseGroupsQuery, SearchExamCourseGroupsQueryVariables>(SearchExamCourseGroupsDocument, options);
        }
export type SearchExamCourseGroupsQueryHookResult = ReturnType<typeof useSearchExamCourseGroupsQuery>;
export type SearchExamCourseGroupsLazyQueryHookResult = ReturnType<typeof useSearchExamCourseGroupsLazyQuery>;
export type SearchExamCourseGroupsSuspenseQueryHookResult = ReturnType<typeof useSearchExamCourseGroupsSuspenseQuery>;
export type SearchExamCourseGroupsQueryResult = Apollo.QueryResult<SearchExamCourseGroupsQuery, SearchExamCourseGroupsQueryVariables>;
export const GetExamCourseGroupByIdDocument = gql`
    query getExamCourseGroupById($getExamCourseGroupByIdInput: GetExamCourseGroupByIdInput!) {
  excGetExamCourseGroupById(
    getExamCourseGroupByIdInput: $getExamCourseGroupByIdInput
  ) {
    tag {
      id
      name
    }
  }
}
    `;

/**
 * __useGetExamCourseGroupByIdQuery__
 *
 * To run a query within a React component, call `useGetExamCourseGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCourseGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCourseGroupByIdQuery({
 *   variables: {
 *      getExamCourseGroupByIdInput: // value for 'getExamCourseGroupByIdInput'
 *   },
 * });
 */
export function useGetExamCourseGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamCourseGroupByIdQuery, GetExamCourseGroupByIdQueryVariables> & ({ variables: GetExamCourseGroupByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCourseGroupByIdQuery, GetExamCourseGroupByIdQueryVariables>(GetExamCourseGroupByIdDocument, options);
      }
export function useGetExamCourseGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCourseGroupByIdQuery, GetExamCourseGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCourseGroupByIdQuery, GetExamCourseGroupByIdQueryVariables>(GetExamCourseGroupByIdDocument, options);
        }
// @ts-ignore
export function useGetExamCourseGroupByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExamCourseGroupByIdQuery, GetExamCourseGroupByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetExamCourseGroupByIdQuery, GetExamCourseGroupByIdQueryVariables>;
export function useGetExamCourseGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCourseGroupByIdQuery, GetExamCourseGroupByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetExamCourseGroupByIdQuery | undefined, GetExamCourseGroupByIdQueryVariables>;
export function useGetExamCourseGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCourseGroupByIdQuery, GetExamCourseGroupByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCourseGroupByIdQuery, GetExamCourseGroupByIdQueryVariables>(GetExamCourseGroupByIdDocument, options);
        }
export type GetExamCourseGroupByIdQueryHookResult = ReturnType<typeof useGetExamCourseGroupByIdQuery>;
export type GetExamCourseGroupByIdLazyQueryHookResult = ReturnType<typeof useGetExamCourseGroupByIdLazyQuery>;
export type GetExamCourseGroupByIdSuspenseQueryHookResult = ReturnType<typeof useGetExamCourseGroupByIdSuspenseQuery>;
export type GetExamCourseGroupByIdQueryResult = Apollo.QueryResult<GetExamCourseGroupByIdQuery, GetExamCourseGroupByIdQueryVariables>;
export const DeleteQConfigStructureDocument = gql`
    mutation deleteQConfigStructure($deleteQConfigStructureInput: DeleteQConfigStructureInput!) {
  excDeleteQConfigStructure(
    deleteQConfigStructureInput: $deleteQConfigStructureInput
  ) {
    qConfig {
      id
    }
  }
}
    `;
export type DeleteQConfigStructureMutationFn = Apollo.MutationFunction<DeleteQConfigStructureMutation, DeleteQConfigStructureMutationVariables>;

/**
 * __useDeleteQConfigStructureMutation__
 *
 * To run a mutation, you first call `useDeleteQConfigStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQConfigStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQConfigStructureMutation, { data, loading, error }] = useDeleteQConfigStructureMutation({
 *   variables: {
 *      deleteQConfigStructureInput: // value for 'deleteQConfigStructureInput'
 *   },
 * });
 */
export function useDeleteQConfigStructureMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQConfigStructureMutation, DeleteQConfigStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQConfigStructureMutation, DeleteQConfigStructureMutationVariables>(DeleteQConfigStructureDocument, options);
      }
export type DeleteQConfigStructureMutationHookResult = ReturnType<typeof useDeleteQConfigStructureMutation>;
export type DeleteQConfigStructureMutationResult = Apollo.MutationResult<DeleteQConfigStructureMutation>;
export type DeleteQConfigStructureMutationOptions = Apollo.BaseMutationOptions<DeleteQConfigStructureMutation, DeleteQConfigStructureMutationVariables>;
export const SearchQConfigsDocument = gql`
    query searchQConfigs($searchQConfigsInput: SearchQConfigsInput!) {
  excSearchQConfigs(searchQConfigsInput: $searchQConfigsInput) {
    qConfigs {
      id
      name
      code
      type
      status
      updatedAt
    }
    total
  }
}
    `;

/**
 * __useSearchQConfigsQuery__
 *
 * To run a query within a React component, call `useSearchQConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQConfigsQuery({
 *   variables: {
 *      searchQConfigsInput: // value for 'searchQConfigsInput'
 *   },
 * });
 */
export function useSearchQConfigsQuery(baseOptions: Apollo.QueryHookOptions<SearchQConfigsQuery, SearchQConfigsQueryVariables> & ({ variables: SearchQConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQConfigsQuery, SearchQConfigsQueryVariables>(SearchQConfigsDocument, options);
      }
export function useSearchQConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQConfigsQuery, SearchQConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQConfigsQuery, SearchQConfigsQueryVariables>(SearchQConfigsDocument, options);
        }
// @ts-ignore
export function useSearchQConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQConfigsQuery, SearchQConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQConfigsQuery, SearchQConfigsQueryVariables>;
export function useSearchQConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQConfigsQuery, SearchQConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQConfigsQuery | undefined, SearchQConfigsQueryVariables>;
export function useSearchQConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQConfigsQuery, SearchQConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQConfigsQuery, SearchQConfigsQueryVariables>(SearchQConfigsDocument, options);
        }
export type SearchQConfigsQueryHookResult = ReturnType<typeof useSearchQConfigsQuery>;
export type SearchQConfigsLazyQueryHookResult = ReturnType<typeof useSearchQConfigsLazyQuery>;
export type SearchQConfigsSuspenseQueryHookResult = ReturnType<typeof useSearchQConfigsSuspenseQuery>;
export type SearchQConfigsQueryResult = Apollo.QueryResult<SearchQConfigsQuery, SearchQConfigsQueryVariables>;
export const GetQConfigByIdDocument = gql`
    query getQConfigById($getQConfigByIdInput: GetQConfigByIdInput!) {
  excGetQConfigById(getQConfigByIdInput: $getQConfigByIdInput) {
    qConfig {
      ...QConfigDetails
    }
  }
}
    ${QConfigDetailsFragmentDoc}`;

/**
 * __useGetQConfigByIdQuery__
 *
 * To run a query within a React component, call `useGetQConfigByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQConfigByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQConfigByIdQuery({
 *   variables: {
 *      getQConfigByIdInput: // value for 'getQConfigByIdInput'
 *   },
 * });
 */
export function useGetQConfigByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQConfigByIdQuery, GetQConfigByIdQueryVariables> & ({ variables: GetQConfigByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQConfigByIdQuery, GetQConfigByIdQueryVariables>(GetQConfigByIdDocument, options);
      }
export function useGetQConfigByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQConfigByIdQuery, GetQConfigByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQConfigByIdQuery, GetQConfigByIdQueryVariables>(GetQConfigByIdDocument, options);
        }
// @ts-ignore
export function useGetQConfigByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQConfigByIdQuery, GetQConfigByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQConfigByIdQuery, GetQConfigByIdQueryVariables>;
export function useGetQConfigByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQConfigByIdQuery, GetQConfigByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQConfigByIdQuery | undefined, GetQConfigByIdQueryVariables>;
export function useGetQConfigByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQConfigByIdQuery, GetQConfigByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQConfigByIdQuery, GetQConfigByIdQueryVariables>(GetQConfigByIdDocument, options);
        }
export type GetQConfigByIdQueryHookResult = ReturnType<typeof useGetQConfigByIdQuery>;
export type GetQConfigByIdLazyQueryHookResult = ReturnType<typeof useGetQConfigByIdLazyQuery>;
export type GetQConfigByIdSuspenseQueryHookResult = ReturnType<typeof useGetQConfigByIdSuspenseQuery>;
export type GetQConfigByIdQueryResult = Apollo.QueryResult<GetQConfigByIdQuery, GetQConfigByIdQueryVariables>;
export const GetQConfigChapterSingleQuestionPropertiesCountDocument = gql`
    query getQConfigChapterSingleQuestionPropertiesCount($input: GetQConfigChapterSingleQuestionPropertiesCountInput!) {
  excGetQConfigChapterSingleQuestionPropertiesCount(
    GetQConfigChapterSingleQuestionPropertiesCountInput: $input
  ) {
    tags {
      id
      name
    }
    totalQuestions
  }
}
    `;

/**
 * __useGetQConfigChapterSingleQuestionPropertiesCountQuery__
 *
 * To run a query within a React component, call `useGetQConfigChapterSingleQuestionPropertiesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQConfigChapterSingleQuestionPropertiesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQConfigChapterSingleQuestionPropertiesCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQConfigChapterSingleQuestionPropertiesCountQuery(baseOptions: Apollo.QueryHookOptions<GetQConfigChapterSingleQuestionPropertiesCountQuery, GetQConfigChapterSingleQuestionPropertiesCountQueryVariables> & ({ variables: GetQConfigChapterSingleQuestionPropertiesCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQConfigChapterSingleQuestionPropertiesCountQuery, GetQConfigChapterSingleQuestionPropertiesCountQueryVariables>(GetQConfigChapterSingleQuestionPropertiesCountDocument, options);
      }
export function useGetQConfigChapterSingleQuestionPropertiesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQConfigChapterSingleQuestionPropertiesCountQuery, GetQConfigChapterSingleQuestionPropertiesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQConfigChapterSingleQuestionPropertiesCountQuery, GetQConfigChapterSingleQuestionPropertiesCountQueryVariables>(GetQConfigChapterSingleQuestionPropertiesCountDocument, options);
        }
// @ts-ignore
export function useGetQConfigChapterSingleQuestionPropertiesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQConfigChapterSingleQuestionPropertiesCountQuery, GetQConfigChapterSingleQuestionPropertiesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetQConfigChapterSingleQuestionPropertiesCountQuery, GetQConfigChapterSingleQuestionPropertiesCountQueryVariables>;
export function useGetQConfigChapterSingleQuestionPropertiesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQConfigChapterSingleQuestionPropertiesCountQuery, GetQConfigChapterSingleQuestionPropertiesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetQConfigChapterSingleQuestionPropertiesCountQuery | undefined, GetQConfigChapterSingleQuestionPropertiesCountQueryVariables>;
export function useGetQConfigChapterSingleQuestionPropertiesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQConfigChapterSingleQuestionPropertiesCountQuery, GetQConfigChapterSingleQuestionPropertiesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQConfigChapterSingleQuestionPropertiesCountQuery, GetQConfigChapterSingleQuestionPropertiesCountQueryVariables>(GetQConfigChapterSingleQuestionPropertiesCountDocument, options);
        }
export type GetQConfigChapterSingleQuestionPropertiesCountQueryHookResult = ReturnType<typeof useGetQConfigChapterSingleQuestionPropertiesCountQuery>;
export type GetQConfigChapterSingleQuestionPropertiesCountLazyQueryHookResult = ReturnType<typeof useGetQConfigChapterSingleQuestionPropertiesCountLazyQuery>;
export type GetQConfigChapterSingleQuestionPropertiesCountSuspenseQueryHookResult = ReturnType<typeof useGetQConfigChapterSingleQuestionPropertiesCountSuspenseQuery>;
export type GetQConfigChapterSingleQuestionPropertiesCountQueryResult = Apollo.QueryResult<GetQConfigChapterSingleQuestionPropertiesCountQuery, GetQConfigChapterSingleQuestionPropertiesCountQueryVariables>;
export const GetQConfigChapterItemSetQuestionPropertiesCountDocument = gql`
    query getQConfigChapterItemSetQuestionPropertiesCount($input: GetQConfigChapterItemSetQuestionPropertiesCountInput!) {
  excGetQConfigChapterItemSetQuestionPropertiesCount(
    GetQConfigChapterItemSetQuestionPropertiesCountInput: $input
  ) {
    totalQuestions
    tagGroups {
      count
      tags {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetQConfigChapterItemSetQuestionPropertiesCountQuery__
 *
 * To run a query within a React component, call `useGetQConfigChapterItemSetQuestionPropertiesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQConfigChapterItemSetQuestionPropertiesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQConfigChapterItemSetQuestionPropertiesCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQConfigChapterItemSetQuestionPropertiesCountQuery(baseOptions: Apollo.QueryHookOptions<GetQConfigChapterItemSetQuestionPropertiesCountQuery, GetQConfigChapterItemSetQuestionPropertiesCountQueryVariables> & ({ variables: GetQConfigChapterItemSetQuestionPropertiesCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQConfigChapterItemSetQuestionPropertiesCountQuery, GetQConfigChapterItemSetQuestionPropertiesCountQueryVariables>(GetQConfigChapterItemSetQuestionPropertiesCountDocument, options);
      }
export function useGetQConfigChapterItemSetQuestionPropertiesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQConfigChapterItemSetQuestionPropertiesCountQuery, GetQConfigChapterItemSetQuestionPropertiesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQConfigChapterItemSetQuestionPropertiesCountQuery, GetQConfigChapterItemSetQuestionPropertiesCountQueryVariables>(GetQConfigChapterItemSetQuestionPropertiesCountDocument, options);
        }
// @ts-ignore
export function useGetQConfigChapterItemSetQuestionPropertiesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQConfigChapterItemSetQuestionPropertiesCountQuery, GetQConfigChapterItemSetQuestionPropertiesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetQConfigChapterItemSetQuestionPropertiesCountQuery, GetQConfigChapterItemSetQuestionPropertiesCountQueryVariables>;
export function useGetQConfigChapterItemSetQuestionPropertiesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQConfigChapterItemSetQuestionPropertiesCountQuery, GetQConfigChapterItemSetQuestionPropertiesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetQConfigChapterItemSetQuestionPropertiesCountQuery | undefined, GetQConfigChapterItemSetQuestionPropertiesCountQueryVariables>;
export function useGetQConfigChapterItemSetQuestionPropertiesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQConfigChapterItemSetQuestionPropertiesCountQuery, GetQConfigChapterItemSetQuestionPropertiesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQConfigChapterItemSetQuestionPropertiesCountQuery, GetQConfigChapterItemSetQuestionPropertiesCountQueryVariables>(GetQConfigChapterItemSetQuestionPropertiesCountDocument, options);
        }
export type GetQConfigChapterItemSetQuestionPropertiesCountQueryHookResult = ReturnType<typeof useGetQConfigChapterItemSetQuestionPropertiesCountQuery>;
export type GetQConfigChapterItemSetQuestionPropertiesCountLazyQueryHookResult = ReturnType<typeof useGetQConfigChapterItemSetQuestionPropertiesCountLazyQuery>;
export type GetQConfigChapterItemSetQuestionPropertiesCountSuspenseQueryHookResult = ReturnType<typeof useGetQConfigChapterItemSetQuestionPropertiesCountSuspenseQuery>;
export type GetQConfigChapterItemSetQuestionPropertiesCountQueryResult = Apollo.QueryResult<GetQConfigChapterItemSetQuestionPropertiesCountQuery, GetQConfigChapterItemSetQuestionPropertiesCountQueryVariables>;
export const CreateQConfigDocument = gql`
    mutation createQConfig($createQConfigInput: CreateQConfigInput!) {
  excCreateQConfig(createQConfigInput: $createQConfigInput) {
    qConfig {
      ...QConfigDetails
    }
  }
}
    ${QConfigDetailsFragmentDoc}`;
export type CreateQConfigMutationFn = Apollo.MutationFunction<CreateQConfigMutation, CreateQConfigMutationVariables>;

/**
 * __useCreateQConfigMutation__
 *
 * To run a mutation, you first call `useCreateQConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQConfigMutation, { data, loading, error }] = useCreateQConfigMutation({
 *   variables: {
 *      createQConfigInput: // value for 'createQConfigInput'
 *   },
 * });
 */
export function useCreateQConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateQConfigMutation, CreateQConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQConfigMutation, CreateQConfigMutationVariables>(CreateQConfigDocument, options);
      }
export type CreateQConfigMutationHookResult = ReturnType<typeof useCreateQConfigMutation>;
export type CreateQConfigMutationResult = Apollo.MutationResult<CreateQConfigMutation>;
export type CreateQConfigMutationOptions = Apollo.BaseMutationOptions<CreateQConfigMutation, CreateQConfigMutationVariables>;
export const AddQConfigStructuresDocument = gql`
    mutation addQConfigStructures($addQConfigStructuresInput: AddQConfigStructuresInput!) {
  excAddQConfigStructures(addQConfigStructuresInput: $addQConfigStructuresInput) {
    qConfig {
      ...QConfigDetails
    }
  }
}
    ${QConfigDetailsFragmentDoc}`;
export type AddQConfigStructuresMutationFn = Apollo.MutationFunction<AddQConfigStructuresMutation, AddQConfigStructuresMutationVariables>;

/**
 * __useAddQConfigStructuresMutation__
 *
 * To run a mutation, you first call `useAddQConfigStructuresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQConfigStructuresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQConfigStructuresMutation, { data, loading, error }] = useAddQConfigStructuresMutation({
 *   variables: {
 *      addQConfigStructuresInput: // value for 'addQConfigStructuresInput'
 *   },
 * });
 */
export function useAddQConfigStructuresMutation(baseOptions?: Apollo.MutationHookOptions<AddQConfigStructuresMutation, AddQConfigStructuresMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQConfigStructuresMutation, AddQConfigStructuresMutationVariables>(AddQConfigStructuresDocument, options);
      }
export type AddQConfigStructuresMutationHookResult = ReturnType<typeof useAddQConfigStructuresMutation>;
export type AddQConfigStructuresMutationResult = Apollo.MutationResult<AddQConfigStructuresMutation>;
export type AddQConfigStructuresMutationOptions = Apollo.BaseMutationOptions<AddQConfigStructuresMutation, AddQConfigStructuresMutationVariables>;
export const PublishQConfigDocument = gql`
    mutation publishQConfig($publishQConfigInput: PublishQConfigInput!) {
  excPublishQConfig(publishQConfigInput: $publishQConfigInput) {
    qConfig {
      ...QConfigDetails
    }
  }
}
    ${QConfigDetailsFragmentDoc}`;
export type PublishQConfigMutationFn = Apollo.MutationFunction<PublishQConfigMutation, PublishQConfigMutationVariables>;

/**
 * __usePublishQConfigMutation__
 *
 * To run a mutation, you first call `usePublishQConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishQConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishQConfigMutation, { data, loading, error }] = usePublishQConfigMutation({
 *   variables: {
 *      publishQConfigInput: // value for 'publishQConfigInput'
 *   },
 * });
 */
export function usePublishQConfigMutation(baseOptions?: Apollo.MutationHookOptions<PublishQConfigMutation, PublishQConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishQConfigMutation, PublishQConfigMutationVariables>(PublishQConfigDocument, options);
      }
export type PublishQConfigMutationHookResult = ReturnType<typeof usePublishQConfigMutation>;
export type PublishQConfigMutationResult = Apollo.MutationResult<PublishQConfigMutation>;
export type PublishQConfigMutationOptions = Apollo.BaseMutationOptions<PublishQConfigMutation, PublishQConfigMutationVariables>;
export const UpdateQConfigStructureNamesDocument = gql`
    mutation updateQConfigStructureNames($updateQConfigStructureNamesInput: UpdateQConfigStructureNamesInput!) {
  excUpdateQConfigStructureNames(
    updateQConfigStructureNamesInput: $updateQConfigStructureNamesInput
  ) {
    qConfigStructures {
      id
      name
    }
  }
}
    `;
export type UpdateQConfigStructureNamesMutationFn = Apollo.MutationFunction<UpdateQConfigStructureNamesMutation, UpdateQConfigStructureNamesMutationVariables>;

/**
 * __useUpdateQConfigStructureNamesMutation__
 *
 * To run a mutation, you first call `useUpdateQConfigStructureNamesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQConfigStructureNamesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQConfigStructureNamesMutation, { data, loading, error }] = useUpdateQConfigStructureNamesMutation({
 *   variables: {
 *      updateQConfigStructureNamesInput: // value for 'updateQConfigStructureNamesInput'
 *   },
 * });
 */
export function useUpdateQConfigStructureNamesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQConfigStructureNamesMutation, UpdateQConfigStructureNamesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQConfigStructureNamesMutation, UpdateQConfigStructureNamesMutationVariables>(UpdateQConfigStructureNamesDocument, options);
      }
export type UpdateQConfigStructureNamesMutationHookResult = ReturnType<typeof useUpdateQConfigStructureNamesMutation>;
export type UpdateQConfigStructureNamesMutationResult = Apollo.MutationResult<UpdateQConfigStructureNamesMutation>;
export type UpdateQConfigStructureNamesMutationOptions = Apollo.BaseMutationOptions<UpdateQConfigStructureNamesMutation, UpdateQConfigStructureNamesMutationVariables>;
export const UpdateQconfigSettingsAsDraftDocument = gql`
    mutation updateQconfigSettingsAsDraft($updateQConfigSettingsAsDraftInput: UpdateQConfigSettingsAsDraftInput!) {
  excUpdateQconfigSettingsAsDraft(
    updateQConfigSettingsAsDraftInput: $updateQConfigSettingsAsDraftInput
  ) {
    qConfig {
      id
    }
  }
}
    `;
export type UpdateQconfigSettingsAsDraftMutationFn = Apollo.MutationFunction<UpdateQconfigSettingsAsDraftMutation, UpdateQconfigSettingsAsDraftMutationVariables>;

/**
 * __useUpdateQconfigSettingsAsDraftMutation__
 *
 * To run a mutation, you first call `useUpdateQconfigSettingsAsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQconfigSettingsAsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQconfigSettingsAsDraftMutation, { data, loading, error }] = useUpdateQconfigSettingsAsDraftMutation({
 *   variables: {
 *      updateQConfigSettingsAsDraftInput: // value for 'updateQConfigSettingsAsDraftInput'
 *   },
 * });
 */
export function useUpdateQconfigSettingsAsDraftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQconfigSettingsAsDraftMutation, UpdateQconfigSettingsAsDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQconfigSettingsAsDraftMutation, UpdateQconfigSettingsAsDraftMutationVariables>(UpdateQconfigSettingsAsDraftDocument, options);
      }
export type UpdateQconfigSettingsAsDraftMutationHookResult = ReturnType<typeof useUpdateQconfigSettingsAsDraftMutation>;
export type UpdateQconfigSettingsAsDraftMutationResult = Apollo.MutationResult<UpdateQconfigSettingsAsDraftMutation>;
export type UpdateQconfigSettingsAsDraftMutationOptions = Apollo.BaseMutationOptions<UpdateQconfigSettingsAsDraftMutation, UpdateQconfigSettingsAsDraftMutationVariables>;
export const AddSingleQuestionQConfigStructureDocument = gql`
    mutation addSingleQuestionQConfigStructure($addSingleQuestionQConfigStructureInput: AddSingleQuestionQConfigStructureInput!) {
  excAddSingleQuestionQConfigStructure(
    addSingleQuestionQConfigStructureInput: $addSingleQuestionQConfigStructureInput
  ) {
    qConfig {
      id
    }
  }
}
    `;
export type AddSingleQuestionQConfigStructureMutationFn = Apollo.MutationFunction<AddSingleQuestionQConfigStructureMutation, AddSingleQuestionQConfigStructureMutationVariables>;

/**
 * __useAddSingleQuestionQConfigStructureMutation__
 *
 * To run a mutation, you first call `useAddSingleQuestionQConfigStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSingleQuestionQConfigStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSingleQuestionQConfigStructureMutation, { data, loading, error }] = useAddSingleQuestionQConfigStructureMutation({
 *   variables: {
 *      addSingleQuestionQConfigStructureInput: // value for 'addSingleQuestionQConfigStructureInput'
 *   },
 * });
 */
export function useAddSingleQuestionQConfigStructureMutation(baseOptions?: Apollo.MutationHookOptions<AddSingleQuestionQConfigStructureMutation, AddSingleQuestionQConfigStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSingleQuestionQConfigStructureMutation, AddSingleQuestionQConfigStructureMutationVariables>(AddSingleQuestionQConfigStructureDocument, options);
      }
export type AddSingleQuestionQConfigStructureMutationHookResult = ReturnType<typeof useAddSingleQuestionQConfigStructureMutation>;
export type AddSingleQuestionQConfigStructureMutationResult = Apollo.MutationResult<AddSingleQuestionQConfigStructureMutation>;
export type AddSingleQuestionQConfigStructureMutationOptions = Apollo.BaseMutationOptions<AddSingleQuestionQConfigStructureMutation, AddSingleQuestionQConfigStructureMutationVariables>;
export const AddItemSetQuestionQConfigStructureDocument = gql`
    mutation addItemSetQuestionQConfigStructure($addItemSetQuestionQConfigStructureInput: AddItemSetQuestionQConfigStructureInput!) {
  excAddItemSetQuestionQConfigStructure(
    addItemSetQuestionQConfigStructureInput: $addItemSetQuestionQConfigStructureInput
  ) {
    qConfig {
      id
    }
  }
}
    `;
export type AddItemSetQuestionQConfigStructureMutationFn = Apollo.MutationFunction<AddItemSetQuestionQConfigStructureMutation, AddItemSetQuestionQConfigStructureMutationVariables>;

/**
 * __useAddItemSetQuestionQConfigStructureMutation__
 *
 * To run a mutation, you first call `useAddItemSetQuestionQConfigStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemSetQuestionQConfigStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemSetQuestionQConfigStructureMutation, { data, loading, error }] = useAddItemSetQuestionQConfigStructureMutation({
 *   variables: {
 *      addItemSetQuestionQConfigStructureInput: // value for 'addItemSetQuestionQConfigStructureInput'
 *   },
 * });
 */
export function useAddItemSetQuestionQConfigStructureMutation(baseOptions?: Apollo.MutationHookOptions<AddItemSetQuestionQConfigStructureMutation, AddItemSetQuestionQConfigStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemSetQuestionQConfigStructureMutation, AddItemSetQuestionQConfigStructureMutationVariables>(AddItemSetQuestionQConfigStructureDocument, options);
      }
export type AddItemSetQuestionQConfigStructureMutationHookResult = ReturnType<typeof useAddItemSetQuestionQConfigStructureMutation>;
export type AddItemSetQuestionQConfigStructureMutationResult = Apollo.MutationResult<AddItemSetQuestionQConfigStructureMutation>;
export type AddItemSetQuestionQConfigStructureMutationOptions = Apollo.BaseMutationOptions<AddItemSetQuestionQConfigStructureMutation, AddItemSetQuestionQConfigStructureMutationVariables>;
export const DuplicateQConfigDocument = gql`
    mutation duplicateQConfig($duplicateQConfigInput: DuplicateQConfigInput!) {
  excDuplicateQConfig(duplicateQConfigInput: $duplicateQConfigInput) {
    qConfig {
      id
    }
  }
}
    `;
export type DuplicateQConfigMutationFn = Apollo.MutationFunction<DuplicateQConfigMutation, DuplicateQConfigMutationVariables>;

/**
 * __useDuplicateQConfigMutation__
 *
 * To run a mutation, you first call `useDuplicateQConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateQConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateQConfigMutation, { data, loading, error }] = useDuplicateQConfigMutation({
 *   variables: {
 *      duplicateQConfigInput: // value for 'duplicateQConfigInput'
 *   },
 * });
 */
export function useDuplicateQConfigMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateQConfigMutation, DuplicateQConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateQConfigMutation, DuplicateQConfigMutationVariables>(DuplicateQConfigDocument, options);
      }
export type DuplicateQConfigMutationHookResult = ReturnType<typeof useDuplicateQConfigMutation>;
export type DuplicateQConfigMutationResult = Apollo.MutationResult<DuplicateQConfigMutation>;
export type DuplicateQConfigMutationOptions = Apollo.BaseMutationOptions<DuplicateQConfigMutation, DuplicateQConfigMutationVariables>;
export const DisableQConfigDocument = gql`
    mutation disableQConfig($disableQConfigInput: DisableQConfigInput!) {
  excDisableQConfig(disableQConfigInput: $disableQConfigInput) {
    qConfig {
      id
    }
  }
}
    `;
export type DisableQConfigMutationFn = Apollo.MutationFunction<DisableQConfigMutation, DisableQConfigMutationVariables>;

/**
 * __useDisableQConfigMutation__
 *
 * To run a mutation, you first call `useDisableQConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableQConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableQConfigMutation, { data, loading, error }] = useDisableQConfigMutation({
 *   variables: {
 *      disableQConfigInput: // value for 'disableQConfigInput'
 *   },
 * });
 */
export function useDisableQConfigMutation(baseOptions?: Apollo.MutationHookOptions<DisableQConfigMutation, DisableQConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableQConfigMutation, DisableQConfigMutationVariables>(DisableQConfigDocument, options);
      }
export type DisableQConfigMutationHookResult = ReturnType<typeof useDisableQConfigMutation>;
export type DisableQConfigMutationResult = Apollo.MutationResult<DisableQConfigMutation>;
export type DisableQConfigMutationOptions = Apollo.BaseMutationOptions<DisableQConfigMutation, DisableQConfigMutationVariables>;
export const UpdateSingleQuestionQConfigStructureDocument = gql`
    mutation updateSingleQuestionQConfigStructure($updateSingleQuestionQConfigStructureInput: UpdateSingleQuestionQConfigStructureInput!) {
  excUpdateSingleQuestionQConfigStructure(
    updateSingleQuestionQConfigStructureInput: $updateSingleQuestionQConfigStructureInput
  ) {
    qConfig {
      id
    }
  }
}
    `;
export type UpdateSingleQuestionQConfigStructureMutationFn = Apollo.MutationFunction<UpdateSingleQuestionQConfigStructureMutation, UpdateSingleQuestionQConfigStructureMutationVariables>;

/**
 * __useUpdateSingleQuestionQConfigStructureMutation__
 *
 * To run a mutation, you first call `useUpdateSingleQuestionQConfigStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSingleQuestionQConfigStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSingleQuestionQConfigStructureMutation, { data, loading, error }] = useUpdateSingleQuestionQConfigStructureMutation({
 *   variables: {
 *      updateSingleQuestionQConfigStructureInput: // value for 'updateSingleQuestionQConfigStructureInput'
 *   },
 * });
 */
export function useUpdateSingleQuestionQConfigStructureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSingleQuestionQConfigStructureMutation, UpdateSingleQuestionQConfigStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSingleQuestionQConfigStructureMutation, UpdateSingleQuestionQConfigStructureMutationVariables>(UpdateSingleQuestionQConfigStructureDocument, options);
      }
export type UpdateSingleQuestionQConfigStructureMutationHookResult = ReturnType<typeof useUpdateSingleQuestionQConfigStructureMutation>;
export type UpdateSingleQuestionQConfigStructureMutationResult = Apollo.MutationResult<UpdateSingleQuestionQConfigStructureMutation>;
export type UpdateSingleQuestionQConfigStructureMutationOptions = Apollo.BaseMutationOptions<UpdateSingleQuestionQConfigStructureMutation, UpdateSingleQuestionQConfigStructureMutationVariables>;
export const UpdateItemSetQuestionQConfigStructureDocument = gql`
    mutation updateItemSetQuestionQConfigStructure($input: UpdateItemSetQuestionQConfigStructureInput!) {
  excUpdateItemSetQuestionQConfigStructure(
    updateItemSetQuestionQConfigStructureInput: $input
  ) {
    qConfig {
      id
    }
  }
}
    `;
export type UpdateItemSetQuestionQConfigStructureMutationFn = Apollo.MutationFunction<UpdateItemSetQuestionQConfigStructureMutation, UpdateItemSetQuestionQConfigStructureMutationVariables>;

/**
 * __useUpdateItemSetQuestionQConfigStructureMutation__
 *
 * To run a mutation, you first call `useUpdateItemSetQuestionQConfigStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemSetQuestionQConfigStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemSetQuestionQConfigStructureMutation, { data, loading, error }] = useUpdateItemSetQuestionQConfigStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateItemSetQuestionQConfigStructureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemSetQuestionQConfigStructureMutation, UpdateItemSetQuestionQConfigStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemSetQuestionQConfigStructureMutation, UpdateItemSetQuestionQConfigStructureMutationVariables>(UpdateItemSetQuestionQConfigStructureDocument, options);
      }
export type UpdateItemSetQuestionQConfigStructureMutationHookResult = ReturnType<typeof useUpdateItemSetQuestionQConfigStructureMutation>;
export type UpdateItemSetQuestionQConfigStructureMutationResult = Apollo.MutationResult<UpdateItemSetQuestionQConfigStructureMutation>;
export type UpdateItemSetQuestionQConfigStructureMutationOptions = Apollo.BaseMutationOptions<UpdateItemSetQuestionQConfigStructureMutation, UpdateItemSetQuestionQConfigStructureMutationVariables>;
export const UpdateQConfigAsDraftDocument = gql`
    mutation updateQConfigAsDraft($updateQConfigAsDraftInput: UpdateQConfigAsDraftInput!) {
  excUpdateQConfigAsDraft(updateQConfigAsDraftInput: $updateQConfigAsDraftInput) {
    qConfig {
      id
    }
  }
}
    `;
export type UpdateQConfigAsDraftMutationFn = Apollo.MutationFunction<UpdateQConfigAsDraftMutation, UpdateQConfigAsDraftMutationVariables>;

/**
 * __useUpdateQConfigAsDraftMutation__
 *
 * To run a mutation, you first call `useUpdateQConfigAsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQConfigAsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQConfigAsDraftMutation, { data, loading, error }] = useUpdateQConfigAsDraftMutation({
 *   variables: {
 *      updateQConfigAsDraftInput: // value for 'updateQConfigAsDraftInput'
 *   },
 * });
 */
export function useUpdateQConfigAsDraftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQConfigAsDraftMutation, UpdateQConfigAsDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQConfigAsDraftMutation, UpdateQConfigAsDraftMutationVariables>(UpdateQConfigAsDraftDocument, options);
      }
export type UpdateQConfigAsDraftMutationHookResult = ReturnType<typeof useUpdateQConfigAsDraftMutation>;
export type UpdateQConfigAsDraftMutationResult = Apollo.MutationResult<UpdateQConfigAsDraftMutation>;
export type UpdateQConfigAsDraftMutationOptions = Apollo.BaseMutationOptions<UpdateQConfigAsDraftMutation, UpdateQConfigAsDraftMutationVariables>;
export const SearchQConfigGeneratorsDocument = gql`
    query searchQConfigGenerators($searchQConfigGeneratorsInput: SearchQConfigGeneratorsInput!) {
  excSearchQConfigGenerators(
    searchQConfigGeneratorsInput: $searchQConfigGeneratorsInput
  ) {
    qConfigGenerators {
      id
      examCourseId
      name
      code
      totalQuestions
      needTotal
      latestExecution {
        id
        qConfigGeneratorId
        round
        status
        metadata
        startedAt
        endedAt
        needTotal
        totalResults
        createdAt
      }
    }
    total
  }
}
    `;

/**
 * __useSearchQConfigGeneratorsQuery__
 *
 * To run a query within a React component, call `useSearchQConfigGeneratorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQConfigGeneratorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQConfigGeneratorsQuery({
 *   variables: {
 *      searchQConfigGeneratorsInput: // value for 'searchQConfigGeneratorsInput'
 *   },
 * });
 */
export function useSearchQConfigGeneratorsQuery(baseOptions: Apollo.QueryHookOptions<SearchQConfigGeneratorsQuery, SearchQConfigGeneratorsQueryVariables> & ({ variables: SearchQConfigGeneratorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQConfigGeneratorsQuery, SearchQConfigGeneratorsQueryVariables>(SearchQConfigGeneratorsDocument, options);
      }
export function useSearchQConfigGeneratorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQConfigGeneratorsQuery, SearchQConfigGeneratorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQConfigGeneratorsQuery, SearchQConfigGeneratorsQueryVariables>(SearchQConfigGeneratorsDocument, options);
        }
// @ts-ignore
export function useSearchQConfigGeneratorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQConfigGeneratorsQuery, SearchQConfigGeneratorsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQConfigGeneratorsQuery, SearchQConfigGeneratorsQueryVariables>;
export function useSearchQConfigGeneratorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQConfigGeneratorsQuery, SearchQConfigGeneratorsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQConfigGeneratorsQuery | undefined, SearchQConfigGeneratorsQueryVariables>;
export function useSearchQConfigGeneratorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQConfigGeneratorsQuery, SearchQConfigGeneratorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQConfigGeneratorsQuery, SearchQConfigGeneratorsQueryVariables>(SearchQConfigGeneratorsDocument, options);
        }
export type SearchQConfigGeneratorsQueryHookResult = ReturnType<typeof useSearchQConfigGeneratorsQuery>;
export type SearchQConfigGeneratorsLazyQueryHookResult = ReturnType<typeof useSearchQConfigGeneratorsLazyQuery>;
export type SearchQConfigGeneratorsSuspenseQueryHookResult = ReturnType<typeof useSearchQConfigGeneratorsSuspenseQuery>;
export type SearchQConfigGeneratorsQueryResult = Apollo.QueryResult<SearchQConfigGeneratorsQuery, SearchQConfigGeneratorsQueryVariables>;
export const CreateQConfigGeneratorDocument = gql`
    mutation createQConfigGenerator($createQConfigGeneratorInput: CreateQConfigGeneratorInput!) {
  excCreateQConfigGenerator(
    CreateQConfigGeneratorInput: $createQConfigGeneratorInput
  ) {
    qConfigGenerator {
      id
    }
  }
}
    `;
export type CreateQConfigGeneratorMutationFn = Apollo.MutationFunction<CreateQConfigGeneratorMutation, CreateQConfigGeneratorMutationVariables>;

/**
 * __useCreateQConfigGeneratorMutation__
 *
 * To run a mutation, you first call `useCreateQConfigGeneratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQConfigGeneratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQConfigGeneratorMutation, { data, loading, error }] = useCreateQConfigGeneratorMutation({
 *   variables: {
 *      createQConfigGeneratorInput: // value for 'createQConfigGeneratorInput'
 *   },
 * });
 */
export function useCreateQConfigGeneratorMutation(baseOptions?: Apollo.MutationHookOptions<CreateQConfigGeneratorMutation, CreateQConfigGeneratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQConfigGeneratorMutation, CreateQConfigGeneratorMutationVariables>(CreateQConfigGeneratorDocument, options);
      }
export type CreateQConfigGeneratorMutationHookResult = ReturnType<typeof useCreateQConfigGeneratorMutation>;
export type CreateQConfigGeneratorMutationResult = Apollo.MutationResult<CreateQConfigGeneratorMutation>;
export type CreateQConfigGeneratorMutationOptions = Apollo.BaseMutationOptions<CreateQConfigGeneratorMutation, CreateQConfigGeneratorMutationVariables>;
export const DeleteQConfigDocument = gql`
    mutation deleteQConfig($deleteQConfigInput: DeleteQConfigInput!) {
  excDeleteQConfig(deleteQConfigInput: $deleteQConfigInput) {
    qConfig {
      id
    }
  }
}
    `;
export type DeleteQConfigMutationFn = Apollo.MutationFunction<DeleteQConfigMutation, DeleteQConfigMutationVariables>;

/**
 * __useDeleteQConfigMutation__
 *
 * To run a mutation, you first call `useDeleteQConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQConfigMutation, { data, loading, error }] = useDeleteQConfigMutation({
 *   variables: {
 *      deleteQConfigInput: // value for 'deleteQConfigInput'
 *   },
 * });
 */
export function useDeleteQConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQConfigMutation, DeleteQConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQConfigMutation, DeleteQConfigMutationVariables>(DeleteQConfigDocument, options);
      }
export type DeleteQConfigMutationHookResult = ReturnType<typeof useDeleteQConfigMutation>;
export type DeleteQConfigMutationResult = Apollo.MutationResult<DeleteQConfigMutation>;
export type DeleteQConfigMutationOptions = Apollo.BaseMutationOptions<DeleteQConfigMutation, DeleteQConfigMutationVariables>;
export const GetQConfigGeneratorByIdDocument = gql`
    query getQConfigGeneratorById($getQConfigGeneratorByIdInput: GetQConfigGeneratorByIdInput!) {
  excGetQConfigGeneratorById(
    getQConfigGeneratorByIdInput: $getQConfigGeneratorByIdInput
  ) {
    qConfigGenerator {
      id
      name
      code
      totalQuestions
      metadata {
        conditions {
          questionTypes {
            type
            needTotal
          }
          tags {
            tag {
              id
              name
            }
            needTotal
          }
        }
      }
      needTotal
      qBankStructures {
        id
        code
        name
      }
      latestExecution {
        id
        status
        needTotal
        totalResults
        createdAt
        results {
          id
          qConfig {
            id
            name
            code
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetQConfigGeneratorByIdQuery__
 *
 * To run a query within a React component, call `useGetQConfigGeneratorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQConfigGeneratorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQConfigGeneratorByIdQuery({
 *   variables: {
 *      getQConfigGeneratorByIdInput: // value for 'getQConfigGeneratorByIdInput'
 *   },
 * });
 */
export function useGetQConfigGeneratorByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQConfigGeneratorByIdQuery, GetQConfigGeneratorByIdQueryVariables> & ({ variables: GetQConfigGeneratorByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQConfigGeneratorByIdQuery, GetQConfigGeneratorByIdQueryVariables>(GetQConfigGeneratorByIdDocument, options);
      }
export function useGetQConfigGeneratorByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQConfigGeneratorByIdQuery, GetQConfigGeneratorByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQConfigGeneratorByIdQuery, GetQConfigGeneratorByIdQueryVariables>(GetQConfigGeneratorByIdDocument, options);
        }
// @ts-ignore
export function useGetQConfigGeneratorByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQConfigGeneratorByIdQuery, GetQConfigGeneratorByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQConfigGeneratorByIdQuery, GetQConfigGeneratorByIdQueryVariables>;
export function useGetQConfigGeneratorByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQConfigGeneratorByIdQuery, GetQConfigGeneratorByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQConfigGeneratorByIdQuery | undefined, GetQConfigGeneratorByIdQueryVariables>;
export function useGetQConfigGeneratorByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQConfigGeneratorByIdQuery, GetQConfigGeneratorByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQConfigGeneratorByIdQuery, GetQConfigGeneratorByIdQueryVariables>(GetQConfigGeneratorByIdDocument, options);
        }
export type GetQConfigGeneratorByIdQueryHookResult = ReturnType<typeof useGetQConfigGeneratorByIdQuery>;
export type GetQConfigGeneratorByIdLazyQueryHookResult = ReturnType<typeof useGetQConfigGeneratorByIdLazyQuery>;
export type GetQConfigGeneratorByIdSuspenseQueryHookResult = ReturnType<typeof useGetQConfigGeneratorByIdSuspenseQuery>;
export type GetQConfigGeneratorByIdQueryResult = Apollo.QueryResult<GetQConfigGeneratorByIdQuery, GetQConfigGeneratorByIdQueryVariables>;
export const SearchQConfigActivityLogDocument = gql`
    query searchQConfigActivityLog($searchQConfigActivityLogInput: SearchQConfigAuditLogInput!) {
  excSearchQConfigAuditLog(
    SearchQConfigAuditLogInput: $searchQConfigActivityLogInput
  ) {
    qConfigAuditLogs {
      id
      action
      detail
      actionTime
      fullName
    }
    total
  }
}
    `;

/**
 * __useSearchQConfigActivityLogQuery__
 *
 * To run a query within a React component, call `useSearchQConfigActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQConfigActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQConfigActivityLogQuery({
 *   variables: {
 *      searchQConfigActivityLogInput: // value for 'searchQConfigActivityLogInput'
 *   },
 * });
 */
export function useSearchQConfigActivityLogQuery(baseOptions: Apollo.QueryHookOptions<SearchQConfigActivityLogQuery, SearchQConfigActivityLogQueryVariables> & ({ variables: SearchQConfigActivityLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQConfigActivityLogQuery, SearchQConfigActivityLogQueryVariables>(SearchQConfigActivityLogDocument, options);
      }
export function useSearchQConfigActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQConfigActivityLogQuery, SearchQConfigActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQConfigActivityLogQuery, SearchQConfigActivityLogQueryVariables>(SearchQConfigActivityLogDocument, options);
        }
// @ts-ignore
export function useSearchQConfigActivityLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQConfigActivityLogQuery, SearchQConfigActivityLogQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQConfigActivityLogQuery, SearchQConfigActivityLogQueryVariables>;
export function useSearchQConfigActivityLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQConfigActivityLogQuery, SearchQConfigActivityLogQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQConfigActivityLogQuery | undefined, SearchQConfigActivityLogQueryVariables>;
export function useSearchQConfigActivityLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQConfigActivityLogQuery, SearchQConfigActivityLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQConfigActivityLogQuery, SearchQConfigActivityLogQueryVariables>(SearchQConfigActivityLogDocument, options);
        }
export type SearchQConfigActivityLogQueryHookResult = ReturnType<typeof useSearchQConfigActivityLogQuery>;
export type SearchQConfigActivityLogLazyQueryHookResult = ReturnType<typeof useSearchQConfigActivityLogLazyQuery>;
export type SearchQConfigActivityLogSuspenseQueryHookResult = ReturnType<typeof useSearchQConfigActivityLogSuspenseQuery>;
export type SearchQConfigActivityLogQueryResult = Apollo.QueryResult<SearchQConfigActivityLogQuery, SearchQConfigActivityLogQueryVariables>;
export const GetDisabledLosInQConfigDocument = gql`
    query getDisabledLosInQConfig($getDisabledLearningObjectiveStatementsByQConfigIdInput: GetDisabledLearningObjectiveStatementsByQConfigIdInput!) {
  excGetDisabledLearningObjectiveStatementsByQConfigId(
    GetDisabledLearningObjectiveStatementsByQConfigIdInput: $getDisabledLearningObjectiveStatementsByQConfigIdInput
  ) {
    disabledLearningObjectiveStatements {
      id
      name
    }
  }
}
    `;

/**
 * __useGetDisabledLosInQConfigQuery__
 *
 * To run a query within a React component, call `useGetDisabledLosInQConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisabledLosInQConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisabledLosInQConfigQuery({
 *   variables: {
 *      getDisabledLearningObjectiveStatementsByQConfigIdInput: // value for 'getDisabledLearningObjectiveStatementsByQConfigIdInput'
 *   },
 * });
 */
export function useGetDisabledLosInQConfigQuery(baseOptions: Apollo.QueryHookOptions<GetDisabledLosInQConfigQuery, GetDisabledLosInQConfigQueryVariables> & ({ variables: GetDisabledLosInQConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisabledLosInQConfigQuery, GetDisabledLosInQConfigQueryVariables>(GetDisabledLosInQConfigDocument, options);
      }
export function useGetDisabledLosInQConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisabledLosInQConfigQuery, GetDisabledLosInQConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisabledLosInQConfigQuery, GetDisabledLosInQConfigQueryVariables>(GetDisabledLosInQConfigDocument, options);
        }
// @ts-ignore
export function useGetDisabledLosInQConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDisabledLosInQConfigQuery, GetDisabledLosInQConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetDisabledLosInQConfigQuery, GetDisabledLosInQConfigQueryVariables>;
export function useGetDisabledLosInQConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDisabledLosInQConfigQuery, GetDisabledLosInQConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetDisabledLosInQConfigQuery | undefined, GetDisabledLosInQConfigQueryVariables>;
export function useGetDisabledLosInQConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDisabledLosInQConfigQuery, GetDisabledLosInQConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDisabledLosInQConfigQuery, GetDisabledLosInQConfigQueryVariables>(GetDisabledLosInQConfigDocument, options);
        }
export type GetDisabledLosInQConfigQueryHookResult = ReturnType<typeof useGetDisabledLosInQConfigQuery>;
export type GetDisabledLosInQConfigLazyQueryHookResult = ReturnType<typeof useGetDisabledLosInQConfigLazyQuery>;
export type GetDisabledLosInQConfigSuspenseQueryHookResult = ReturnType<typeof useGetDisabledLosInQConfigSuspenseQuery>;
export type GetDisabledLosInQConfigQueryResult = Apollo.QueryResult<GetDisabledLosInQConfigQuery, GetDisabledLosInQConfigQueryVariables>;
export const GetLosByQConfigStructureDocument = gql`
    query getLOSByQConfigStructure($input: GetQConfigChapterInput!) {
  excGetQConfigChapter(GetQConfigChapterInput: $input) {
    id
    learningObjectiveStatements {
      id
      tag {
        name
      }
    }
  }
}
    `;

/**
 * __useGetLosByQConfigStructureQuery__
 *
 * To run a query within a React component, call `useGetLosByQConfigStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLosByQConfigStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLosByQConfigStructureQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLosByQConfigStructureQuery(baseOptions: Apollo.QueryHookOptions<GetLosByQConfigStructureQuery, GetLosByQConfigStructureQueryVariables> & ({ variables: GetLosByQConfigStructureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLosByQConfigStructureQuery, GetLosByQConfigStructureQueryVariables>(GetLosByQConfigStructureDocument, options);
      }
export function useGetLosByQConfigStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLosByQConfigStructureQuery, GetLosByQConfigStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLosByQConfigStructureQuery, GetLosByQConfigStructureQueryVariables>(GetLosByQConfigStructureDocument, options);
        }
// @ts-ignore
export function useGetLosByQConfigStructureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLosByQConfigStructureQuery, GetLosByQConfigStructureQueryVariables>): Apollo.UseSuspenseQueryResult<GetLosByQConfigStructureQuery, GetLosByQConfigStructureQueryVariables>;
export function useGetLosByQConfigStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLosByQConfigStructureQuery, GetLosByQConfigStructureQueryVariables>): Apollo.UseSuspenseQueryResult<GetLosByQConfigStructureQuery | undefined, GetLosByQConfigStructureQueryVariables>;
export function useGetLosByQConfigStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLosByQConfigStructureQuery, GetLosByQConfigStructureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLosByQConfigStructureQuery, GetLosByQConfigStructureQueryVariables>(GetLosByQConfigStructureDocument, options);
        }
export type GetLosByQConfigStructureQueryHookResult = ReturnType<typeof useGetLosByQConfigStructureQuery>;
export type GetLosByQConfigStructureLazyQueryHookResult = ReturnType<typeof useGetLosByQConfigStructureLazyQuery>;
export type GetLosByQConfigStructureSuspenseQueryHookResult = ReturnType<typeof useGetLosByQConfigStructureSuspenseQuery>;
export type GetLosByQConfigStructureQueryResult = Apollo.QueryResult<GetLosByQConfigStructureQuery, GetLosByQConfigStructureQueryVariables>;
export const GetLevelItemSubtreeByQConfigStructureDocument = gql`
    query getLevelItemSubtreeByQConfigStructure($input: GetQConfigChapterInput!) {
  excGetQConfigChapter(GetQConfigChapterInput: $input) {
    id
    levelItemSubtree {
      id
      parentLevelItemId
      order
      qBankStructureLevelId
      tag {
        id
        name
      }
      level: qBankStructureLevel {
        id
        level
        category
        enabled
      }
    }
  }
}
    `;

/**
 * __useGetLevelItemSubtreeByQConfigStructureQuery__
 *
 * To run a query within a React component, call `useGetLevelItemSubtreeByQConfigStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLevelItemSubtreeByQConfigStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLevelItemSubtreeByQConfigStructureQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLevelItemSubtreeByQConfigStructureQuery(baseOptions: Apollo.QueryHookOptions<GetLevelItemSubtreeByQConfigStructureQuery, GetLevelItemSubtreeByQConfigStructureQueryVariables> & ({ variables: GetLevelItemSubtreeByQConfigStructureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLevelItemSubtreeByQConfigStructureQuery, GetLevelItemSubtreeByQConfigStructureQueryVariables>(GetLevelItemSubtreeByQConfigStructureDocument, options);
      }
export function useGetLevelItemSubtreeByQConfigStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLevelItemSubtreeByQConfigStructureQuery, GetLevelItemSubtreeByQConfigStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLevelItemSubtreeByQConfigStructureQuery, GetLevelItemSubtreeByQConfigStructureQueryVariables>(GetLevelItemSubtreeByQConfigStructureDocument, options);
        }
// @ts-ignore
export function useGetLevelItemSubtreeByQConfigStructureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLevelItemSubtreeByQConfigStructureQuery, GetLevelItemSubtreeByQConfigStructureQueryVariables>): Apollo.UseSuspenseQueryResult<GetLevelItemSubtreeByQConfigStructureQuery, GetLevelItemSubtreeByQConfigStructureQueryVariables>;
export function useGetLevelItemSubtreeByQConfigStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLevelItemSubtreeByQConfigStructureQuery, GetLevelItemSubtreeByQConfigStructureQueryVariables>): Apollo.UseSuspenseQueryResult<GetLevelItemSubtreeByQConfigStructureQuery | undefined, GetLevelItemSubtreeByQConfigStructureQueryVariables>;
export function useGetLevelItemSubtreeByQConfigStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLevelItemSubtreeByQConfigStructureQuery, GetLevelItemSubtreeByQConfigStructureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLevelItemSubtreeByQConfigStructureQuery, GetLevelItemSubtreeByQConfigStructureQueryVariables>(GetLevelItemSubtreeByQConfigStructureDocument, options);
        }
export type GetLevelItemSubtreeByQConfigStructureQueryHookResult = ReturnType<typeof useGetLevelItemSubtreeByQConfigStructureQuery>;
export type GetLevelItemSubtreeByQConfigStructureLazyQueryHookResult = ReturnType<typeof useGetLevelItemSubtreeByQConfigStructureLazyQuery>;
export type GetLevelItemSubtreeByQConfigStructureSuspenseQueryHookResult = ReturnType<typeof useGetLevelItemSubtreeByQConfigStructureSuspenseQuery>;
export type GetLevelItemSubtreeByQConfigStructureQueryResult = Apollo.QueryResult<GetLevelItemSubtreeByQConfigStructureQuery, GetLevelItemSubtreeByQConfigStructureQueryVariables>;
export const SearchQSetsDocument = gql`
    query searchQSets($searchQSetsInput: SearchQSetsInput!) {
  excSearchQSets(searchQSetsInput: $searchQSetsInput) {
    qSets {
      id
      examCourseId
      qConfigId
      code
      status
      updatedAt
      qConfig {
        id
        name
        code
        totalQuestions
        timeLimit {
          total
        }
      }
    }
    total
  }
}
    `;

/**
 * __useSearchQSetsQuery__
 *
 * To run a query within a React component, call `useSearchQSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQSetsQuery({
 *   variables: {
 *      searchQSetsInput: // value for 'searchQSetsInput'
 *   },
 * });
 */
export function useSearchQSetsQuery(baseOptions: Apollo.QueryHookOptions<SearchQSetsQuery, SearchQSetsQueryVariables> & ({ variables: SearchQSetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQSetsQuery, SearchQSetsQueryVariables>(SearchQSetsDocument, options);
      }
export function useSearchQSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQSetsQuery, SearchQSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQSetsQuery, SearchQSetsQueryVariables>(SearchQSetsDocument, options);
        }
// @ts-ignore
export function useSearchQSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQSetsQuery, SearchQSetsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQSetsQuery, SearchQSetsQueryVariables>;
export function useSearchQSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQSetsQuery, SearchQSetsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQSetsQuery | undefined, SearchQSetsQueryVariables>;
export function useSearchQSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQSetsQuery, SearchQSetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQSetsQuery, SearchQSetsQueryVariables>(SearchQSetsDocument, options);
        }
export type SearchQSetsQueryHookResult = ReturnType<typeof useSearchQSetsQuery>;
export type SearchQSetsLazyQueryHookResult = ReturnType<typeof useSearchQSetsLazyQuery>;
export type SearchQSetsSuspenseQueryHookResult = ReturnType<typeof useSearchQSetsSuspenseQuery>;
export type SearchQSetsQueryResult = Apollo.QueryResult<SearchQSetsQuery, SearchQSetsQueryVariables>;
export const GetDraftQSetsDocument = gql`
    query getDraftQSets($searchQSetsInput: SearchQSetsInput!) {
  excSearchQSets(searchQSetsInput: $searchQSetsInput) {
    qSets {
      id
      code
      status
      updatedAt
      qConfig {
        id
        name
        code
      }
    }
    total
  }
}
    `;

/**
 * __useGetDraftQSetsQuery__
 *
 * To run a query within a React component, call `useGetDraftQSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDraftQSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDraftQSetsQuery({
 *   variables: {
 *      searchQSetsInput: // value for 'searchQSetsInput'
 *   },
 * });
 */
export function useGetDraftQSetsQuery(baseOptions: Apollo.QueryHookOptions<GetDraftQSetsQuery, GetDraftQSetsQueryVariables> & ({ variables: GetDraftQSetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDraftQSetsQuery, GetDraftQSetsQueryVariables>(GetDraftQSetsDocument, options);
      }
export function useGetDraftQSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDraftQSetsQuery, GetDraftQSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDraftQSetsQuery, GetDraftQSetsQueryVariables>(GetDraftQSetsDocument, options);
        }
// @ts-ignore
export function useGetDraftQSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDraftQSetsQuery, GetDraftQSetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDraftQSetsQuery, GetDraftQSetsQueryVariables>;
export function useGetDraftQSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDraftQSetsQuery, GetDraftQSetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDraftQSetsQuery | undefined, GetDraftQSetsQueryVariables>;
export function useGetDraftQSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDraftQSetsQuery, GetDraftQSetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDraftQSetsQuery, GetDraftQSetsQueryVariables>(GetDraftQSetsDocument, options);
        }
export type GetDraftQSetsQueryHookResult = ReturnType<typeof useGetDraftQSetsQuery>;
export type GetDraftQSetsLazyQueryHookResult = ReturnType<typeof useGetDraftQSetsLazyQuery>;
export type GetDraftQSetsSuspenseQueryHookResult = ReturnType<typeof useGetDraftQSetsSuspenseQuery>;
export type GetDraftQSetsQueryResult = Apollo.QueryResult<GetDraftQSetsQuery, GetDraftQSetsQueryVariables>;
export const GetPublishedQSetsDocument = gql`
    query getPublishedQSets($searchQSetsInput: SearchQSetsInput!) {
  excSearchQSets(searchQSetsInput: $searchQSetsInput) {
    qSets {
      id
      code
      status
      updatedAt
      lastPublishedAt
      examUsageStatus
      qConfig {
        id
        name
        code
      }
    }
    total
  }
}
    `;

/**
 * __useGetPublishedQSetsQuery__
 *
 * To run a query within a React component, call `useGetPublishedQSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishedQSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishedQSetsQuery({
 *   variables: {
 *      searchQSetsInput: // value for 'searchQSetsInput'
 *   },
 * });
 */
export function useGetPublishedQSetsQuery(baseOptions: Apollo.QueryHookOptions<GetPublishedQSetsQuery, GetPublishedQSetsQueryVariables> & ({ variables: GetPublishedQSetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishedQSetsQuery, GetPublishedQSetsQueryVariables>(GetPublishedQSetsDocument, options);
      }
export function useGetPublishedQSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishedQSetsQuery, GetPublishedQSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishedQSetsQuery, GetPublishedQSetsQueryVariables>(GetPublishedQSetsDocument, options);
        }
// @ts-ignore
export function useGetPublishedQSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPublishedQSetsQuery, GetPublishedQSetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPublishedQSetsQuery, GetPublishedQSetsQueryVariables>;
export function useGetPublishedQSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublishedQSetsQuery, GetPublishedQSetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPublishedQSetsQuery | undefined, GetPublishedQSetsQueryVariables>;
export function useGetPublishedQSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublishedQSetsQuery, GetPublishedQSetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublishedQSetsQuery, GetPublishedQSetsQueryVariables>(GetPublishedQSetsDocument, options);
        }
export type GetPublishedQSetsQueryHookResult = ReturnType<typeof useGetPublishedQSetsQuery>;
export type GetPublishedQSetsLazyQueryHookResult = ReturnType<typeof useGetPublishedQSetsLazyQuery>;
export type GetPublishedQSetsSuspenseQueryHookResult = ReturnType<typeof useGetPublishedQSetsSuspenseQuery>;
export type GetPublishedQSetsQueryResult = Apollo.QueryResult<GetPublishedQSetsQuery, GetPublishedQSetsQueryVariables>;
export const GetInReviewQSetsDocument = gql`
    query getInReviewQSets($searchQSetsInput: SearchQSetsInput!) {
  excSearchQSets(searchQSetsInput: $searchQSetsInput) {
    qSets {
      id
      code
      status
      updatedAt
      lastPublishedAt
      lastReviewedAt
      qConfig {
        id
        name
        code
      }
      assignees {
        firstname
        lastname
      }
    }
    total
  }
}
    `;

/**
 * __useGetInReviewQSetsQuery__
 *
 * To run a query within a React component, call `useGetInReviewQSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInReviewQSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInReviewQSetsQuery({
 *   variables: {
 *      searchQSetsInput: // value for 'searchQSetsInput'
 *   },
 * });
 */
export function useGetInReviewQSetsQuery(baseOptions: Apollo.QueryHookOptions<GetInReviewQSetsQuery, GetInReviewQSetsQueryVariables> & ({ variables: GetInReviewQSetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInReviewQSetsQuery, GetInReviewQSetsQueryVariables>(GetInReviewQSetsDocument, options);
      }
export function useGetInReviewQSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInReviewQSetsQuery, GetInReviewQSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInReviewQSetsQuery, GetInReviewQSetsQueryVariables>(GetInReviewQSetsDocument, options);
        }
// @ts-ignore
export function useGetInReviewQSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInReviewQSetsQuery, GetInReviewQSetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInReviewQSetsQuery, GetInReviewQSetsQueryVariables>;
export function useGetInReviewQSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInReviewQSetsQuery, GetInReviewQSetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInReviewQSetsQuery | undefined, GetInReviewQSetsQueryVariables>;
export function useGetInReviewQSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInReviewQSetsQuery, GetInReviewQSetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInReviewQSetsQuery, GetInReviewQSetsQueryVariables>(GetInReviewQSetsDocument, options);
        }
export type GetInReviewQSetsQueryHookResult = ReturnType<typeof useGetInReviewQSetsQuery>;
export type GetInReviewQSetsLazyQueryHookResult = ReturnType<typeof useGetInReviewQSetsLazyQuery>;
export type GetInReviewQSetsSuspenseQueryHookResult = ReturnType<typeof useGetInReviewQSetsSuspenseQuery>;
export type GetInReviewQSetsQueryResult = Apollo.QueryResult<GetInReviewQSetsQuery, GetInReviewQSetsQueryVariables>;
export const GetReviewedQSetsDocument = gql`
    query getReviewedQSets($searchQSetsInput: SearchQSetsInput!) {
  excSearchQSets(searchQSetsInput: $searchQSetsInput) {
    qSets {
      id
      code
      status
      updatedAt
      lastPublishedAt
      lastReviewedAt
      qConfig {
        id
        name
        code
      }
      assignees {
        firstname
        lastname
      }
    }
    total
  }
}
    `;

/**
 * __useGetReviewedQSetsQuery__
 *
 * To run a query within a React component, call `useGetReviewedQSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewedQSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewedQSetsQuery({
 *   variables: {
 *      searchQSetsInput: // value for 'searchQSetsInput'
 *   },
 * });
 */
export function useGetReviewedQSetsQuery(baseOptions: Apollo.QueryHookOptions<GetReviewedQSetsQuery, GetReviewedQSetsQueryVariables> & ({ variables: GetReviewedQSetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewedQSetsQuery, GetReviewedQSetsQueryVariables>(GetReviewedQSetsDocument, options);
      }
export function useGetReviewedQSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewedQSetsQuery, GetReviewedQSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewedQSetsQuery, GetReviewedQSetsQueryVariables>(GetReviewedQSetsDocument, options);
        }
// @ts-ignore
export function useGetReviewedQSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReviewedQSetsQuery, GetReviewedQSetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReviewedQSetsQuery, GetReviewedQSetsQueryVariables>;
export function useGetReviewedQSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReviewedQSetsQuery, GetReviewedQSetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReviewedQSetsQuery | undefined, GetReviewedQSetsQueryVariables>;
export function useGetReviewedQSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReviewedQSetsQuery, GetReviewedQSetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReviewedQSetsQuery, GetReviewedQSetsQueryVariables>(GetReviewedQSetsDocument, options);
        }
export type GetReviewedQSetsQueryHookResult = ReturnType<typeof useGetReviewedQSetsQuery>;
export type GetReviewedQSetsLazyQueryHookResult = ReturnType<typeof useGetReviewedQSetsLazyQuery>;
export type GetReviewedQSetsSuspenseQueryHookResult = ReturnType<typeof useGetReviewedQSetsSuspenseQuery>;
export type GetReviewedQSetsQueryResult = Apollo.QueryResult<GetReviewedQSetsQuery, GetReviewedQSetsQueryVariables>;
export const GetDisabledQSetsDocument = gql`
    query getDisabledQSets($searchQSetsInput: SearchQSetsInput!) {
  excSearchQSets(searchQSetsInput: $searchQSetsInput) {
    qSets {
      id
      code
      status
      qConfig {
        id
        name
        code
      }
      disabledAt
    }
    total
  }
}
    `;

/**
 * __useGetDisabledQSetsQuery__
 *
 * To run a query within a React component, call `useGetDisabledQSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisabledQSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisabledQSetsQuery({
 *   variables: {
 *      searchQSetsInput: // value for 'searchQSetsInput'
 *   },
 * });
 */
export function useGetDisabledQSetsQuery(baseOptions: Apollo.QueryHookOptions<GetDisabledQSetsQuery, GetDisabledQSetsQueryVariables> & ({ variables: GetDisabledQSetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisabledQSetsQuery, GetDisabledQSetsQueryVariables>(GetDisabledQSetsDocument, options);
      }
export function useGetDisabledQSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisabledQSetsQuery, GetDisabledQSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisabledQSetsQuery, GetDisabledQSetsQueryVariables>(GetDisabledQSetsDocument, options);
        }
// @ts-ignore
export function useGetDisabledQSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDisabledQSetsQuery, GetDisabledQSetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDisabledQSetsQuery, GetDisabledQSetsQueryVariables>;
export function useGetDisabledQSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDisabledQSetsQuery, GetDisabledQSetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDisabledQSetsQuery | undefined, GetDisabledQSetsQueryVariables>;
export function useGetDisabledQSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDisabledQSetsQuery, GetDisabledQSetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDisabledQSetsQuery, GetDisabledQSetsQueryVariables>(GetDisabledQSetsDocument, options);
        }
export type GetDisabledQSetsQueryHookResult = ReturnType<typeof useGetDisabledQSetsQuery>;
export type GetDisabledQSetsLazyQueryHookResult = ReturnType<typeof useGetDisabledQSetsLazyQuery>;
export type GetDisabledQSetsSuspenseQueryHookResult = ReturnType<typeof useGetDisabledQSetsSuspenseQuery>;
export type GetDisabledQSetsQueryResult = Apollo.QueryResult<GetDisabledQSetsQuery, GetDisabledQSetsQueryVariables>;
export const GetQSetByIdDocument = gql`
    query getQSetById($input: GetQSetByIdInput!) {
  excGetQSetById(input: $input) {
    qSet {
      id
      code
      status
      examCourseId
      pAvgValue
      conditions {
        tags {
          tag {
            id
            name
          }
          count
        }
        questionTypes {
          type
          count
        }
        averagePValue
      }
      qConfig {
        examCourse {
          name
        }
        fullScore
        totalQuestions
        metadata {
          conditions {
            questionTypes {
              type
              needTotal
            }
            tags {
              tag {
                name
              }
              needTotal
            }
          }
        }
        passingCriteria {
          value
          type
        }
        randomType
        structures {
          id
          name
          category
          type
          score
          passingCriteria {
            value
            type
          }
          totalQuestions
        }
        timeLimit {
          values {
            qConfigStructureIds
            value
            order
          }
          type
          total
        }
      }
    }
  }
}
    `;

/**
 * __useGetQSetByIdQuery__
 *
 * To run a query within a React component, call `useGetQSetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQSetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQSetByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQSetByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQSetByIdQuery, GetQSetByIdQueryVariables> & ({ variables: GetQSetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQSetByIdQuery, GetQSetByIdQueryVariables>(GetQSetByIdDocument, options);
      }
export function useGetQSetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQSetByIdQuery, GetQSetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQSetByIdQuery, GetQSetByIdQueryVariables>(GetQSetByIdDocument, options);
        }
// @ts-ignore
export function useGetQSetByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQSetByIdQuery, GetQSetByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQSetByIdQuery, GetQSetByIdQueryVariables>;
export function useGetQSetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetByIdQuery, GetQSetByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQSetByIdQuery | undefined, GetQSetByIdQueryVariables>;
export function useGetQSetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetByIdQuery, GetQSetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQSetByIdQuery, GetQSetByIdQueryVariables>(GetQSetByIdDocument, options);
        }
export type GetQSetByIdQueryHookResult = ReturnType<typeof useGetQSetByIdQuery>;
export type GetQSetByIdLazyQueryHookResult = ReturnType<typeof useGetQSetByIdLazyQuery>;
export type GetQSetByIdSuspenseQueryHookResult = ReturnType<typeof useGetQSetByIdSuspenseQuery>;
export type GetQSetByIdQueryResult = Apollo.QueryResult<GetQSetByIdQuery, GetQSetByIdQueryVariables>;
export const SearchQSetQuestionsDocument = gql`
    query searchQSetQuestions($input: SearchQSetQuestionsInput!) {
  excSearchQSetQuestions(input: $input) {
    qSetQuestions {
      id
      questionId
      questionGroupId
      questionRefCode
      order
      question {
        id
        tags {
          id
          name
          category
        }
        type
        details
        refCode
        metadata {
          choices {
            label
            order
            value
          }
          reference
        }
        correctAnswer {
          value
        }
        questionGroup {
          id
          type
          size
          metadata {
            paragraph
          }
          refCode
        }
        solution {
          type
          value
        }
      }
    }
    total
  }
}
    `;

/**
 * __useSearchQSetQuestionsQuery__
 *
 * To run a query within a React component, call `useSearchQSetQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQSetQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQSetQuestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchQSetQuestionsQuery(baseOptions: Apollo.QueryHookOptions<SearchQSetQuestionsQuery, SearchQSetQuestionsQueryVariables> & ({ variables: SearchQSetQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQSetQuestionsQuery, SearchQSetQuestionsQueryVariables>(SearchQSetQuestionsDocument, options);
      }
export function useSearchQSetQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQSetQuestionsQuery, SearchQSetQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQSetQuestionsQuery, SearchQSetQuestionsQueryVariables>(SearchQSetQuestionsDocument, options);
        }
// @ts-ignore
export function useSearchQSetQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQSetQuestionsQuery, SearchQSetQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQSetQuestionsQuery, SearchQSetQuestionsQueryVariables>;
export function useSearchQSetQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQSetQuestionsQuery, SearchQSetQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQSetQuestionsQuery | undefined, SearchQSetQuestionsQueryVariables>;
export function useSearchQSetQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQSetQuestionsQuery, SearchQSetQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQSetQuestionsQuery, SearchQSetQuestionsQueryVariables>(SearchQSetQuestionsDocument, options);
        }
export type SearchQSetQuestionsQueryHookResult = ReturnType<typeof useSearchQSetQuestionsQuery>;
export type SearchQSetQuestionsLazyQueryHookResult = ReturnType<typeof useSearchQSetQuestionsLazyQuery>;
export type SearchQSetQuestionsSuspenseQueryHookResult = ReturnType<typeof useSearchQSetQuestionsSuspenseQuery>;
export type SearchQSetQuestionsQueryResult = Apollo.QueryResult<SearchQSetQuestionsQuery, SearchQSetQuestionsQueryVariables>;
export const GetQSetGeneratorExecutionByIdDocument = gql`
    query getQSetGeneratorExecutionById($input: GetQSetGeneratorExecutionByIdInput!) {
  excGetQSetGeneratorExecutionById(GetQSetGeneratorExecutionByIdInput: $input) {
    qSetGeneratorExecution {
      id
      generator {
        id
        code
        needTotal
        duplicationRate
        totalQuestions
        qConfig {
          id
          name
          code
        }
      }
      results {
        id
        name
        code
        criteriaResult
        averageDuplicationRate
      }
    }
  }
}
    `;

/**
 * __useGetQSetGeneratorExecutionByIdQuery__
 *
 * To run a query within a React component, call `useGetQSetGeneratorExecutionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQSetGeneratorExecutionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQSetGeneratorExecutionByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQSetGeneratorExecutionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQSetGeneratorExecutionByIdQuery, GetQSetGeneratorExecutionByIdQueryVariables> & ({ variables: GetQSetGeneratorExecutionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQSetGeneratorExecutionByIdQuery, GetQSetGeneratorExecutionByIdQueryVariables>(GetQSetGeneratorExecutionByIdDocument, options);
      }
export function useGetQSetGeneratorExecutionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQSetGeneratorExecutionByIdQuery, GetQSetGeneratorExecutionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQSetGeneratorExecutionByIdQuery, GetQSetGeneratorExecutionByIdQueryVariables>(GetQSetGeneratorExecutionByIdDocument, options);
        }
// @ts-ignore
export function useGetQSetGeneratorExecutionByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQSetGeneratorExecutionByIdQuery, GetQSetGeneratorExecutionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQSetGeneratorExecutionByIdQuery, GetQSetGeneratorExecutionByIdQueryVariables>;
export function useGetQSetGeneratorExecutionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetGeneratorExecutionByIdQuery, GetQSetGeneratorExecutionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQSetGeneratorExecutionByIdQuery | undefined, GetQSetGeneratorExecutionByIdQueryVariables>;
export function useGetQSetGeneratorExecutionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetGeneratorExecutionByIdQuery, GetQSetGeneratorExecutionByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQSetGeneratorExecutionByIdQuery, GetQSetGeneratorExecutionByIdQueryVariables>(GetQSetGeneratorExecutionByIdDocument, options);
        }
export type GetQSetGeneratorExecutionByIdQueryHookResult = ReturnType<typeof useGetQSetGeneratorExecutionByIdQuery>;
export type GetQSetGeneratorExecutionByIdLazyQueryHookResult = ReturnType<typeof useGetQSetGeneratorExecutionByIdLazyQuery>;
export type GetQSetGeneratorExecutionByIdSuspenseQueryHookResult = ReturnType<typeof useGetQSetGeneratorExecutionByIdSuspenseQuery>;
export type GetQSetGeneratorExecutionByIdQueryResult = Apollo.QueryResult<GetQSetGeneratorExecutionByIdQuery, GetQSetGeneratorExecutionByIdQueryVariables>;
export const ExecuteQSetGeneratorDocument = gql`
    mutation executeQSetGenerator($executeQSetGeneratorInput: ExecuteQSetGeneratorInput!) {
  excExecuteQSetGenerator(ExecuteQSetGeneratorInput: $executeQSetGeneratorInput) {
    qSetGeneratorExecution {
      id
      qSetGeneratorId
      round
      status
      startedAt
      endedAt
    }
  }
}
    `;
export type ExecuteQSetGeneratorMutationFn = Apollo.MutationFunction<ExecuteQSetGeneratorMutation, ExecuteQSetGeneratorMutationVariables>;

/**
 * __useExecuteQSetGeneratorMutation__
 *
 * To run a mutation, you first call `useExecuteQSetGeneratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteQSetGeneratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeQSetGeneratorMutation, { data, loading, error }] = useExecuteQSetGeneratorMutation({
 *   variables: {
 *      executeQSetGeneratorInput: // value for 'executeQSetGeneratorInput'
 *   },
 * });
 */
export function useExecuteQSetGeneratorMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteQSetGeneratorMutation, ExecuteQSetGeneratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteQSetGeneratorMutation, ExecuteQSetGeneratorMutationVariables>(ExecuteQSetGeneratorDocument, options);
      }
export type ExecuteQSetGeneratorMutationHookResult = ReturnType<typeof useExecuteQSetGeneratorMutation>;
export type ExecuteQSetGeneratorMutationResult = Apollo.MutationResult<ExecuteQSetGeneratorMutation>;
export type ExecuteQSetGeneratorMutationOptions = Apollo.BaseMutationOptions<ExecuteQSetGeneratorMutation, ExecuteQSetGeneratorMutationVariables>;
export const CreateQSetsByGeneratorExecutionDocument = gql`
    mutation createQSetsByGeneratorExecution($input: CreateQSetsByGeneratorExecutionInput!) {
  excCreateQSetsByGeneratorExecution(input: $input) {
    qSets {
      id
    }
  }
}
    `;
export type CreateQSetsByGeneratorExecutionMutationFn = Apollo.MutationFunction<CreateQSetsByGeneratorExecutionMutation, CreateQSetsByGeneratorExecutionMutationVariables>;

/**
 * __useCreateQSetsByGeneratorExecutionMutation__
 *
 * To run a mutation, you first call `useCreateQSetsByGeneratorExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQSetsByGeneratorExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQSetsByGeneratorExecutionMutation, { data, loading, error }] = useCreateQSetsByGeneratorExecutionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQSetsByGeneratorExecutionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQSetsByGeneratorExecutionMutation, CreateQSetsByGeneratorExecutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQSetsByGeneratorExecutionMutation, CreateQSetsByGeneratorExecutionMutationVariables>(CreateQSetsByGeneratorExecutionDocument, options);
      }
export type CreateQSetsByGeneratorExecutionMutationHookResult = ReturnType<typeof useCreateQSetsByGeneratorExecutionMutation>;
export type CreateQSetsByGeneratorExecutionMutationResult = Apollo.MutationResult<CreateQSetsByGeneratorExecutionMutation>;
export type CreateQSetsByGeneratorExecutionMutationOptions = Apollo.BaseMutationOptions<CreateQSetsByGeneratorExecutionMutation, CreateQSetsByGeneratorExecutionMutationVariables>;
export const GetQuestionToChangeByIdDocument = gql`
    query getQuestionToChangeById($qctGetQuestionById: String!) {
  qctGetQuestionById(id: $qctGetQuestionById) {
    id
    refCode
    refQBankStructureId
    tags {
      id
      name
      category
    }
    questionGroup {
      id
      type
    }
    questionStructures {
      id
      levelItem {
        id
        parentLevelItemId
        tag {
          id
          name
        }
        qBankStructureLevel {
          category
        }
      }
    }
  }
}
    `;

/**
 * __useGetQuestionToChangeByIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionToChangeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionToChangeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionToChangeByIdQuery({
 *   variables: {
 *      qctGetQuestionById: // value for 'qctGetQuestionById'
 *   },
 * });
 */
export function useGetQuestionToChangeByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionToChangeByIdQuery, GetQuestionToChangeByIdQueryVariables> & ({ variables: GetQuestionToChangeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionToChangeByIdQuery, GetQuestionToChangeByIdQueryVariables>(GetQuestionToChangeByIdDocument, options);
      }
export function useGetQuestionToChangeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionToChangeByIdQuery, GetQuestionToChangeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionToChangeByIdQuery, GetQuestionToChangeByIdQueryVariables>(GetQuestionToChangeByIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionToChangeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionToChangeByIdQuery, GetQuestionToChangeByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionToChangeByIdQuery, GetQuestionToChangeByIdQueryVariables>;
export function useGetQuestionToChangeByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionToChangeByIdQuery, GetQuestionToChangeByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionToChangeByIdQuery | undefined, GetQuestionToChangeByIdQueryVariables>;
export function useGetQuestionToChangeByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionToChangeByIdQuery, GetQuestionToChangeByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionToChangeByIdQuery, GetQuestionToChangeByIdQueryVariables>(GetQuestionToChangeByIdDocument, options);
        }
export type GetQuestionToChangeByIdQueryHookResult = ReturnType<typeof useGetQuestionToChangeByIdQuery>;
export type GetQuestionToChangeByIdLazyQueryHookResult = ReturnType<typeof useGetQuestionToChangeByIdLazyQuery>;
export type GetQuestionToChangeByIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionToChangeByIdSuspenseQuery>;
export type GetQuestionToChangeByIdQueryResult = Apollo.QueryResult<GetQuestionToChangeByIdQuery, GetQuestionToChangeByIdQueryVariables>;
export const GetTopicAndSubTopicByChapterIdDocument = gql`
    query getTopicAndSubTopicByChapterId($qbsGetQBankStructureLevelItemChildrenById: String!) {
  qbsGetQBankStructureLevelItemChildrenById(
    id: $qbsGetQBankStructureLevelItemChildrenById
  ) {
    id
    tag {
      id
      name
    }
    qBankStructureLevel {
      category
    }
    parentLevelItemId
  }
}
    `;

/**
 * __useGetTopicAndSubTopicByChapterIdQuery__
 *
 * To run a query within a React component, call `useGetTopicAndSubTopicByChapterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicAndSubTopicByChapterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicAndSubTopicByChapterIdQuery({
 *   variables: {
 *      qbsGetQBankStructureLevelItemChildrenById: // value for 'qbsGetQBankStructureLevelItemChildrenById'
 *   },
 * });
 */
export function useGetTopicAndSubTopicByChapterIdQuery(baseOptions: Apollo.QueryHookOptions<GetTopicAndSubTopicByChapterIdQuery, GetTopicAndSubTopicByChapterIdQueryVariables> & ({ variables: GetTopicAndSubTopicByChapterIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicAndSubTopicByChapterIdQuery, GetTopicAndSubTopicByChapterIdQueryVariables>(GetTopicAndSubTopicByChapterIdDocument, options);
      }
export function useGetTopicAndSubTopicByChapterIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicAndSubTopicByChapterIdQuery, GetTopicAndSubTopicByChapterIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicAndSubTopicByChapterIdQuery, GetTopicAndSubTopicByChapterIdQueryVariables>(GetTopicAndSubTopicByChapterIdDocument, options);
        }
// @ts-ignore
export function useGetTopicAndSubTopicByChapterIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTopicAndSubTopicByChapterIdQuery, GetTopicAndSubTopicByChapterIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetTopicAndSubTopicByChapterIdQuery, GetTopicAndSubTopicByChapterIdQueryVariables>;
export function useGetTopicAndSubTopicByChapterIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopicAndSubTopicByChapterIdQuery, GetTopicAndSubTopicByChapterIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetTopicAndSubTopicByChapterIdQuery | undefined, GetTopicAndSubTopicByChapterIdQueryVariables>;
export function useGetTopicAndSubTopicByChapterIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopicAndSubTopicByChapterIdQuery, GetTopicAndSubTopicByChapterIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTopicAndSubTopicByChapterIdQuery, GetTopicAndSubTopicByChapterIdQueryVariables>(GetTopicAndSubTopicByChapterIdDocument, options);
        }
export type GetTopicAndSubTopicByChapterIdQueryHookResult = ReturnType<typeof useGetTopicAndSubTopicByChapterIdQuery>;
export type GetTopicAndSubTopicByChapterIdLazyQueryHookResult = ReturnType<typeof useGetTopicAndSubTopicByChapterIdLazyQuery>;
export type GetTopicAndSubTopicByChapterIdSuspenseQueryHookResult = ReturnType<typeof useGetTopicAndSubTopicByChapterIdSuspenseQuery>;
export type GetTopicAndSubTopicByChapterIdQueryResult = Apollo.QueryResult<GetTopicAndSubTopicByChapterIdQuery, GetTopicAndSubTopicByChapterIdQueryVariables>;
export const SearchQuestionsToChangeDocument = gql`
    query searchQuestionsToChange($search: SearchQuestionsInput!, $paging: PageInput!, $order: OrderInput!) {
  qctSearchQuestions(search: $search, paging: $paging, order: $order) {
    total
    questions {
      id
      refCode
      refQBankStructureId
      tags {
        name
        category
      }
    }
  }
}
    `;

/**
 * __useSearchQuestionsToChangeQuery__
 *
 * To run a query within a React component, call `useSearchQuestionsToChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuestionsToChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuestionsToChangeQuery({
 *   variables: {
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchQuestionsToChangeQuery(baseOptions: Apollo.QueryHookOptions<SearchQuestionsToChangeQuery, SearchQuestionsToChangeQueryVariables> & ({ variables: SearchQuestionsToChangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuestionsToChangeQuery, SearchQuestionsToChangeQueryVariables>(SearchQuestionsToChangeDocument, options);
      }
export function useSearchQuestionsToChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuestionsToChangeQuery, SearchQuestionsToChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuestionsToChangeQuery, SearchQuestionsToChangeQueryVariables>(SearchQuestionsToChangeDocument, options);
        }
// @ts-ignore
export function useSearchQuestionsToChangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQuestionsToChangeQuery, SearchQuestionsToChangeQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionsToChangeQuery, SearchQuestionsToChangeQueryVariables>;
export function useSearchQuestionsToChangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionsToChangeQuery, SearchQuestionsToChangeQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionsToChangeQuery | undefined, SearchQuestionsToChangeQueryVariables>;
export function useSearchQuestionsToChangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionsToChangeQuery, SearchQuestionsToChangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuestionsToChangeQuery, SearchQuestionsToChangeQueryVariables>(SearchQuestionsToChangeDocument, options);
        }
export type SearchQuestionsToChangeQueryHookResult = ReturnType<typeof useSearchQuestionsToChangeQuery>;
export type SearchQuestionsToChangeLazyQueryHookResult = ReturnType<typeof useSearchQuestionsToChangeLazyQuery>;
export type SearchQuestionsToChangeSuspenseQueryHookResult = ReturnType<typeof useSearchQuestionsToChangeSuspenseQuery>;
export type SearchQuestionsToChangeQueryResult = Apollo.QueryResult<SearchQuestionsToChangeQuery, SearchQuestionsToChangeQueryVariables>;
export const GetUsedQSetQuestionsByQuestionIdsDocument = gql`
    query getUsedQSetQuestionsByQuestionIds($input: GetQsetQuestionsByQuestionIdsInput!) {
  excGetQSetQuestionsByQuestionIds(input: $input) {
    qSetQuestions {
      questionId
      order
    }
  }
}
    `;

/**
 * __useGetUsedQSetQuestionsByQuestionIdsQuery__
 *
 * To run a query within a React component, call `useGetUsedQSetQuestionsByQuestionIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsedQSetQuestionsByQuestionIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsedQSetQuestionsByQuestionIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUsedQSetQuestionsByQuestionIdsQuery(baseOptions: Apollo.QueryHookOptions<GetUsedQSetQuestionsByQuestionIdsQuery, GetUsedQSetQuestionsByQuestionIdsQueryVariables> & ({ variables: GetUsedQSetQuestionsByQuestionIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsedQSetQuestionsByQuestionIdsQuery, GetUsedQSetQuestionsByQuestionIdsQueryVariables>(GetUsedQSetQuestionsByQuestionIdsDocument, options);
      }
export function useGetUsedQSetQuestionsByQuestionIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsedQSetQuestionsByQuestionIdsQuery, GetUsedQSetQuestionsByQuestionIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsedQSetQuestionsByQuestionIdsQuery, GetUsedQSetQuestionsByQuestionIdsQueryVariables>(GetUsedQSetQuestionsByQuestionIdsDocument, options);
        }
// @ts-ignore
export function useGetUsedQSetQuestionsByQuestionIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsedQSetQuestionsByQuestionIdsQuery, GetUsedQSetQuestionsByQuestionIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsedQSetQuestionsByQuestionIdsQuery, GetUsedQSetQuestionsByQuestionIdsQueryVariables>;
export function useGetUsedQSetQuestionsByQuestionIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsedQSetQuestionsByQuestionIdsQuery, GetUsedQSetQuestionsByQuestionIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsedQSetQuestionsByQuestionIdsQuery | undefined, GetUsedQSetQuestionsByQuestionIdsQueryVariables>;
export function useGetUsedQSetQuestionsByQuestionIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsedQSetQuestionsByQuestionIdsQuery, GetUsedQSetQuestionsByQuestionIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsedQSetQuestionsByQuestionIdsQuery, GetUsedQSetQuestionsByQuestionIdsQueryVariables>(GetUsedQSetQuestionsByQuestionIdsDocument, options);
        }
export type GetUsedQSetQuestionsByQuestionIdsQueryHookResult = ReturnType<typeof useGetUsedQSetQuestionsByQuestionIdsQuery>;
export type GetUsedQSetQuestionsByQuestionIdsLazyQueryHookResult = ReturnType<typeof useGetUsedQSetQuestionsByQuestionIdsLazyQuery>;
export type GetUsedQSetQuestionsByQuestionIdsSuspenseQueryHookResult = ReturnType<typeof useGetUsedQSetQuestionsByQuestionIdsSuspenseQuery>;
export type GetUsedQSetQuestionsByQuestionIdsQueryResult = Apollo.QueryResult<GetUsedQSetQuestionsByQuestionIdsQuery, GetUsedQSetQuestionsByQuestionIdsQueryVariables>;
export const ChangeSingleQuestionDocument = gql`
    mutation changeSingleQuestion($changeSingleQuestionInput: ChangeSingleQuestionInput!) {
  excChangeSingleQuestion(changeSingleQuestionInput: $changeSingleQuestionInput) {
    qSetQuestion {
      questionRefCode
      order
    }
  }
}
    `;
export type ChangeSingleQuestionMutationFn = Apollo.MutationFunction<ChangeSingleQuestionMutation, ChangeSingleQuestionMutationVariables>;

/**
 * __useChangeSingleQuestionMutation__
 *
 * To run a mutation, you first call `useChangeSingleQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSingleQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSingleQuestionMutation, { data, loading, error }] = useChangeSingleQuestionMutation({
 *   variables: {
 *      changeSingleQuestionInput: // value for 'changeSingleQuestionInput'
 *   },
 * });
 */
export function useChangeSingleQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSingleQuestionMutation, ChangeSingleQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSingleQuestionMutation, ChangeSingleQuestionMutationVariables>(ChangeSingleQuestionDocument, options);
      }
export type ChangeSingleQuestionMutationHookResult = ReturnType<typeof useChangeSingleQuestionMutation>;
export type ChangeSingleQuestionMutationResult = Apollo.MutationResult<ChangeSingleQuestionMutation>;
export type ChangeSingleQuestionMutationOptions = Apollo.BaseMutationOptions<ChangeSingleQuestionMutation, ChangeSingleQuestionMutationVariables>;
export const ChangeItemSetQuestionDocument = gql`
    mutation changeItemSetQuestion($changeItemSetQuestionInput: ChangeItemSetQuestionInput!) {
  excChangeItemSetQuestion(
    changeItemSetQuestionInput: $changeItemSetQuestionInput
  ) {
    qSetQuestions {
      id
      questionRefCode
      order
    }
  }
}
    `;
export type ChangeItemSetQuestionMutationFn = Apollo.MutationFunction<ChangeItemSetQuestionMutation, ChangeItemSetQuestionMutationVariables>;

/**
 * __useChangeItemSetQuestionMutation__
 *
 * To run a mutation, you first call `useChangeItemSetQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeItemSetQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeItemSetQuestionMutation, { data, loading, error }] = useChangeItemSetQuestionMutation({
 *   variables: {
 *      changeItemSetQuestionInput: // value for 'changeItemSetQuestionInput'
 *   },
 * });
 */
export function useChangeItemSetQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ChangeItemSetQuestionMutation, ChangeItemSetQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeItemSetQuestionMutation, ChangeItemSetQuestionMutationVariables>(ChangeItemSetQuestionDocument, options);
      }
export type ChangeItemSetQuestionMutationHookResult = ReturnType<typeof useChangeItemSetQuestionMutation>;
export type ChangeItemSetQuestionMutationResult = Apollo.MutationResult<ChangeItemSetQuestionMutation>;
export type ChangeItemSetQuestionMutationOptions = Apollo.BaseMutationOptions<ChangeItemSetQuestionMutation, ChangeItemSetQuestionMutationVariables>;
export const ExecuteQSetCheckSimilarityDocument = gql`
    query executeQSetCheckSimilarity($input: GetQSetSimilaritiesInput!) {
  excGetQSetSimilarities(input: $input) {
    id
    qSetSimilarityResults {
      id
      qSetACode
      qSetBCode
      duplicationRate
      duplicationCount
      duplicatedQuestionIds
      totalQuestions
    }
  }
}
    `;

/**
 * __useExecuteQSetCheckSimilarityQuery__
 *
 * To run a query within a React component, call `useExecuteQSetCheckSimilarityQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecuteQSetCheckSimilarityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecuteQSetCheckSimilarityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteQSetCheckSimilarityQuery(baseOptions: Apollo.QueryHookOptions<ExecuteQSetCheckSimilarityQuery, ExecuteQSetCheckSimilarityQueryVariables> & ({ variables: ExecuteQSetCheckSimilarityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExecuteQSetCheckSimilarityQuery, ExecuteQSetCheckSimilarityQueryVariables>(ExecuteQSetCheckSimilarityDocument, options);
      }
export function useExecuteQSetCheckSimilarityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExecuteQSetCheckSimilarityQuery, ExecuteQSetCheckSimilarityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExecuteQSetCheckSimilarityQuery, ExecuteQSetCheckSimilarityQueryVariables>(ExecuteQSetCheckSimilarityDocument, options);
        }
// @ts-ignore
export function useExecuteQSetCheckSimilaritySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExecuteQSetCheckSimilarityQuery, ExecuteQSetCheckSimilarityQueryVariables>): Apollo.UseSuspenseQueryResult<ExecuteQSetCheckSimilarityQuery, ExecuteQSetCheckSimilarityQueryVariables>;
export function useExecuteQSetCheckSimilaritySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExecuteQSetCheckSimilarityQuery, ExecuteQSetCheckSimilarityQueryVariables>): Apollo.UseSuspenseQueryResult<ExecuteQSetCheckSimilarityQuery | undefined, ExecuteQSetCheckSimilarityQueryVariables>;
export function useExecuteQSetCheckSimilaritySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExecuteQSetCheckSimilarityQuery, ExecuteQSetCheckSimilarityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExecuteQSetCheckSimilarityQuery, ExecuteQSetCheckSimilarityQueryVariables>(ExecuteQSetCheckSimilarityDocument, options);
        }
export type ExecuteQSetCheckSimilarityQueryHookResult = ReturnType<typeof useExecuteQSetCheckSimilarityQuery>;
export type ExecuteQSetCheckSimilarityLazyQueryHookResult = ReturnType<typeof useExecuteQSetCheckSimilarityLazyQuery>;
export type ExecuteQSetCheckSimilaritySuspenseQueryHookResult = ReturnType<typeof useExecuteQSetCheckSimilaritySuspenseQuery>;
export type ExecuteQSetCheckSimilarityQueryResult = Apollo.QueryResult<ExecuteQSetCheckSimilarityQuery, ExecuteQSetCheckSimilarityQueryVariables>;
export const GetQSetSimilarityWithQuestionsByIdDocument = gql`
    query getQSetSimilarityWithQuestionsById($input: GetQSetSimilarityByIdInput!) {
  excGetQSetSimilarityWithQuestionsById(input: $input) {
    qSetSimilarityResult {
      qSetA
      qSetACode
      qSetBCode
      duplicatedQuestions {
        id
        questionId
        questionGroupId
        questionRefCode
        order
        question {
          id
          tags {
            id
            name
            category
          }
          type
          details
          refCode
          metadata {
            choices {
              label
              order
              value
            }
            reference
          }
          correctAnswer {
            value
          }
          questionGroup {
            id
            type
            size
            metadata {
              paragraph
            }
            refCode
          }
          solution {
            type
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetQSetSimilarityWithQuestionsByIdQuery__
 *
 * To run a query within a React component, call `useGetQSetSimilarityWithQuestionsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQSetSimilarityWithQuestionsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQSetSimilarityWithQuestionsByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQSetSimilarityWithQuestionsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQSetSimilarityWithQuestionsByIdQuery, GetQSetSimilarityWithQuestionsByIdQueryVariables> & ({ variables: GetQSetSimilarityWithQuestionsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQSetSimilarityWithQuestionsByIdQuery, GetQSetSimilarityWithQuestionsByIdQueryVariables>(GetQSetSimilarityWithQuestionsByIdDocument, options);
      }
export function useGetQSetSimilarityWithQuestionsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQSetSimilarityWithQuestionsByIdQuery, GetQSetSimilarityWithQuestionsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQSetSimilarityWithQuestionsByIdQuery, GetQSetSimilarityWithQuestionsByIdQueryVariables>(GetQSetSimilarityWithQuestionsByIdDocument, options);
        }
// @ts-ignore
export function useGetQSetSimilarityWithQuestionsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQSetSimilarityWithQuestionsByIdQuery, GetQSetSimilarityWithQuestionsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQSetSimilarityWithQuestionsByIdQuery, GetQSetSimilarityWithQuestionsByIdQueryVariables>;
export function useGetQSetSimilarityWithQuestionsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetSimilarityWithQuestionsByIdQuery, GetQSetSimilarityWithQuestionsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQSetSimilarityWithQuestionsByIdQuery | undefined, GetQSetSimilarityWithQuestionsByIdQueryVariables>;
export function useGetQSetSimilarityWithQuestionsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetSimilarityWithQuestionsByIdQuery, GetQSetSimilarityWithQuestionsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQSetSimilarityWithQuestionsByIdQuery, GetQSetSimilarityWithQuestionsByIdQueryVariables>(GetQSetSimilarityWithQuestionsByIdDocument, options);
        }
export type GetQSetSimilarityWithQuestionsByIdQueryHookResult = ReturnType<typeof useGetQSetSimilarityWithQuestionsByIdQuery>;
export type GetQSetSimilarityWithQuestionsByIdLazyQueryHookResult = ReturnType<typeof useGetQSetSimilarityWithQuestionsByIdLazyQuery>;
export type GetQSetSimilarityWithQuestionsByIdSuspenseQueryHookResult = ReturnType<typeof useGetQSetSimilarityWithQuestionsByIdSuspenseQuery>;
export type GetQSetSimilarityWithQuestionsByIdQueryResult = Apollo.QueryResult<GetQSetSimilarityWithQuestionsByIdQuery, GetQSetSimilarityWithQuestionsByIdQueryVariables>;
export const DuplicateQSetDocument = gql`
    mutation duplicateQSet($input: DuplicateQSetInput!) {
  excDuplicateQSet(input: $input) {
    qSet {
      id
      examCourseId
    }
  }
}
    `;
export type DuplicateQSetMutationFn = Apollo.MutationFunction<DuplicateQSetMutation, DuplicateQSetMutationVariables>;

/**
 * __useDuplicateQSetMutation__
 *
 * To run a mutation, you first call `useDuplicateQSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateQSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateQSetMutation, { data, loading, error }] = useDuplicateQSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateQSetMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateQSetMutation, DuplicateQSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateQSetMutation, DuplicateQSetMutationVariables>(DuplicateQSetDocument, options);
      }
export type DuplicateQSetMutationHookResult = ReturnType<typeof useDuplicateQSetMutation>;
export type DuplicateQSetMutationResult = Apollo.MutationResult<DuplicateQSetMutation>;
export type DuplicateQSetMutationOptions = Apollo.BaseMutationOptions<DuplicateQSetMutation, DuplicateQSetMutationVariables>;
export const SearchQSetQuestionsSnapshotDocument = gql`
    query searchQSetQuestionsSnapshot($input: SearchQSetQuestionsInput!) {
  excSearchQSetQuestions(input: $input) {
    qSetQuestions {
      id
      questionId
      questionGroupId
      questionRefCode
      order
      questionSnapshot {
        id
        tags {
          id
          name
          category
        }
        type
        details
        refCode
        metadata {
          choices {
            label
            order
            value
          }
          reference
        }
        correctAnswer {
          value
        }
        questionGroup {
          id
          type
          size
          metadata {
            paragraph
          }
          refCode
        }
        solution {
          type
          value
        }
      }
    }
    total
  }
}
    `;

/**
 * __useSearchQSetQuestionsSnapshotQuery__
 *
 * To run a query within a React component, call `useSearchQSetQuestionsSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQSetQuestionsSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQSetQuestionsSnapshotQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchQSetQuestionsSnapshotQuery(baseOptions: Apollo.QueryHookOptions<SearchQSetQuestionsSnapshotQuery, SearchQSetQuestionsSnapshotQueryVariables> & ({ variables: SearchQSetQuestionsSnapshotQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQSetQuestionsSnapshotQuery, SearchQSetQuestionsSnapshotQueryVariables>(SearchQSetQuestionsSnapshotDocument, options);
      }
export function useSearchQSetQuestionsSnapshotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQSetQuestionsSnapshotQuery, SearchQSetQuestionsSnapshotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQSetQuestionsSnapshotQuery, SearchQSetQuestionsSnapshotQueryVariables>(SearchQSetQuestionsSnapshotDocument, options);
        }
// @ts-ignore
export function useSearchQSetQuestionsSnapshotSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQSetQuestionsSnapshotQuery, SearchQSetQuestionsSnapshotQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQSetQuestionsSnapshotQuery, SearchQSetQuestionsSnapshotQueryVariables>;
export function useSearchQSetQuestionsSnapshotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQSetQuestionsSnapshotQuery, SearchQSetQuestionsSnapshotQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQSetQuestionsSnapshotQuery | undefined, SearchQSetQuestionsSnapshotQueryVariables>;
export function useSearchQSetQuestionsSnapshotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQSetQuestionsSnapshotQuery, SearchQSetQuestionsSnapshotQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQSetQuestionsSnapshotQuery, SearchQSetQuestionsSnapshotQueryVariables>(SearchQSetQuestionsSnapshotDocument, options);
        }
export type SearchQSetQuestionsSnapshotQueryHookResult = ReturnType<typeof useSearchQSetQuestionsSnapshotQuery>;
export type SearchQSetQuestionsSnapshotLazyQueryHookResult = ReturnType<typeof useSearchQSetQuestionsSnapshotLazyQuery>;
export type SearchQSetQuestionsSnapshotSuspenseQueryHookResult = ReturnType<typeof useSearchQSetQuestionsSnapshotSuspenseQuery>;
export type SearchQSetQuestionsSnapshotQueryResult = Apollo.QueryResult<SearchQSetQuestionsSnapshotQuery, SearchQSetQuestionsSnapshotQueryVariables>;
export const ExportQSetDocument = gql`
    query exportQSet($input: ExportQSetInput!) {
  excExportQSet(input: $input) {
    message
  }
}
    `;

/**
 * __useExportQSetQuery__
 *
 * To run a query within a React component, call `useExportQSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportQSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportQSetQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportQSetQuery(baseOptions: Apollo.QueryHookOptions<ExportQSetQuery, ExportQSetQueryVariables> & ({ variables: ExportQSetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportQSetQuery, ExportQSetQueryVariables>(ExportQSetDocument, options);
      }
export function useExportQSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportQSetQuery, ExportQSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportQSetQuery, ExportQSetQueryVariables>(ExportQSetDocument, options);
        }
// @ts-ignore
export function useExportQSetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportQSetQuery, ExportQSetQueryVariables>): Apollo.UseSuspenseQueryResult<ExportQSetQuery, ExportQSetQueryVariables>;
export function useExportQSetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportQSetQuery, ExportQSetQueryVariables>): Apollo.UseSuspenseQueryResult<ExportQSetQuery | undefined, ExportQSetQueryVariables>;
export function useExportQSetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportQSetQuery, ExportQSetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportQSetQuery, ExportQSetQueryVariables>(ExportQSetDocument, options);
        }
export type ExportQSetQueryHookResult = ReturnType<typeof useExportQSetQuery>;
export type ExportQSetLazyQueryHookResult = ReturnType<typeof useExportQSetLazyQuery>;
export type ExportQSetSuspenseQueryHookResult = ReturnType<typeof useExportQSetSuspenseQuery>;
export type ExportQSetQueryResult = Apollo.QueryResult<ExportQSetQuery, ExportQSetQueryVariables>;
export const ExportTaskQSetDocument = gql`
    query exportTaskQSet($input: ExportTaskQSetInput!) {
  excExportTaskQSet(input: $input) {
    message
  }
}
    `;

/**
 * __useExportTaskQSetQuery__
 *
 * To run a query within a React component, call `useExportTaskQSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTaskQSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTaskQSetQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportTaskQSetQuery(baseOptions: Apollo.QueryHookOptions<ExportTaskQSetQuery, ExportTaskQSetQueryVariables> & ({ variables: ExportTaskQSetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportTaskQSetQuery, ExportTaskQSetQueryVariables>(ExportTaskQSetDocument, options);
      }
export function useExportTaskQSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportTaskQSetQuery, ExportTaskQSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportTaskQSetQuery, ExportTaskQSetQueryVariables>(ExportTaskQSetDocument, options);
        }
// @ts-ignore
export function useExportTaskQSetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportTaskQSetQuery, ExportTaskQSetQueryVariables>): Apollo.UseSuspenseQueryResult<ExportTaskQSetQuery, ExportTaskQSetQueryVariables>;
export function useExportTaskQSetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportTaskQSetQuery, ExportTaskQSetQueryVariables>): Apollo.UseSuspenseQueryResult<ExportTaskQSetQuery | undefined, ExportTaskQSetQueryVariables>;
export function useExportTaskQSetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportTaskQSetQuery, ExportTaskQSetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportTaskQSetQuery, ExportTaskQSetQueryVariables>(ExportTaskQSetDocument, options);
        }
export type ExportTaskQSetQueryHookResult = ReturnType<typeof useExportTaskQSetQuery>;
export type ExportTaskQSetLazyQueryHookResult = ReturnType<typeof useExportTaskQSetLazyQuery>;
export type ExportTaskQSetSuspenseQueryHookResult = ReturnType<typeof useExportTaskQSetSuspenseQuery>;
export type ExportTaskQSetQueryResult = Apollo.QueryResult<ExportTaskQSetQuery, ExportTaskQSetQueryVariables>;
export const PublishQSetsDocument = gql`
    mutation publishQSets($input: PublishQSetsInput!) {
  excPublishQSets(input: $input) {
    data
  }
}
    `;
export type PublishQSetsMutationFn = Apollo.MutationFunction<PublishQSetsMutation, PublishQSetsMutationVariables>;

/**
 * __usePublishQSetsMutation__
 *
 * To run a mutation, you first call `usePublishQSetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishQSetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishQSetsMutation, { data, loading, error }] = usePublishQSetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishQSetsMutation(baseOptions?: Apollo.MutationHookOptions<PublishQSetsMutation, PublishQSetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishQSetsMutation, PublishQSetsMutationVariables>(PublishQSetsDocument, options);
      }
export type PublishQSetsMutationHookResult = ReturnType<typeof usePublishQSetsMutation>;
export type PublishQSetsMutationResult = Apollo.MutationResult<PublishQSetsMutation>;
export type PublishQSetsMutationOptions = Apollo.BaseMutationOptions<PublishQSetsMutation, PublishQSetsMutationVariables>;
export const DeleteQSetByIdDocument = gql`
    mutation deleteQSetById($input: DeleteQSetByIdInput!) {
  excDeleteQSetById(input: $input) {
    message
  }
}
    `;
export type DeleteQSetByIdMutationFn = Apollo.MutationFunction<DeleteQSetByIdMutation, DeleteQSetByIdMutationVariables>;

/**
 * __useDeleteQSetByIdMutation__
 *
 * To run a mutation, you first call `useDeleteQSetByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQSetByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQSetByIdMutation, { data, loading, error }] = useDeleteQSetByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteQSetByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQSetByIdMutation, DeleteQSetByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQSetByIdMutation, DeleteQSetByIdMutationVariables>(DeleteQSetByIdDocument, options);
      }
export type DeleteQSetByIdMutationHookResult = ReturnType<typeof useDeleteQSetByIdMutation>;
export type DeleteQSetByIdMutationResult = Apollo.MutationResult<DeleteQSetByIdMutation>;
export type DeleteQSetByIdMutationOptions = Apollo.BaseMutationOptions<DeleteQSetByIdMutation, DeleteQSetByIdMutationVariables>;
export const UpdateExamUsageOfQSetsDocument = gql`
    mutation updateExamUsageOfQSets($input: UpdateExamUsageOfQSetsInput!) {
  excUpdateExamUsageOfQSets(input: $input) {
    qSets {
      id
      examUsageStatus
    }
  }
}
    `;
export type UpdateExamUsageOfQSetsMutationFn = Apollo.MutationFunction<UpdateExamUsageOfQSetsMutation, UpdateExamUsageOfQSetsMutationVariables>;

/**
 * __useUpdateExamUsageOfQSetsMutation__
 *
 * To run a mutation, you first call `useUpdateExamUsageOfQSetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExamUsageOfQSetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExamUsageOfQSetsMutation, { data, loading, error }] = useUpdateExamUsageOfQSetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExamUsageOfQSetsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExamUsageOfQSetsMutation, UpdateExamUsageOfQSetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExamUsageOfQSetsMutation, UpdateExamUsageOfQSetsMutationVariables>(UpdateExamUsageOfQSetsDocument, options);
      }
export type UpdateExamUsageOfQSetsMutationHookResult = ReturnType<typeof useUpdateExamUsageOfQSetsMutation>;
export type UpdateExamUsageOfQSetsMutationResult = Apollo.MutationResult<UpdateExamUsageOfQSetsMutation>;
export type UpdateExamUsageOfQSetsMutationOptions = Apollo.BaseMutationOptions<UpdateExamUsageOfQSetsMutation, UpdateExamUsageOfQSetsMutationVariables>;
export const DisableQSetsDocument = gql`
    mutation disableQSets($input: DisableQSetsInput!) {
  excDisableQSets(input: $input) {
    qSets {
      id
    }
  }
}
    `;
export type DisableQSetsMutationFn = Apollo.MutationFunction<DisableQSetsMutation, DisableQSetsMutationVariables>;

/**
 * __useDisableQSetsMutation__
 *
 * To run a mutation, you first call `useDisableQSetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableQSetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableQSetsMutation, { data, loading, error }] = useDisableQSetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableQSetsMutation(baseOptions?: Apollo.MutationHookOptions<DisableQSetsMutation, DisableQSetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableQSetsMutation, DisableQSetsMutationVariables>(DisableQSetsDocument, options);
      }
export type DisableQSetsMutationHookResult = ReturnType<typeof useDisableQSetsMutation>;
export type DisableQSetsMutationResult = Apollo.MutationResult<DisableQSetsMutation>;
export type DisableQSetsMutationOptions = Apollo.BaseMutationOptions<DisableQSetsMutation, DisableQSetsMutationVariables>;
export const GetDownloadSignedUrlForQuestionsByQSetIdDocument = gql`
    query getDownloadSignedUrlForQuestionsByQSetId($input: GetDownloadSignedUrlForQuestionsByQSetIdInput!) {
  excGetDownloadSignedUrlForQuestionsByQSetId(input: $input) {
    signedUrls
  }
}
    `;

/**
 * __useGetDownloadSignedUrlForQuestionsByQSetIdQuery__
 *
 * To run a query within a React component, call `useGetDownloadSignedUrlForQuestionsByQSetIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSignedUrlForQuestionsByQSetIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSignedUrlForQuestionsByQSetIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDownloadSignedUrlForQuestionsByQSetIdQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables> & ({ variables: GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>(GetDownloadSignedUrlForQuestionsByQSetIdDocument, options);
      }
export function useGetDownloadSignedUrlForQuestionsByQSetIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>(GetDownloadSignedUrlForQuestionsByQSetIdDocument, options);
        }
// @ts-ignore
export function useGetDownloadSignedUrlForQuestionsByQSetIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>;
export function useGetDownloadSignedUrlForQuestionsByQSetIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadSignedUrlForQuestionsByQSetIdQuery | undefined, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>;
export function useGetDownloadSignedUrlForQuestionsByQSetIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>(GetDownloadSignedUrlForQuestionsByQSetIdDocument, options);
        }
export type GetDownloadSignedUrlForQuestionsByQSetIdQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionsByQSetIdQuery>;
export type GetDownloadSignedUrlForQuestionsByQSetIdLazyQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionsByQSetIdLazyQuery>;
export type GetDownloadSignedUrlForQuestionsByQSetIdSuspenseQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionsByQSetIdSuspenseQuery>;
export type GetDownloadSignedUrlForQuestionsByQSetIdQueryResult = Apollo.QueryResult<GetDownloadSignedUrlForQuestionsByQSetIdQuery, GetDownloadSignedUrlForQuestionsByQSetIdQueryVariables>;
export const GetQSetByTaskIdDocument = gql`
    query getQSetByTaskId($input: GetQSetByTaskIdInput!) {
  excGetQSetByTaskId(input: $input) {
    qSet {
      id
      code
      examCourseId
      qConfigId
      status
      updatedAt
      assignees {
        id
      }
      conditions {
        tags {
          tag {
            id
            name
          }
          count
        }
        questionTypes {
          type
          count
        }
        averagePValue
      }
    }
  }
}
    `;

/**
 * __useGetQSetByTaskIdQuery__
 *
 * To run a query within a React component, call `useGetQSetByTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQSetByTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQSetByTaskIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQSetByTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables> & ({ variables: GetQSetByTaskIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>(GetQSetByTaskIdDocument, options);
      }
export function useGetQSetByTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>(GetQSetByTaskIdDocument, options);
        }
// @ts-ignore
export function useGetQSetByTaskIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>;
export function useGetQSetByTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQSetByTaskIdQuery | undefined, GetQSetByTaskIdQueryVariables>;
export function useGetQSetByTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>(GetQSetByTaskIdDocument, options);
        }
export type GetQSetByTaskIdQueryHookResult = ReturnType<typeof useGetQSetByTaskIdQuery>;
export type GetQSetByTaskIdLazyQueryHookResult = ReturnType<typeof useGetQSetByTaskIdLazyQuery>;
export type GetQSetByTaskIdSuspenseQueryHookResult = ReturnType<typeof useGetQSetByTaskIdSuspenseQuery>;
export type GetQSetByTaskIdQueryResult = Apollo.QueryResult<GetQSetByTaskIdQuery, GetQSetByTaskIdQueryVariables>;
export const SearchQSetAuditLogsDocument = gql`
    query searchQSetAuditLogs($searchQSetAuditLogInput: SearchQSetAuditLogInput!) {
  excSearchQSetAuditLog(SearchQSetAuditLogInput: $searchQSetAuditLogInput) {
    qSetAuditLogs {
      id
      action
      fullName
      detail
      actionTime
    }
    total
  }
}
    `;

/**
 * __useSearchQSetAuditLogsQuery__
 *
 * To run a query within a React component, call `useSearchQSetAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQSetAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQSetAuditLogsQuery({
 *   variables: {
 *      searchQSetAuditLogInput: // value for 'searchQSetAuditLogInput'
 *   },
 * });
 */
export function useSearchQSetAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<SearchQSetAuditLogsQuery, SearchQSetAuditLogsQueryVariables> & ({ variables: SearchQSetAuditLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQSetAuditLogsQuery, SearchQSetAuditLogsQueryVariables>(SearchQSetAuditLogsDocument, options);
      }
export function useSearchQSetAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQSetAuditLogsQuery, SearchQSetAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQSetAuditLogsQuery, SearchQSetAuditLogsQueryVariables>(SearchQSetAuditLogsDocument, options);
        }
// @ts-ignore
export function useSearchQSetAuditLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQSetAuditLogsQuery, SearchQSetAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQSetAuditLogsQuery, SearchQSetAuditLogsQueryVariables>;
export function useSearchQSetAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQSetAuditLogsQuery, SearchQSetAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQSetAuditLogsQuery | undefined, SearchQSetAuditLogsQueryVariables>;
export function useSearchQSetAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQSetAuditLogsQuery, SearchQSetAuditLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQSetAuditLogsQuery, SearchQSetAuditLogsQueryVariables>(SearchQSetAuditLogsDocument, options);
        }
export type SearchQSetAuditLogsQueryHookResult = ReturnType<typeof useSearchQSetAuditLogsQuery>;
export type SearchQSetAuditLogsLazyQueryHookResult = ReturnType<typeof useSearchQSetAuditLogsLazyQuery>;
export type SearchQSetAuditLogsSuspenseQueryHookResult = ReturnType<typeof useSearchQSetAuditLogsSuspenseQuery>;
export type SearchQSetAuditLogsQueryResult = Apollo.QueryResult<SearchQSetAuditLogsQuery, SearchQSetAuditLogsQueryVariables>;
export const GetQSetQuestionDownloadSignedUrlsDocument = gql`
    query getQSetQuestionDownloadSignedUrls($input: GetQSetQuestionDownloadSignedUrlsInput!) {
  excGetQSetQuestionDownloadSignedUrls(input: $input) {
    questionSignedUrls
    questionGroupSignedUrls
  }
}
    `;

/**
 * __useGetQSetQuestionDownloadSignedUrlsQuery__
 *
 * To run a query within a React component, call `useGetQSetQuestionDownloadSignedUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQSetQuestionDownloadSignedUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQSetQuestionDownloadSignedUrlsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQSetQuestionDownloadSignedUrlsQuery(baseOptions: Apollo.QueryHookOptions<GetQSetQuestionDownloadSignedUrlsQuery, GetQSetQuestionDownloadSignedUrlsQueryVariables> & ({ variables: GetQSetQuestionDownloadSignedUrlsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQSetQuestionDownloadSignedUrlsQuery, GetQSetQuestionDownloadSignedUrlsQueryVariables>(GetQSetQuestionDownloadSignedUrlsDocument, options);
      }
export function useGetQSetQuestionDownloadSignedUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQSetQuestionDownloadSignedUrlsQuery, GetQSetQuestionDownloadSignedUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQSetQuestionDownloadSignedUrlsQuery, GetQSetQuestionDownloadSignedUrlsQueryVariables>(GetQSetQuestionDownloadSignedUrlsDocument, options);
        }
// @ts-ignore
export function useGetQSetQuestionDownloadSignedUrlsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQSetQuestionDownloadSignedUrlsQuery, GetQSetQuestionDownloadSignedUrlsQueryVariables>): Apollo.UseSuspenseQueryResult<GetQSetQuestionDownloadSignedUrlsQuery, GetQSetQuestionDownloadSignedUrlsQueryVariables>;
export function useGetQSetQuestionDownloadSignedUrlsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetQuestionDownloadSignedUrlsQuery, GetQSetQuestionDownloadSignedUrlsQueryVariables>): Apollo.UseSuspenseQueryResult<GetQSetQuestionDownloadSignedUrlsQuery | undefined, GetQSetQuestionDownloadSignedUrlsQueryVariables>;
export function useGetQSetQuestionDownloadSignedUrlsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetQuestionDownloadSignedUrlsQuery, GetQSetQuestionDownloadSignedUrlsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQSetQuestionDownloadSignedUrlsQuery, GetQSetQuestionDownloadSignedUrlsQueryVariables>(GetQSetQuestionDownloadSignedUrlsDocument, options);
        }
export type GetQSetQuestionDownloadSignedUrlsQueryHookResult = ReturnType<typeof useGetQSetQuestionDownloadSignedUrlsQuery>;
export type GetQSetQuestionDownloadSignedUrlsLazyQueryHookResult = ReturnType<typeof useGetQSetQuestionDownloadSignedUrlsLazyQuery>;
export type GetQSetQuestionDownloadSignedUrlsSuspenseQueryHookResult = ReturnType<typeof useGetQSetQuestionDownloadSignedUrlsSuspenseQuery>;
export type GetQSetQuestionDownloadSignedUrlsQueryResult = Apollo.QueryResult<GetQSetQuestionDownloadSignedUrlsQuery, GetQSetQuestionDownloadSignedUrlsQueryVariables>;
export const SearchLearningObjectiveStatementsDocument = gql`
    query searchLearningObjectiveStatements($search: SearchLearningObjectiveStatementsInput!, $paging: PageInput!, $order: OrderInput!) {
  qbsSearchLearningObjectiveStatements(
    search: $search
    paging: $paging
    order: $order
  ) {
    learningObjectiveStatements {
      id
      qBankStructureId
      qBankStructureLevelItemId
      tagId
      status
      tag {
        id
        name
      }
      activeQuestionCount {
        single
        itemSet
      }
      createdAt
      updatedAt
      enabled
    }
    total
  }
}
    `;

/**
 * __useSearchLearningObjectiveStatementsQuery__
 *
 * To run a query within a React component, call `useSearchLearningObjectiveStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLearningObjectiveStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLearningObjectiveStatementsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchLearningObjectiveStatementsQuery(baseOptions: Apollo.QueryHookOptions<SearchLearningObjectiveStatementsQuery, SearchLearningObjectiveStatementsQueryVariables> & ({ variables: SearchLearningObjectiveStatementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchLearningObjectiveStatementsQuery, SearchLearningObjectiveStatementsQueryVariables>(SearchLearningObjectiveStatementsDocument, options);
      }
export function useSearchLearningObjectiveStatementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchLearningObjectiveStatementsQuery, SearchLearningObjectiveStatementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchLearningObjectiveStatementsQuery, SearchLearningObjectiveStatementsQueryVariables>(SearchLearningObjectiveStatementsDocument, options);
        }
// @ts-ignore
export function useSearchLearningObjectiveStatementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchLearningObjectiveStatementsQuery, SearchLearningObjectiveStatementsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchLearningObjectiveStatementsQuery, SearchLearningObjectiveStatementsQueryVariables>;
export function useSearchLearningObjectiveStatementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchLearningObjectiveStatementsQuery, SearchLearningObjectiveStatementsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchLearningObjectiveStatementsQuery | undefined, SearchLearningObjectiveStatementsQueryVariables>;
export function useSearchLearningObjectiveStatementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchLearningObjectiveStatementsQuery, SearchLearningObjectiveStatementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchLearningObjectiveStatementsQuery, SearchLearningObjectiveStatementsQueryVariables>(SearchLearningObjectiveStatementsDocument, options);
        }
export type SearchLearningObjectiveStatementsQueryHookResult = ReturnType<typeof useSearchLearningObjectiveStatementsQuery>;
export type SearchLearningObjectiveStatementsLazyQueryHookResult = ReturnType<typeof useSearchLearningObjectiveStatementsLazyQuery>;
export type SearchLearningObjectiveStatementsSuspenseQueryHookResult = ReturnType<typeof useSearchLearningObjectiveStatementsSuspenseQuery>;
export type SearchLearningObjectiveStatementsQueryResult = Apollo.QueryResult<SearchLearningObjectiveStatementsQuery, SearchLearningObjectiveStatementsQueryVariables>;
export const GetLearningObjectiveStatementByIdDocument = gql`
    query getLearningObjectiveStatementById($input: GetLearningObjectiveStatementByIdInput!) {
  qbsGetLearningObjectiveStatementById(input: $input) {
    id
    tag {
      id
      name
    }
    createdAt
    updatedAt
    qBankStructureId
    qBankStructureLevelItem {
      id
      tag {
        name
      }
    }
  }
}
    `;

/**
 * __useGetLearningObjectiveStatementByIdQuery__
 *
 * To run a query within a React component, call `useGetLearningObjectiveStatementByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningObjectiveStatementByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningObjectiveStatementByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLearningObjectiveStatementByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLearningObjectiveStatementByIdQuery, GetLearningObjectiveStatementByIdQueryVariables> & ({ variables: GetLearningObjectiveStatementByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearningObjectiveStatementByIdQuery, GetLearningObjectiveStatementByIdQueryVariables>(GetLearningObjectiveStatementByIdDocument, options);
      }
export function useGetLearningObjectiveStatementByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearningObjectiveStatementByIdQuery, GetLearningObjectiveStatementByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearningObjectiveStatementByIdQuery, GetLearningObjectiveStatementByIdQueryVariables>(GetLearningObjectiveStatementByIdDocument, options);
        }
// @ts-ignore
export function useGetLearningObjectiveStatementByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLearningObjectiveStatementByIdQuery, GetLearningObjectiveStatementByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLearningObjectiveStatementByIdQuery, GetLearningObjectiveStatementByIdQueryVariables>;
export function useGetLearningObjectiveStatementByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningObjectiveStatementByIdQuery, GetLearningObjectiveStatementByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLearningObjectiveStatementByIdQuery | undefined, GetLearningObjectiveStatementByIdQueryVariables>;
export function useGetLearningObjectiveStatementByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningObjectiveStatementByIdQuery, GetLearningObjectiveStatementByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearningObjectiveStatementByIdQuery, GetLearningObjectiveStatementByIdQueryVariables>(GetLearningObjectiveStatementByIdDocument, options);
        }
export type GetLearningObjectiveStatementByIdQueryHookResult = ReturnType<typeof useGetLearningObjectiveStatementByIdQuery>;
export type GetLearningObjectiveStatementByIdLazyQueryHookResult = ReturnType<typeof useGetLearningObjectiveStatementByIdLazyQuery>;
export type GetLearningObjectiveStatementByIdSuspenseQueryHookResult = ReturnType<typeof useGetLearningObjectiveStatementByIdSuspenseQuery>;
export type GetLearningObjectiveStatementByIdQueryResult = Apollo.QueryResult<GetLearningObjectiveStatementByIdQuery, GetLearningObjectiveStatementByIdQueryVariables>;
export const CreateLearningObjectiveStatementsDocument = gql`
    mutation createLearningObjectiveStatements($input: CreateLearningObjectiveStatementsInput!) {
  qbsCreateLearningObjectiveStatements(input: $input) {
    id
    qBankStructureId
    qBankStructureLevelItemId
    tagId
    createdAt
    updatedAt
    tag {
      id
      name
      slug
      category
      description
    }
  }
}
    `;
export type CreateLearningObjectiveStatementsMutationFn = Apollo.MutationFunction<CreateLearningObjectiveStatementsMutation, CreateLearningObjectiveStatementsMutationVariables>;

/**
 * __useCreateLearningObjectiveStatementsMutation__
 *
 * To run a mutation, you first call `useCreateLearningObjectiveStatementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningObjectiveStatementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningObjectiveStatementsMutation, { data, loading, error }] = useCreateLearningObjectiveStatementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLearningObjectiveStatementsMutation(baseOptions?: Apollo.MutationHookOptions<CreateLearningObjectiveStatementsMutation, CreateLearningObjectiveStatementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLearningObjectiveStatementsMutation, CreateLearningObjectiveStatementsMutationVariables>(CreateLearningObjectiveStatementsDocument, options);
      }
export type CreateLearningObjectiveStatementsMutationHookResult = ReturnType<typeof useCreateLearningObjectiveStatementsMutation>;
export type CreateLearningObjectiveStatementsMutationResult = Apollo.MutationResult<CreateLearningObjectiveStatementsMutation>;
export type CreateLearningObjectiveStatementsMutationOptions = Apollo.BaseMutationOptions<CreateLearningObjectiveStatementsMutation, CreateLearningObjectiveStatementsMutationVariables>;
export const UpdateLearningObjectiveStatementDocument = gql`
    mutation updateLearningObjectiveStatement($input: UpdateLearningObjectiveStatementInput!) {
  qbsUpdateLearningObjectiveStatement(input: $input) {
    id
  }
}
    `;
export type UpdateLearningObjectiveStatementMutationFn = Apollo.MutationFunction<UpdateLearningObjectiveStatementMutation, UpdateLearningObjectiveStatementMutationVariables>;

/**
 * __useUpdateLearningObjectiveStatementMutation__
 *
 * To run a mutation, you first call `useUpdateLearningObjectiveStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningObjectiveStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningObjectiveStatementMutation, { data, loading, error }] = useUpdateLearningObjectiveStatementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLearningObjectiveStatementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLearningObjectiveStatementMutation, UpdateLearningObjectiveStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLearningObjectiveStatementMutation, UpdateLearningObjectiveStatementMutationVariables>(UpdateLearningObjectiveStatementDocument, options);
      }
export type UpdateLearningObjectiveStatementMutationHookResult = ReturnType<typeof useUpdateLearningObjectiveStatementMutation>;
export type UpdateLearningObjectiveStatementMutationResult = Apollo.MutationResult<UpdateLearningObjectiveStatementMutation>;
export type UpdateLearningObjectiveStatementMutationOptions = Apollo.BaseMutationOptions<UpdateLearningObjectiveStatementMutation, UpdateLearningObjectiveStatementMutationVariables>;
export const DeleteLearningObjectiveStatementsDocument = gql`
    mutation deleteLearningObjectiveStatements($input: DeleteLearningObjectiveStatementInput!) {
  qbsDeleteLearningObjectiveStatement(input: $input) {
    data
  }
}
    `;
export type DeleteLearningObjectiveStatementsMutationFn = Apollo.MutationFunction<DeleteLearningObjectiveStatementsMutation, DeleteLearningObjectiveStatementsMutationVariables>;

/**
 * __useDeleteLearningObjectiveStatementsMutation__
 *
 * To run a mutation, you first call `useDeleteLearningObjectiveStatementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLearningObjectiveStatementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLearningObjectiveStatementsMutation, { data, loading, error }] = useDeleteLearningObjectiveStatementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLearningObjectiveStatementsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLearningObjectiveStatementsMutation, DeleteLearningObjectiveStatementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLearningObjectiveStatementsMutation, DeleteLearningObjectiveStatementsMutationVariables>(DeleteLearningObjectiveStatementsDocument, options);
      }
export type DeleteLearningObjectiveStatementsMutationHookResult = ReturnType<typeof useDeleteLearningObjectiveStatementsMutation>;
export type DeleteLearningObjectiveStatementsMutationResult = Apollo.MutationResult<DeleteLearningObjectiveStatementsMutation>;
export type DeleteLearningObjectiveStatementsMutationOptions = Apollo.BaseMutationOptions<DeleteLearningObjectiveStatementsMutation, DeleteLearningObjectiveStatementsMutationVariables>;
export const DisableLearningObjectiveStatementDocument = gql`
    mutation disableLearningObjectiveStatement($input: DisableLearningObjectiveStatementInput!) {
  qbsDisableLearningObjectiveStatement(input: $input) {
    id
  }
}
    `;
export type DisableLearningObjectiveStatementMutationFn = Apollo.MutationFunction<DisableLearningObjectiveStatementMutation, DisableLearningObjectiveStatementMutationVariables>;

/**
 * __useDisableLearningObjectiveStatementMutation__
 *
 * To run a mutation, you first call `useDisableLearningObjectiveStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableLearningObjectiveStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableLearningObjectiveStatementMutation, { data, loading, error }] = useDisableLearningObjectiveStatementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableLearningObjectiveStatementMutation(baseOptions?: Apollo.MutationHookOptions<DisableLearningObjectiveStatementMutation, DisableLearningObjectiveStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableLearningObjectiveStatementMutation, DisableLearningObjectiveStatementMutationVariables>(DisableLearningObjectiveStatementDocument, options);
      }
export type DisableLearningObjectiveStatementMutationHookResult = ReturnType<typeof useDisableLearningObjectiveStatementMutation>;
export type DisableLearningObjectiveStatementMutationResult = Apollo.MutationResult<DisableLearningObjectiveStatementMutation>;
export type DisableLearningObjectiveStatementMutationOptions = Apollo.BaseMutationOptions<DisableLearningObjectiveStatementMutation, DisableLearningObjectiveStatementMutationVariables>;
export const GetQBankStructureLevelItemsByQBankStructureIdDocument = gql`
    query getQBankStructureLevelItemsByQBankStructureId($qBankStructureId: String!, $options: GetQBankStructureLevelItemsByQBankStructureIdOptions) {
  qbsGetQBankStructureLevelItemsByQBankStructureId(
    qBankStructureId: $qBankStructureId
    options: $options
  ) {
    id
    qBankStructureId
    tagId
    parentLevelItemId
    order
    qBankStructureLevelId
    tag {
      id
      name
    }
  }
}
    `;

/**
 * __useGetQBankStructureLevelItemsByQBankStructureIdQuery__
 *
 * To run a query within a React component, call `useGetQBankStructureLevelItemsByQBankStructureIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQBankStructureLevelItemsByQBankStructureIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQBankStructureLevelItemsByQBankStructureIdQuery({
 *   variables: {
 *      qBankStructureId: // value for 'qBankStructureId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetQBankStructureLevelItemsByQBankStructureIdQuery(baseOptions: Apollo.QueryHookOptions<GetQBankStructureLevelItemsByQBankStructureIdQuery, GetQBankStructureLevelItemsByQBankStructureIdQueryVariables> & ({ variables: GetQBankStructureLevelItemsByQBankStructureIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQBankStructureLevelItemsByQBankStructureIdQuery, GetQBankStructureLevelItemsByQBankStructureIdQueryVariables>(GetQBankStructureLevelItemsByQBankStructureIdDocument, options);
      }
export function useGetQBankStructureLevelItemsByQBankStructureIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQBankStructureLevelItemsByQBankStructureIdQuery, GetQBankStructureLevelItemsByQBankStructureIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQBankStructureLevelItemsByQBankStructureIdQuery, GetQBankStructureLevelItemsByQBankStructureIdQueryVariables>(GetQBankStructureLevelItemsByQBankStructureIdDocument, options);
        }
// @ts-ignore
export function useGetQBankStructureLevelItemsByQBankStructureIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsByQBankStructureIdQuery, GetQBankStructureLevelItemsByQBankStructureIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelItemsByQBankStructureIdQuery, GetQBankStructureLevelItemsByQBankStructureIdQueryVariables>;
export function useGetQBankStructureLevelItemsByQBankStructureIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsByQBankStructureIdQuery, GetQBankStructureLevelItemsByQBankStructureIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelItemsByQBankStructureIdQuery | undefined, GetQBankStructureLevelItemsByQBankStructureIdQueryVariables>;
export function useGetQBankStructureLevelItemsByQBankStructureIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsByQBankStructureIdQuery, GetQBankStructureLevelItemsByQBankStructureIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQBankStructureLevelItemsByQBankStructureIdQuery, GetQBankStructureLevelItemsByQBankStructureIdQueryVariables>(GetQBankStructureLevelItemsByQBankStructureIdDocument, options);
        }
export type GetQBankStructureLevelItemsByQBankStructureIdQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsByQBankStructureIdQuery>;
export type GetQBankStructureLevelItemsByQBankStructureIdLazyQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsByQBankStructureIdLazyQuery>;
export type GetQBankStructureLevelItemsByQBankStructureIdSuspenseQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsByQBankStructureIdSuspenseQuery>;
export type GetQBankStructureLevelItemsByQBankStructureIdQueryResult = Apollo.QueryResult<GetQBankStructureLevelItemsByQBankStructureIdQuery, GetQBankStructureLevelItemsByQBankStructureIdQueryVariables>;
export const GetQBankStructureLevelItemsWithQIdByQBankStructureIdDocument = gql`
    query getQBankStructureLevelItemsWithQIdByQBankStructureId($qBankStructureId: String!, $options: GetQBankStructureLevelItemsByQBankStructureIdOptions) {
  qbsGetQBankStructureLevelItemsByQBankStructureId(
    qBankStructureId: $qBankStructureId
    options: $options
  ) {
    id
    qBankStructureId
    tagId
    parentLevelItemId
    order
    qBankStructureLevelId
    tag {
      id
      name
    }
    qId
  }
}
    `;

/**
 * __useGetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery__
 *
 * To run a query within a React component, call `useGetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery({
 *   variables: {
 *      qBankStructureId: // value for 'qBankStructureId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery(baseOptions: Apollo.QueryHookOptions<GetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery, GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryVariables> & ({ variables: GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery, GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryVariables>(GetQBankStructureLevelItemsWithQIdByQBankStructureIdDocument, options);
      }
export function useGetQBankStructureLevelItemsWithQIdByQBankStructureIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery, GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery, GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryVariables>(GetQBankStructureLevelItemsWithQIdByQBankStructureIdDocument, options);
        }
// @ts-ignore
export function useGetQBankStructureLevelItemsWithQIdByQBankStructureIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery, GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery, GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryVariables>;
export function useGetQBankStructureLevelItemsWithQIdByQBankStructureIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery, GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery | undefined, GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryVariables>;
export function useGetQBankStructureLevelItemsWithQIdByQBankStructureIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery, GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery, GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryVariables>(GetQBankStructureLevelItemsWithQIdByQBankStructureIdDocument, options);
        }
export type GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery>;
export type GetQBankStructureLevelItemsWithQIdByQBankStructureIdLazyQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsWithQIdByQBankStructureIdLazyQuery>;
export type GetQBankStructureLevelItemsWithQIdByQBankStructureIdSuspenseQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsWithQIdByQBankStructureIdSuspenseQuery>;
export type GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryResult = Apollo.QueryResult<GetQBankStructureLevelItemsWithQIdByQBankStructureIdQuery, GetQBankStructureLevelItemsWithQIdByQBankStructureIdQueryVariables>;
export const GetQBankStructureLevelItemsByQBankStructureIdAndUserIdDocument = gql`
    query getQBankStructureLevelItemsByQBankStructureIdAndUserId($qBankStructureId: String!, $userId: String!, $options: QBankStructureLevelItemCategory) {
  qbsGetQBankStructureLevelItemsByQBankStructureIdAndUserId(
    qBankStructureId: $qBankStructureId
    userId: $userId
    options: $options
  ) {
    id
    qBankStructureId
    name
    parentLevelItemId
    order
    qBankStructureLevelId
    type
    isVisible
  }
}
    `;

/**
 * __useGetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery__
 *
 * To run a query within a React component, call `useGetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery({
 *   variables: {
 *      qBankStructureId: // value for 'qBankStructureId'
 *      userId: // value for 'userId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery, GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryVariables> & ({ variables: GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery, GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryVariables>(GetQBankStructureLevelItemsByQBankStructureIdAndUserIdDocument, options);
      }
export function useGetQBankStructureLevelItemsByQBankStructureIdAndUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery, GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery, GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryVariables>(GetQBankStructureLevelItemsByQBankStructureIdAndUserIdDocument, options);
        }
// @ts-ignore
export function useGetQBankStructureLevelItemsByQBankStructureIdAndUserIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery, GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery, GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryVariables>;
export function useGetQBankStructureLevelItemsByQBankStructureIdAndUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery, GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery | undefined, GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryVariables>;
export function useGetQBankStructureLevelItemsByQBankStructureIdAndUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery, GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery, GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryVariables>(GetQBankStructureLevelItemsByQBankStructureIdAndUserIdDocument, options);
        }
export type GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery>;
export type GetQBankStructureLevelItemsByQBankStructureIdAndUserIdLazyQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsByQBankStructureIdAndUserIdLazyQuery>;
export type GetQBankStructureLevelItemsByQBankStructureIdAndUserIdSuspenseQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsByQBankStructureIdAndUserIdSuspenseQuery>;
export type GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryResult = Apollo.QueryResult<GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQuery, GetQBankStructureLevelItemsByQBankStructureIdAndUserIdQueryVariables>;
export const GetQBankStructureLevelItemChildrenByIdDocument = gql`
    query getQBankStructureLevelItemChildrenById($id: String!) {
  qbsGetQBankStructureLevelItemChildrenById(id: $id) {
    id
    parentLevelItemId
    order
    qBankStructureLevelId
    tag {
      id
      name
    }
  }
}
    `;

/**
 * __useGetQBankStructureLevelItemChildrenByIdQuery__
 *
 * To run a query within a React component, call `useGetQBankStructureLevelItemChildrenByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQBankStructureLevelItemChildrenByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQBankStructureLevelItemChildrenByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQBankStructureLevelItemChildrenByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQBankStructureLevelItemChildrenByIdQuery, GetQBankStructureLevelItemChildrenByIdQueryVariables> & ({ variables: GetQBankStructureLevelItemChildrenByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQBankStructureLevelItemChildrenByIdQuery, GetQBankStructureLevelItemChildrenByIdQueryVariables>(GetQBankStructureLevelItemChildrenByIdDocument, options);
      }
export function useGetQBankStructureLevelItemChildrenByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQBankStructureLevelItemChildrenByIdQuery, GetQBankStructureLevelItemChildrenByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQBankStructureLevelItemChildrenByIdQuery, GetQBankStructureLevelItemChildrenByIdQueryVariables>(GetQBankStructureLevelItemChildrenByIdDocument, options);
        }
// @ts-ignore
export function useGetQBankStructureLevelItemChildrenByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemChildrenByIdQuery, GetQBankStructureLevelItemChildrenByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelItemChildrenByIdQuery, GetQBankStructureLevelItemChildrenByIdQueryVariables>;
export function useGetQBankStructureLevelItemChildrenByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemChildrenByIdQuery, GetQBankStructureLevelItemChildrenByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelItemChildrenByIdQuery | undefined, GetQBankStructureLevelItemChildrenByIdQueryVariables>;
export function useGetQBankStructureLevelItemChildrenByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemChildrenByIdQuery, GetQBankStructureLevelItemChildrenByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQBankStructureLevelItemChildrenByIdQuery, GetQBankStructureLevelItemChildrenByIdQueryVariables>(GetQBankStructureLevelItemChildrenByIdDocument, options);
        }
export type GetQBankStructureLevelItemChildrenByIdQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemChildrenByIdQuery>;
export type GetQBankStructureLevelItemChildrenByIdLazyQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemChildrenByIdLazyQuery>;
export type GetQBankStructureLevelItemChildrenByIdSuspenseQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemChildrenByIdSuspenseQuery>;
export type GetQBankStructureLevelItemChildrenByIdQueryResult = Apollo.QueryResult<GetQBankStructureLevelItemChildrenByIdQuery, GetQBankStructureLevelItemChildrenByIdQueryVariables>;
export const GetQBankStructureLevelsByQBankStructureIdDocument = gql`
    query getQBankStructureLevelsByQBankStructureId($qBankStructureId: String!) {
  qbsGetQBankStructureLevelsByQBankStructureId(
    qBankStructureId: $qBankStructureId
  ) {
    id
    level
    category
    enabled
  }
}
    `;

/**
 * __useGetQBankStructureLevelsByQBankStructureIdQuery__
 *
 * To run a query within a React component, call `useGetQBankStructureLevelsByQBankStructureIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQBankStructureLevelsByQBankStructureIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQBankStructureLevelsByQBankStructureIdQuery({
 *   variables: {
 *      qBankStructureId: // value for 'qBankStructureId'
 *   },
 * });
 */
export function useGetQBankStructureLevelsByQBankStructureIdQuery(baseOptions: Apollo.QueryHookOptions<GetQBankStructureLevelsByQBankStructureIdQuery, GetQBankStructureLevelsByQBankStructureIdQueryVariables> & ({ variables: GetQBankStructureLevelsByQBankStructureIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQBankStructureLevelsByQBankStructureIdQuery, GetQBankStructureLevelsByQBankStructureIdQueryVariables>(GetQBankStructureLevelsByQBankStructureIdDocument, options);
      }
export function useGetQBankStructureLevelsByQBankStructureIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQBankStructureLevelsByQBankStructureIdQuery, GetQBankStructureLevelsByQBankStructureIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQBankStructureLevelsByQBankStructureIdQuery, GetQBankStructureLevelsByQBankStructureIdQueryVariables>(GetQBankStructureLevelsByQBankStructureIdDocument, options);
        }
// @ts-ignore
export function useGetQBankStructureLevelsByQBankStructureIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelsByQBankStructureIdQuery, GetQBankStructureLevelsByQBankStructureIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelsByQBankStructureIdQuery, GetQBankStructureLevelsByQBankStructureIdQueryVariables>;
export function useGetQBankStructureLevelsByQBankStructureIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelsByQBankStructureIdQuery, GetQBankStructureLevelsByQBankStructureIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelsByQBankStructureIdQuery | undefined, GetQBankStructureLevelsByQBankStructureIdQueryVariables>;
export function useGetQBankStructureLevelsByQBankStructureIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelsByQBankStructureIdQuery, GetQBankStructureLevelsByQBankStructureIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQBankStructureLevelsByQBankStructureIdQuery, GetQBankStructureLevelsByQBankStructureIdQueryVariables>(GetQBankStructureLevelsByQBankStructureIdDocument, options);
        }
export type GetQBankStructureLevelsByQBankStructureIdQueryHookResult = ReturnType<typeof useGetQBankStructureLevelsByQBankStructureIdQuery>;
export type GetQBankStructureLevelsByQBankStructureIdLazyQueryHookResult = ReturnType<typeof useGetQBankStructureLevelsByQBankStructureIdLazyQuery>;
export type GetQBankStructureLevelsByQBankStructureIdSuspenseQueryHookResult = ReturnType<typeof useGetQBankStructureLevelsByQBankStructureIdSuspenseQuery>;
export type GetQBankStructureLevelsByQBankStructureIdQueryResult = Apollo.QueryResult<GetQBankStructureLevelsByQBankStructureIdQuery, GetQBankStructureLevelsByQBankStructureIdQueryVariables>;
export const UpdateQBankStructureLevelsByQBankStructureIdDocument = gql`
    mutation updateQBankStructureLevelsByQBankStructureId($input: UpdateQBankStructureLevelsByQBankStructureIdInput!) {
  qbsUpdateQBankStructureLevelsByQBankStructureId(input: $input) {
    qBankStructureId
    level
    id
    enabled
    category
  }
}
    `;
export type UpdateQBankStructureLevelsByQBankStructureIdMutationFn = Apollo.MutationFunction<UpdateQBankStructureLevelsByQBankStructureIdMutation, UpdateQBankStructureLevelsByQBankStructureIdMutationVariables>;

/**
 * __useUpdateQBankStructureLevelsByQBankStructureIdMutation__
 *
 * To run a mutation, you first call `useUpdateQBankStructureLevelsByQBankStructureIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQBankStructureLevelsByQBankStructureIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQBankStructureLevelsByQBankStructureIdMutation, { data, loading, error }] = useUpdateQBankStructureLevelsByQBankStructureIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQBankStructureLevelsByQBankStructureIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQBankStructureLevelsByQBankStructureIdMutation, UpdateQBankStructureLevelsByQBankStructureIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQBankStructureLevelsByQBankStructureIdMutation, UpdateQBankStructureLevelsByQBankStructureIdMutationVariables>(UpdateQBankStructureLevelsByQBankStructureIdDocument, options);
      }
export type UpdateQBankStructureLevelsByQBankStructureIdMutationHookResult = ReturnType<typeof useUpdateQBankStructureLevelsByQBankStructureIdMutation>;
export type UpdateQBankStructureLevelsByQBankStructureIdMutationResult = Apollo.MutationResult<UpdateQBankStructureLevelsByQBankStructureIdMutation>;
export type UpdateQBankStructureLevelsByQBankStructureIdMutationOptions = Apollo.BaseMutationOptions<UpdateQBankStructureLevelsByQBankStructureIdMutation, UpdateQBankStructureLevelsByQBankStructureIdMutationVariables>;
export const GetQBankStructuresByIdsDocument = gql`
    query getQBankStructuresByIds($ids: [String!]!) {
  qbsGetQBankStructuresByIds(ids: $ids) {
    id
    name
    code
  }
}
    `;

/**
 * __useGetQBankStructuresByIdsQuery__
 *
 * To run a query within a React component, call `useGetQBankStructuresByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQBankStructuresByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQBankStructuresByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetQBankStructuresByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetQBankStructuresByIdsQuery, GetQBankStructuresByIdsQueryVariables> & ({ variables: GetQBankStructuresByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQBankStructuresByIdsQuery, GetQBankStructuresByIdsQueryVariables>(GetQBankStructuresByIdsDocument, options);
      }
export function useGetQBankStructuresByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQBankStructuresByIdsQuery, GetQBankStructuresByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQBankStructuresByIdsQuery, GetQBankStructuresByIdsQueryVariables>(GetQBankStructuresByIdsDocument, options);
        }
// @ts-ignore
export function useGetQBankStructuresByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQBankStructuresByIdsQuery, GetQBankStructuresByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructuresByIdsQuery, GetQBankStructuresByIdsQueryVariables>;
export function useGetQBankStructuresByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructuresByIdsQuery, GetQBankStructuresByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructuresByIdsQuery | undefined, GetQBankStructuresByIdsQueryVariables>;
export function useGetQBankStructuresByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructuresByIdsQuery, GetQBankStructuresByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQBankStructuresByIdsQuery, GetQBankStructuresByIdsQueryVariables>(GetQBankStructuresByIdsDocument, options);
        }
export type GetQBankStructuresByIdsQueryHookResult = ReturnType<typeof useGetQBankStructuresByIdsQuery>;
export type GetQBankStructuresByIdsLazyQueryHookResult = ReturnType<typeof useGetQBankStructuresByIdsLazyQuery>;
export type GetQBankStructuresByIdsSuspenseQueryHookResult = ReturnType<typeof useGetQBankStructuresByIdsSuspenseQuery>;
export type GetQBankStructuresByIdsQueryResult = Apollo.QueryResult<GetQBankStructuresByIdsQuery, GetQBankStructuresByIdsQueryVariables>;
export const UpdateUserToQBankStructureDocument = gql`
    mutation updateUserToQBankStructure($input: UpdateUsersContentVisibilityInput!) {
  qbsUpdateUsersQBankStructureLevelItemContentVisibility(input: $input) {
    userIds
    qbankStructureId
    courseId
    visibleContent {
      contentId
      contentType
      parentContentId
    }
  }
}
    `;
export type UpdateUserToQBankStructureMutationFn = Apollo.MutationFunction<UpdateUserToQBankStructureMutation, UpdateUserToQBankStructureMutationVariables>;

/**
 * __useUpdateUserToQBankStructureMutation__
 *
 * To run a mutation, you first call `useUpdateUserToQBankStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserToQBankStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserToQBankStructureMutation, { data, loading, error }] = useUpdateUserToQBankStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserToQBankStructureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserToQBankStructureMutation, UpdateUserToQBankStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserToQBankStructureMutation, UpdateUserToQBankStructureMutationVariables>(UpdateUserToQBankStructureDocument, options);
      }
export type UpdateUserToQBankStructureMutationHookResult = ReturnType<typeof useUpdateUserToQBankStructureMutation>;
export type UpdateUserToQBankStructureMutationResult = Apollo.MutationResult<UpdateUserToQBankStructureMutation>;
export type UpdateUserToQBankStructureMutationOptions = Apollo.BaseMutationOptions<UpdateUserToQBankStructureMutation, UpdateUserToQBankStructureMutationVariables>;
export const SearchQBankStructuresDocument = gql`
    query searchQBankStructures($search: SearchQBankStructureInput!, $paging: PageInput!, $order: OrderInput!) {
  qbsSearchQBankStructures(search: $search, paging: $paging, order: $order) {
    qBankStructures {
      ...QBankStructure
    }
    total
  }
}
    ${QBankStructureFragmentDoc}`;

/**
 * __useSearchQBankStructuresQuery__
 *
 * To run a query within a React component, call `useSearchQBankStructuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQBankStructuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQBankStructuresQuery({
 *   variables: {
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchQBankStructuresQuery(baseOptions: Apollo.QueryHookOptions<SearchQBankStructuresQuery, SearchQBankStructuresQueryVariables> & ({ variables: SearchQBankStructuresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQBankStructuresQuery, SearchQBankStructuresQueryVariables>(SearchQBankStructuresDocument, options);
      }
export function useSearchQBankStructuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQBankStructuresQuery, SearchQBankStructuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQBankStructuresQuery, SearchQBankStructuresQueryVariables>(SearchQBankStructuresDocument, options);
        }
// @ts-ignore
export function useSearchQBankStructuresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQBankStructuresQuery, SearchQBankStructuresQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQBankStructuresQuery, SearchQBankStructuresQueryVariables>;
export function useSearchQBankStructuresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQBankStructuresQuery, SearchQBankStructuresQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQBankStructuresQuery | undefined, SearchQBankStructuresQueryVariables>;
export function useSearchQBankStructuresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQBankStructuresQuery, SearchQBankStructuresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQBankStructuresQuery, SearchQBankStructuresQueryVariables>(SearchQBankStructuresDocument, options);
        }
export type SearchQBankStructuresQueryHookResult = ReturnType<typeof useSearchQBankStructuresQuery>;
export type SearchQBankStructuresLazyQueryHookResult = ReturnType<typeof useSearchQBankStructuresLazyQuery>;
export type SearchQBankStructuresSuspenseQueryHookResult = ReturnType<typeof useSearchQBankStructuresSuspenseQuery>;
export type SearchQBankStructuresQueryResult = Apollo.QueryResult<SearchQBankStructuresQuery, SearchQBankStructuresQueryVariables>;
export const GetQBankStructureByIdDocument = gql`
    query getQBankStructureById($id: String!) {
  qbsGetQBankStructureById(id: $id) {
    ...QBankStructure
  }
}
    ${QBankStructureFragmentDoc}`;

/**
 * __useGetQBankStructureByIdQuery__
 *
 * To run a query within a React component, call `useGetQBankStructureByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQBankStructureByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQBankStructureByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQBankStructureByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQBankStructureByIdQuery, GetQBankStructureByIdQueryVariables> & ({ variables: GetQBankStructureByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQBankStructureByIdQuery, GetQBankStructureByIdQueryVariables>(GetQBankStructureByIdDocument, options);
      }
export function useGetQBankStructureByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQBankStructureByIdQuery, GetQBankStructureByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQBankStructureByIdQuery, GetQBankStructureByIdQueryVariables>(GetQBankStructureByIdDocument, options);
        }
// @ts-ignore
export function useGetQBankStructureByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQBankStructureByIdQuery, GetQBankStructureByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureByIdQuery, GetQBankStructureByIdQueryVariables>;
export function useGetQBankStructureByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureByIdQuery, GetQBankStructureByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureByIdQuery | undefined, GetQBankStructureByIdQueryVariables>;
export function useGetQBankStructureByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureByIdQuery, GetQBankStructureByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQBankStructureByIdQuery, GetQBankStructureByIdQueryVariables>(GetQBankStructureByIdDocument, options);
        }
export type GetQBankStructureByIdQueryHookResult = ReturnType<typeof useGetQBankStructureByIdQuery>;
export type GetQBankStructureByIdLazyQueryHookResult = ReturnType<typeof useGetQBankStructureByIdLazyQuery>;
export type GetQBankStructureByIdSuspenseQueryHookResult = ReturnType<typeof useGetQBankStructureByIdSuspenseQuery>;
export type GetQBankStructureByIdQueryResult = Apollo.QueryResult<GetQBankStructureByIdQuery, GetQBankStructureByIdQueryVariables>;
export const CreateQBankStructureDocument = gql`
    mutation createQBankStructure($input: CreateQBankStructureInput!) {
  qbsCreateQBankStructure(input: $input) {
    ...QBankStructure
  }
}
    ${QBankStructureFragmentDoc}`;
export type CreateQBankStructureMutationFn = Apollo.MutationFunction<CreateQBankStructureMutation, CreateQBankStructureMutationVariables>;

/**
 * __useCreateQBankStructureMutation__
 *
 * To run a mutation, you first call `useCreateQBankStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQBankStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQBankStructureMutation, { data, loading, error }] = useCreateQBankStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQBankStructureMutation(baseOptions?: Apollo.MutationHookOptions<CreateQBankStructureMutation, CreateQBankStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQBankStructureMutation, CreateQBankStructureMutationVariables>(CreateQBankStructureDocument, options);
      }
export type CreateQBankStructureMutationHookResult = ReturnType<typeof useCreateQBankStructureMutation>;
export type CreateQBankStructureMutationResult = Apollo.MutationResult<CreateQBankStructureMutation>;
export type CreateQBankStructureMutationOptions = Apollo.BaseMutationOptions<CreateQBankStructureMutation, CreateQBankStructureMutationVariables>;
export const DuplicateQBankStructureDocument = gql`
    mutation duplicateQBankStructure($input: DuplicateQBankStructureInput!) {
  qbsDuplicateQBankStructure(input: $input) {
    ...QBankStructure
  }
}
    ${QBankStructureFragmentDoc}`;
export type DuplicateQBankStructureMutationFn = Apollo.MutationFunction<DuplicateQBankStructureMutation, DuplicateQBankStructureMutationVariables>;

/**
 * __useDuplicateQBankStructureMutation__
 *
 * To run a mutation, you first call `useDuplicateQBankStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateQBankStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateQBankStructureMutation, { data, loading, error }] = useDuplicateQBankStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateQBankStructureMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateQBankStructureMutation, DuplicateQBankStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateQBankStructureMutation, DuplicateQBankStructureMutationVariables>(DuplicateQBankStructureDocument, options);
      }
export type DuplicateQBankStructureMutationHookResult = ReturnType<typeof useDuplicateQBankStructureMutation>;
export type DuplicateQBankStructureMutationResult = Apollo.MutationResult<DuplicateQBankStructureMutation>;
export type DuplicateQBankStructureMutationOptions = Apollo.BaseMutationOptions<DuplicateQBankStructureMutation, DuplicateQBankStructureMutationVariables>;
export const PublishQBankStructureDocument = gql`
    mutation publishQBankStructure($id: String!) {
  qbsPublishQBankStructure(id: $id) {
    ...QBankStructure
  }
}
    ${QBankStructureFragmentDoc}`;
export type PublishQBankStructureMutationFn = Apollo.MutationFunction<PublishQBankStructureMutation, PublishQBankStructureMutationVariables>;

/**
 * __usePublishQBankStructureMutation__
 *
 * To run a mutation, you first call `usePublishQBankStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishQBankStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishQBankStructureMutation, { data, loading, error }] = usePublishQBankStructureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishQBankStructureMutation(baseOptions?: Apollo.MutationHookOptions<PublishQBankStructureMutation, PublishQBankStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishQBankStructureMutation, PublishQBankStructureMutationVariables>(PublishQBankStructureDocument, options);
      }
export type PublishQBankStructureMutationHookResult = ReturnType<typeof usePublishQBankStructureMutation>;
export type PublishQBankStructureMutationResult = Apollo.MutationResult<PublishQBankStructureMutation>;
export type PublishQBankStructureMutationOptions = Apollo.BaseMutationOptions<PublishQBankStructureMutation, PublishQBankStructureMutationVariables>;
export const UnpublishQBankStructureDocument = gql`
    mutation unpublishQBankStructure($unpublishQBankStructureId: String!) {
  qbsUnpublishQBankStructure(id: $unpublishQBankStructureId) {
    ...QBankStructure
  }
}
    ${QBankStructureFragmentDoc}`;
export type UnpublishQBankStructureMutationFn = Apollo.MutationFunction<UnpublishQBankStructureMutation, UnpublishQBankStructureMutationVariables>;

/**
 * __useUnpublishQBankStructureMutation__
 *
 * To run a mutation, you first call `useUnpublishQBankStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishQBankStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishQBankStructureMutation, { data, loading, error }] = useUnpublishQBankStructureMutation({
 *   variables: {
 *      unpublishQBankStructureId: // value for 'unpublishQBankStructureId'
 *   },
 * });
 */
export function useUnpublishQBankStructureMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishQBankStructureMutation, UnpublishQBankStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishQBankStructureMutation, UnpublishQBankStructureMutationVariables>(UnpublishQBankStructureDocument, options);
      }
export type UnpublishQBankStructureMutationHookResult = ReturnType<typeof useUnpublishQBankStructureMutation>;
export type UnpublishQBankStructureMutationResult = Apollo.MutationResult<UnpublishQBankStructureMutation>;
export type UnpublishQBankStructureMutationOptions = Apollo.BaseMutationOptions<UnpublishQBankStructureMutation, UnpublishQBankStructureMutationVariables>;
export const ArchiveQBankStructureDocument = gql`
    mutation archiveQBankStructure($archiveQBankStructureId: String!) {
  qbsArchiveQBankStructure(id: $archiveQBankStructureId) {
    ...QBankStructure
  }
}
    ${QBankStructureFragmentDoc}`;
export type ArchiveQBankStructureMutationFn = Apollo.MutationFunction<ArchiveQBankStructureMutation, ArchiveQBankStructureMutationVariables>;

/**
 * __useArchiveQBankStructureMutation__
 *
 * To run a mutation, you first call `useArchiveQBankStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveQBankStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveQBankStructureMutation, { data, loading, error }] = useArchiveQBankStructureMutation({
 *   variables: {
 *      archiveQBankStructureId: // value for 'archiveQBankStructureId'
 *   },
 * });
 */
export function useArchiveQBankStructureMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveQBankStructureMutation, ArchiveQBankStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveQBankStructureMutation, ArchiveQBankStructureMutationVariables>(ArchiveQBankStructureDocument, options);
      }
export type ArchiveQBankStructureMutationHookResult = ReturnType<typeof useArchiveQBankStructureMutation>;
export type ArchiveQBankStructureMutationResult = Apollo.MutationResult<ArchiveQBankStructureMutation>;
export type ArchiveQBankStructureMutationOptions = Apollo.BaseMutationOptions<ArchiveQBankStructureMutation, ArchiveQBankStructureMutationVariables>;
export const UpdateQBankStructureAsDraftDocument = gql`
    mutation updateQBankStructureAsDraft($input: UpdateQBankStructureAsDraftInput!) {
  qbsUpdateQBankStructureAsDraft(input: $input) {
    ...QBankStructure
  }
}
    ${QBankStructureFragmentDoc}`;
export type UpdateQBankStructureAsDraftMutationFn = Apollo.MutationFunction<UpdateQBankStructureAsDraftMutation, UpdateQBankStructureAsDraftMutationVariables>;

/**
 * __useUpdateQBankStructureAsDraftMutation__
 *
 * To run a mutation, you first call `useUpdateQBankStructureAsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQBankStructureAsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQBankStructureAsDraftMutation, { data, loading, error }] = useUpdateQBankStructureAsDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQBankStructureAsDraftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQBankStructureAsDraftMutation, UpdateQBankStructureAsDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQBankStructureAsDraftMutation, UpdateQBankStructureAsDraftMutationVariables>(UpdateQBankStructureAsDraftDocument, options);
      }
export type UpdateQBankStructureAsDraftMutationHookResult = ReturnType<typeof useUpdateQBankStructureAsDraftMutation>;
export type UpdateQBankStructureAsDraftMutationResult = Apollo.MutationResult<UpdateQBankStructureAsDraftMutation>;
export type UpdateQBankStructureAsDraftMutationOptions = Apollo.BaseMutationOptions<UpdateQBankStructureAsDraftMutation, UpdateQBankStructureAsDraftMutationVariables>;
export const UpdateQBankStructureAsPublishedDocument = gql`
    mutation updateQBankStructureAsPublished($input: UpdateQBankStructureAsPublishedInput!) {
  qbsUpdateQBankStructureAsPublished(input: $input) {
    ...QBankStructure
  }
}
    ${QBankStructureFragmentDoc}`;
export type UpdateQBankStructureAsPublishedMutationFn = Apollo.MutationFunction<UpdateQBankStructureAsPublishedMutation, UpdateQBankStructureAsPublishedMutationVariables>;

/**
 * __useUpdateQBankStructureAsPublishedMutation__
 *
 * To run a mutation, you first call `useUpdateQBankStructureAsPublishedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQBankStructureAsPublishedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQBankStructureAsPublishedMutation, { data, loading, error }] = useUpdateQBankStructureAsPublishedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQBankStructureAsPublishedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQBankStructureAsPublishedMutation, UpdateQBankStructureAsPublishedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQBankStructureAsPublishedMutation, UpdateQBankStructureAsPublishedMutationVariables>(UpdateQBankStructureAsPublishedDocument, options);
      }
export type UpdateQBankStructureAsPublishedMutationHookResult = ReturnType<typeof useUpdateQBankStructureAsPublishedMutation>;
export type UpdateQBankStructureAsPublishedMutationResult = Apollo.MutationResult<UpdateQBankStructureAsPublishedMutation>;
export type UpdateQBankStructureAsPublishedMutationOptions = Apollo.BaseMutationOptions<UpdateQBankStructureAsPublishedMutation, UpdateQBankStructureAsPublishedMutationVariables>;
export const UpdateQBankStructureAsUnpublishedDocument = gql`
    mutation updateQBankStructureAsUnpublished($input: UpdateQBankStructureAsUnpublishedInput!) {
  qbsUpdateQBankStructureAsUnpublished(input: $input) {
    ...QBankStructure
  }
}
    ${QBankStructureFragmentDoc}`;
export type UpdateQBankStructureAsUnpublishedMutationFn = Apollo.MutationFunction<UpdateQBankStructureAsUnpublishedMutation, UpdateQBankStructureAsUnpublishedMutationVariables>;

/**
 * __useUpdateQBankStructureAsUnpublishedMutation__
 *
 * To run a mutation, you first call `useUpdateQBankStructureAsUnpublishedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQBankStructureAsUnpublishedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQBankStructureAsUnpublishedMutation, { data, loading, error }] = useUpdateQBankStructureAsUnpublishedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQBankStructureAsUnpublishedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQBankStructureAsUnpublishedMutation, UpdateQBankStructureAsUnpublishedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQBankStructureAsUnpublishedMutation, UpdateQBankStructureAsUnpublishedMutationVariables>(UpdateQBankStructureAsUnpublishedDocument, options);
      }
export type UpdateQBankStructureAsUnpublishedMutationHookResult = ReturnType<typeof useUpdateQBankStructureAsUnpublishedMutation>;
export type UpdateQBankStructureAsUnpublishedMutationResult = Apollo.MutationResult<UpdateQBankStructureAsUnpublishedMutation>;
export type UpdateQBankStructureAsUnpublishedMutationOptions = Apollo.BaseMutationOptions<UpdateQBankStructureAsUnpublishedMutation, UpdateQBankStructureAsUnpublishedMutationVariables>;
export const UpdateQBankStructureAsArchivedDocument = gql`
    mutation updateQBankStructureAsArchived($input: UpdateQBankStructureAsArchivedInput!) {
  qbsUpdateQBankStructureAsArchived(input: $input) {
    ...QBankStructure
  }
}
    ${QBankStructureFragmentDoc}`;
export type UpdateQBankStructureAsArchivedMutationFn = Apollo.MutationFunction<UpdateQBankStructureAsArchivedMutation, UpdateQBankStructureAsArchivedMutationVariables>;

/**
 * __useUpdateQBankStructureAsArchivedMutation__
 *
 * To run a mutation, you first call `useUpdateQBankStructureAsArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQBankStructureAsArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQBankStructureAsArchivedMutation, { data, loading, error }] = useUpdateQBankStructureAsArchivedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQBankStructureAsArchivedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQBankStructureAsArchivedMutation, UpdateQBankStructureAsArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQBankStructureAsArchivedMutation, UpdateQBankStructureAsArchivedMutationVariables>(UpdateQBankStructureAsArchivedDocument, options);
      }
export type UpdateQBankStructureAsArchivedMutationHookResult = ReturnType<typeof useUpdateQBankStructureAsArchivedMutation>;
export type UpdateQBankStructureAsArchivedMutationResult = Apollo.MutationResult<UpdateQBankStructureAsArchivedMutation>;
export type UpdateQBankStructureAsArchivedMutationOptions = Apollo.BaseMutationOptions<UpdateQBankStructureAsArchivedMutation, UpdateQBankStructureAsArchivedMutationVariables>;
export const SaveQBankStructureAsDraftDocument = gql`
    mutation saveQBankStructureAsDraft($input: SaveAsInput!) {
  qbsSaveAsDraft(input: $input) {
    data
    message
    status
  }
}
    `;
export type SaveQBankStructureAsDraftMutationFn = Apollo.MutationFunction<SaveQBankStructureAsDraftMutation, SaveQBankStructureAsDraftMutationVariables>;

/**
 * __useSaveQBankStructureAsDraftMutation__
 *
 * To run a mutation, you first call `useSaveQBankStructureAsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQBankStructureAsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQBankStructureAsDraftMutation, { data, loading, error }] = useSaveQBankStructureAsDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveQBankStructureAsDraftMutation(baseOptions?: Apollo.MutationHookOptions<SaveQBankStructureAsDraftMutation, SaveQBankStructureAsDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveQBankStructureAsDraftMutation, SaveQBankStructureAsDraftMutationVariables>(SaveQBankStructureAsDraftDocument, options);
      }
export type SaveQBankStructureAsDraftMutationHookResult = ReturnType<typeof useSaveQBankStructureAsDraftMutation>;
export type SaveQBankStructureAsDraftMutationResult = Apollo.MutationResult<SaveQBankStructureAsDraftMutation>;
export type SaveQBankStructureAsDraftMutationOptions = Apollo.BaseMutationOptions<SaveQBankStructureAsDraftMutation, SaveQBankStructureAsDraftMutationVariables>;
export const SaveAsUnpublishedDocument = gql`
    mutation saveAsUnpublished($input: SaveAsInput!) {
  qbsSaveAsUnpublished(input: $input) {
    data
    message
    status
  }
}
    `;
export type SaveAsUnpublishedMutationFn = Apollo.MutationFunction<SaveAsUnpublishedMutation, SaveAsUnpublishedMutationVariables>;

/**
 * __useSaveAsUnpublishedMutation__
 *
 * To run a mutation, you first call `useSaveAsUnpublishedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAsUnpublishedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAsUnpublishedMutation, { data, loading, error }] = useSaveAsUnpublishedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAsUnpublishedMutation(baseOptions?: Apollo.MutationHookOptions<SaveAsUnpublishedMutation, SaveAsUnpublishedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAsUnpublishedMutation, SaveAsUnpublishedMutationVariables>(SaveAsUnpublishedDocument, options);
      }
export type SaveAsUnpublishedMutationHookResult = ReturnType<typeof useSaveAsUnpublishedMutation>;
export type SaveAsUnpublishedMutationResult = Apollo.MutationResult<SaveAsUnpublishedMutation>;
export type SaveAsUnpublishedMutationOptions = Apollo.BaseMutationOptions<SaveAsUnpublishedMutation, SaveAsUnpublishedMutationVariables>;
export const ValidateQBankStructureBeforePublishDocument = gql`
    query validateQBankStructureBeforePublish($input: ValidateQBankStructureBeforePublishInput!) {
  qbsValidateQBankStructureBeforePublish(input: $input) {
    case
    passed
    issues {
      details
      levelItemId
    }
  }
}
    `;

/**
 * __useValidateQBankStructureBeforePublishQuery__
 *
 * To run a query within a React component, call `useValidateQBankStructureBeforePublishQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateQBankStructureBeforePublishQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateQBankStructureBeforePublishQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateQBankStructureBeforePublishQuery(baseOptions: Apollo.QueryHookOptions<ValidateQBankStructureBeforePublishQuery, ValidateQBankStructureBeforePublishQueryVariables> & ({ variables: ValidateQBankStructureBeforePublishQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateQBankStructureBeforePublishQuery, ValidateQBankStructureBeforePublishQueryVariables>(ValidateQBankStructureBeforePublishDocument, options);
      }
export function useValidateQBankStructureBeforePublishLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateQBankStructureBeforePublishQuery, ValidateQBankStructureBeforePublishQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateQBankStructureBeforePublishQuery, ValidateQBankStructureBeforePublishQueryVariables>(ValidateQBankStructureBeforePublishDocument, options);
        }
// @ts-ignore
export function useValidateQBankStructureBeforePublishSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateQBankStructureBeforePublishQuery, ValidateQBankStructureBeforePublishQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateQBankStructureBeforePublishQuery, ValidateQBankStructureBeforePublishQueryVariables>;
export function useValidateQBankStructureBeforePublishSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateQBankStructureBeforePublishQuery, ValidateQBankStructureBeforePublishQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateQBankStructureBeforePublishQuery | undefined, ValidateQBankStructureBeforePublishQueryVariables>;
export function useValidateQBankStructureBeforePublishSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateQBankStructureBeforePublishQuery, ValidateQBankStructureBeforePublishQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateQBankStructureBeforePublishQuery, ValidateQBankStructureBeforePublishQueryVariables>(ValidateQBankStructureBeforePublishDocument, options);
        }
export type ValidateQBankStructureBeforePublishQueryHookResult = ReturnType<typeof useValidateQBankStructureBeforePublishQuery>;
export type ValidateQBankStructureBeforePublishLazyQueryHookResult = ReturnType<typeof useValidateQBankStructureBeforePublishLazyQuery>;
export type ValidateQBankStructureBeforePublishSuspenseQueryHookResult = ReturnType<typeof useValidateQBankStructureBeforePublishSuspenseQuery>;
export type ValidateQBankStructureBeforePublishQueryResult = Apollo.QueryResult<ValidateQBankStructureBeforePublishQuery, ValidateQBankStructureBeforePublishQueryVariables>;
export const SearchQBankStructureGroupTagsDocument = gql`
    query searchQBankStructureGroupTags($search: SearchQBankStructureGroupTagInput!, $paging: PageInput!, $order: OrderInput!) {
  qbsSearchQBankStructureGroupTags(
    search: $search
    paging: $paging
    order: $order
  ) {
    tags {
      id
      name
      slug
      category
      description
    }
    total
  }
}
    `;

/**
 * __useSearchQBankStructureGroupTagsQuery__
 *
 * To run a query within a React component, call `useSearchQBankStructureGroupTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQBankStructureGroupTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQBankStructureGroupTagsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchQBankStructureGroupTagsQuery(baseOptions: Apollo.QueryHookOptions<SearchQBankStructureGroupTagsQuery, SearchQBankStructureGroupTagsQueryVariables> & ({ variables: SearchQBankStructureGroupTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQBankStructureGroupTagsQuery, SearchQBankStructureGroupTagsQueryVariables>(SearchQBankStructureGroupTagsDocument, options);
      }
export function useSearchQBankStructureGroupTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQBankStructureGroupTagsQuery, SearchQBankStructureGroupTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQBankStructureGroupTagsQuery, SearchQBankStructureGroupTagsQueryVariables>(SearchQBankStructureGroupTagsDocument, options);
        }
// @ts-ignore
export function useSearchQBankStructureGroupTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQBankStructureGroupTagsQuery, SearchQBankStructureGroupTagsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQBankStructureGroupTagsQuery, SearchQBankStructureGroupTagsQueryVariables>;
export function useSearchQBankStructureGroupTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQBankStructureGroupTagsQuery, SearchQBankStructureGroupTagsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQBankStructureGroupTagsQuery | undefined, SearchQBankStructureGroupTagsQueryVariables>;
export function useSearchQBankStructureGroupTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQBankStructureGroupTagsQuery, SearchQBankStructureGroupTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQBankStructureGroupTagsQuery, SearchQBankStructureGroupTagsQueryVariables>(SearchQBankStructureGroupTagsDocument, options);
        }
export type SearchQBankStructureGroupTagsQueryHookResult = ReturnType<typeof useSearchQBankStructureGroupTagsQuery>;
export type SearchQBankStructureGroupTagsLazyQueryHookResult = ReturnType<typeof useSearchQBankStructureGroupTagsLazyQuery>;
export type SearchQBankStructureGroupTagsSuspenseQueryHookResult = ReturnType<typeof useSearchQBankStructureGroupTagsSuspenseQuery>;
export type SearchQBankStructureGroupTagsQueryResult = Apollo.QueryResult<SearchQBankStructureGroupTagsQuery, SearchQBankStructureGroupTagsQueryVariables>;
export const GetQBankStructureGroupTagByIdDocument = gql`
    query getQBankStructureGroupTagById($qbsGetQBankStructureGroupTagById: String!) {
  qbsGetQBankStructureGroupTagById(id: $qbsGetQBankStructureGroupTagById) {
    id
    name
    slug
    category
    description
  }
}
    `;

/**
 * __useGetQBankStructureGroupTagByIdQuery__
 *
 * To run a query within a React component, call `useGetQBankStructureGroupTagByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQBankStructureGroupTagByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQBankStructureGroupTagByIdQuery({
 *   variables: {
 *      qbsGetQBankStructureGroupTagById: // value for 'qbsGetQBankStructureGroupTagById'
 *   },
 * });
 */
export function useGetQBankStructureGroupTagByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQBankStructureGroupTagByIdQuery, GetQBankStructureGroupTagByIdQueryVariables> & ({ variables: GetQBankStructureGroupTagByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQBankStructureGroupTagByIdQuery, GetQBankStructureGroupTagByIdQueryVariables>(GetQBankStructureGroupTagByIdDocument, options);
      }
export function useGetQBankStructureGroupTagByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQBankStructureGroupTagByIdQuery, GetQBankStructureGroupTagByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQBankStructureGroupTagByIdQuery, GetQBankStructureGroupTagByIdQueryVariables>(GetQBankStructureGroupTagByIdDocument, options);
        }
// @ts-ignore
export function useGetQBankStructureGroupTagByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQBankStructureGroupTagByIdQuery, GetQBankStructureGroupTagByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureGroupTagByIdQuery, GetQBankStructureGroupTagByIdQueryVariables>;
export function useGetQBankStructureGroupTagByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureGroupTagByIdQuery, GetQBankStructureGroupTagByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureGroupTagByIdQuery | undefined, GetQBankStructureGroupTagByIdQueryVariables>;
export function useGetQBankStructureGroupTagByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureGroupTagByIdQuery, GetQBankStructureGroupTagByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQBankStructureGroupTagByIdQuery, GetQBankStructureGroupTagByIdQueryVariables>(GetQBankStructureGroupTagByIdDocument, options);
        }
export type GetQBankStructureGroupTagByIdQueryHookResult = ReturnType<typeof useGetQBankStructureGroupTagByIdQuery>;
export type GetQBankStructureGroupTagByIdLazyQueryHookResult = ReturnType<typeof useGetQBankStructureGroupTagByIdLazyQuery>;
export type GetQBankStructureGroupTagByIdSuspenseQueryHookResult = ReturnType<typeof useGetQBankStructureGroupTagByIdSuspenseQuery>;
export type GetQBankStructureGroupTagByIdQueryResult = Apollo.QueryResult<GetQBankStructureGroupTagByIdQuery, GetQBankStructureGroupTagByIdQueryVariables>;
export const GetQBankStructureLevelItemsAbilityByQBankStructureIdDocument = gql`
    query getQBankStructureLevelItemsAbilityByQBankStructureId($qBankStructureId: String!) {
  qbsGetQBankStructureLevelItemsAbilityByQBankStructureId(
    qBankStructureId: $qBankStructureId
  ) {
    id
    isChildrenAddable
  }
}
    `;

/**
 * __useGetQBankStructureLevelItemsAbilityByQBankStructureIdQuery__
 *
 * To run a query within a React component, call `useGetQBankStructureLevelItemsAbilityByQBankStructureIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQBankStructureLevelItemsAbilityByQBankStructureIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQBankStructureLevelItemsAbilityByQBankStructureIdQuery({
 *   variables: {
 *      qBankStructureId: // value for 'qBankStructureId'
 *   },
 * });
 */
export function useGetQBankStructureLevelItemsAbilityByQBankStructureIdQuery(baseOptions: Apollo.QueryHookOptions<GetQBankStructureLevelItemsAbilityByQBankStructureIdQuery, GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryVariables> & ({ variables: GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQBankStructureLevelItemsAbilityByQBankStructureIdQuery, GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryVariables>(GetQBankStructureLevelItemsAbilityByQBankStructureIdDocument, options);
      }
export function useGetQBankStructureLevelItemsAbilityByQBankStructureIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQBankStructureLevelItemsAbilityByQBankStructureIdQuery, GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQBankStructureLevelItemsAbilityByQBankStructureIdQuery, GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryVariables>(GetQBankStructureLevelItemsAbilityByQBankStructureIdDocument, options);
        }
// @ts-ignore
export function useGetQBankStructureLevelItemsAbilityByQBankStructureIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsAbilityByQBankStructureIdQuery, GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelItemsAbilityByQBankStructureIdQuery, GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryVariables>;
export function useGetQBankStructureLevelItemsAbilityByQBankStructureIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsAbilityByQBankStructureIdQuery, GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelItemsAbilityByQBankStructureIdQuery | undefined, GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryVariables>;
export function useGetQBankStructureLevelItemsAbilityByQBankStructureIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsAbilityByQBankStructureIdQuery, GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQBankStructureLevelItemsAbilityByQBankStructureIdQuery, GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryVariables>(GetQBankStructureLevelItemsAbilityByQBankStructureIdDocument, options);
        }
export type GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsAbilityByQBankStructureIdQuery>;
export type GetQBankStructureLevelItemsAbilityByQBankStructureIdLazyQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsAbilityByQBankStructureIdLazyQuery>;
export type GetQBankStructureLevelItemsAbilityByQBankStructureIdSuspenseQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsAbilityByQBankStructureIdSuspenseQuery>;
export type GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryResult = Apollo.QueryResult<GetQBankStructureLevelItemsAbilityByQBankStructureIdQuery, GetQBankStructureLevelItemsAbilityByQBankStructureIdQueryVariables>;
export const QbsSearchQBankStructureAuditLogsDocument = gql`
    query QbsSearchQBankStructureAuditLogs($input: SearchQBankStructureAuditLogsInputType!) {
  qbsSearchQBankStructureAuditLogs(input: $input) {
    qBankStructureAuditLogs {
      id
      action
      actionTime
      detail
      fullName
    }
    total
  }
}
    `;

/**
 * __useQbsSearchQBankStructureAuditLogsQuery__
 *
 * To run a query within a React component, call `useQbsSearchQBankStructureAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQbsSearchQBankStructureAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQbsSearchQBankStructureAuditLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQbsSearchQBankStructureAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<QbsSearchQBankStructureAuditLogsQuery, QbsSearchQBankStructureAuditLogsQueryVariables> & ({ variables: QbsSearchQBankStructureAuditLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QbsSearchQBankStructureAuditLogsQuery, QbsSearchQBankStructureAuditLogsQueryVariables>(QbsSearchQBankStructureAuditLogsDocument, options);
      }
export function useQbsSearchQBankStructureAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QbsSearchQBankStructureAuditLogsQuery, QbsSearchQBankStructureAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QbsSearchQBankStructureAuditLogsQuery, QbsSearchQBankStructureAuditLogsQueryVariables>(QbsSearchQBankStructureAuditLogsDocument, options);
        }
// @ts-ignore
export function useQbsSearchQBankStructureAuditLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QbsSearchQBankStructureAuditLogsQuery, QbsSearchQBankStructureAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<QbsSearchQBankStructureAuditLogsQuery, QbsSearchQBankStructureAuditLogsQueryVariables>;
export function useQbsSearchQBankStructureAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QbsSearchQBankStructureAuditLogsQuery, QbsSearchQBankStructureAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<QbsSearchQBankStructureAuditLogsQuery | undefined, QbsSearchQBankStructureAuditLogsQueryVariables>;
export function useQbsSearchQBankStructureAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QbsSearchQBankStructureAuditLogsQuery, QbsSearchQBankStructureAuditLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QbsSearchQBankStructureAuditLogsQuery, QbsSearchQBankStructureAuditLogsQueryVariables>(QbsSearchQBankStructureAuditLogsDocument, options);
        }
export type QbsSearchQBankStructureAuditLogsQueryHookResult = ReturnType<typeof useQbsSearchQBankStructureAuditLogsQuery>;
export type QbsSearchQBankStructureAuditLogsLazyQueryHookResult = ReturnType<typeof useQbsSearchQBankStructureAuditLogsLazyQuery>;
export type QbsSearchQBankStructureAuditLogsSuspenseQueryHookResult = ReturnType<typeof useQbsSearchQBankStructureAuditLogsSuspenseQuery>;
export type QbsSearchQBankStructureAuditLogsQueryResult = Apollo.QueryResult<QbsSearchQBankStructureAuditLogsQuery, QbsSearchQBankStructureAuditLogsQueryVariables>;
export const SearchTagsDocument = gql`
    query searchTags($search: SearchTagsInput!, $paging: PageInput!, $order: OrderInput!) {
  qbsSearchTags(search: $search, paging: $paging, order: $order) {
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useSearchTagsQuery__
 *
 * To run a query within a React component, call `useSearchTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTagsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchTagsQuery(baseOptions: Apollo.QueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables> & ({ variables: SearchTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTagsQuery, SearchTagsQueryVariables>(SearchTagsDocument, options);
      }
export function useSearchTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTagsQuery, SearchTagsQueryVariables>(SearchTagsDocument, options);
        }
// @ts-ignore
export function useSearchTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTagsQuery, SearchTagsQueryVariables>;
export function useSearchTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTagsQuery | undefined, SearchTagsQueryVariables>;
export function useSearchTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTagsQuery, SearchTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTagsQuery, SearchTagsQueryVariables>(SearchTagsDocument, options);
        }
export type SearchTagsQueryHookResult = ReturnType<typeof useSearchTagsQuery>;
export type SearchTagsLazyQueryHookResult = ReturnType<typeof useSearchTagsLazyQuery>;
export type SearchTagsSuspenseQueryHookResult = ReturnType<typeof useSearchTagsSuspenseQuery>;
export type SearchTagsQueryResult = Apollo.QueryResult<SearchTagsQuery, SearchTagsQueryVariables>;
export const SearchTagsByCategoryDocument = gql`
    query searchTagsByCategory($search: SearchTagsInput!, $order: OrderInput!) {
  qbsSearchTags(search: $search, order: $order) {
    tags {
      name
      id
    }
  }
}
    `;

/**
 * __useSearchTagsByCategoryQuery__
 *
 * To run a query within a React component, call `useSearchTagsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTagsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTagsByCategoryQuery({
 *   variables: {
 *      search: // value for 'search'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchTagsByCategoryQuery(baseOptions: Apollo.QueryHookOptions<SearchTagsByCategoryQuery, SearchTagsByCategoryQueryVariables> & ({ variables: SearchTagsByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTagsByCategoryQuery, SearchTagsByCategoryQueryVariables>(SearchTagsByCategoryDocument, options);
      }
export function useSearchTagsByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTagsByCategoryQuery, SearchTagsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTagsByCategoryQuery, SearchTagsByCategoryQueryVariables>(SearchTagsByCategoryDocument, options);
        }
// @ts-ignore
export function useSearchTagsByCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchTagsByCategoryQuery, SearchTagsByCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTagsByCategoryQuery, SearchTagsByCategoryQueryVariables>;
export function useSearchTagsByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTagsByCategoryQuery, SearchTagsByCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTagsByCategoryQuery | undefined, SearchTagsByCategoryQueryVariables>;
export function useSearchTagsByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTagsByCategoryQuery, SearchTagsByCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTagsByCategoryQuery, SearchTagsByCategoryQueryVariables>(SearchTagsByCategoryDocument, options);
        }
export type SearchTagsByCategoryQueryHookResult = ReturnType<typeof useSearchTagsByCategoryQuery>;
export type SearchTagsByCategoryLazyQueryHookResult = ReturnType<typeof useSearchTagsByCategoryLazyQuery>;
export type SearchTagsByCategorySuspenseQueryHookResult = ReturnType<typeof useSearchTagsByCategorySuspenseQuery>;
export type SearchTagsByCategoryQueryResult = Apollo.QueryResult<SearchTagsByCategoryQuery, SearchTagsByCategoryQueryVariables>;
export const GetTagsByCategoryDocument = gql`
    query getTagsByCategory($input: GetTagsByCategoryInput!) {
  qbsGetTagsByCategory(getTagsByCategoryInput: $input) {
    id
    name
    slug
    description
    category
  }
}
    `;

/**
 * __useGetTagsByCategoryQuery__
 *
 * To run a query within a React component, call `useGetTagsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsByCategoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTagsByCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetTagsByCategoryQuery, GetTagsByCategoryQueryVariables> & ({ variables: GetTagsByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsByCategoryQuery, GetTagsByCategoryQueryVariables>(GetTagsByCategoryDocument, options);
      }
export function useGetTagsByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsByCategoryQuery, GetTagsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsByCategoryQuery, GetTagsByCategoryQueryVariables>(GetTagsByCategoryDocument, options);
        }
// @ts-ignore
export function useGetTagsByCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagsByCategoryQuery, GetTagsByCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagsByCategoryQuery, GetTagsByCategoryQueryVariables>;
export function useGetTagsByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagsByCategoryQuery, GetTagsByCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagsByCategoryQuery | undefined, GetTagsByCategoryQueryVariables>;
export function useGetTagsByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagsByCategoryQuery, GetTagsByCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagsByCategoryQuery, GetTagsByCategoryQueryVariables>(GetTagsByCategoryDocument, options);
        }
export type GetTagsByCategoryQueryHookResult = ReturnType<typeof useGetTagsByCategoryQuery>;
export type GetTagsByCategoryLazyQueryHookResult = ReturnType<typeof useGetTagsByCategoryLazyQuery>;
export type GetTagsByCategorySuspenseQueryHookResult = ReturnType<typeof useGetTagsByCategorySuspenseQuery>;
export type GetTagsByCategoryQueryResult = Apollo.QueryResult<GetTagsByCategoryQuery, GetTagsByCategoryQueryVariables>;
export const GetUploadSignedUrlForQuestionDocument = gql`
    query getUploadSignedUrlForQuestion($input: GetUploadSignedUrlQuestionInput!) {
  qctGetUploadSignedUrlQuestion(input: $input) {
    signedUrl
    storageObject {
      fileName
    }
  }
}
    `;

/**
 * __useGetUploadSignedUrlForQuestionQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlForQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlForQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlForQuestionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUploadSignedUrlForQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlForQuestionQuery, GetUploadSignedUrlForQuestionQueryVariables> & ({ variables: GetUploadSignedUrlForQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlForQuestionQuery, GetUploadSignedUrlForQuestionQueryVariables>(GetUploadSignedUrlForQuestionDocument, options);
      }
export function useGetUploadSignedUrlForQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlForQuestionQuery, GetUploadSignedUrlForQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlForQuestionQuery, GetUploadSignedUrlForQuestionQueryVariables>(GetUploadSignedUrlForQuestionDocument, options);
        }
// @ts-ignore
export function useGetUploadSignedUrlForQuestionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForQuestionQuery, GetUploadSignedUrlForQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadSignedUrlForQuestionQuery, GetUploadSignedUrlForQuestionQueryVariables>;
export function useGetUploadSignedUrlForQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForQuestionQuery, GetUploadSignedUrlForQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadSignedUrlForQuestionQuery | undefined, GetUploadSignedUrlForQuestionQueryVariables>;
export function useGetUploadSignedUrlForQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForQuestionQuery, GetUploadSignedUrlForQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlForQuestionQuery, GetUploadSignedUrlForQuestionQueryVariables>(GetUploadSignedUrlForQuestionDocument, options);
        }
export type GetUploadSignedUrlForQuestionQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForQuestionQuery>;
export type GetUploadSignedUrlForQuestionLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForQuestionLazyQuery>;
export type GetUploadSignedUrlForQuestionSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForQuestionSuspenseQuery>;
export type GetUploadSignedUrlForQuestionQueryResult = Apollo.QueryResult<GetUploadSignedUrlForQuestionQuery, GetUploadSignedUrlForQuestionQueryVariables>;
export const GetDownloadSignedUrlForQuestionDocument = gql`
    query getDownloadSignedUrlForQuestion($input: GetDownloadSignedUrlQuestionInput!) {
  qctGetDownloadSignedUrlQuestion(input: $input) {
    signedUrls
  }
}
    `;

/**
 * __useGetDownloadSignedUrlForQuestionQuery__
 *
 * To run a query within a React component, call `useGetDownloadSignedUrlForQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSignedUrlForQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSignedUrlForQuestionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDownloadSignedUrlForQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadSignedUrlForQuestionQuery, GetDownloadSignedUrlForQuestionQueryVariables> & ({ variables: GetDownloadSignedUrlForQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadSignedUrlForQuestionQuery, GetDownloadSignedUrlForQuestionQueryVariables>(GetDownloadSignedUrlForQuestionDocument, options);
      }
export function useGetDownloadSignedUrlForQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadSignedUrlForQuestionQuery, GetDownloadSignedUrlForQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadSignedUrlForQuestionQuery, GetDownloadSignedUrlForQuestionQueryVariables>(GetDownloadSignedUrlForQuestionDocument, options);
        }
// @ts-ignore
export function useGetDownloadSignedUrlForQuestionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionQuery, GetDownloadSignedUrlForQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadSignedUrlForQuestionQuery, GetDownloadSignedUrlForQuestionQueryVariables>;
export function useGetDownloadSignedUrlForQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionQuery, GetDownloadSignedUrlForQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadSignedUrlForQuestionQuery | undefined, GetDownloadSignedUrlForQuestionQueryVariables>;
export function useGetDownloadSignedUrlForQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionQuery, GetDownloadSignedUrlForQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadSignedUrlForQuestionQuery, GetDownloadSignedUrlForQuestionQueryVariables>(GetDownloadSignedUrlForQuestionDocument, options);
        }
export type GetDownloadSignedUrlForQuestionQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionQuery>;
export type GetDownloadSignedUrlForQuestionLazyQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionLazyQuery>;
export type GetDownloadSignedUrlForQuestionSuspenseQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionSuspenseQuery>;
export type GetDownloadSignedUrlForQuestionQueryResult = Apollo.QueryResult<GetDownloadSignedUrlForQuestionQuery, GetDownloadSignedUrlForQuestionQueryVariables>;
export const SearchQuestionsDocument = gql`
    query searchQuestions($search: SearchQuestionsInput!, $paging: PageInput!, $order: OrderInput!) {
  qctSearchQuestions(search: $search, paging: $paging, order: $order) {
    questions {
      ...Question
    }
    total
  }
}
    ${QuestionFragmentDoc}`;

/**
 * __useSearchQuestionsQuery__
 *
 * To run a query within a React component, call `useSearchQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuestionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchQuestionsQuery(baseOptions: Apollo.QueryHookOptions<SearchQuestionsQuery, SearchQuestionsQueryVariables> & ({ variables: SearchQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuestionsQuery, SearchQuestionsQueryVariables>(SearchQuestionsDocument, options);
      }
export function useSearchQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuestionsQuery, SearchQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuestionsQuery, SearchQuestionsQueryVariables>(SearchQuestionsDocument, options);
        }
// @ts-ignore
export function useSearchQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQuestionsQuery, SearchQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionsQuery, SearchQuestionsQueryVariables>;
export function useSearchQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionsQuery, SearchQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionsQuery | undefined, SearchQuestionsQueryVariables>;
export function useSearchQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionsQuery, SearchQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuestionsQuery, SearchQuestionsQueryVariables>(SearchQuestionsDocument, options);
        }
export type SearchQuestionsQueryHookResult = ReturnType<typeof useSearchQuestionsQuery>;
export type SearchQuestionsLazyQueryHookResult = ReturnType<typeof useSearchQuestionsLazyQuery>;
export type SearchQuestionsSuspenseQueryHookResult = ReturnType<typeof useSearchQuestionsSuspenseQuery>;
export type SearchQuestionsQueryResult = Apollo.QueryResult<SearchQuestionsQuery, SearchQuestionsQueryVariables>;
export const CreateQuestionDocument = gql`
    mutation createQuestion($input: CreateQuestionInput!) {
  qctCreateQuestion(input: $input) {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export type CreateQuestionMutationFn = Apollo.MutationFunction<CreateQuestionMutation, CreateQuestionMutationVariables>;

/**
 * __useCreateQuestionMutation__
 *
 * To run a mutation, you first call `useCreateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionMutation, { data, loading, error }] = useCreateQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionMutation, CreateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionMutation, CreateQuestionMutationVariables>(CreateQuestionDocument, options);
      }
export type CreateQuestionMutationHookResult = ReturnType<typeof useCreateQuestionMutation>;
export type CreateQuestionMutationResult = Apollo.MutationResult<CreateQuestionMutation>;
export type CreateQuestionMutationOptions = Apollo.BaseMutationOptions<CreateQuestionMutation, CreateQuestionMutationVariables>;
export const SaveQuestionAsDraftDocument = gql`
    mutation saveQuestionAsDraft($input: SaveQuestionAsDraftInput!) {
  qctSaveQuestionAsDraft(input: $input) {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export type SaveQuestionAsDraftMutationFn = Apollo.MutationFunction<SaveQuestionAsDraftMutation, SaveQuestionAsDraftMutationVariables>;

/**
 * __useSaveQuestionAsDraftMutation__
 *
 * To run a mutation, you first call `useSaveQuestionAsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuestionAsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuestionAsDraftMutation, { data, loading, error }] = useSaveQuestionAsDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveQuestionAsDraftMutation(baseOptions?: Apollo.MutationHookOptions<SaveQuestionAsDraftMutation, SaveQuestionAsDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveQuestionAsDraftMutation, SaveQuestionAsDraftMutationVariables>(SaveQuestionAsDraftDocument, options);
      }
export type SaveQuestionAsDraftMutationHookResult = ReturnType<typeof useSaveQuestionAsDraftMutation>;
export type SaveQuestionAsDraftMutationResult = Apollo.MutationResult<SaveQuestionAsDraftMutation>;
export type SaveQuestionAsDraftMutationOptions = Apollo.BaseMutationOptions<SaveQuestionAsDraftMutation, SaveQuestionAsDraftMutationVariables>;
export const SaveQuestionAsUnpublishedDocument = gql`
    mutation saveQuestionAsUnpublished($input: SaveQuestionAsUnpublishInput!) {
  qctSaveQuestionAsUnpublish(input: $input) {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export type SaveQuestionAsUnpublishedMutationFn = Apollo.MutationFunction<SaveQuestionAsUnpublishedMutation, SaveQuestionAsUnpublishedMutationVariables>;

/**
 * __useSaveQuestionAsUnpublishedMutation__
 *
 * To run a mutation, you first call `useSaveQuestionAsUnpublishedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuestionAsUnpublishedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuestionAsUnpublishedMutation, { data, loading, error }] = useSaveQuestionAsUnpublishedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveQuestionAsUnpublishedMutation(baseOptions?: Apollo.MutationHookOptions<SaveQuestionAsUnpublishedMutation, SaveQuestionAsUnpublishedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveQuestionAsUnpublishedMutation, SaveQuestionAsUnpublishedMutationVariables>(SaveQuestionAsUnpublishedDocument, options);
      }
export type SaveQuestionAsUnpublishedMutationHookResult = ReturnType<typeof useSaveQuestionAsUnpublishedMutation>;
export type SaveQuestionAsUnpublishedMutationResult = Apollo.MutationResult<SaveQuestionAsUnpublishedMutation>;
export type SaveQuestionAsUnpublishedMutationOptions = Apollo.BaseMutationOptions<SaveQuestionAsUnpublishedMutation, SaveQuestionAsUnpublishedMutationVariables>;
export const GetUploadSignedUrlImportQuestionSpreadsheetDocument = gql`
    query getUploadSignedUrlImportQuestionSpreadsheet($input: GetUploadSignedUrlImportQuestionSpreadsheetInput!) {
  qctGetUploadSignedUrlImportQuestionSpreadsheet(input: $input) {
    signedUrl
    storageObject {
      fileName
    }
  }
}
    `;

/**
 * __useGetUploadSignedUrlImportQuestionSpreadsheetQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlImportQuestionSpreadsheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlImportQuestionSpreadsheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlImportQuestionSpreadsheetQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUploadSignedUrlImportQuestionSpreadsheetQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlImportQuestionSpreadsheetQuery, GetUploadSignedUrlImportQuestionSpreadsheetQueryVariables> & ({ variables: GetUploadSignedUrlImportQuestionSpreadsheetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlImportQuestionSpreadsheetQuery, GetUploadSignedUrlImportQuestionSpreadsheetQueryVariables>(GetUploadSignedUrlImportQuestionSpreadsheetDocument, options);
      }
export function useGetUploadSignedUrlImportQuestionSpreadsheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlImportQuestionSpreadsheetQuery, GetUploadSignedUrlImportQuestionSpreadsheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlImportQuestionSpreadsheetQuery, GetUploadSignedUrlImportQuestionSpreadsheetQueryVariables>(GetUploadSignedUrlImportQuestionSpreadsheetDocument, options);
        }
// @ts-ignore
export function useGetUploadSignedUrlImportQuestionSpreadsheetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlImportQuestionSpreadsheetQuery, GetUploadSignedUrlImportQuestionSpreadsheetQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadSignedUrlImportQuestionSpreadsheetQuery, GetUploadSignedUrlImportQuestionSpreadsheetQueryVariables>;
export function useGetUploadSignedUrlImportQuestionSpreadsheetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlImportQuestionSpreadsheetQuery, GetUploadSignedUrlImportQuestionSpreadsheetQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadSignedUrlImportQuestionSpreadsheetQuery | undefined, GetUploadSignedUrlImportQuestionSpreadsheetQueryVariables>;
export function useGetUploadSignedUrlImportQuestionSpreadsheetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlImportQuestionSpreadsheetQuery, GetUploadSignedUrlImportQuestionSpreadsheetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlImportQuestionSpreadsheetQuery, GetUploadSignedUrlImportQuestionSpreadsheetQueryVariables>(GetUploadSignedUrlImportQuestionSpreadsheetDocument, options);
        }
export type GetUploadSignedUrlImportQuestionSpreadsheetQueryHookResult = ReturnType<typeof useGetUploadSignedUrlImportQuestionSpreadsheetQuery>;
export type GetUploadSignedUrlImportQuestionSpreadsheetLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlImportQuestionSpreadsheetLazyQuery>;
export type GetUploadSignedUrlImportQuestionSpreadsheetSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlImportQuestionSpreadsheetSuspenseQuery>;
export type GetUploadSignedUrlImportQuestionSpreadsheetQueryResult = Apollo.QueryResult<GetUploadSignedUrlImportQuestionSpreadsheetQuery, GetUploadSignedUrlImportQuestionSpreadsheetQueryVariables>;
export const ImportQuestionSpreadsheetDocument = gql`
    mutation importQuestionSpreadsheet($input: ImportQuestionSpreadsheetInput!) {
  qctImportQuestionSpreadsheet(input: $input) {
    success
    message
  }
}
    `;
export type ImportQuestionSpreadsheetMutationFn = Apollo.MutationFunction<ImportQuestionSpreadsheetMutation, ImportQuestionSpreadsheetMutationVariables>;

/**
 * __useImportQuestionSpreadsheetMutation__
 *
 * To run a mutation, you first call `useImportQuestionSpreadsheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportQuestionSpreadsheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importQuestionSpreadsheetMutation, { data, loading, error }] = useImportQuestionSpreadsheetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportQuestionSpreadsheetMutation(baseOptions?: Apollo.MutationHookOptions<ImportQuestionSpreadsheetMutation, ImportQuestionSpreadsheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportQuestionSpreadsheetMutation, ImportQuestionSpreadsheetMutationVariables>(ImportQuestionSpreadsheetDocument, options);
      }
export type ImportQuestionSpreadsheetMutationHookResult = ReturnType<typeof useImportQuestionSpreadsheetMutation>;
export type ImportQuestionSpreadsheetMutationResult = Apollo.MutationResult<ImportQuestionSpreadsheetMutation>;
export type ImportQuestionSpreadsheetMutationOptions = Apollo.BaseMutationOptions<ImportQuestionSpreadsheetMutation, ImportQuestionSpreadsheetMutationVariables>;
export const ExportSingleQuestionDocument = gql`
    mutation exportSingleQuestion($input: ExportSingleQuestionInput!) {
  qctExportSingleQuestion(input: $input) {
    message
  }
}
    `;
export type ExportSingleQuestionMutationFn = Apollo.MutationFunction<ExportSingleQuestionMutation, ExportSingleQuestionMutationVariables>;

/**
 * __useExportSingleQuestionMutation__
 *
 * To run a mutation, you first call `useExportSingleQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSingleQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSingleQuestionMutation, { data, loading, error }] = useExportSingleQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportSingleQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ExportSingleQuestionMutation, ExportSingleQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSingleQuestionMutation, ExportSingleQuestionMutationVariables>(ExportSingleQuestionDocument, options);
      }
export type ExportSingleQuestionMutationHookResult = ReturnType<typeof useExportSingleQuestionMutation>;
export type ExportSingleQuestionMutationResult = Apollo.MutationResult<ExportSingleQuestionMutation>;
export type ExportSingleQuestionMutationOptions = Apollo.BaseMutationOptions<ExportSingleQuestionMutation, ExportSingleQuestionMutationVariables>;
export const GetQuestionByIdDocument = gql`
    query getQuestionById($id: String!) {
  qctGetQuestionById(id: $id) {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;

/**
 * __useGetQuestionByIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuestionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionByIdQuery, GetQuestionByIdQueryVariables> & ({ variables: GetQuestionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionByIdQuery, GetQuestionByIdQueryVariables>(GetQuestionByIdDocument, options);
      }
export function useGetQuestionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionByIdQuery, GetQuestionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionByIdQuery, GetQuestionByIdQueryVariables>(GetQuestionByIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionByIdQuery, GetQuestionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionByIdQuery, GetQuestionByIdQueryVariables>;
export function useGetQuestionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionByIdQuery, GetQuestionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionByIdQuery | undefined, GetQuestionByIdQueryVariables>;
export function useGetQuestionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionByIdQuery, GetQuestionByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionByIdQuery, GetQuestionByIdQueryVariables>(GetQuestionByIdDocument, options);
        }
export type GetQuestionByIdQueryHookResult = ReturnType<typeof useGetQuestionByIdQuery>;
export type GetQuestionByIdLazyQueryHookResult = ReturnType<typeof useGetQuestionByIdLazyQuery>;
export type GetQuestionByIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionByIdSuspenseQuery>;
export type GetQuestionByIdQueryResult = Apollo.QueryResult<GetQuestionByIdQuery, GetQuestionByIdQueryVariables>;
export const GetQuestionGroupsByQBankStructureLevelItemIdDocument = gql`
    query getQuestionGroupsByQBankStructureLevelItemId($input: GetQuestionGroupsByQBankStructureLevelItemIdInput!) {
  qctGetQuestionGroupsByQBankStructureLevelItemId(input: $input) {
    ...QuestionGroup
  }
}
    ${QuestionGroupFragmentDoc}`;

/**
 * __useGetQuestionGroupsByQBankStructureLevelItemIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionGroupsByQBankStructureLevelItemIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionGroupsByQBankStructureLevelItemIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionGroupsByQBankStructureLevelItemIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuestionGroupsByQBankStructureLevelItemIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionGroupsByQBankStructureLevelItemIdQuery, GetQuestionGroupsByQBankStructureLevelItemIdQueryVariables> & ({ variables: GetQuestionGroupsByQBankStructureLevelItemIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionGroupsByQBankStructureLevelItemIdQuery, GetQuestionGroupsByQBankStructureLevelItemIdQueryVariables>(GetQuestionGroupsByQBankStructureLevelItemIdDocument, options);
      }
export function useGetQuestionGroupsByQBankStructureLevelItemIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionGroupsByQBankStructureLevelItemIdQuery, GetQuestionGroupsByQBankStructureLevelItemIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionGroupsByQBankStructureLevelItemIdQuery, GetQuestionGroupsByQBankStructureLevelItemIdQueryVariables>(GetQuestionGroupsByQBankStructureLevelItemIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionGroupsByQBankStructureLevelItemIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionGroupsByQBankStructureLevelItemIdQuery, GetQuestionGroupsByQBankStructureLevelItemIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionGroupsByQBankStructureLevelItemIdQuery, GetQuestionGroupsByQBankStructureLevelItemIdQueryVariables>;
export function useGetQuestionGroupsByQBankStructureLevelItemIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionGroupsByQBankStructureLevelItemIdQuery, GetQuestionGroupsByQBankStructureLevelItemIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionGroupsByQBankStructureLevelItemIdQuery | undefined, GetQuestionGroupsByQBankStructureLevelItemIdQueryVariables>;
export function useGetQuestionGroupsByQBankStructureLevelItemIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionGroupsByQBankStructureLevelItemIdQuery, GetQuestionGroupsByQBankStructureLevelItemIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionGroupsByQBankStructureLevelItemIdQuery, GetQuestionGroupsByQBankStructureLevelItemIdQueryVariables>(GetQuestionGroupsByQBankStructureLevelItemIdDocument, options);
        }
export type GetQuestionGroupsByQBankStructureLevelItemIdQueryHookResult = ReturnType<typeof useGetQuestionGroupsByQBankStructureLevelItemIdQuery>;
export type GetQuestionGroupsByQBankStructureLevelItemIdLazyQueryHookResult = ReturnType<typeof useGetQuestionGroupsByQBankStructureLevelItemIdLazyQuery>;
export type GetQuestionGroupsByQBankStructureLevelItemIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionGroupsByQBankStructureLevelItemIdSuspenseQuery>;
export type GetQuestionGroupsByQBankStructureLevelItemIdQueryResult = Apollo.QueryResult<GetQuestionGroupsByQBankStructureLevelItemIdQuery, GetQuestionGroupsByQBankStructureLevelItemIdQueryVariables>;
export const GetQuestionGroupByIdDocument = gql`
    query getQuestionGroupById($questionGroupId: String!) {
  qctGetQuestionGroupById(questionGroupId: $questionGroupId) {
    ...QuestionGroup
  }
}
    ${QuestionGroupFragmentDoc}`;

/**
 * __useGetQuestionGroupByIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionGroupByIdQuery({
 *   variables: {
 *      questionGroupId: // value for 'questionGroupId'
 *   },
 * });
 */
export function useGetQuestionGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionGroupByIdQuery, GetQuestionGroupByIdQueryVariables> & ({ variables: GetQuestionGroupByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionGroupByIdQuery, GetQuestionGroupByIdQueryVariables>(GetQuestionGroupByIdDocument, options);
      }
export function useGetQuestionGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionGroupByIdQuery, GetQuestionGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionGroupByIdQuery, GetQuestionGroupByIdQueryVariables>(GetQuestionGroupByIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionGroupByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionGroupByIdQuery, GetQuestionGroupByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionGroupByIdQuery, GetQuestionGroupByIdQueryVariables>;
export function useGetQuestionGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionGroupByIdQuery, GetQuestionGroupByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionGroupByIdQuery | undefined, GetQuestionGroupByIdQueryVariables>;
export function useGetQuestionGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionGroupByIdQuery, GetQuestionGroupByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionGroupByIdQuery, GetQuestionGroupByIdQueryVariables>(GetQuestionGroupByIdDocument, options);
        }
export type GetQuestionGroupByIdQueryHookResult = ReturnType<typeof useGetQuestionGroupByIdQuery>;
export type GetQuestionGroupByIdLazyQueryHookResult = ReturnType<typeof useGetQuestionGroupByIdLazyQuery>;
export type GetQuestionGroupByIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionGroupByIdSuspenseQuery>;
export type GetQuestionGroupByIdQueryResult = Apollo.QueryResult<GetQuestionGroupByIdQuery, GetQuestionGroupByIdQueryVariables>;
export const CreateItemSetQuestionGroupDocument = gql`
    mutation createItemSetQuestionGroup($input: CreateItemSetInput!) {
  qctCreateItemSet(input: $input) {
    ...QuestionGroup
  }
}
    ${QuestionGroupFragmentDoc}`;
export type CreateItemSetQuestionGroupMutationFn = Apollo.MutationFunction<CreateItemSetQuestionGroupMutation, CreateItemSetQuestionGroupMutationVariables>;

/**
 * __useCreateItemSetQuestionGroupMutation__
 *
 * To run a mutation, you first call `useCreateItemSetQuestionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemSetQuestionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemSetQuestionGroupMutation, { data, loading, error }] = useCreateItemSetQuestionGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateItemSetQuestionGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateItemSetQuestionGroupMutation, CreateItemSetQuestionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateItemSetQuestionGroupMutation, CreateItemSetQuestionGroupMutationVariables>(CreateItemSetQuestionGroupDocument, options);
      }
export type CreateItemSetQuestionGroupMutationHookResult = ReturnType<typeof useCreateItemSetQuestionGroupMutation>;
export type CreateItemSetQuestionGroupMutationResult = Apollo.MutationResult<CreateItemSetQuestionGroupMutation>;
export type CreateItemSetQuestionGroupMutationOptions = Apollo.BaseMutationOptions<CreateItemSetQuestionGroupMutation, CreateItemSetQuestionGroupMutationVariables>;
export const DuplicateQuestionDocument = gql`
    mutation DuplicateQuestion($input: DuplicateQuestionInput!) {
  qctDuplicateQuestion(input: $input) {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export type DuplicateQuestionMutationFn = Apollo.MutationFunction<DuplicateQuestionMutation, DuplicateQuestionMutationVariables>;

/**
 * __useDuplicateQuestionMutation__
 *
 * To run a mutation, you first call `useDuplicateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateQuestionMutation, { data, loading, error }] = useDuplicateQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateQuestionMutation, DuplicateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateQuestionMutation, DuplicateQuestionMutationVariables>(DuplicateQuestionDocument, options);
      }
export type DuplicateQuestionMutationHookResult = ReturnType<typeof useDuplicateQuestionMutation>;
export type DuplicateQuestionMutationResult = Apollo.MutationResult<DuplicateQuestionMutation>;
export type DuplicateQuestionMutationOptions = Apollo.BaseMutationOptions<DuplicateQuestionMutation, DuplicateQuestionMutationVariables>;
export const PublishQuestionDocument = gql`
    mutation publishQuestion($id: String!) {
  qctPublishQuestion(id: $id) {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export type PublishQuestionMutationFn = Apollo.MutationFunction<PublishQuestionMutation, PublishQuestionMutationVariables>;

/**
 * __usePublishQuestionMutation__
 *
 * To run a mutation, you first call `usePublishQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishQuestionMutation, { data, loading, error }] = usePublishQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishQuestionMutation(baseOptions?: Apollo.MutationHookOptions<PublishQuestionMutation, PublishQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishQuestionMutation, PublishQuestionMutationVariables>(PublishQuestionDocument, options);
      }
export type PublishQuestionMutationHookResult = ReturnType<typeof usePublishQuestionMutation>;
export type PublishQuestionMutationResult = Apollo.MutationResult<PublishQuestionMutation>;
export type PublishQuestionMutationOptions = Apollo.BaseMutationOptions<PublishQuestionMutation, PublishQuestionMutationVariables>;
export const PublishItemSetDocument = gql`
    mutation publishItemSet($id: String!) {
  qctPublishItemSet(id: $id) {
    ...QuestionGroup
  }
}
    ${QuestionGroupFragmentDoc}`;
export type PublishItemSetMutationFn = Apollo.MutationFunction<PublishItemSetMutation, PublishItemSetMutationVariables>;

/**
 * __usePublishItemSetMutation__
 *
 * To run a mutation, you first call `usePublishItemSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishItemSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishItemSetMutation, { data, loading, error }] = usePublishItemSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishItemSetMutation(baseOptions?: Apollo.MutationHookOptions<PublishItemSetMutation, PublishItemSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishItemSetMutation, PublishItemSetMutationVariables>(PublishItemSetDocument, options);
      }
export type PublishItemSetMutationHookResult = ReturnType<typeof usePublishItemSetMutation>;
export type PublishItemSetMutationResult = Apollo.MutationResult<PublishItemSetMutation>;
export type PublishItemSetMutationOptions = Apollo.BaseMutationOptions<PublishItemSetMutation, PublishItemSetMutationVariables>;
export const SearchQuestionGroupsDocument = gql`
    query searchQuestionGroups($search: SearchQuestionGroupsInput!, $paging: PageInput!, $order: OrderInput!) {
  qctSearchQuestionGroups(search: $search, paging: $paging, order: $order) {
    questionGroups {
      ...QuestionGroup
    }
    total
  }
}
    ${QuestionGroupFragmentDoc}`;

/**
 * __useSearchQuestionGroupsQuery__
 *
 * To run a query within a React component, call `useSearchQuestionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuestionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuestionGroupsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchQuestionGroupsQuery(baseOptions: Apollo.QueryHookOptions<SearchQuestionGroupsQuery, SearchQuestionGroupsQueryVariables> & ({ variables: SearchQuestionGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuestionGroupsQuery, SearchQuestionGroupsQueryVariables>(SearchQuestionGroupsDocument, options);
      }
export function useSearchQuestionGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuestionGroupsQuery, SearchQuestionGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuestionGroupsQuery, SearchQuestionGroupsQueryVariables>(SearchQuestionGroupsDocument, options);
        }
// @ts-ignore
export function useSearchQuestionGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQuestionGroupsQuery, SearchQuestionGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionGroupsQuery, SearchQuestionGroupsQueryVariables>;
export function useSearchQuestionGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionGroupsQuery, SearchQuestionGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionGroupsQuery | undefined, SearchQuestionGroupsQueryVariables>;
export function useSearchQuestionGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionGroupsQuery, SearchQuestionGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuestionGroupsQuery, SearchQuestionGroupsQueryVariables>(SearchQuestionGroupsDocument, options);
        }
export type SearchQuestionGroupsQueryHookResult = ReturnType<typeof useSearchQuestionGroupsQuery>;
export type SearchQuestionGroupsLazyQueryHookResult = ReturnType<typeof useSearchQuestionGroupsLazyQuery>;
export type SearchQuestionGroupsSuspenseQueryHookResult = ReturnType<typeof useSearchQuestionGroupsSuspenseQuery>;
export type SearchQuestionGroupsQueryResult = Apollo.QueryResult<SearchQuestionGroupsQuery, SearchQuestionGroupsQueryVariables>;
export const SearchItemSetQuestionsInLocationDocument = gql`
    query searchItemSetQuestionsInLocation($search: SearchQuestionGroupsInput!, $paging: PageInput!, $order: OrderInput!) {
  qctSearchQuestionGroups(search: $search, paging: $paging, order: $order) {
    questionGroups {
      id
      name
      totalQuestions
      status
      refCode
    }
    total
  }
}
    `;

/**
 * __useSearchItemSetQuestionsInLocationQuery__
 *
 * To run a query within a React component, call `useSearchItemSetQuestionsInLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchItemSetQuestionsInLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchItemSetQuestionsInLocationQuery({
 *   variables: {
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchItemSetQuestionsInLocationQuery(baseOptions: Apollo.QueryHookOptions<SearchItemSetQuestionsInLocationQuery, SearchItemSetQuestionsInLocationQueryVariables> & ({ variables: SearchItemSetQuestionsInLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchItemSetQuestionsInLocationQuery, SearchItemSetQuestionsInLocationQueryVariables>(SearchItemSetQuestionsInLocationDocument, options);
      }
export function useSearchItemSetQuestionsInLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchItemSetQuestionsInLocationQuery, SearchItemSetQuestionsInLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchItemSetQuestionsInLocationQuery, SearchItemSetQuestionsInLocationQueryVariables>(SearchItemSetQuestionsInLocationDocument, options);
        }
// @ts-ignore
export function useSearchItemSetQuestionsInLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchItemSetQuestionsInLocationQuery, SearchItemSetQuestionsInLocationQueryVariables>): Apollo.UseSuspenseQueryResult<SearchItemSetQuestionsInLocationQuery, SearchItemSetQuestionsInLocationQueryVariables>;
export function useSearchItemSetQuestionsInLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchItemSetQuestionsInLocationQuery, SearchItemSetQuestionsInLocationQueryVariables>): Apollo.UseSuspenseQueryResult<SearchItemSetQuestionsInLocationQuery | undefined, SearchItemSetQuestionsInLocationQueryVariables>;
export function useSearchItemSetQuestionsInLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchItemSetQuestionsInLocationQuery, SearchItemSetQuestionsInLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchItemSetQuestionsInLocationQuery, SearchItemSetQuestionsInLocationQueryVariables>(SearchItemSetQuestionsInLocationDocument, options);
        }
export type SearchItemSetQuestionsInLocationQueryHookResult = ReturnType<typeof useSearchItemSetQuestionsInLocationQuery>;
export type SearchItemSetQuestionsInLocationLazyQueryHookResult = ReturnType<typeof useSearchItemSetQuestionsInLocationLazyQuery>;
export type SearchItemSetQuestionsInLocationSuspenseQueryHookResult = ReturnType<typeof useSearchItemSetQuestionsInLocationSuspenseQuery>;
export type SearchItemSetQuestionsInLocationQueryResult = Apollo.QueryResult<SearchItemSetQuestionsInLocationQuery, SearchItemSetQuestionsInLocationQueryVariables>;
export const SaveItemSetAsDraftDocument = gql`
    mutation saveItemSetAsDraft($input: SaveItemSetAsDraftInput!) {
  qctSaveItemSetAsDraft(input: $input) {
    ...QuestionGroup
  }
}
    ${QuestionGroupFragmentDoc}`;
export type SaveItemSetAsDraftMutationFn = Apollo.MutationFunction<SaveItemSetAsDraftMutation, SaveItemSetAsDraftMutationVariables>;

/**
 * __useSaveItemSetAsDraftMutation__
 *
 * To run a mutation, you first call `useSaveItemSetAsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveItemSetAsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveItemSetAsDraftMutation, { data, loading, error }] = useSaveItemSetAsDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveItemSetAsDraftMutation(baseOptions?: Apollo.MutationHookOptions<SaveItemSetAsDraftMutation, SaveItemSetAsDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveItemSetAsDraftMutation, SaveItemSetAsDraftMutationVariables>(SaveItemSetAsDraftDocument, options);
      }
export type SaveItemSetAsDraftMutationHookResult = ReturnType<typeof useSaveItemSetAsDraftMutation>;
export type SaveItemSetAsDraftMutationResult = Apollo.MutationResult<SaveItemSetAsDraftMutation>;
export type SaveItemSetAsDraftMutationOptions = Apollo.BaseMutationOptions<SaveItemSetAsDraftMutation, SaveItemSetAsDraftMutationVariables>;
export const GetDownloadSignedUrlForQuestionsDocument = gql`
    query getDownloadSignedUrlForQuestions($input: GetDownloadSignedUrlForQuestionsInput!) {
  qctGetDownloadSignedUrlForQuestions(input: $input) {
    signedUrls
  }
}
    `;

/**
 * __useGetDownloadSignedUrlForQuestionsQuery__
 *
 * To run a query within a React component, call `useGetDownloadSignedUrlForQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSignedUrlForQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSignedUrlForQuestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDownloadSignedUrlForQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadSignedUrlForQuestionsQuery, GetDownloadSignedUrlForQuestionsQueryVariables> & ({ variables: GetDownloadSignedUrlForQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadSignedUrlForQuestionsQuery, GetDownloadSignedUrlForQuestionsQueryVariables>(GetDownloadSignedUrlForQuestionsDocument, options);
      }
export function useGetDownloadSignedUrlForQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadSignedUrlForQuestionsQuery, GetDownloadSignedUrlForQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadSignedUrlForQuestionsQuery, GetDownloadSignedUrlForQuestionsQueryVariables>(GetDownloadSignedUrlForQuestionsDocument, options);
        }
// @ts-ignore
export function useGetDownloadSignedUrlForQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionsQuery, GetDownloadSignedUrlForQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadSignedUrlForQuestionsQuery, GetDownloadSignedUrlForQuestionsQueryVariables>;
export function useGetDownloadSignedUrlForQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionsQuery, GetDownloadSignedUrlForQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadSignedUrlForQuestionsQuery | undefined, GetDownloadSignedUrlForQuestionsQueryVariables>;
export function useGetDownloadSignedUrlForQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionsQuery, GetDownloadSignedUrlForQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadSignedUrlForQuestionsQuery, GetDownloadSignedUrlForQuestionsQueryVariables>(GetDownloadSignedUrlForQuestionsDocument, options);
        }
export type GetDownloadSignedUrlForQuestionsQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionsQuery>;
export type GetDownloadSignedUrlForQuestionsLazyQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionsLazyQuery>;
export type GetDownloadSignedUrlForQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionsSuspenseQuery>;
export type GetDownloadSignedUrlForQuestionsQueryResult = Apollo.QueryResult<GetDownloadSignedUrlForQuestionsQuery, GetDownloadSignedUrlForQuestionsQueryVariables>;
export const GetDownloadSignedUrlForQuestionGroupsDocument = gql`
    query getDownloadSignedUrlForQuestionGroups($input: GetDownloadSignedUrlForQuestionGroupsInput!) {
  qctGetDownloadSignedUrlForQuestionGroups(input: $input) {
    signedUrls
  }
}
    `;

/**
 * __useGetDownloadSignedUrlForQuestionGroupsQuery__
 *
 * To run a query within a React component, call `useGetDownloadSignedUrlForQuestionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSignedUrlForQuestionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSignedUrlForQuestionGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDownloadSignedUrlForQuestionGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadSignedUrlForQuestionGroupsQuery, GetDownloadSignedUrlForQuestionGroupsQueryVariables> & ({ variables: GetDownloadSignedUrlForQuestionGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadSignedUrlForQuestionGroupsQuery, GetDownloadSignedUrlForQuestionGroupsQueryVariables>(GetDownloadSignedUrlForQuestionGroupsDocument, options);
      }
export function useGetDownloadSignedUrlForQuestionGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadSignedUrlForQuestionGroupsQuery, GetDownloadSignedUrlForQuestionGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadSignedUrlForQuestionGroupsQuery, GetDownloadSignedUrlForQuestionGroupsQueryVariables>(GetDownloadSignedUrlForQuestionGroupsDocument, options);
        }
// @ts-ignore
export function useGetDownloadSignedUrlForQuestionGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionGroupsQuery, GetDownloadSignedUrlForQuestionGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadSignedUrlForQuestionGroupsQuery, GetDownloadSignedUrlForQuestionGroupsQueryVariables>;
export function useGetDownloadSignedUrlForQuestionGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionGroupsQuery, GetDownloadSignedUrlForQuestionGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadSignedUrlForQuestionGroupsQuery | undefined, GetDownloadSignedUrlForQuestionGroupsQueryVariables>;
export function useGetDownloadSignedUrlForQuestionGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionGroupsQuery, GetDownloadSignedUrlForQuestionGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadSignedUrlForQuestionGroupsQuery, GetDownloadSignedUrlForQuestionGroupsQueryVariables>(GetDownloadSignedUrlForQuestionGroupsDocument, options);
        }
export type GetDownloadSignedUrlForQuestionGroupsQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionGroupsQuery>;
export type GetDownloadSignedUrlForQuestionGroupsLazyQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionGroupsLazyQuery>;
export type GetDownloadSignedUrlForQuestionGroupsSuspenseQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionGroupsSuspenseQuery>;
export type GetDownloadSignedUrlForQuestionGroupsQueryResult = Apollo.QueryResult<GetDownloadSignedUrlForQuestionGroupsQuery, GetDownloadSignedUrlForQuestionGroupsQueryVariables>;
export const ExportItemSetDocument = gql`
    mutation exportItemSet($input: ExportItemSetInput!) {
  qctExportItemSet(input: $input) {
    message
  }
}
    `;
export type ExportItemSetMutationFn = Apollo.MutationFunction<ExportItemSetMutation, ExportItemSetMutationVariables>;

/**
 * __useExportItemSetMutation__
 *
 * To run a mutation, you first call `useExportItemSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportItemSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportItemSetMutation, { data, loading, error }] = useExportItemSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportItemSetMutation(baseOptions?: Apollo.MutationHookOptions<ExportItemSetMutation, ExportItemSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportItemSetMutation, ExportItemSetMutationVariables>(ExportItemSetDocument, options);
      }
export type ExportItemSetMutationHookResult = ReturnType<typeof useExportItemSetMutation>;
export type ExportItemSetMutationResult = Apollo.MutationResult<ExportItemSetMutation>;
export type ExportItemSetMutationOptions = Apollo.BaseMutationOptions<ExportItemSetMutation, ExportItemSetMutationVariables>;
export const PendingQuestionDocument = gql`
    mutation pendingQuestion($id: String!) {
  qctUnpublishQuestion(id: $id) {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export type PendingQuestionMutationFn = Apollo.MutationFunction<PendingQuestionMutation, PendingQuestionMutationVariables>;

/**
 * __usePendingQuestionMutation__
 *
 * To run a mutation, you first call `usePendingQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePendingQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pendingQuestionMutation, { data, loading, error }] = usePendingQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePendingQuestionMutation(baseOptions?: Apollo.MutationHookOptions<PendingQuestionMutation, PendingQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PendingQuestionMutation, PendingQuestionMutationVariables>(PendingQuestionDocument, options);
      }
export type PendingQuestionMutationHookResult = ReturnType<typeof usePendingQuestionMutation>;
export type PendingQuestionMutationResult = Apollo.MutationResult<PendingQuestionMutation>;
export type PendingQuestionMutationOptions = Apollo.BaseMutationOptions<PendingQuestionMutation, PendingQuestionMutationVariables>;
export const DisableQuestionDocument = gql`
    mutation disableQuestion($id: String!) {
  qctDisableQuestion(id: $id) {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export type DisableQuestionMutationFn = Apollo.MutationFunction<DisableQuestionMutation, DisableQuestionMutationVariables>;

/**
 * __useDisableQuestionMutation__
 *
 * To run a mutation, you first call `useDisableQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableQuestionMutation, { data, loading, error }] = useDisableQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DisableQuestionMutation, DisableQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableQuestionMutation, DisableQuestionMutationVariables>(DisableQuestionDocument, options);
      }
export type DisableQuestionMutationHookResult = ReturnType<typeof useDisableQuestionMutation>;
export type DisableQuestionMutationResult = Apollo.MutationResult<DisableQuestionMutation>;
export type DisableQuestionMutationOptions = Apollo.BaseMutationOptions<DisableQuestionMutation, DisableQuestionMutationVariables>;
export const SaveItemSetAsUnpublishedDocument = gql`
    mutation saveItemSetAsUnpublished($input: SaveItemSetAsUnpublishInput!) {
  qctSaveItemSetAsUnpublish(input: $input) {
    ...QuestionGroup
  }
}
    ${QuestionGroupFragmentDoc}`;
export type SaveItemSetAsUnpublishedMutationFn = Apollo.MutationFunction<SaveItemSetAsUnpublishedMutation, SaveItemSetAsUnpublishedMutationVariables>;

/**
 * __useSaveItemSetAsUnpublishedMutation__
 *
 * To run a mutation, you first call `useSaveItemSetAsUnpublishedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveItemSetAsUnpublishedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveItemSetAsUnpublishedMutation, { data, loading, error }] = useSaveItemSetAsUnpublishedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveItemSetAsUnpublishedMutation(baseOptions?: Apollo.MutationHookOptions<SaveItemSetAsUnpublishedMutation, SaveItemSetAsUnpublishedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveItemSetAsUnpublishedMutation, SaveItemSetAsUnpublishedMutationVariables>(SaveItemSetAsUnpublishedDocument, options);
      }
export type SaveItemSetAsUnpublishedMutationHookResult = ReturnType<typeof useSaveItemSetAsUnpublishedMutation>;
export type SaveItemSetAsUnpublishedMutationResult = Apollo.MutationResult<SaveItemSetAsUnpublishedMutation>;
export type SaveItemSetAsUnpublishedMutationOptions = Apollo.BaseMutationOptions<SaveItemSetAsUnpublishedMutation, SaveItemSetAsUnpublishedMutationVariables>;
export const PendingItemSetDocument = gql`
    mutation pendingItemSet($id: String!) {
  qctUnpublishItemSet(id: $id) {
    ...QuestionGroup
  }
}
    ${QuestionGroupFragmentDoc}`;
export type PendingItemSetMutationFn = Apollo.MutationFunction<PendingItemSetMutation, PendingItemSetMutationVariables>;

/**
 * __usePendingItemSetMutation__
 *
 * To run a mutation, you first call `usePendingItemSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePendingItemSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pendingItemSetMutation, { data, loading, error }] = usePendingItemSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePendingItemSetMutation(baseOptions?: Apollo.MutationHookOptions<PendingItemSetMutation, PendingItemSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PendingItemSetMutation, PendingItemSetMutationVariables>(PendingItemSetDocument, options);
      }
export type PendingItemSetMutationHookResult = ReturnType<typeof usePendingItemSetMutation>;
export type PendingItemSetMutationResult = Apollo.MutationResult<PendingItemSetMutation>;
export type PendingItemSetMutationOptions = Apollo.BaseMutationOptions<PendingItemSetMutation, PendingItemSetMutationVariables>;
export const DisableItemSetDocument = gql`
    mutation disableItemSet($id: String!) {
  qctDisableItemSet(id: $id) {
    ...QuestionGroup
  }
}
    ${QuestionGroupFragmentDoc}`;
export type DisableItemSetMutationFn = Apollo.MutationFunction<DisableItemSetMutation, DisableItemSetMutationVariables>;

/**
 * __useDisableItemSetMutation__
 *
 * To run a mutation, you first call `useDisableItemSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableItemSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableItemSetMutation, { data, loading, error }] = useDisableItemSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableItemSetMutation(baseOptions?: Apollo.MutationHookOptions<DisableItemSetMutation, DisableItemSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableItemSetMutation, DisableItemSetMutationVariables>(DisableItemSetDocument, options);
      }
export type DisableItemSetMutationHookResult = ReturnType<typeof useDisableItemSetMutation>;
export type DisableItemSetMutationResult = Apollo.MutationResult<DisableItemSetMutation>;
export type DisableItemSetMutationOptions = Apollo.BaseMutationOptions<DisableItemSetMutation, DisableItemSetMutationVariables>;
export const DeleteItemSetSubQuestionDocument = gql`
    mutation deleteItemSetSubQuestion($input: DeleteItemSetSubQuestionInput!) {
  qctDeleteItemSetSubQuestion(input: $input) {
    ...QuestionGroup
  }
}
    ${QuestionGroupFragmentDoc}`;
export type DeleteItemSetSubQuestionMutationFn = Apollo.MutationFunction<DeleteItemSetSubQuestionMutation, DeleteItemSetSubQuestionMutationVariables>;

/**
 * __useDeleteItemSetSubQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteItemSetSubQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemSetSubQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemSetSubQuestionMutation, { data, loading, error }] = useDeleteItemSetSubQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteItemSetSubQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteItemSetSubQuestionMutation, DeleteItemSetSubQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteItemSetSubQuestionMutation, DeleteItemSetSubQuestionMutationVariables>(DeleteItemSetSubQuestionDocument, options);
      }
export type DeleteItemSetSubQuestionMutationHookResult = ReturnType<typeof useDeleteItemSetSubQuestionMutation>;
export type DeleteItemSetSubQuestionMutationResult = Apollo.MutationResult<DeleteItemSetSubQuestionMutation>;
export type DeleteItemSetSubQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteItemSetSubQuestionMutation, DeleteItemSetSubQuestionMutationVariables>;
export const GetSingleQuestionPropertiesByStatusAndLocationDocument = gql`
    query getSingleQuestionPropertiesByStatusAndLocation($input: GetSingleQuestionPropertiesByStatusAndLocationInputType!) {
  qctGetSingleQuestionPropertiesByStatusAndLocation(input: $input) {
    locationType
    locationId
    questionProperties {
      tags {
        id
        name
      }
      totalQuestions
    }
  }
}
    `;

/**
 * __useGetSingleQuestionPropertiesByStatusAndLocationQuery__
 *
 * To run a query within a React component, call `useGetSingleQuestionPropertiesByStatusAndLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleQuestionPropertiesByStatusAndLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleQuestionPropertiesByStatusAndLocationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSingleQuestionPropertiesByStatusAndLocationQuery(baseOptions: Apollo.QueryHookOptions<GetSingleQuestionPropertiesByStatusAndLocationQuery, GetSingleQuestionPropertiesByStatusAndLocationQueryVariables> & ({ variables: GetSingleQuestionPropertiesByStatusAndLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleQuestionPropertiesByStatusAndLocationQuery, GetSingleQuestionPropertiesByStatusAndLocationQueryVariables>(GetSingleQuestionPropertiesByStatusAndLocationDocument, options);
      }
export function useGetSingleQuestionPropertiesByStatusAndLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleQuestionPropertiesByStatusAndLocationQuery, GetSingleQuestionPropertiesByStatusAndLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleQuestionPropertiesByStatusAndLocationQuery, GetSingleQuestionPropertiesByStatusAndLocationQueryVariables>(GetSingleQuestionPropertiesByStatusAndLocationDocument, options);
        }
// @ts-ignore
export function useGetSingleQuestionPropertiesByStatusAndLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSingleQuestionPropertiesByStatusAndLocationQuery, GetSingleQuestionPropertiesByStatusAndLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleQuestionPropertiesByStatusAndLocationQuery, GetSingleQuestionPropertiesByStatusAndLocationQueryVariables>;
export function useGetSingleQuestionPropertiesByStatusAndLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleQuestionPropertiesByStatusAndLocationQuery, GetSingleQuestionPropertiesByStatusAndLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleQuestionPropertiesByStatusAndLocationQuery | undefined, GetSingleQuestionPropertiesByStatusAndLocationQueryVariables>;
export function useGetSingleQuestionPropertiesByStatusAndLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleQuestionPropertiesByStatusAndLocationQuery, GetSingleQuestionPropertiesByStatusAndLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleQuestionPropertiesByStatusAndLocationQuery, GetSingleQuestionPropertiesByStatusAndLocationQueryVariables>(GetSingleQuestionPropertiesByStatusAndLocationDocument, options);
        }
export type GetSingleQuestionPropertiesByStatusAndLocationQueryHookResult = ReturnType<typeof useGetSingleQuestionPropertiesByStatusAndLocationQuery>;
export type GetSingleQuestionPropertiesByStatusAndLocationLazyQueryHookResult = ReturnType<typeof useGetSingleQuestionPropertiesByStatusAndLocationLazyQuery>;
export type GetSingleQuestionPropertiesByStatusAndLocationSuspenseQueryHookResult = ReturnType<typeof useGetSingleQuestionPropertiesByStatusAndLocationSuspenseQuery>;
export type GetSingleQuestionPropertiesByStatusAndLocationQueryResult = Apollo.QueryResult<GetSingleQuestionPropertiesByStatusAndLocationQuery, GetSingleQuestionPropertiesByStatusAndLocationQueryVariables>;
export const GetItemSetQuestionPropertiesByStatusAndLocationDocument = gql`
    query getItemSetQuestionPropertiesByStatusAndLocation($input: GetItemSetQuestionPropertiesByStatusAndLocationInputType!) {
  qctGetItemSetQuestionPropertiesByStatusAndLocation(input: $input) {
    locationType
    locationId
    size
    questionProperties {
      tagGroups {
        tags {
          id
          name
        }
        count
      }
      totalQuestions
    }
  }
}
    `;

/**
 * __useGetItemSetQuestionPropertiesByStatusAndLocationQuery__
 *
 * To run a query within a React component, call `useGetItemSetQuestionPropertiesByStatusAndLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemSetQuestionPropertiesByStatusAndLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemSetQuestionPropertiesByStatusAndLocationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetItemSetQuestionPropertiesByStatusAndLocationQuery(baseOptions: Apollo.QueryHookOptions<GetItemSetQuestionPropertiesByStatusAndLocationQuery, GetItemSetQuestionPropertiesByStatusAndLocationQueryVariables> & ({ variables: GetItemSetQuestionPropertiesByStatusAndLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItemSetQuestionPropertiesByStatusAndLocationQuery, GetItemSetQuestionPropertiesByStatusAndLocationQueryVariables>(GetItemSetQuestionPropertiesByStatusAndLocationDocument, options);
      }
export function useGetItemSetQuestionPropertiesByStatusAndLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItemSetQuestionPropertiesByStatusAndLocationQuery, GetItemSetQuestionPropertiesByStatusAndLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItemSetQuestionPropertiesByStatusAndLocationQuery, GetItemSetQuestionPropertiesByStatusAndLocationQueryVariables>(GetItemSetQuestionPropertiesByStatusAndLocationDocument, options);
        }
// @ts-ignore
export function useGetItemSetQuestionPropertiesByStatusAndLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItemSetQuestionPropertiesByStatusAndLocationQuery, GetItemSetQuestionPropertiesByStatusAndLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GetItemSetQuestionPropertiesByStatusAndLocationQuery, GetItemSetQuestionPropertiesByStatusAndLocationQueryVariables>;
export function useGetItemSetQuestionPropertiesByStatusAndLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetItemSetQuestionPropertiesByStatusAndLocationQuery, GetItemSetQuestionPropertiesByStatusAndLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GetItemSetQuestionPropertiesByStatusAndLocationQuery | undefined, GetItemSetQuestionPropertiesByStatusAndLocationQueryVariables>;
export function useGetItemSetQuestionPropertiesByStatusAndLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetItemSetQuestionPropertiesByStatusAndLocationQuery, GetItemSetQuestionPropertiesByStatusAndLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItemSetQuestionPropertiesByStatusAndLocationQuery, GetItemSetQuestionPropertiesByStatusAndLocationQueryVariables>(GetItemSetQuestionPropertiesByStatusAndLocationDocument, options);
        }
export type GetItemSetQuestionPropertiesByStatusAndLocationQueryHookResult = ReturnType<typeof useGetItemSetQuestionPropertiesByStatusAndLocationQuery>;
export type GetItemSetQuestionPropertiesByStatusAndLocationLazyQueryHookResult = ReturnType<typeof useGetItemSetQuestionPropertiesByStatusAndLocationLazyQuery>;
export type GetItemSetQuestionPropertiesByStatusAndLocationSuspenseQueryHookResult = ReturnType<typeof useGetItemSetQuestionPropertiesByStatusAndLocationSuspenseQuery>;
export type GetItemSetQuestionPropertiesByStatusAndLocationQueryResult = Apollo.QueryResult<GetItemSetQuestionPropertiesByStatusAndLocationQuery, GetItemSetQuestionPropertiesByStatusAndLocationQueryVariables>;
export const GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationDocument = gql`
    query getSingleQuestionQuestionGroupPropertiesByStatusAndLocation($input: GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationInputType!) {
  qctGetSingleQuestionQuestionGroupPropertiesByStatusAndLocation(input: $input) {
    locationType
    locationId
    questionGroupProperties {
      questionGroupType
      totalQuestionGroups
      totalQuestions
      questionProperties {
        tags {
          id
          name
        }
        totalQuestions
      }
    }
  }
}
    `;

/**
 * __useGetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery__
 *
 * To run a query within a React component, call `useGetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery(baseOptions: Apollo.QueryHookOptions<GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery, GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryVariables> & ({ variables: GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery, GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryVariables>(GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationDocument, options);
      }
export function useGetSingleQuestionQuestionGroupPropertiesByStatusAndLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery, GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery, GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryVariables>(GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationDocument, options);
        }
// @ts-ignore
export function useGetSingleQuestionQuestionGroupPropertiesByStatusAndLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery, GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery, GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryVariables>;
export function useGetSingleQuestionQuestionGroupPropertiesByStatusAndLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery, GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery | undefined, GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryVariables>;
export function useGetSingleQuestionQuestionGroupPropertiesByStatusAndLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery, GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery, GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryVariables>(GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationDocument, options);
        }
export type GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryHookResult = ReturnType<typeof useGetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery>;
export type GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationLazyQueryHookResult = ReturnType<typeof useGetSingleQuestionQuestionGroupPropertiesByStatusAndLocationLazyQuery>;
export type GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationSuspenseQueryHookResult = ReturnType<typeof useGetSingleQuestionQuestionGroupPropertiesByStatusAndLocationSuspenseQuery>;
export type GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryResult = Apollo.QueryResult<GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQuery, GetSingleQuestionQuestionGroupPropertiesByStatusAndLocationQueryVariables>;
export const SearchQContentAuditLogsDocument = gql`
    query searchQContentAuditLogs($input: SearchQContentAuditLogsInputType!) {
  qctSearchQContentAuditLogs(input: $input) {
    qContentAuditLogs {
      id
      action
      fullName
      detail
      actionTime
    }
    total
  }
}
    `;

/**
 * __useSearchQContentAuditLogsQuery__
 *
 * To run a query within a React component, call `useSearchQContentAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQContentAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQContentAuditLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchQContentAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<SearchQContentAuditLogsQuery, SearchQContentAuditLogsQueryVariables> & ({ variables: SearchQContentAuditLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQContentAuditLogsQuery, SearchQContentAuditLogsQueryVariables>(SearchQContentAuditLogsDocument, options);
      }
export function useSearchQContentAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQContentAuditLogsQuery, SearchQContentAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQContentAuditLogsQuery, SearchQContentAuditLogsQueryVariables>(SearchQContentAuditLogsDocument, options);
        }
// @ts-ignore
export function useSearchQContentAuditLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQContentAuditLogsQuery, SearchQContentAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQContentAuditLogsQuery, SearchQContentAuditLogsQueryVariables>;
export function useSearchQContentAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQContentAuditLogsQuery, SearchQContentAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQContentAuditLogsQuery | undefined, SearchQContentAuditLogsQueryVariables>;
export function useSearchQContentAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQContentAuditLogsQuery, SearchQContentAuditLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQContentAuditLogsQuery, SearchQContentAuditLogsQueryVariables>(SearchQContentAuditLogsDocument, options);
        }
export type SearchQContentAuditLogsQueryHookResult = ReturnType<typeof useSearchQContentAuditLogsQuery>;
export type SearchQContentAuditLogsLazyQueryHookResult = ReturnType<typeof useSearchQContentAuditLogsLazyQuery>;
export type SearchQContentAuditLogsSuspenseQueryHookResult = ReturnType<typeof useSearchQContentAuditLogsSuspenseQuery>;
export type SearchQContentAuditLogsQueryResult = Apollo.QueryResult<SearchQContentAuditLogsQuery, SearchQContentAuditLogsQueryVariables>;
export const GetQuestionUsageByIdDocument = gql`
    query getQuestionUsageById($questionId: String!) {
  qctGetQuestionUsageById(id: $questionId) {
    qSetQuestionId
    qSetQuestionOrder
    qSetCode
    qSetStatus
    examCourseCode
    examCourseName
    qConfigRefCode
  }
}
    `;

/**
 * __useGetQuestionUsageByIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionUsageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionUsageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionUsageByIdQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useGetQuestionUsageByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionUsageByIdQuery, GetQuestionUsageByIdQueryVariables> & ({ variables: GetQuestionUsageByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionUsageByIdQuery, GetQuestionUsageByIdQueryVariables>(GetQuestionUsageByIdDocument, options);
      }
export function useGetQuestionUsageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionUsageByIdQuery, GetQuestionUsageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionUsageByIdQuery, GetQuestionUsageByIdQueryVariables>(GetQuestionUsageByIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionUsageByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionUsageByIdQuery, GetQuestionUsageByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionUsageByIdQuery, GetQuestionUsageByIdQueryVariables>;
export function useGetQuestionUsageByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionUsageByIdQuery, GetQuestionUsageByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionUsageByIdQuery | undefined, GetQuestionUsageByIdQueryVariables>;
export function useGetQuestionUsageByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionUsageByIdQuery, GetQuestionUsageByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionUsageByIdQuery, GetQuestionUsageByIdQueryVariables>(GetQuestionUsageByIdDocument, options);
        }
export type GetQuestionUsageByIdQueryHookResult = ReturnType<typeof useGetQuestionUsageByIdQuery>;
export type GetQuestionUsageByIdLazyQueryHookResult = ReturnType<typeof useGetQuestionUsageByIdLazyQuery>;
export type GetQuestionUsageByIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionUsageByIdSuspenseQuery>;
export type GetQuestionUsageByIdQueryResult = Apollo.QueryResult<GetQuestionUsageByIdQuery, GetQuestionUsageByIdQueryVariables>;
export const SearchQuestionsByLosDocument = gql`
    query searchQuestionsByLOS($search: SearchQuestionsInLearningObjectiveStatementInput!, $order: OrderInput!, $paging: PageInput!) {
  qctSearchQuestionsInLearningObjectiveStatement(
    search: $search
    order: $order
    paging: $paging
  ) {
    questions {
      id
      refCode
      status
      questionGroup {
        id
        name
        type
      }
    }
    total
  }
}
    `;

/**
 * __useSearchQuestionsByLosQuery__
 *
 * To run a query within a React component, call `useSearchQuestionsByLosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuestionsByLosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuestionsByLosQuery({
 *   variables: {
 *      search: // value for 'search'
 *      order: // value for 'order'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useSearchQuestionsByLosQuery(baseOptions: Apollo.QueryHookOptions<SearchQuestionsByLosQuery, SearchQuestionsByLosQueryVariables> & ({ variables: SearchQuestionsByLosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuestionsByLosQuery, SearchQuestionsByLosQueryVariables>(SearchQuestionsByLosDocument, options);
      }
export function useSearchQuestionsByLosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuestionsByLosQuery, SearchQuestionsByLosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuestionsByLosQuery, SearchQuestionsByLosQueryVariables>(SearchQuestionsByLosDocument, options);
        }
// @ts-ignore
export function useSearchQuestionsByLosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQuestionsByLosQuery, SearchQuestionsByLosQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionsByLosQuery, SearchQuestionsByLosQueryVariables>;
export function useSearchQuestionsByLosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionsByLosQuery, SearchQuestionsByLosQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionsByLosQuery | undefined, SearchQuestionsByLosQueryVariables>;
export function useSearchQuestionsByLosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionsByLosQuery, SearchQuestionsByLosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuestionsByLosQuery, SearchQuestionsByLosQueryVariables>(SearchQuestionsByLosDocument, options);
        }
export type SearchQuestionsByLosQueryHookResult = ReturnType<typeof useSearchQuestionsByLosQuery>;
export type SearchQuestionsByLosLazyQueryHookResult = ReturnType<typeof useSearchQuestionsByLosLazyQuery>;
export type SearchQuestionsByLosSuspenseQueryHookResult = ReturnType<typeof useSearchQuestionsByLosSuspenseQuery>;
export type SearchQuestionsByLosQueryResult = Apollo.QueryResult<SearchQuestionsByLosQuery, SearchQuestionsByLosQueryVariables>;
export const SearchQuestionsByKeywordDocument = gql`
    query searchQuestionsByKeyword($input: SearchQuestionsByKeywordInput!, $paging: PageInput!) {
  qctSearchQuestionsByKeyword(input: $input, paging: $paging) {
    total
    items {
      id
      refCode
      details
      type
      status
      pValue
      bIndexValue
      metadata {
        reference
        firstPublishedAt
        audit1
        audit2
        audit3
        choices {
          label
          order
          value
        }
        owner {
          type
          value
        }
      }
      correctAnswer {
        value
      }
      solution {
        type
        value
      }
      questionGroupId
      groupOrder
      refQBankStructureId
      createdBy
      lastPublishedBy
      lastPublishedAt
      locationIds
      questionGroup {
        id
        name
        type
        status
        paragraph
        size
      }
      tags {
        id
        name
        category
      }
      updatedAt
    }
  }
}
    `;

/**
 * __useSearchQuestionsByKeywordQuery__
 *
 * To run a query within a React component, call `useSearchQuestionsByKeywordQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuestionsByKeywordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuestionsByKeywordQuery({
 *   variables: {
 *      input: // value for 'input'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useSearchQuestionsByKeywordQuery(baseOptions: Apollo.QueryHookOptions<SearchQuestionsByKeywordQuery, SearchQuestionsByKeywordQueryVariables> & ({ variables: SearchQuestionsByKeywordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuestionsByKeywordQuery, SearchQuestionsByKeywordQueryVariables>(SearchQuestionsByKeywordDocument, options);
      }
export function useSearchQuestionsByKeywordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuestionsByKeywordQuery, SearchQuestionsByKeywordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuestionsByKeywordQuery, SearchQuestionsByKeywordQueryVariables>(SearchQuestionsByKeywordDocument, options);
        }
// @ts-ignore
export function useSearchQuestionsByKeywordSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQuestionsByKeywordQuery, SearchQuestionsByKeywordQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionsByKeywordQuery, SearchQuestionsByKeywordQueryVariables>;
export function useSearchQuestionsByKeywordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionsByKeywordQuery, SearchQuestionsByKeywordQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionsByKeywordQuery | undefined, SearchQuestionsByKeywordQueryVariables>;
export function useSearchQuestionsByKeywordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionsByKeywordQuery, SearchQuestionsByKeywordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuestionsByKeywordQuery, SearchQuestionsByKeywordQueryVariables>(SearchQuestionsByKeywordDocument, options);
        }
export type SearchQuestionsByKeywordQueryHookResult = ReturnType<typeof useSearchQuestionsByKeywordQuery>;
export type SearchQuestionsByKeywordLazyQueryHookResult = ReturnType<typeof useSearchQuestionsByKeywordLazyQuery>;
export type SearchQuestionsByKeywordSuspenseQueryHookResult = ReturnType<typeof useSearchQuestionsByKeywordSuspenseQuery>;
export type SearchQuestionsByKeywordQueryResult = Apollo.QueryResult<SearchQuestionsByKeywordQuery, SearchQuestionsByKeywordQueryVariables>;
export const SearchQuestionsByQIdsDocument = gql`
    query searchQuestionsByQIds($input: SearchQuestionsByQIdsInput!, $paging: PageInput!) {
  qctSearchQuestionsByQIds(input: $input, paging: $paging) {
    total
    items {
      id
      refCode
      details
      type
      status
      pValue
      bIndexValue
      metadata {
        reference
        firstPublishedAt
        audit1
        audit2
        audit3
        choices {
          label
          order
          value
        }
        owner {
          type
          value
        }
      }
      correctAnswer {
        value
      }
      solution {
        type
        value
      }
      questionGroupId
      groupOrder
      refQBankStructureId
      createdBy
      lastPublishedBy
      lastPublishedAt
      locationIds
      questionGroup {
        id
        name
        type
        status
        paragraph
        size
      }
      tags {
        id
        name
        category
      }
      updatedAt
    }
    foundQIds
    notFoundQIds
  }
}
    `;

/**
 * __useSearchQuestionsByQIdsQuery__
 *
 * To run a query within a React component, call `useSearchQuestionsByQIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuestionsByQIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuestionsByQIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useSearchQuestionsByQIdsQuery(baseOptions: Apollo.QueryHookOptions<SearchQuestionsByQIdsQuery, SearchQuestionsByQIdsQueryVariables> & ({ variables: SearchQuestionsByQIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuestionsByQIdsQuery, SearchQuestionsByQIdsQueryVariables>(SearchQuestionsByQIdsDocument, options);
      }
export function useSearchQuestionsByQIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuestionsByQIdsQuery, SearchQuestionsByQIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuestionsByQIdsQuery, SearchQuestionsByQIdsQueryVariables>(SearchQuestionsByQIdsDocument, options);
        }
// @ts-ignore
export function useSearchQuestionsByQIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQuestionsByQIdsQuery, SearchQuestionsByQIdsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionsByQIdsQuery, SearchQuestionsByQIdsQueryVariables>;
export function useSearchQuestionsByQIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionsByQIdsQuery, SearchQuestionsByQIdsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionsByQIdsQuery | undefined, SearchQuestionsByQIdsQueryVariables>;
export function useSearchQuestionsByQIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionsByQIdsQuery, SearchQuestionsByQIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuestionsByQIdsQuery, SearchQuestionsByQIdsQueryVariables>(SearchQuestionsByQIdsDocument, options);
        }
export type SearchQuestionsByQIdsQueryHookResult = ReturnType<typeof useSearchQuestionsByQIdsQuery>;
export type SearchQuestionsByQIdsLazyQueryHookResult = ReturnType<typeof useSearchQuestionsByQIdsLazyQuery>;
export type SearchQuestionsByQIdsSuspenseQueryHookResult = ReturnType<typeof useSearchQuestionsByQIdsSuspenseQuery>;
export type SearchQuestionsByQIdsQueryResult = Apollo.QueryResult<SearchQuestionsByQIdsQuery, SearchQuestionsByQIdsQueryVariables>;
export const ExportSearchResultsDocument = gql`
    mutation exportSearchResults($input: ExportSearchResultsInput!) {
  qctExportSearchResults(input: $input) {
    message
  }
}
    `;
export type ExportSearchResultsMutationFn = Apollo.MutationFunction<ExportSearchResultsMutation, ExportSearchResultsMutationVariables>;

/**
 * __useExportSearchResultsMutation__
 *
 * To run a mutation, you first call `useExportSearchResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSearchResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSearchResultsMutation, { data, loading, error }] = useExportSearchResultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportSearchResultsMutation(baseOptions?: Apollo.MutationHookOptions<ExportSearchResultsMutation, ExportSearchResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportSearchResultsMutation, ExportSearchResultsMutationVariables>(ExportSearchResultsDocument, options);
      }
export type ExportSearchResultsMutationHookResult = ReturnType<typeof useExportSearchResultsMutation>;
export type ExportSearchResultsMutationResult = Apollo.MutationResult<ExportSearchResultsMutation>;
export type ExportSearchResultsMutationOptions = Apollo.BaseMutationOptions<ExportSearchResultsMutation, ExportSearchResultsMutationVariables>;
export const GetAppPermissionsDocument = gql`
    query getAppPermissions {
  getAppPermissions {
    id
  }
}
    `;

/**
 * __useGetAppPermissionsQuery__
 *
 * To run a query within a React component, call `useGetAppPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAppPermissionsQuery, GetAppPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppPermissionsQuery, GetAppPermissionsQueryVariables>(GetAppPermissionsDocument, options);
      }
export function useGetAppPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppPermissionsQuery, GetAppPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppPermissionsQuery, GetAppPermissionsQueryVariables>(GetAppPermissionsDocument, options);
        }
// @ts-ignore
export function useGetAppPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppPermissionsQuery, GetAppPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppPermissionsQuery, GetAppPermissionsQueryVariables>;
export function useGetAppPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppPermissionsQuery, GetAppPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppPermissionsQuery | undefined, GetAppPermissionsQueryVariables>;
export function useGetAppPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppPermissionsQuery, GetAppPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppPermissionsQuery, GetAppPermissionsQueryVariables>(GetAppPermissionsDocument, options);
        }
export type GetAppPermissionsQueryHookResult = ReturnType<typeof useGetAppPermissionsQuery>;
export type GetAppPermissionsLazyQueryHookResult = ReturnType<typeof useGetAppPermissionsLazyQuery>;
export type GetAppPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetAppPermissionsSuspenseQuery>;
export type GetAppPermissionsQueryResult = Apollo.QueryResult<GetAppPermissionsQuery, GetAppPermissionsQueryVariables>;
export const GetAppRoleAppPermissionsDocument = gql`
    query getAppRoleAppPermissions($appRoleId: String!) {
  getAppRoleAppPermissions(appRoleId: $appRoleId) {
    id
  }
}
    `;

/**
 * __useGetAppRoleAppPermissionsQuery__
 *
 * To run a query within a React component, call `useGetAppRoleAppPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppRoleAppPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppRoleAppPermissionsQuery({
 *   variables: {
 *      appRoleId: // value for 'appRoleId'
 *   },
 * });
 */
export function useGetAppRoleAppPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetAppRoleAppPermissionsQuery, GetAppRoleAppPermissionsQueryVariables> & ({ variables: GetAppRoleAppPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppRoleAppPermissionsQuery, GetAppRoleAppPermissionsQueryVariables>(GetAppRoleAppPermissionsDocument, options);
      }
export function useGetAppRoleAppPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppRoleAppPermissionsQuery, GetAppRoleAppPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppRoleAppPermissionsQuery, GetAppRoleAppPermissionsQueryVariables>(GetAppRoleAppPermissionsDocument, options);
        }
// @ts-ignore
export function useGetAppRoleAppPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppRoleAppPermissionsQuery, GetAppRoleAppPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppRoleAppPermissionsQuery, GetAppRoleAppPermissionsQueryVariables>;
export function useGetAppRoleAppPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppRoleAppPermissionsQuery, GetAppRoleAppPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppRoleAppPermissionsQuery | undefined, GetAppRoleAppPermissionsQueryVariables>;
export function useGetAppRoleAppPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppRoleAppPermissionsQuery, GetAppRoleAppPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppRoleAppPermissionsQuery, GetAppRoleAppPermissionsQueryVariables>(GetAppRoleAppPermissionsDocument, options);
        }
export type GetAppRoleAppPermissionsQueryHookResult = ReturnType<typeof useGetAppRoleAppPermissionsQuery>;
export type GetAppRoleAppPermissionsLazyQueryHookResult = ReturnType<typeof useGetAppRoleAppPermissionsLazyQuery>;
export type GetAppRoleAppPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetAppRoleAppPermissionsSuspenseQuery>;
export type GetAppRoleAppPermissionsQueryResult = Apollo.QueryResult<GetAppRoleAppPermissionsQuery, GetAppRoleAppPermissionsQueryVariables>;
export const UpdateAppRoleAppPermissionsDocument = gql`
    mutation updateAppRoleAppPermissions($appPermissionIds: [String!]!, $updateAppRoleAppPermissionsAppRoleId: String!) {
  suUpdateAppRoleAppPermissions(
    appPermissionIds: $appPermissionIds
    appRoleId: $updateAppRoleAppPermissionsAppRoleId
  ) {
    code
    message
    success
  }
}
    `;
export type UpdateAppRoleAppPermissionsMutationFn = Apollo.MutationFunction<UpdateAppRoleAppPermissionsMutation, UpdateAppRoleAppPermissionsMutationVariables>;

/**
 * __useUpdateAppRoleAppPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateAppRoleAppPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppRoleAppPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppRoleAppPermissionsMutation, { data, loading, error }] = useUpdateAppRoleAppPermissionsMutation({
 *   variables: {
 *      appPermissionIds: // value for 'appPermissionIds'
 *      updateAppRoleAppPermissionsAppRoleId: // value for 'updateAppRoleAppPermissionsAppRoleId'
 *   },
 * });
 */
export function useUpdateAppRoleAppPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppRoleAppPermissionsMutation, UpdateAppRoleAppPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppRoleAppPermissionsMutation, UpdateAppRoleAppPermissionsMutationVariables>(UpdateAppRoleAppPermissionsDocument, options);
      }
export type UpdateAppRoleAppPermissionsMutationHookResult = ReturnType<typeof useUpdateAppRoleAppPermissionsMutation>;
export type UpdateAppRoleAppPermissionsMutationResult = Apollo.MutationResult<UpdateAppRoleAppPermissionsMutation>;
export type UpdateAppRoleAppPermissionsMutationOptions = Apollo.BaseMutationOptions<UpdateAppRoleAppPermissionsMutation, UpdateAppRoleAppPermissionsMutationVariables>;
export const CreateAppRoleDocument = gql`
    mutation createAppRole($data: CreateAppRoleInput!) {
  suCreateAppRole(data: $data) {
    code
    success
    message
    details
    newAppRole {
      name
      description
      id
    }
  }
}
    `;
export type CreateAppRoleMutationFn = Apollo.MutationFunction<CreateAppRoleMutation, CreateAppRoleMutationVariables>;

/**
 * __useCreateAppRoleMutation__
 *
 * To run a mutation, you first call `useCreateAppRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppRoleMutation, { data, loading, error }] = useCreateAppRoleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAppRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppRoleMutation, CreateAppRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppRoleMutation, CreateAppRoleMutationVariables>(CreateAppRoleDocument, options);
      }
export type CreateAppRoleMutationHookResult = ReturnType<typeof useCreateAppRoleMutation>;
export type CreateAppRoleMutationResult = Apollo.MutationResult<CreateAppRoleMutation>;
export type CreateAppRoleMutationOptions = Apollo.BaseMutationOptions<CreateAppRoleMutation, CreateAppRoleMutationVariables>;
export const UpdateAppRoleDocument = gql`
    mutation updateAppRole($data: UpdateAppRoleInput!) {
  suUpdateAppRole(data: $data) {
    code
    success
    message
    details
    appRole {
      id
      name
      description
    }
  }
}
    `;
export type UpdateAppRoleMutationFn = Apollo.MutationFunction<UpdateAppRoleMutation, UpdateAppRoleMutationVariables>;

/**
 * __useUpdateAppRoleMutation__
 *
 * To run a mutation, you first call `useUpdateAppRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppRoleMutation, { data, loading, error }] = useUpdateAppRoleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAppRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppRoleMutation, UpdateAppRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppRoleMutation, UpdateAppRoleMutationVariables>(UpdateAppRoleDocument, options);
      }
export type UpdateAppRoleMutationHookResult = ReturnType<typeof useUpdateAppRoleMutation>;
export type UpdateAppRoleMutationResult = Apollo.MutationResult<UpdateAppRoleMutation>;
export type UpdateAppRoleMutationOptions = Apollo.BaseMutationOptions<UpdateAppRoleMutation, UpdateAppRoleMutationVariables>;
export const DeleteAppRoleDocument = gql`
    mutation deleteAppRole($data: DeleteAppRoleInput!) {
  suDeleteAppRole(data: $data) {
    code
    success
    message
  }
}
    `;
export type DeleteAppRoleMutationFn = Apollo.MutationFunction<DeleteAppRoleMutation, DeleteAppRoleMutationVariables>;

/**
 * __useDeleteAppRoleMutation__
 *
 * To run a mutation, you first call `useDeleteAppRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppRoleMutation, { data, loading, error }] = useDeleteAppRoleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteAppRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAppRoleMutation, DeleteAppRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAppRoleMutation, DeleteAppRoleMutationVariables>(DeleteAppRoleDocument, options);
      }
export type DeleteAppRoleMutationHookResult = ReturnType<typeof useDeleteAppRoleMutation>;
export type DeleteAppRoleMutationResult = Apollo.MutationResult<DeleteAppRoleMutation>;
export type DeleteAppRoleMutationOptions = Apollo.BaseMutationOptions<DeleteAppRoleMutation, DeleteAppRoleMutationVariables>;
export const GetAppRoleDocument = gql`
    query getAppRole($appRoleId: String!) {
  suGetAppRole(appRoleId: $appRoleId) {
    id
    name
    description
  }
}
    `;

/**
 * __useGetAppRoleQuery__
 *
 * To run a query within a React component, call `useGetAppRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppRoleQuery({
 *   variables: {
 *      appRoleId: // value for 'appRoleId'
 *   },
 * });
 */
export function useGetAppRoleQuery(baseOptions: Apollo.QueryHookOptions<GetAppRoleQuery, GetAppRoleQueryVariables> & ({ variables: GetAppRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppRoleQuery, GetAppRoleQueryVariables>(GetAppRoleDocument, options);
      }
export function useGetAppRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppRoleQuery, GetAppRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppRoleQuery, GetAppRoleQueryVariables>(GetAppRoleDocument, options);
        }
// @ts-ignore
export function useGetAppRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppRoleQuery, GetAppRoleQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppRoleQuery, GetAppRoleQueryVariables>;
export function useGetAppRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppRoleQuery, GetAppRoleQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppRoleQuery | undefined, GetAppRoleQueryVariables>;
export function useGetAppRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppRoleQuery, GetAppRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppRoleQuery, GetAppRoleQueryVariables>(GetAppRoleDocument, options);
        }
export type GetAppRoleQueryHookResult = ReturnType<typeof useGetAppRoleQuery>;
export type GetAppRoleLazyQueryHookResult = ReturnType<typeof useGetAppRoleLazyQuery>;
export type GetAppRoleSuspenseQueryHookResult = ReturnType<typeof useGetAppRoleSuspenseQuery>;
export type GetAppRoleQueryResult = Apollo.QueryResult<GetAppRoleQuery, GetAppRoleQueryVariables>;
export const GetAppRolesDocument = gql`
    query getAppRoles($order: OrderInput, $paging: PageInput, $search: AppRoleSearchInput) {
  getAppRoles(order: $order, paging: $paging, search: $search) {
    total
    roles {
      name
      id
      description
    }
  }
}
    `;

/**
 * __useGetAppRolesQuery__
 *
 * To run a query within a React component, call `useGetAppRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppRolesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      paging: // value for 'paging'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAppRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetAppRolesQuery, GetAppRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppRolesQuery, GetAppRolesQueryVariables>(GetAppRolesDocument, options);
      }
export function useGetAppRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppRolesQuery, GetAppRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppRolesQuery, GetAppRolesQueryVariables>(GetAppRolesDocument, options);
        }
// @ts-ignore
export function useGetAppRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppRolesQuery, GetAppRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppRolesQuery, GetAppRolesQueryVariables>;
export function useGetAppRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppRolesQuery, GetAppRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppRolesQuery | undefined, GetAppRolesQueryVariables>;
export function useGetAppRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppRolesQuery, GetAppRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppRolesQuery, GetAppRolesQueryVariables>(GetAppRolesDocument, options);
        }
export type GetAppRolesQueryHookResult = ReturnType<typeof useGetAppRolesQuery>;
export type GetAppRolesLazyQueryHookResult = ReturnType<typeof useGetAppRolesLazyQuery>;
export type GetAppRolesSuspenseQueryHookResult = ReturnType<typeof useGetAppRolesSuspenseQuery>;
export type GetAppRolesQueryResult = Apollo.QueryResult<GetAppRolesQuery, GetAppRolesQueryVariables>;
export const SearchUserAppRoleViewDocument = gql`
    query searchUserAppRoleView($appRoleId: String, $invertRoleFilter: Boolean, $order: OrderInput, $paging: PageInput, $search: SearchInput) {
  getUserAppRoleView(
    appRoleId: $appRoleId
    invertRoleFilter: $invertRoleFilter
    order: $order
    paging: $paging
    search: $search
  ) {
    users {
      firstname
      lastname
      email
      id
      lastLoginAt
      status
      invitationExpireAt
    }
    total
  }
}
    `;

/**
 * __useSearchUserAppRoleViewQuery__
 *
 * To run a query within a React component, call `useSearchUserAppRoleViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserAppRoleViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserAppRoleViewQuery({
 *   variables: {
 *      appRoleId: // value for 'appRoleId'
 *      invertRoleFilter: // value for 'invertRoleFilter'
 *      order: // value for 'order'
 *      paging: // value for 'paging'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchUserAppRoleViewQuery(baseOptions?: Apollo.QueryHookOptions<SearchUserAppRoleViewQuery, SearchUserAppRoleViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUserAppRoleViewQuery, SearchUserAppRoleViewQueryVariables>(SearchUserAppRoleViewDocument, options);
      }
export function useSearchUserAppRoleViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserAppRoleViewQuery, SearchUserAppRoleViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUserAppRoleViewQuery, SearchUserAppRoleViewQueryVariables>(SearchUserAppRoleViewDocument, options);
        }
// @ts-ignore
export function useSearchUserAppRoleViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUserAppRoleViewQuery, SearchUserAppRoleViewQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUserAppRoleViewQuery, SearchUserAppRoleViewQueryVariables>;
export function useSearchUserAppRoleViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUserAppRoleViewQuery, SearchUserAppRoleViewQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUserAppRoleViewQuery | undefined, SearchUserAppRoleViewQueryVariables>;
export function useSearchUserAppRoleViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUserAppRoleViewQuery, SearchUserAppRoleViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUserAppRoleViewQuery, SearchUserAppRoleViewQueryVariables>(SearchUserAppRoleViewDocument, options);
        }
export type SearchUserAppRoleViewQueryHookResult = ReturnType<typeof useSearchUserAppRoleViewQuery>;
export type SearchUserAppRoleViewLazyQueryHookResult = ReturnType<typeof useSearchUserAppRoleViewLazyQuery>;
export type SearchUserAppRoleViewSuspenseQueryHookResult = ReturnType<typeof useSearchUserAppRoleViewSuspenseQuery>;
export type SearchUserAppRoleViewQueryResult = Apollo.QueryResult<SearchUserAppRoleViewQuery, SearchUserAppRoleViewQueryVariables>;
export const AssignUserAppRoleDocument = gql`
    mutation assignUserAppRole($data: AssignUserAppRoleInput!) {
  suAssignUserAppRole(data: $data) {
    success
    message
    code
  }
}
    `;
export type AssignUserAppRoleMutationFn = Apollo.MutationFunction<AssignUserAppRoleMutation, AssignUserAppRoleMutationVariables>;

/**
 * __useAssignUserAppRoleMutation__
 *
 * To run a mutation, you first call `useAssignUserAppRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUserAppRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUserAppRoleMutation, { data, loading, error }] = useAssignUserAppRoleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAssignUserAppRoleMutation(baseOptions?: Apollo.MutationHookOptions<AssignUserAppRoleMutation, AssignUserAppRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignUserAppRoleMutation, AssignUserAppRoleMutationVariables>(AssignUserAppRoleDocument, options);
      }
export type AssignUserAppRoleMutationHookResult = ReturnType<typeof useAssignUserAppRoleMutation>;
export type AssignUserAppRoleMutationResult = Apollo.MutationResult<AssignUserAppRoleMutation>;
export type AssignUserAppRoleMutationOptions = Apollo.BaseMutationOptions<AssignUserAppRoleMutation, AssignUserAppRoleMutationVariables>;
export const UnassignUserAppRoleDocument = gql`
    mutation unassignUserAppRole($data: UnassignUserAppRoleInput!) {
  unassignUserAppRole(data: $data) {
    success
    message
    code
  }
}
    `;
export type UnassignUserAppRoleMutationFn = Apollo.MutationFunction<UnassignUserAppRoleMutation, UnassignUserAppRoleMutationVariables>;

/**
 * __useUnassignUserAppRoleMutation__
 *
 * To run a mutation, you first call `useUnassignUserAppRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignUserAppRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignUserAppRoleMutation, { data, loading, error }] = useUnassignUserAppRoleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUnassignUserAppRoleMutation(baseOptions?: Apollo.MutationHookOptions<UnassignUserAppRoleMutation, UnassignUserAppRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignUserAppRoleMutation, UnassignUserAppRoleMutationVariables>(UnassignUserAppRoleDocument, options);
      }
export type UnassignUserAppRoleMutationHookResult = ReturnType<typeof useUnassignUserAppRoleMutation>;
export type UnassignUserAppRoleMutationResult = Apollo.MutationResult<UnassignUserAppRoleMutation>;
export type UnassignUserAppRoleMutationOptions = Apollo.BaseMutationOptions<UnassignUserAppRoleMutation, UnassignUserAppRoleMutationVariables>;
export const AssignUserAppRolesDocument = gql`
    mutation assignUserAppRoles($data: AssignUserAppRolesInput!) {
  assignUserAppRoles(data: $data) {
    code
    success
    message
  }
}
    `;
export type AssignUserAppRolesMutationFn = Apollo.MutationFunction<AssignUserAppRolesMutation, AssignUserAppRolesMutationVariables>;

/**
 * __useAssignUserAppRolesMutation__
 *
 * To run a mutation, you first call `useAssignUserAppRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUserAppRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUserAppRolesMutation, { data, loading, error }] = useAssignUserAppRolesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAssignUserAppRolesMutation(baseOptions?: Apollo.MutationHookOptions<AssignUserAppRolesMutation, AssignUserAppRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignUserAppRolesMutation, AssignUserAppRolesMutationVariables>(AssignUserAppRolesDocument, options);
      }
export type AssignUserAppRolesMutationHookResult = ReturnType<typeof useAssignUserAppRolesMutation>;
export type AssignUserAppRolesMutationResult = Apollo.MutationResult<AssignUserAppRolesMutation>;
export type AssignUserAppRolesMutationOptions = Apollo.BaseMutationOptions<AssignUserAppRolesMutation, AssignUserAppRolesMutationVariables>;
export const UnassignUserAppRolesDocument = gql`
    mutation unassignUserAppRoles($data: UnassignUserAppRolesInput!) {
  suUnassignUserAppRoles(data: $data) {
    success
    message
    code
    details
    appRoles {
      name
      level
      id
      description
    }
  }
}
    `;
export type UnassignUserAppRolesMutationFn = Apollo.MutationFunction<UnassignUserAppRolesMutation, UnassignUserAppRolesMutationVariables>;

/**
 * __useUnassignUserAppRolesMutation__
 *
 * To run a mutation, you first call `useUnassignUserAppRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignUserAppRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignUserAppRolesMutation, { data, loading, error }] = useUnassignUserAppRolesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUnassignUserAppRolesMutation(baseOptions?: Apollo.MutationHookOptions<UnassignUserAppRolesMutation, UnassignUserAppRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignUserAppRolesMutation, UnassignUserAppRolesMutationVariables>(UnassignUserAppRolesDocument, options);
      }
export type UnassignUserAppRolesMutationHookResult = ReturnType<typeof useUnassignUserAppRolesMutation>;
export type UnassignUserAppRolesMutationResult = Apollo.MutationResult<UnassignUserAppRolesMutation>;
export type UnassignUserAppRolesMutationOptions = Apollo.BaseMutationOptions<UnassignUserAppRolesMutation, UnassignUserAppRolesMutationVariables>;
export const SearchUserListDocument = gql`
    query searchUserList($order: OrderInput, $paging: PageInput, $search: UsBoUserSearchInput) {
  UsBoUsers(order: $order, paging: $paging, search: $search) {
    total
    users {
      id
      appRoles
      status
      email
      firstname
      id
      lastname
      lastLoginAt
      invitationExpireAt
    }
  }
}
    `;

/**
 * __useSearchUserListQuery__
 *
 * To run a query within a React component, call `useSearchUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserListQuery({
 *   variables: {
 *      order: // value for 'order'
 *      paging: // value for 'paging'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchUserListQuery(baseOptions?: Apollo.QueryHookOptions<SearchUserListQuery, SearchUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUserListQuery, SearchUserListQueryVariables>(SearchUserListDocument, options);
      }
export function useSearchUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserListQuery, SearchUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUserListQuery, SearchUserListQueryVariables>(SearchUserListDocument, options);
        }
// @ts-ignore
export function useSearchUserListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUserListQuery, SearchUserListQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUserListQuery, SearchUserListQueryVariables>;
export function useSearchUserListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUserListQuery, SearchUserListQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUserListQuery | undefined, SearchUserListQueryVariables>;
export function useSearchUserListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUserListQuery, SearchUserListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUserListQuery, SearchUserListQueryVariables>(SearchUserListDocument, options);
        }
export type SearchUserListQueryHookResult = ReturnType<typeof useSearchUserListQuery>;
export type SearchUserListLazyQueryHookResult = ReturnType<typeof useSearchUserListLazyQuery>;
export type SearchUserListSuspenseQueryHookResult = ReturnType<typeof useSearchUserListSuspenseQuery>;
export type SearchUserListQueryResult = Apollo.QueryResult<SearchUserListQuery, SearchUserListQueryVariables>;
export const SearchUsersByAppRoleFiltersDocument = gql`
    query searchUsersByAppRoleFilters($appRoleNames: [String!], $order: OrderInput, $paging: PageInput, $search: UsBoUserSearchInput) {
  UsBoSearchUsersWithAppRoleFilters(
    appRoleNames: $appRoleNames
    order: $order
    paging: $paging
    search: $search
  ) {
    total
    users {
      ...UsBoUser
    }
  }
}
    ${UsBoUserFragmentDoc}`;

/**
 * __useSearchUsersByAppRoleFiltersQuery__
 *
 * To run a query within a React component, call `useSearchUsersByAppRoleFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersByAppRoleFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersByAppRoleFiltersQuery({
 *   variables: {
 *      appRoleNames: // value for 'appRoleNames'
 *      order: // value for 'order'
 *      paging: // value for 'paging'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchUsersByAppRoleFiltersQuery(baseOptions?: Apollo.QueryHookOptions<SearchUsersByAppRoleFiltersQuery, SearchUsersByAppRoleFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersByAppRoleFiltersQuery, SearchUsersByAppRoleFiltersQueryVariables>(SearchUsersByAppRoleFiltersDocument, options);
      }
export function useSearchUsersByAppRoleFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersByAppRoleFiltersQuery, SearchUsersByAppRoleFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersByAppRoleFiltersQuery, SearchUsersByAppRoleFiltersQueryVariables>(SearchUsersByAppRoleFiltersDocument, options);
        }
// @ts-ignore
export function useSearchUsersByAppRoleFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUsersByAppRoleFiltersQuery, SearchUsersByAppRoleFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUsersByAppRoleFiltersQuery, SearchUsersByAppRoleFiltersQueryVariables>;
export function useSearchUsersByAppRoleFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersByAppRoleFiltersQuery, SearchUsersByAppRoleFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUsersByAppRoleFiltersQuery | undefined, SearchUsersByAppRoleFiltersQueryVariables>;
export function useSearchUsersByAppRoleFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersByAppRoleFiltersQuery, SearchUsersByAppRoleFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUsersByAppRoleFiltersQuery, SearchUsersByAppRoleFiltersQueryVariables>(SearchUsersByAppRoleFiltersDocument, options);
        }
export type SearchUsersByAppRoleFiltersQueryHookResult = ReturnType<typeof useSearchUsersByAppRoleFiltersQuery>;
export type SearchUsersByAppRoleFiltersLazyQueryHookResult = ReturnType<typeof useSearchUsersByAppRoleFiltersLazyQuery>;
export type SearchUsersByAppRoleFiltersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersByAppRoleFiltersSuspenseQuery>;
export type SearchUsersByAppRoleFiltersQueryResult = Apollo.QueryResult<SearchUsersByAppRoleFiltersQuery, SearchUsersByAppRoleFiltersQueryVariables>;
export const GetUserProfileDocument = gql`
    query getUserProfile($userId: String!) {
  UsBoUser(userId: $userId) {
    ...UsBoUser
  }
}
    ${UsBoUserFragmentDoc}`;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserProfileQuery(baseOptions: Apollo.QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables> & ({ variables: GetUserProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
      }
export function useGetUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
// @ts-ignore
export function useGetUserProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>;
export function useGetUserProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserProfileQuery | undefined, GetUserProfileQueryVariables>;
export function useGetUserProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>;
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>;
export type GetUserProfileSuspenseQueryHookResult = ReturnType<typeof useGetUserProfileSuspenseQuery>;
export type GetUserProfileQueryResult = Apollo.QueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const CreateIndividualUserDocument = gql`
    mutation createIndividualUser($quickCreateInput: QuickCreateInput!, $appRoleIds: AppRoleIdsInput) {
  suQuickCreateUser(quickCreateInput: $quickCreateInput, appRoleIds: $appRoleIds) {
    success
    message
    createdUser {
      id
    }
    appRolesResponse {
      code
      success
      message
      appRoles {
        id
      }
    }
  }
}
    `;
export type CreateIndividualUserMutationFn = Apollo.MutationFunction<CreateIndividualUserMutation, CreateIndividualUserMutationVariables>;

/**
 * __useCreateIndividualUserMutation__
 *
 * To run a mutation, you first call `useCreateIndividualUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndividualUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndividualUserMutation, { data, loading, error }] = useCreateIndividualUserMutation({
 *   variables: {
 *      quickCreateInput: // value for 'quickCreateInput'
 *      appRoleIds: // value for 'appRoleIds'
 *   },
 * });
 */
export function useCreateIndividualUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndividualUserMutation, CreateIndividualUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndividualUserMutation, CreateIndividualUserMutationVariables>(CreateIndividualUserDocument, options);
      }
export type CreateIndividualUserMutationHookResult = ReturnType<typeof useCreateIndividualUserMutation>;
export type CreateIndividualUserMutationResult = Apollo.MutationResult<CreateIndividualUserMutation>;
export type CreateIndividualUserMutationOptions = Apollo.BaseMutationOptions<CreateIndividualUserMutation, CreateIndividualUserMutationVariables>;
export const AcceptResetPasswordDocument = gql`
    mutation acceptResetPassword($newPassword: String!, $token: String!) {
  suAcceptResetPassword(newPassword: $newPassword, token: $token) {
    success
    message
  }
}
    `;
export type AcceptResetPasswordMutationFn = Apollo.MutationFunction<AcceptResetPasswordMutation, AcceptResetPasswordMutationVariables>;

/**
 * __useAcceptResetPasswordMutation__
 *
 * To run a mutation, you first call `useAcceptResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptResetPasswordMutation, { data, loading, error }] = useAcceptResetPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAcceptResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<AcceptResetPasswordMutation, AcceptResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptResetPasswordMutation, AcceptResetPasswordMutationVariables>(AcceptResetPasswordDocument, options);
      }
export type AcceptResetPasswordMutationHookResult = ReturnType<typeof useAcceptResetPasswordMutation>;
export type AcceptResetPasswordMutationResult = Apollo.MutationResult<AcceptResetPasswordMutation>;
export type AcceptResetPasswordMutationOptions = Apollo.BaseMutationOptions<AcceptResetPasswordMutation, AcceptResetPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($email: String!) {
  suResetPassword(email: $email) {
    code
    success
    message
    details
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ResendResetPasswordEmailDocument = gql`
    mutation ResendResetPasswordEmail($userId: String!) {
  suResendResetPasswordEmail(userId: $userId) {
    success
    message
  }
}
    `;
export type ResendResetPasswordEmailMutationFn = Apollo.MutationFunction<ResendResetPasswordEmailMutation, ResendResetPasswordEmailMutationVariables>;

/**
 * __useResendResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useResendResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendResetPasswordEmailMutation, { data, loading, error }] = useResendResetPasswordEmailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResendResetPasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendResetPasswordEmailMutation, ResendResetPasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendResetPasswordEmailMutation, ResendResetPasswordEmailMutationVariables>(ResendResetPasswordEmailDocument, options);
      }
export type ResendResetPasswordEmailMutationHookResult = ReturnType<typeof useResendResetPasswordEmailMutation>;
export type ResendResetPasswordEmailMutationResult = Apollo.MutationResult<ResendResetPasswordEmailMutation>;
export type ResendResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<ResendResetPasswordEmailMutation, ResendResetPasswordEmailMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($userId: String!, $data: UpdateUserInput!) {
  suUpdateUser(userId: $userId, data: $data) {
    id
    firstname
    lastname
    email
    lastLoginAt
    status
    createdAt
    invitationExpireAt
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserAppRolesDocument = gql`
    mutation updateUserAppRoles($data: UpdateUserAppRolesInput!) {
  updateUserAppRoles(data: $data) {
    code
    success
    message
  }
}
    `;
export type UpdateUserAppRolesMutationFn = Apollo.MutationFunction<UpdateUserAppRolesMutation, UpdateUserAppRolesMutationVariables>;

/**
 * __useUpdateUserAppRolesMutation__
 *
 * To run a mutation, you first call `useUpdateUserAppRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAppRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAppRolesMutation, { data, loading, error }] = useUpdateUserAppRolesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserAppRolesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAppRolesMutation, UpdateUserAppRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAppRolesMutation, UpdateUserAppRolesMutationVariables>(UpdateUserAppRolesDocument, options);
      }
export type UpdateUserAppRolesMutationHookResult = ReturnType<typeof useUpdateUserAppRolesMutation>;
export type UpdateUserAppRolesMutationResult = Apollo.MutationResult<UpdateUserAppRolesMutation>;
export type UpdateUserAppRolesMutationOptions = Apollo.BaseMutationOptions<UpdateUserAppRolesMutation, UpdateUserAppRolesMutationVariables>;
export const UpdateUserAppRoleByNamesDocument = gql`
    mutation updateUserAppRoleByNames($data: UpdateUserAppRoleByNamesInput!) {
  updateUserAppRoleByNames(data: $data) {
    code
    success
    message
  }
}
    `;
export type UpdateUserAppRoleByNamesMutationFn = Apollo.MutationFunction<UpdateUserAppRoleByNamesMutation, UpdateUserAppRoleByNamesMutationVariables>;

/**
 * __useUpdateUserAppRoleByNamesMutation__
 *
 * To run a mutation, you first call `useUpdateUserAppRoleByNamesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAppRoleByNamesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAppRoleByNamesMutation, { data, loading, error }] = useUpdateUserAppRoleByNamesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserAppRoleByNamesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAppRoleByNamesMutation, UpdateUserAppRoleByNamesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAppRoleByNamesMutation, UpdateUserAppRoleByNamesMutationVariables>(UpdateUserAppRoleByNamesDocument, options);
      }
export type UpdateUserAppRoleByNamesMutationHookResult = ReturnType<typeof useUpdateUserAppRoleByNamesMutation>;
export type UpdateUserAppRoleByNamesMutationResult = Apollo.MutationResult<UpdateUserAppRoleByNamesMutation>;
export type UpdateUserAppRoleByNamesMutationOptions = Apollo.BaseMutationOptions<UpdateUserAppRoleByNamesMutation, UpdateUserAppRoleByNamesMutationVariables>;
export const UserUpdateStatusDocument = gql`
    mutation userUpdateStatus($data: UpdateUserStatusInput!) {
  suUpdateUserStatus(data: $data) {
    code
    success
    message
  }
}
    `;
export type UserUpdateStatusMutationFn = Apollo.MutationFunction<UserUpdateStatusMutation, UserUpdateStatusMutationVariables>;

/**
 * __useUserUpdateStatusMutation__
 *
 * To run a mutation, you first call `useUserUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateStatusMutation, { data, loading, error }] = useUserUpdateStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUserUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateStatusMutation, UserUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateStatusMutation, UserUpdateStatusMutationVariables>(UserUpdateStatusDocument, options);
      }
export type UserUpdateStatusMutationHookResult = ReturnType<typeof useUserUpdateStatusMutation>;
export type UserUpdateStatusMutationResult = Apollo.MutationResult<UserUpdateStatusMutation>;
export type UserUpdateStatusMutationOptions = Apollo.BaseMutationOptions<UserUpdateStatusMutation, UserUpdateStatusMutationVariables>;
export const ValidateTokenDocument = gql`
    query ValidateToken($token: String!) {
  validateToken(token: $token) {
    description
    isValid
  }
}
    `;

/**
 * __useValidateTokenQuery__
 *
 * To run a query within a React component, call `useValidateTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateTokenQuery(baseOptions: Apollo.QueryHookOptions<ValidateTokenQuery, ValidateTokenQueryVariables> & ({ variables: ValidateTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateTokenQuery, ValidateTokenQueryVariables>(ValidateTokenDocument, options);
      }
export function useValidateTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateTokenQuery, ValidateTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateTokenQuery, ValidateTokenQueryVariables>(ValidateTokenDocument, options);
        }
// @ts-ignore
export function useValidateTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateTokenQuery, ValidateTokenQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateTokenQuery, ValidateTokenQueryVariables>;
export function useValidateTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateTokenQuery, ValidateTokenQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateTokenQuery | undefined, ValidateTokenQueryVariables>;
export function useValidateTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateTokenQuery, ValidateTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateTokenQuery, ValidateTokenQueryVariables>(ValidateTokenDocument, options);
        }
export type ValidateTokenQueryHookResult = ReturnType<typeof useValidateTokenQuery>;
export type ValidateTokenLazyQueryHookResult = ReturnType<typeof useValidateTokenLazyQuery>;
export type ValidateTokenSuspenseQueryHookResult = ReturnType<typeof useValidateTokenSuspenseQuery>;
export type ValidateTokenQueryResult = Apollo.QueryResult<ValidateTokenQuery, ValidateTokenQueryVariables>;
export const GetReviewQSetSubtaskDetailsByIdDocument = gql`
    query getReviewQSetSubtaskDetailsById($getTaskByIdInput: GetTaskByIdInput!) {
  wflGetTaskById(getTaskByIdInput: $getTaskByIdInput) {
    task {
      ownerId
      assignerId
      assignee {
        id
        firstname
        lastname
      }
      status
      currentWorkflowStep {
        workflowCode
        code
        name
      }
      dueDate
      name
      id
      workflowId
      currentWorkflowStepId
      code
      updatedAt
      parentTask {
        ownerId
        name
      }
      owner {
        id
        firstname
        lastname
      }
      metadata {
        ... on TaskMetadataWithQSet {
          qSet {
            id
            code
            pAvgValue
            status
            examCourse {
              code
              examId
              name
            }
            qConfig {
              fullScore
              totalQuestions
              metadata {
                conditions {
                  questionTypes {
                    type
                    needTotal
                  }
                  tags {
                    tag {
                      id
                      name
                    }
                    needTotal
                  }
                }
                timeLimit {
                  type
                  values {
                    order
                    value
                    qConfigStructureIds
                  }
                  total
                }
                passingCriteria {
                  type
                  value
                }
                randomConfig {
                  type
                  groupBy
                }
              }
              structures {
                id
                passingCriteria {
                  value
                  type
                }
                score
                name
                order
                category
                totalQuestions
                type
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetReviewQSetSubtaskDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetReviewQSetSubtaskDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewQSetSubtaskDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewQSetSubtaskDetailsByIdQuery({
 *   variables: {
 *      getTaskByIdInput: // value for 'getTaskByIdInput'
 *   },
 * });
 */
export function useGetReviewQSetSubtaskDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetReviewQSetSubtaskDetailsByIdQuery, GetReviewQSetSubtaskDetailsByIdQueryVariables> & ({ variables: GetReviewQSetSubtaskDetailsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewQSetSubtaskDetailsByIdQuery, GetReviewQSetSubtaskDetailsByIdQueryVariables>(GetReviewQSetSubtaskDetailsByIdDocument, options);
      }
export function useGetReviewQSetSubtaskDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewQSetSubtaskDetailsByIdQuery, GetReviewQSetSubtaskDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewQSetSubtaskDetailsByIdQuery, GetReviewQSetSubtaskDetailsByIdQueryVariables>(GetReviewQSetSubtaskDetailsByIdDocument, options);
        }
// @ts-ignore
export function useGetReviewQSetSubtaskDetailsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReviewQSetSubtaskDetailsByIdQuery, GetReviewQSetSubtaskDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetReviewQSetSubtaskDetailsByIdQuery, GetReviewQSetSubtaskDetailsByIdQueryVariables>;
export function useGetReviewQSetSubtaskDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReviewQSetSubtaskDetailsByIdQuery, GetReviewQSetSubtaskDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetReviewQSetSubtaskDetailsByIdQuery | undefined, GetReviewQSetSubtaskDetailsByIdQueryVariables>;
export function useGetReviewQSetSubtaskDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReviewQSetSubtaskDetailsByIdQuery, GetReviewQSetSubtaskDetailsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReviewQSetSubtaskDetailsByIdQuery, GetReviewQSetSubtaskDetailsByIdQueryVariables>(GetReviewQSetSubtaskDetailsByIdDocument, options);
        }
export type GetReviewQSetSubtaskDetailsByIdQueryHookResult = ReturnType<typeof useGetReviewQSetSubtaskDetailsByIdQuery>;
export type GetReviewQSetSubtaskDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetReviewQSetSubtaskDetailsByIdLazyQuery>;
export type GetReviewQSetSubtaskDetailsByIdSuspenseQueryHookResult = ReturnType<typeof useGetReviewQSetSubtaskDetailsByIdSuspenseQuery>;
export type GetReviewQSetSubtaskDetailsByIdQueryResult = Apollo.QueryResult<GetReviewQSetSubtaskDetailsByIdQuery, GetReviewQSetSubtaskDetailsByIdQueryVariables>;
export const GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdDocument = gql`
    query getQConfigDetailsFromReviewQSetSubtaskBySubtaskId($getTaskByIdInput: GetTaskByIdInput!) {
  wflGetTaskById(getTaskByIdInput: $getTaskByIdInput) {
    task {
      metadata {
        ... on TaskMetadataWithQSet {
          qSet {
            qConfig {
              metadata {
                timeLimit {
                  type
                  values {
                    order
                    value
                    qConfigStructureIds
                  }
                }
                randomConfig {
                  type
                  groupBy
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery__
 *
 * To run a query within a React component, call `useGetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery({
 *   variables: {
 *      getTaskByIdInput: // value for 'getTaskByIdInput'
 *   },
 * });
 */
export function useGetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery, GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryVariables> & ({ variables: GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery, GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryVariables>(GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdDocument, options);
      }
export function useGetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery, GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery, GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryVariables>(GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdDocument, options);
        }
// @ts-ignore
export function useGetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery, GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery, GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryVariables>;
export function useGetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery, GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery | undefined, GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryVariables>;
export function useGetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery, GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery, GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryVariables>(GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdDocument, options);
        }
export type GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryHookResult = ReturnType<typeof useGetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery>;
export type GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdLazyQueryHookResult = ReturnType<typeof useGetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdLazyQuery>;
export type GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdSuspenseQueryHookResult = ReturnType<typeof useGetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdSuspenseQuery>;
export type GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryResult = Apollo.QueryResult<GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQuery, GetQConfigDetailsFromReviewQSetSubtaskBySubtaskIdQueryVariables>;
export const GetDownloadSignedUrlForExamCourseCommentDocument = gql`
    query getDownloadSignedUrlForExamCourseComment($getDownloadSignedUrlForExamCourseCommentInput: GetDownloadSignedUrlForExamCourseCommentInput!) {
  excGetDownloadSignedUrlForExamCourseComment(
    GetDownloadSignedUrlForExamCourseCommentInput: $getDownloadSignedUrlForExamCourseCommentInput
  ) {
    signedUrls
  }
}
    `;

/**
 * __useGetDownloadSignedUrlForExamCourseCommentQuery__
 *
 * To run a query within a React component, call `useGetDownloadSignedUrlForExamCourseCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSignedUrlForExamCourseCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSignedUrlForExamCourseCommentQuery({
 *   variables: {
 *      getDownloadSignedUrlForExamCourseCommentInput: // value for 'getDownloadSignedUrlForExamCourseCommentInput'
 *   },
 * });
 */
export function useGetDownloadSignedUrlForExamCourseCommentQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadSignedUrlForExamCourseCommentQuery, GetDownloadSignedUrlForExamCourseCommentQueryVariables> & ({ variables: GetDownloadSignedUrlForExamCourseCommentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadSignedUrlForExamCourseCommentQuery, GetDownloadSignedUrlForExamCourseCommentQueryVariables>(GetDownloadSignedUrlForExamCourseCommentDocument, options);
      }
export function useGetDownloadSignedUrlForExamCourseCommentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadSignedUrlForExamCourseCommentQuery, GetDownloadSignedUrlForExamCourseCommentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadSignedUrlForExamCourseCommentQuery, GetDownloadSignedUrlForExamCourseCommentQueryVariables>(GetDownloadSignedUrlForExamCourseCommentDocument, options);
        }
// @ts-ignore
export function useGetDownloadSignedUrlForExamCourseCommentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForExamCourseCommentQuery, GetDownloadSignedUrlForExamCourseCommentQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadSignedUrlForExamCourseCommentQuery, GetDownloadSignedUrlForExamCourseCommentQueryVariables>;
export function useGetDownloadSignedUrlForExamCourseCommentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForExamCourseCommentQuery, GetDownloadSignedUrlForExamCourseCommentQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadSignedUrlForExamCourseCommentQuery | undefined, GetDownloadSignedUrlForExamCourseCommentQueryVariables>;
export function useGetDownloadSignedUrlForExamCourseCommentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForExamCourseCommentQuery, GetDownloadSignedUrlForExamCourseCommentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadSignedUrlForExamCourseCommentQuery, GetDownloadSignedUrlForExamCourseCommentQueryVariables>(GetDownloadSignedUrlForExamCourseCommentDocument, options);
        }
export type GetDownloadSignedUrlForExamCourseCommentQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamCourseCommentQuery>;
export type GetDownloadSignedUrlForExamCourseCommentLazyQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamCourseCommentLazyQuery>;
export type GetDownloadSignedUrlForExamCourseCommentSuspenseQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamCourseCommentSuspenseQuery>;
export type GetDownloadSignedUrlForExamCourseCommentQueryResult = Apollo.QueryResult<GetDownloadSignedUrlForExamCourseCommentQuery, GetDownloadSignedUrlForExamCourseCommentQueryVariables>;
export const GetUploadSignedUrlForExamCourseCommentDocument = gql`
    query getUploadSignedUrlForExamCourseComment($getUploadSignedUrlForExamCourseCommentInput: GetUploadSignedUrlForExamCourseCommentInput!) {
  excGetUploadSignedUrlForExamCourseComment(
    GetUploadSignedUrlForExamCourseCommentInput: $getUploadSignedUrlForExamCourseCommentInput
  ) {
    signedUrl
    storageObject {
      provider
      bucket
      key
      fileName
    }
  }
}
    `;

/**
 * __useGetUploadSignedUrlForExamCourseCommentQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlForExamCourseCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlForExamCourseCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlForExamCourseCommentQuery({
 *   variables: {
 *      getUploadSignedUrlForExamCourseCommentInput: // value for 'getUploadSignedUrlForExamCourseCommentInput'
 *   },
 * });
 */
export function useGetUploadSignedUrlForExamCourseCommentQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlForExamCourseCommentQuery, GetUploadSignedUrlForExamCourseCommentQueryVariables> & ({ variables: GetUploadSignedUrlForExamCourseCommentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlForExamCourseCommentQuery, GetUploadSignedUrlForExamCourseCommentQueryVariables>(GetUploadSignedUrlForExamCourseCommentDocument, options);
      }
export function useGetUploadSignedUrlForExamCourseCommentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlForExamCourseCommentQuery, GetUploadSignedUrlForExamCourseCommentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlForExamCourseCommentQuery, GetUploadSignedUrlForExamCourseCommentQueryVariables>(GetUploadSignedUrlForExamCourseCommentDocument, options);
        }
// @ts-ignore
export function useGetUploadSignedUrlForExamCourseCommentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForExamCourseCommentQuery, GetUploadSignedUrlForExamCourseCommentQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadSignedUrlForExamCourseCommentQuery, GetUploadSignedUrlForExamCourseCommentQueryVariables>;
export function useGetUploadSignedUrlForExamCourseCommentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForExamCourseCommentQuery, GetUploadSignedUrlForExamCourseCommentQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadSignedUrlForExamCourseCommentQuery | undefined, GetUploadSignedUrlForExamCourseCommentQueryVariables>;
export function useGetUploadSignedUrlForExamCourseCommentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForExamCourseCommentQuery, GetUploadSignedUrlForExamCourseCommentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlForExamCourseCommentQuery, GetUploadSignedUrlForExamCourseCommentQueryVariables>(GetUploadSignedUrlForExamCourseCommentDocument, options);
        }
export type GetUploadSignedUrlForExamCourseCommentQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForExamCourseCommentQuery>;
export type GetUploadSignedUrlForExamCourseCommentLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForExamCourseCommentLazyQuery>;
export type GetUploadSignedUrlForExamCourseCommentSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForExamCourseCommentSuspenseQuery>;
export type GetUploadSignedUrlForExamCourseCommentQueryResult = Apollo.QueryResult<GetUploadSignedUrlForExamCourseCommentQuery, GetUploadSignedUrlForExamCourseCommentQueryVariables>;
export const SubmitQSetReviewDocument = gql`
    mutation submitQSetReview($submitQSetReviewInput: SubmitQSetReviewInput!) {
  wflSubmitQSetReview(submitQSetReviewInput: $submitQSetReviewInput) {
    success
    message
    code
    missingQuestionVerdictCount
  }
}
    `;
export type SubmitQSetReviewMutationFn = Apollo.MutationFunction<SubmitQSetReviewMutation, SubmitQSetReviewMutationVariables>;

/**
 * __useSubmitQSetReviewMutation__
 *
 * To run a mutation, you first call `useSubmitQSetReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitQSetReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitQSetReviewMutation, { data, loading, error }] = useSubmitQSetReviewMutation({
 *   variables: {
 *      submitQSetReviewInput: // value for 'submitQSetReviewInput'
 *   },
 * });
 */
export function useSubmitQSetReviewMutation(baseOptions?: Apollo.MutationHookOptions<SubmitQSetReviewMutation, SubmitQSetReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitQSetReviewMutation, SubmitQSetReviewMutationVariables>(SubmitQSetReviewDocument, options);
      }
export type SubmitQSetReviewMutationHookResult = ReturnType<typeof useSubmitQSetReviewMutation>;
export type SubmitQSetReviewMutationResult = Apollo.MutationResult<SubmitQSetReviewMutation>;
export type SubmitQSetReviewMutationOptions = Apollo.BaseMutationOptions<SubmitQSetReviewMutation, SubmitQSetReviewMutationVariables>;
export const GetQBankStructureLevelsForQuestionCreationDocument = gql`
    query getQBankStructureLevelsForQuestionCreation($qBankStructureId: String!, $taskId: String!) {
  qbsGetTaskQBankStructureLevelsByQBankStructureId(
    qBankStructureId: $qBankStructureId
    taskId: $taskId
  ) {
    id
    level
    category
    enabled
  }
}
    `;

/**
 * __useGetQBankStructureLevelsForQuestionCreationQuery__
 *
 * To run a query within a React component, call `useGetQBankStructureLevelsForQuestionCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQBankStructureLevelsForQuestionCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQBankStructureLevelsForQuestionCreationQuery({
 *   variables: {
 *      qBankStructureId: // value for 'qBankStructureId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetQBankStructureLevelsForQuestionCreationQuery(baseOptions: Apollo.QueryHookOptions<GetQBankStructureLevelsForQuestionCreationQuery, GetQBankStructureLevelsForQuestionCreationQueryVariables> & ({ variables: GetQBankStructureLevelsForQuestionCreationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQBankStructureLevelsForQuestionCreationQuery, GetQBankStructureLevelsForQuestionCreationQueryVariables>(GetQBankStructureLevelsForQuestionCreationDocument, options);
      }
export function useGetQBankStructureLevelsForQuestionCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQBankStructureLevelsForQuestionCreationQuery, GetQBankStructureLevelsForQuestionCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQBankStructureLevelsForQuestionCreationQuery, GetQBankStructureLevelsForQuestionCreationQueryVariables>(GetQBankStructureLevelsForQuestionCreationDocument, options);
        }
// @ts-ignore
export function useGetQBankStructureLevelsForQuestionCreationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelsForQuestionCreationQuery, GetQBankStructureLevelsForQuestionCreationQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelsForQuestionCreationQuery, GetQBankStructureLevelsForQuestionCreationQueryVariables>;
export function useGetQBankStructureLevelsForQuestionCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelsForQuestionCreationQuery, GetQBankStructureLevelsForQuestionCreationQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelsForQuestionCreationQuery | undefined, GetQBankStructureLevelsForQuestionCreationQueryVariables>;
export function useGetQBankStructureLevelsForQuestionCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelsForQuestionCreationQuery, GetQBankStructureLevelsForQuestionCreationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQBankStructureLevelsForQuestionCreationQuery, GetQBankStructureLevelsForQuestionCreationQueryVariables>(GetQBankStructureLevelsForQuestionCreationDocument, options);
        }
export type GetQBankStructureLevelsForQuestionCreationQueryHookResult = ReturnType<typeof useGetQBankStructureLevelsForQuestionCreationQuery>;
export type GetQBankStructureLevelsForQuestionCreationLazyQueryHookResult = ReturnType<typeof useGetQBankStructureLevelsForQuestionCreationLazyQuery>;
export type GetQBankStructureLevelsForQuestionCreationSuspenseQueryHookResult = ReturnType<typeof useGetQBankStructureLevelsForQuestionCreationSuspenseQuery>;
export type GetQBankStructureLevelsForQuestionCreationQueryResult = Apollo.QueryResult<GetQBankStructureLevelsForQuestionCreationQuery, GetQBankStructureLevelsForQuestionCreationQueryVariables>;
export const GetQBankStructureLevelItemsForQuestionCreationDocument = gql`
    query getQBankStructureLevelItemsForQuestionCreation($qBankStructureId: String!, $taskId: String!) {
  qbsGetTaskQBankStructureLevelItemsByQBankStructureId(
    qBankStructureId: $qBankStructureId
    taskId: $taskId
  ) {
    id
    qBankStructureId
    tagId
    parentLevelItemId
    order
    qBankStructureLevelId
    tag {
      id
      name
    }
  }
}
    `;

/**
 * __useGetQBankStructureLevelItemsForQuestionCreationQuery__
 *
 * To run a query within a React component, call `useGetQBankStructureLevelItemsForQuestionCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQBankStructureLevelItemsForQuestionCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQBankStructureLevelItemsForQuestionCreationQuery({
 *   variables: {
 *      qBankStructureId: // value for 'qBankStructureId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetQBankStructureLevelItemsForQuestionCreationQuery(baseOptions: Apollo.QueryHookOptions<GetQBankStructureLevelItemsForQuestionCreationQuery, GetQBankStructureLevelItemsForQuestionCreationQueryVariables> & ({ variables: GetQBankStructureLevelItemsForQuestionCreationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQBankStructureLevelItemsForQuestionCreationQuery, GetQBankStructureLevelItemsForQuestionCreationQueryVariables>(GetQBankStructureLevelItemsForQuestionCreationDocument, options);
      }
export function useGetQBankStructureLevelItemsForQuestionCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQBankStructureLevelItemsForQuestionCreationQuery, GetQBankStructureLevelItemsForQuestionCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQBankStructureLevelItemsForQuestionCreationQuery, GetQBankStructureLevelItemsForQuestionCreationQueryVariables>(GetQBankStructureLevelItemsForQuestionCreationDocument, options);
        }
// @ts-ignore
export function useGetQBankStructureLevelItemsForQuestionCreationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsForQuestionCreationQuery, GetQBankStructureLevelItemsForQuestionCreationQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelItemsForQuestionCreationQuery, GetQBankStructureLevelItemsForQuestionCreationQueryVariables>;
export function useGetQBankStructureLevelItemsForQuestionCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsForQuestionCreationQuery, GetQBankStructureLevelItemsForQuestionCreationQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelItemsForQuestionCreationQuery | undefined, GetQBankStructureLevelItemsForQuestionCreationQueryVariables>;
export function useGetQBankStructureLevelItemsForQuestionCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsForQuestionCreationQuery, GetQBankStructureLevelItemsForQuestionCreationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQBankStructureLevelItemsForQuestionCreationQuery, GetQBankStructureLevelItemsForQuestionCreationQueryVariables>(GetQBankStructureLevelItemsForQuestionCreationDocument, options);
        }
export type GetQBankStructureLevelItemsForQuestionCreationQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsForQuestionCreationQuery>;
export type GetQBankStructureLevelItemsForQuestionCreationLazyQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsForQuestionCreationLazyQuery>;
export type GetQBankStructureLevelItemsForQuestionCreationSuspenseQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsForQuestionCreationSuspenseQuery>;
export type GetQBankStructureLevelItemsForQuestionCreationQueryResult = Apollo.QueryResult<GetQBankStructureLevelItemsForQuestionCreationQuery, GetQBankStructureLevelItemsForQuestionCreationQueryVariables>;
export const SearchTaskLearningObjectiveStatementsDocument = gql`
    query searchTaskLearningObjectiveStatements($taskId: String!, $search: SearchLearningObjectiveStatementsInput!, $paging: PageInput!, $order: OrderInput!) {
  qbsSearchTaskLearningObjectiveStatements(
    taskId: $taskId
    search: $search
    paging: $paging
    order: $order
  ) {
    learningObjectiveStatements {
      id
      qBankStructureId
      qBankStructureLevelItemId
      tagId
      tag {
        id
        name
      }
      updatedAt
    }
    total
  }
}
    `;

/**
 * __useSearchTaskLearningObjectiveStatementsQuery__
 *
 * To run a query within a React component, call `useSearchTaskLearningObjectiveStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTaskLearningObjectiveStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTaskLearningObjectiveStatementsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchTaskLearningObjectiveStatementsQuery(baseOptions: Apollo.QueryHookOptions<SearchTaskLearningObjectiveStatementsQuery, SearchTaskLearningObjectiveStatementsQueryVariables> & ({ variables: SearchTaskLearningObjectiveStatementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTaskLearningObjectiveStatementsQuery, SearchTaskLearningObjectiveStatementsQueryVariables>(SearchTaskLearningObjectiveStatementsDocument, options);
      }
export function useSearchTaskLearningObjectiveStatementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTaskLearningObjectiveStatementsQuery, SearchTaskLearningObjectiveStatementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTaskLearningObjectiveStatementsQuery, SearchTaskLearningObjectiveStatementsQueryVariables>(SearchTaskLearningObjectiveStatementsDocument, options);
        }
// @ts-ignore
export function useSearchTaskLearningObjectiveStatementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchTaskLearningObjectiveStatementsQuery, SearchTaskLearningObjectiveStatementsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTaskLearningObjectiveStatementsQuery, SearchTaskLearningObjectiveStatementsQueryVariables>;
export function useSearchTaskLearningObjectiveStatementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTaskLearningObjectiveStatementsQuery, SearchTaskLearningObjectiveStatementsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTaskLearningObjectiveStatementsQuery | undefined, SearchTaskLearningObjectiveStatementsQueryVariables>;
export function useSearchTaskLearningObjectiveStatementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTaskLearningObjectiveStatementsQuery, SearchTaskLearningObjectiveStatementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTaskLearningObjectiveStatementsQuery, SearchTaskLearningObjectiveStatementsQueryVariables>(SearchTaskLearningObjectiveStatementsDocument, options);
        }
export type SearchTaskLearningObjectiveStatementsQueryHookResult = ReturnType<typeof useSearchTaskLearningObjectiveStatementsQuery>;
export type SearchTaskLearningObjectiveStatementsLazyQueryHookResult = ReturnType<typeof useSearchTaskLearningObjectiveStatementsLazyQuery>;
export type SearchTaskLearningObjectiveStatementsSuspenseQueryHookResult = ReturnType<typeof useSearchTaskLearningObjectiveStatementsSuspenseQuery>;
export type SearchTaskLearningObjectiveStatementsQueryResult = Apollo.QueryResult<SearchTaskLearningObjectiveStatementsQuery, SearchTaskLearningObjectiveStatementsQueryVariables>;
export const SearchTaskTagsDocument = gql`
    query searchTaskTags($taskId: String!, $search: SearchTaskTagsInput!, $paging: PageInput!, $order: OrderInput!) {
  qbsSearchTaskTags(
    taskId: $taskId
    search: $search
    paging: $paging
    order: $order
  ) {
    tags {
      name
      id
    }
  }
}
    `;

/**
 * __useSearchTaskTagsQuery__
 *
 * To run a query within a React component, call `useSearchTaskTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTaskTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTaskTagsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchTaskTagsQuery(baseOptions: Apollo.QueryHookOptions<SearchTaskTagsQuery, SearchTaskTagsQueryVariables> & ({ variables: SearchTaskTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTaskTagsQuery, SearchTaskTagsQueryVariables>(SearchTaskTagsDocument, options);
      }
export function useSearchTaskTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTaskTagsQuery, SearchTaskTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTaskTagsQuery, SearchTaskTagsQueryVariables>(SearchTaskTagsDocument, options);
        }
// @ts-ignore
export function useSearchTaskTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchTaskTagsQuery, SearchTaskTagsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTaskTagsQuery, SearchTaskTagsQueryVariables>;
export function useSearchTaskTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTaskTagsQuery, SearchTaskTagsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTaskTagsQuery | undefined, SearchTaskTagsQueryVariables>;
export function useSearchTaskTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTaskTagsQuery, SearchTaskTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTaskTagsQuery, SearchTaskTagsQueryVariables>(SearchTaskTagsDocument, options);
        }
export type SearchTaskTagsQueryHookResult = ReturnType<typeof useSearchTaskTagsQuery>;
export type SearchTaskTagsLazyQueryHookResult = ReturnType<typeof useSearchTaskTagsLazyQuery>;
export type SearchTaskTagsSuspenseQueryHookResult = ReturnType<typeof useSearchTaskTagsSuspenseQuery>;
export type SearchTaskTagsQueryResult = Apollo.QueryResult<SearchTaskTagsQuery, SearchTaskTagsQueryVariables>;
export const CreateInDevelopmentQuestionDocument = gql`
    mutation createInDevelopmentQuestion($input: CreateInDevelopmentQuestionInput!, $taskId: String!) {
  qctCreateInDevelopmentQuestion(input: $input, taskId: $taskId) {
    id
  }
}
    `;
export type CreateInDevelopmentQuestionMutationFn = Apollo.MutationFunction<CreateInDevelopmentQuestionMutation, CreateInDevelopmentQuestionMutationVariables>;

/**
 * __useCreateInDevelopmentQuestionMutation__
 *
 * To run a mutation, you first call `useCreateInDevelopmentQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInDevelopmentQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInDevelopmentQuestionMutation, { data, loading, error }] = useCreateInDevelopmentQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCreateInDevelopmentQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateInDevelopmentQuestionMutation, CreateInDevelopmentQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInDevelopmentQuestionMutation, CreateInDevelopmentQuestionMutationVariables>(CreateInDevelopmentQuestionDocument, options);
      }
export type CreateInDevelopmentQuestionMutationHookResult = ReturnType<typeof useCreateInDevelopmentQuestionMutation>;
export type CreateInDevelopmentQuestionMutationResult = Apollo.MutationResult<CreateInDevelopmentQuestionMutation>;
export type CreateInDevelopmentQuestionMutationOptions = Apollo.BaseMutationOptions<CreateInDevelopmentQuestionMutation, CreateInDevelopmentQuestionMutationVariables>;
export const SaveInDevelopmentQuestionDocument = gql`
    mutation saveInDevelopmentQuestion($input: SaveQuestionAsDraftInput!, $taskId: String!) {
  qctSaveQuestionAsInDevelopment(input: $input, taskId: $taskId) {
    id
  }
}
    `;
export type SaveInDevelopmentQuestionMutationFn = Apollo.MutationFunction<SaveInDevelopmentQuestionMutation, SaveInDevelopmentQuestionMutationVariables>;

/**
 * __useSaveInDevelopmentQuestionMutation__
 *
 * To run a mutation, you first call `useSaveInDevelopmentQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInDevelopmentQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInDevelopmentQuestionMutation, { data, loading, error }] = useSaveInDevelopmentQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useSaveInDevelopmentQuestionMutation(baseOptions?: Apollo.MutationHookOptions<SaveInDevelopmentQuestionMutation, SaveInDevelopmentQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveInDevelopmentQuestionMutation, SaveInDevelopmentQuestionMutationVariables>(SaveInDevelopmentQuestionDocument, options);
      }
export type SaveInDevelopmentQuestionMutationHookResult = ReturnType<typeof useSaveInDevelopmentQuestionMutation>;
export type SaveInDevelopmentQuestionMutationResult = Apollo.MutationResult<SaveInDevelopmentQuestionMutation>;
export type SaveInDevelopmentQuestionMutationOptions = Apollo.BaseMutationOptions<SaveInDevelopmentQuestionMutation, SaveInDevelopmentQuestionMutationVariables>;
export const GetQuestionsByIdAndQuestionCreationTaskIdDocument = gql`
    query getQuestionsByIdAndQuestionCreationTaskId($ids: [String!]!, $taskId: String!) {
  qctGetTaskQuestionsByIds(ids: $ids, taskId: $taskId) {
    ...QuestionForQuestionCreationList
  }
}
    ${QuestionForQuestionCreationListFragmentDoc}`;

/**
 * __useGetQuestionsByIdAndQuestionCreationTaskIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionsByIdAndQuestionCreationTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsByIdAndQuestionCreationTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsByIdAndQuestionCreationTaskIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetQuestionsByIdAndQuestionCreationTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionsByIdAndQuestionCreationTaskIdQuery, GetQuestionsByIdAndQuestionCreationTaskIdQueryVariables> & ({ variables: GetQuestionsByIdAndQuestionCreationTaskIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionsByIdAndQuestionCreationTaskIdQuery, GetQuestionsByIdAndQuestionCreationTaskIdQueryVariables>(GetQuestionsByIdAndQuestionCreationTaskIdDocument, options);
      }
export function useGetQuestionsByIdAndQuestionCreationTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionsByIdAndQuestionCreationTaskIdQuery, GetQuestionsByIdAndQuestionCreationTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionsByIdAndQuestionCreationTaskIdQuery, GetQuestionsByIdAndQuestionCreationTaskIdQueryVariables>(GetQuestionsByIdAndQuestionCreationTaskIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionsByIdAndQuestionCreationTaskIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionsByIdAndQuestionCreationTaskIdQuery, GetQuestionsByIdAndQuestionCreationTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionsByIdAndQuestionCreationTaskIdQuery, GetQuestionsByIdAndQuestionCreationTaskIdQueryVariables>;
export function useGetQuestionsByIdAndQuestionCreationTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionsByIdAndQuestionCreationTaskIdQuery, GetQuestionsByIdAndQuestionCreationTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionsByIdAndQuestionCreationTaskIdQuery | undefined, GetQuestionsByIdAndQuestionCreationTaskIdQueryVariables>;
export function useGetQuestionsByIdAndQuestionCreationTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionsByIdAndQuestionCreationTaskIdQuery, GetQuestionsByIdAndQuestionCreationTaskIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionsByIdAndQuestionCreationTaskIdQuery, GetQuestionsByIdAndQuestionCreationTaskIdQueryVariables>(GetQuestionsByIdAndQuestionCreationTaskIdDocument, options);
        }
export type GetQuestionsByIdAndQuestionCreationTaskIdQueryHookResult = ReturnType<typeof useGetQuestionsByIdAndQuestionCreationTaskIdQuery>;
export type GetQuestionsByIdAndQuestionCreationTaskIdLazyQueryHookResult = ReturnType<typeof useGetQuestionsByIdAndQuestionCreationTaskIdLazyQuery>;
export type GetQuestionsByIdAndQuestionCreationTaskIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionsByIdAndQuestionCreationTaskIdSuspenseQuery>;
export type GetQuestionsByIdAndQuestionCreationTaskIdQueryResult = Apollo.QueryResult<GetQuestionsByIdAndQuestionCreationTaskIdQuery, GetQuestionsByIdAndQuestionCreationTaskIdQueryVariables>;
export const GetCreatingQuestionByIdDocument = gql`
    query getCreatingQuestionById($taskId: String!, $id: String!) {
  qctGetTaskQuestionById(taskId: $taskId, id: $id) {
    id
    details
    metadata {
      choices {
        label
        order
        value
      }
    }
    correctAnswer {
      value
    }
    tags {
      id
      name
      category
    }
    details
    groupOrder
    updatedAt
    refCode
    refQBankStructureId
    status
    updatedAt
    metadata {
      choices {
        label
        order
        value
      }
      reference
      owner {
        type
        value
      }
      audit1
      audit2
      audit3
    }
    correctAnswer {
      value
    }
    solution {
      type
      value
    }
    pValue
    questionStructures {
      refLevelItemId
    }
    questionGroup {
      id
      name
      refCode
      type
    }
    learningObjectiveStatement {
      id
      tag {
        name
      }
    }
  }
}
    `;

/**
 * __useGetCreatingQuestionByIdQuery__
 *
 * To run a query within a React component, call `useGetCreatingQuestionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatingQuestionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatingQuestionByIdQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCreatingQuestionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCreatingQuestionByIdQuery, GetCreatingQuestionByIdQueryVariables> & ({ variables: GetCreatingQuestionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatingQuestionByIdQuery, GetCreatingQuestionByIdQueryVariables>(GetCreatingQuestionByIdDocument, options);
      }
export function useGetCreatingQuestionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatingQuestionByIdQuery, GetCreatingQuestionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatingQuestionByIdQuery, GetCreatingQuestionByIdQueryVariables>(GetCreatingQuestionByIdDocument, options);
        }
// @ts-ignore
export function useGetCreatingQuestionByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCreatingQuestionByIdQuery, GetCreatingQuestionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCreatingQuestionByIdQuery, GetCreatingQuestionByIdQueryVariables>;
export function useGetCreatingQuestionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreatingQuestionByIdQuery, GetCreatingQuestionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCreatingQuestionByIdQuery | undefined, GetCreatingQuestionByIdQueryVariables>;
export function useGetCreatingQuestionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreatingQuestionByIdQuery, GetCreatingQuestionByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreatingQuestionByIdQuery, GetCreatingQuestionByIdQueryVariables>(GetCreatingQuestionByIdDocument, options);
        }
export type GetCreatingQuestionByIdQueryHookResult = ReturnType<typeof useGetCreatingQuestionByIdQuery>;
export type GetCreatingQuestionByIdLazyQueryHookResult = ReturnType<typeof useGetCreatingQuestionByIdLazyQuery>;
export type GetCreatingQuestionByIdSuspenseQueryHookResult = ReturnType<typeof useGetCreatingQuestionByIdSuspenseQuery>;
export type GetCreatingQuestionByIdQueryResult = Apollo.QueryResult<GetCreatingQuestionByIdQuery, GetCreatingQuestionByIdQueryVariables>;
export const CreateItemSetWorkflowDocument = gql`
    mutation createItemSetWorkflow($input: CreateItemSetInput!) {
  qctCreateItemSetWorkflow(input: $input) {
    id
    questions {
      questionGroupId
    }
  }
}
    `;
export type CreateItemSetWorkflowMutationFn = Apollo.MutationFunction<CreateItemSetWorkflowMutation, CreateItemSetWorkflowMutationVariables>;

/**
 * __useCreateItemSetWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateItemSetWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemSetWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemSetWorkflowMutation, { data, loading, error }] = useCreateItemSetWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateItemSetWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<CreateItemSetWorkflowMutation, CreateItemSetWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateItemSetWorkflowMutation, CreateItemSetWorkflowMutationVariables>(CreateItemSetWorkflowDocument, options);
      }
export type CreateItemSetWorkflowMutationHookResult = ReturnType<typeof useCreateItemSetWorkflowMutation>;
export type CreateItemSetWorkflowMutationResult = Apollo.MutationResult<CreateItemSetWorkflowMutation>;
export type CreateItemSetWorkflowMutationOptions = Apollo.BaseMutationOptions<CreateItemSetWorkflowMutation, CreateItemSetWorkflowMutationVariables>;
export const GetTaskQuestionGroupByIdDocument = gql`
    query getTaskQuestionGroupById($questionGroupId: String!, $taskId: String!) {
  qctGetTaskQuestionGroupById(questionGroupId: $questionGroupId, taskId: $taskId) {
    ...QuestionGroup
  }
}
    ${QuestionGroupFragmentDoc}`;

/**
 * __useGetTaskQuestionGroupByIdQuery__
 *
 * To run a query within a React component, call `useGetTaskQuestionGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuestionGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuestionGroupByIdQuery({
 *   variables: {
 *      questionGroupId: // value for 'questionGroupId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskQuestionGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTaskQuestionGroupByIdQuery, GetTaskQuestionGroupByIdQueryVariables> & ({ variables: GetTaskQuestionGroupByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskQuestionGroupByIdQuery, GetTaskQuestionGroupByIdQueryVariables>(GetTaskQuestionGroupByIdDocument, options);
      }
export function useGetTaskQuestionGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskQuestionGroupByIdQuery, GetTaskQuestionGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskQuestionGroupByIdQuery, GetTaskQuestionGroupByIdQueryVariables>(GetTaskQuestionGroupByIdDocument, options);
        }
// @ts-ignore
export function useGetTaskQuestionGroupByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskQuestionGroupByIdQuery, GetTaskQuestionGroupByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskQuestionGroupByIdQuery, GetTaskQuestionGroupByIdQueryVariables>;
export function useGetTaskQuestionGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskQuestionGroupByIdQuery, GetTaskQuestionGroupByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskQuestionGroupByIdQuery | undefined, GetTaskQuestionGroupByIdQueryVariables>;
export function useGetTaskQuestionGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskQuestionGroupByIdQuery, GetTaskQuestionGroupByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskQuestionGroupByIdQuery, GetTaskQuestionGroupByIdQueryVariables>(GetTaskQuestionGroupByIdDocument, options);
        }
export type GetTaskQuestionGroupByIdQueryHookResult = ReturnType<typeof useGetTaskQuestionGroupByIdQuery>;
export type GetTaskQuestionGroupByIdLazyQueryHookResult = ReturnType<typeof useGetTaskQuestionGroupByIdLazyQuery>;
export type GetTaskQuestionGroupByIdSuspenseQueryHookResult = ReturnType<typeof useGetTaskQuestionGroupByIdSuspenseQuery>;
export type GetTaskQuestionGroupByIdQueryResult = Apollo.QueryResult<GetTaskQuestionGroupByIdQuery, GetTaskQuestionGroupByIdQueryVariables>;
export const SaveItemSetAsDraftWorkflowDocument = gql`
    mutation saveItemSetAsDraftWorkflow($input: SaveItemSetAsDraftInput!, $taskId: String!) {
  qctSaveItemSetAsDraftWorkflow(input: $input, taskId: $taskId) {
    id
  }
}
    `;
export type SaveItemSetAsDraftWorkflowMutationFn = Apollo.MutationFunction<SaveItemSetAsDraftWorkflowMutation, SaveItemSetAsDraftWorkflowMutationVariables>;

/**
 * __useSaveItemSetAsDraftWorkflowMutation__
 *
 * To run a mutation, you first call `useSaveItemSetAsDraftWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveItemSetAsDraftWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveItemSetAsDraftWorkflowMutation, { data, loading, error }] = useSaveItemSetAsDraftWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useSaveItemSetAsDraftWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<SaveItemSetAsDraftWorkflowMutation, SaveItemSetAsDraftWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveItemSetAsDraftWorkflowMutation, SaveItemSetAsDraftWorkflowMutationVariables>(SaveItemSetAsDraftWorkflowDocument, options);
      }
export type SaveItemSetAsDraftWorkflowMutationHookResult = ReturnType<typeof useSaveItemSetAsDraftWorkflowMutation>;
export type SaveItemSetAsDraftWorkflowMutationResult = Apollo.MutationResult<SaveItemSetAsDraftWorkflowMutation>;
export type SaveItemSetAsDraftWorkflowMutationOptions = Apollo.BaseMutationOptions<SaveItemSetAsDraftWorkflowMutation, SaveItemSetAsDraftWorkflowMutationVariables>;
export const GetTaskQuestionGroupByIdsDocument = gql`
    query getTaskQuestionGroupByIds($questionGroupIds: [String!]!, $taskId: String!) {
  qctGetTaskQuestionGroupByIds(
    questionGroupIds: $questionGroupIds
    taskId: $taskId
  ) {
    id
    name
    refCode
    type
    size
    questions {
      ...Question
      questionStructures {
        id
        refLevelItemId
        levelItem {
          id
          qBankStructureId
          tagId
          parentLevelItemId
          order
          qBankStructureLevelId
          tag {
            id
            name
            slug
            description
            category
          }
          qBankStructureLevel {
            id
            qBankStructureId
            level
            category
            enabled
          }
          qId
        }
        entityId
        entityName
        refSource
      }
    }
  }
}
    ${QuestionFragmentDoc}`;

/**
 * __useGetTaskQuestionGroupByIdsQuery__
 *
 * To run a query within a React component, call `useGetTaskQuestionGroupByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuestionGroupByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuestionGroupByIdsQuery({
 *   variables: {
 *      questionGroupIds: // value for 'questionGroupIds'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskQuestionGroupByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetTaskQuestionGroupByIdsQuery, GetTaskQuestionGroupByIdsQueryVariables> & ({ variables: GetTaskQuestionGroupByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskQuestionGroupByIdsQuery, GetTaskQuestionGroupByIdsQueryVariables>(GetTaskQuestionGroupByIdsDocument, options);
      }
export function useGetTaskQuestionGroupByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskQuestionGroupByIdsQuery, GetTaskQuestionGroupByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskQuestionGroupByIdsQuery, GetTaskQuestionGroupByIdsQueryVariables>(GetTaskQuestionGroupByIdsDocument, options);
        }
// @ts-ignore
export function useGetTaskQuestionGroupByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskQuestionGroupByIdsQuery, GetTaskQuestionGroupByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskQuestionGroupByIdsQuery, GetTaskQuestionGroupByIdsQueryVariables>;
export function useGetTaskQuestionGroupByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskQuestionGroupByIdsQuery, GetTaskQuestionGroupByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskQuestionGroupByIdsQuery | undefined, GetTaskQuestionGroupByIdsQueryVariables>;
export function useGetTaskQuestionGroupByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskQuestionGroupByIdsQuery, GetTaskQuestionGroupByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskQuestionGroupByIdsQuery, GetTaskQuestionGroupByIdsQueryVariables>(GetTaskQuestionGroupByIdsDocument, options);
        }
export type GetTaskQuestionGroupByIdsQueryHookResult = ReturnType<typeof useGetTaskQuestionGroupByIdsQuery>;
export type GetTaskQuestionGroupByIdsLazyQueryHookResult = ReturnType<typeof useGetTaskQuestionGroupByIdsLazyQuery>;
export type GetTaskQuestionGroupByIdsSuspenseQueryHookResult = ReturnType<typeof useGetTaskQuestionGroupByIdsSuspenseQuery>;
export type GetTaskQuestionGroupByIdsQueryResult = Apollo.QueryResult<GetTaskQuestionGroupByIdsQuery, GetTaskQuestionGroupByIdsQueryVariables>;
export const DeleteItemSetSubQuestionWorkflowDocument = gql`
    mutation deleteItemSetSubQuestionWorkflow($input: DeleteItemSetSubQuestionInput!, $taskId: String!) {
  qctDeleteItemSetSubQuestionWorkflow(input: $input, taskId: $taskId) {
    ...QuestionGroup
  }
}
    ${QuestionGroupFragmentDoc}`;
export type DeleteItemSetSubQuestionWorkflowMutationFn = Apollo.MutationFunction<DeleteItemSetSubQuestionWorkflowMutation, DeleteItemSetSubQuestionWorkflowMutationVariables>;

/**
 * __useDeleteItemSetSubQuestionWorkflowMutation__
 *
 * To run a mutation, you first call `useDeleteItemSetSubQuestionWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemSetSubQuestionWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemSetSubQuestionWorkflowMutation, { data, loading, error }] = useDeleteItemSetSubQuestionWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useDeleteItemSetSubQuestionWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteItemSetSubQuestionWorkflowMutation, DeleteItemSetSubQuestionWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteItemSetSubQuestionWorkflowMutation, DeleteItemSetSubQuestionWorkflowMutationVariables>(DeleteItemSetSubQuestionWorkflowDocument, options);
      }
export type DeleteItemSetSubQuestionWorkflowMutationHookResult = ReturnType<typeof useDeleteItemSetSubQuestionWorkflowMutation>;
export type DeleteItemSetSubQuestionWorkflowMutationResult = Apollo.MutationResult<DeleteItemSetSubQuestionWorkflowMutation>;
export type DeleteItemSetSubQuestionWorkflowMutationOptions = Apollo.BaseMutationOptions<DeleteItemSetSubQuestionWorkflowMutation, DeleteItemSetSubQuestionWorkflowMutationVariables>;
export const GetQuestionReviewTaskByIdDocument = gql`
    query getQuestionReviewTaskById($input: GetTaskByIdInput!) {
  wflGetTaskById(getTaskByIdInput: $input) {
    task {
      ...QuestionReviewTask
    }
  }
}
    ${QuestionReviewTaskFragmentDoc}`;

/**
 * __useGetQuestionReviewTaskByIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionReviewTaskByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionReviewTaskByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionReviewTaskByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuestionReviewTaskByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionReviewTaskByIdQuery, GetQuestionReviewTaskByIdQueryVariables> & ({ variables: GetQuestionReviewTaskByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionReviewTaskByIdQuery, GetQuestionReviewTaskByIdQueryVariables>(GetQuestionReviewTaskByIdDocument, options);
      }
export function useGetQuestionReviewTaskByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionReviewTaskByIdQuery, GetQuestionReviewTaskByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionReviewTaskByIdQuery, GetQuestionReviewTaskByIdQueryVariables>(GetQuestionReviewTaskByIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionReviewTaskByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionReviewTaskByIdQuery, GetQuestionReviewTaskByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionReviewTaskByIdQuery, GetQuestionReviewTaskByIdQueryVariables>;
export function useGetQuestionReviewTaskByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionReviewTaskByIdQuery, GetQuestionReviewTaskByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionReviewTaskByIdQuery | undefined, GetQuestionReviewTaskByIdQueryVariables>;
export function useGetQuestionReviewTaskByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionReviewTaskByIdQuery, GetQuestionReviewTaskByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionReviewTaskByIdQuery, GetQuestionReviewTaskByIdQueryVariables>(GetQuestionReviewTaskByIdDocument, options);
        }
export type GetQuestionReviewTaskByIdQueryHookResult = ReturnType<typeof useGetQuestionReviewTaskByIdQuery>;
export type GetQuestionReviewTaskByIdLazyQueryHookResult = ReturnType<typeof useGetQuestionReviewTaskByIdLazyQuery>;
export type GetQuestionReviewTaskByIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionReviewTaskByIdSuspenseQuery>;
export type GetQuestionReviewTaskByIdQueryResult = Apollo.QueryResult<GetQuestionReviewTaskByIdQuery, GetQuestionReviewTaskByIdQueryVariables>;
export const SearchOwnedQuestionReviewTasksDocument = gql`
    query searchOwnedQuestionReviewTasks($input: SearchOwnedAndAssignedTasksInput!) {
  wflSearchOwnedAndAssignedTasks(searchOwnedAndAssignedTasksInput: $input) {
    tasks {
      ...QuestionReviewTask
    }
    total
  }
}
    ${QuestionReviewTaskFragmentDoc}`;

/**
 * __useSearchOwnedQuestionReviewTasksQuery__
 *
 * To run a query within a React component, call `useSearchOwnedQuestionReviewTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOwnedQuestionReviewTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOwnedQuestionReviewTasksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchOwnedQuestionReviewTasksQuery(baseOptions: Apollo.QueryHookOptions<SearchOwnedQuestionReviewTasksQuery, SearchOwnedQuestionReviewTasksQueryVariables> & ({ variables: SearchOwnedQuestionReviewTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOwnedQuestionReviewTasksQuery, SearchOwnedQuestionReviewTasksQueryVariables>(SearchOwnedQuestionReviewTasksDocument, options);
      }
export function useSearchOwnedQuestionReviewTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOwnedQuestionReviewTasksQuery, SearchOwnedQuestionReviewTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOwnedQuestionReviewTasksQuery, SearchOwnedQuestionReviewTasksQueryVariables>(SearchOwnedQuestionReviewTasksDocument, options);
        }
// @ts-ignore
export function useSearchOwnedQuestionReviewTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchOwnedQuestionReviewTasksQuery, SearchOwnedQuestionReviewTasksQueryVariables>): Apollo.UseSuspenseQueryResult<SearchOwnedQuestionReviewTasksQuery, SearchOwnedQuestionReviewTasksQueryVariables>;
export function useSearchOwnedQuestionReviewTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOwnedQuestionReviewTasksQuery, SearchOwnedQuestionReviewTasksQueryVariables>): Apollo.UseSuspenseQueryResult<SearchOwnedQuestionReviewTasksQuery | undefined, SearchOwnedQuestionReviewTasksQueryVariables>;
export function useSearchOwnedQuestionReviewTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOwnedQuestionReviewTasksQuery, SearchOwnedQuestionReviewTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchOwnedQuestionReviewTasksQuery, SearchOwnedQuestionReviewTasksQueryVariables>(SearchOwnedQuestionReviewTasksDocument, options);
        }
export type SearchOwnedQuestionReviewTasksQueryHookResult = ReturnType<typeof useSearchOwnedQuestionReviewTasksQuery>;
export type SearchOwnedQuestionReviewTasksLazyQueryHookResult = ReturnType<typeof useSearchOwnedQuestionReviewTasksLazyQuery>;
export type SearchOwnedQuestionReviewTasksSuspenseQueryHookResult = ReturnType<typeof useSearchOwnedQuestionReviewTasksSuspenseQuery>;
export type SearchOwnedQuestionReviewTasksQueryResult = Apollo.QueryResult<SearchOwnedQuestionReviewTasksQuery, SearchOwnedQuestionReviewTasksQueryVariables>;
export const SearchQuestionsForQuestionReviewTaskDocument = gql`
    query searchQuestionsForQuestionReviewTask($search: SearchQuestionsInput!, $paging: PageInput!) {
  qctSearchQuestions(search: $search, paging: $paging) {
    questions {
      ...QuestionForQuestionReviewList
    }
    total
  }
}
    ${QuestionForQuestionReviewListFragmentDoc}`;

/**
 * __useSearchQuestionsForQuestionReviewTaskQuery__
 *
 * To run a query within a React component, call `useSearchQuestionsForQuestionReviewTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuestionsForQuestionReviewTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuestionsForQuestionReviewTaskQuery({
 *   variables: {
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useSearchQuestionsForQuestionReviewTaskQuery(baseOptions: Apollo.QueryHookOptions<SearchQuestionsForQuestionReviewTaskQuery, SearchQuestionsForQuestionReviewTaskQueryVariables> & ({ variables: SearchQuestionsForQuestionReviewTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuestionsForQuestionReviewTaskQuery, SearchQuestionsForQuestionReviewTaskQueryVariables>(SearchQuestionsForQuestionReviewTaskDocument, options);
      }
export function useSearchQuestionsForQuestionReviewTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuestionsForQuestionReviewTaskQuery, SearchQuestionsForQuestionReviewTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuestionsForQuestionReviewTaskQuery, SearchQuestionsForQuestionReviewTaskQueryVariables>(SearchQuestionsForQuestionReviewTaskDocument, options);
        }
// @ts-ignore
export function useSearchQuestionsForQuestionReviewTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQuestionsForQuestionReviewTaskQuery, SearchQuestionsForQuestionReviewTaskQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionsForQuestionReviewTaskQuery, SearchQuestionsForQuestionReviewTaskQueryVariables>;
export function useSearchQuestionsForQuestionReviewTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionsForQuestionReviewTaskQuery, SearchQuestionsForQuestionReviewTaskQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionsForQuestionReviewTaskQuery | undefined, SearchQuestionsForQuestionReviewTaskQueryVariables>;
export function useSearchQuestionsForQuestionReviewTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionsForQuestionReviewTaskQuery, SearchQuestionsForQuestionReviewTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuestionsForQuestionReviewTaskQuery, SearchQuestionsForQuestionReviewTaskQueryVariables>(SearchQuestionsForQuestionReviewTaskDocument, options);
        }
export type SearchQuestionsForQuestionReviewTaskQueryHookResult = ReturnType<typeof useSearchQuestionsForQuestionReviewTaskQuery>;
export type SearchQuestionsForQuestionReviewTaskLazyQueryHookResult = ReturnType<typeof useSearchQuestionsForQuestionReviewTaskLazyQuery>;
export type SearchQuestionsForQuestionReviewTaskSuspenseQueryHookResult = ReturnType<typeof useSearchQuestionsForQuestionReviewTaskSuspenseQuery>;
export type SearchQuestionsForQuestionReviewTaskQueryResult = Apollo.QueryResult<SearchQuestionsForQuestionReviewTaskQuery, SearchQuestionsForQuestionReviewTaskQueryVariables>;
export const GetQuestionsByIdAndQuestionReviewTaskIdDocument = gql`
    query getQuestionsByIdAndQuestionReviewTaskId($ids: [String!]!, $taskId: String!) {
  qctGetTaskQuestionsByIds(ids: $ids, taskId: $taskId) {
    ...QuestionForQuestionReviewList
  }
}
    ${QuestionForQuestionReviewListFragmentDoc}`;

/**
 * __useGetQuestionsByIdAndQuestionReviewTaskIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionsByIdAndQuestionReviewTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsByIdAndQuestionReviewTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsByIdAndQuestionReviewTaskIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetQuestionsByIdAndQuestionReviewTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionsByIdAndQuestionReviewTaskIdQuery, GetQuestionsByIdAndQuestionReviewTaskIdQueryVariables> & ({ variables: GetQuestionsByIdAndQuestionReviewTaskIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionsByIdAndQuestionReviewTaskIdQuery, GetQuestionsByIdAndQuestionReviewTaskIdQueryVariables>(GetQuestionsByIdAndQuestionReviewTaskIdDocument, options);
      }
export function useGetQuestionsByIdAndQuestionReviewTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionsByIdAndQuestionReviewTaskIdQuery, GetQuestionsByIdAndQuestionReviewTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionsByIdAndQuestionReviewTaskIdQuery, GetQuestionsByIdAndQuestionReviewTaskIdQueryVariables>(GetQuestionsByIdAndQuestionReviewTaskIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionsByIdAndQuestionReviewTaskIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionsByIdAndQuestionReviewTaskIdQuery, GetQuestionsByIdAndQuestionReviewTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionsByIdAndQuestionReviewTaskIdQuery, GetQuestionsByIdAndQuestionReviewTaskIdQueryVariables>;
export function useGetQuestionsByIdAndQuestionReviewTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionsByIdAndQuestionReviewTaskIdQuery, GetQuestionsByIdAndQuestionReviewTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionsByIdAndQuestionReviewTaskIdQuery | undefined, GetQuestionsByIdAndQuestionReviewTaskIdQueryVariables>;
export function useGetQuestionsByIdAndQuestionReviewTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionsByIdAndQuestionReviewTaskIdQuery, GetQuestionsByIdAndQuestionReviewTaskIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionsByIdAndQuestionReviewTaskIdQuery, GetQuestionsByIdAndQuestionReviewTaskIdQueryVariables>(GetQuestionsByIdAndQuestionReviewTaskIdDocument, options);
        }
export type GetQuestionsByIdAndQuestionReviewTaskIdQueryHookResult = ReturnType<typeof useGetQuestionsByIdAndQuestionReviewTaskIdQuery>;
export type GetQuestionsByIdAndQuestionReviewTaskIdLazyQueryHookResult = ReturnType<typeof useGetQuestionsByIdAndQuestionReviewTaskIdLazyQuery>;
export type GetQuestionsByIdAndQuestionReviewTaskIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionsByIdAndQuestionReviewTaskIdSuspenseQuery>;
export type GetQuestionsByIdAndQuestionReviewTaskIdQueryResult = Apollo.QueryResult<GetQuestionsByIdAndQuestionReviewTaskIdQuery, GetQuestionsByIdAndQuestionReviewTaskIdQueryVariables>;
export const GetQuestionDetailsByIdAndQuestionReviewTaskIdDocument = gql`
    query getQuestionDetailsByIdAndQuestionReviewTaskId($id: String!, $taskId: String!) {
  qctGetTaskQuestionById(id: $id, taskId: $taskId) {
    id
    type
    refCode
    status
    pValue
    updatedAt
    correctAnswer {
      value
    }
    metadata {
      owner {
        type
        value
      }
      choices {
        label
        order
        value
      }
      reference
    }
    solution {
      type
      value
    }
    learningObjectiveStatement {
      id
      tag {
        id
        name
      }
    }
    tags {
      id
      name
    }
    questionStructures {
      id
      levelItem {
        id
        parentLevelItemId
        qBankStructureId
        tag {
          id
          name
        }
        qBankStructureLevel {
          id
          level
          category
        }
      }
    }
    taskComments {
      id
      taskId
      userId
      entityType
      entityId
      content
    }
    taskVerdicts {
      id
      taskId
      userId
      entityType
      entityId
      verdict
    }
  }
}
    `;

/**
 * __useGetQuestionDetailsByIdAndQuestionReviewTaskIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionDetailsByIdAndQuestionReviewTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionDetailsByIdAndQuestionReviewTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionDetailsByIdAndQuestionReviewTaskIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetQuestionDetailsByIdAndQuestionReviewTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionDetailsByIdAndQuestionReviewTaskIdQuery, GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryVariables> & ({ variables: GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionDetailsByIdAndQuestionReviewTaskIdQuery, GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryVariables>(GetQuestionDetailsByIdAndQuestionReviewTaskIdDocument, options);
      }
export function useGetQuestionDetailsByIdAndQuestionReviewTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionDetailsByIdAndQuestionReviewTaskIdQuery, GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionDetailsByIdAndQuestionReviewTaskIdQuery, GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryVariables>(GetQuestionDetailsByIdAndQuestionReviewTaskIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionDetailsByIdAndQuestionReviewTaskIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionDetailsByIdAndQuestionReviewTaskIdQuery, GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionDetailsByIdAndQuestionReviewTaskIdQuery, GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryVariables>;
export function useGetQuestionDetailsByIdAndQuestionReviewTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionDetailsByIdAndQuestionReviewTaskIdQuery, GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionDetailsByIdAndQuestionReviewTaskIdQuery | undefined, GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryVariables>;
export function useGetQuestionDetailsByIdAndQuestionReviewTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionDetailsByIdAndQuestionReviewTaskIdQuery, GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionDetailsByIdAndQuestionReviewTaskIdQuery, GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryVariables>(GetQuestionDetailsByIdAndQuestionReviewTaskIdDocument, options);
        }
export type GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryHookResult = ReturnType<typeof useGetQuestionDetailsByIdAndQuestionReviewTaskIdQuery>;
export type GetQuestionDetailsByIdAndQuestionReviewTaskIdLazyQueryHookResult = ReturnType<typeof useGetQuestionDetailsByIdAndQuestionReviewTaskIdLazyQuery>;
export type GetQuestionDetailsByIdAndQuestionReviewTaskIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionDetailsByIdAndQuestionReviewTaskIdSuspenseQuery>;
export type GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryResult = Apollo.QueryResult<GetQuestionDetailsByIdAndQuestionReviewTaskIdQuery, GetQuestionDetailsByIdAndQuestionReviewTaskIdQueryVariables>;
export const GetStepTransitionsByQuestionReviewTaskIdDocument = gql`
    query getStepTransitionsByQuestionReviewTaskId($input: GetStepTransitionsByTaskIdInput!) {
  wflGetStepTransitionsByTaskId(getStepTransitionsByTaskIdInput: $input) {
    steps {
      id
      type
      condition
      name
      role
    }
  }
}
    `;

/**
 * __useGetStepTransitionsByQuestionReviewTaskIdQuery__
 *
 * To run a query within a React component, call `useGetStepTransitionsByQuestionReviewTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStepTransitionsByQuestionReviewTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStepTransitionsByQuestionReviewTaskIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStepTransitionsByQuestionReviewTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetStepTransitionsByQuestionReviewTaskIdQuery, GetStepTransitionsByQuestionReviewTaskIdQueryVariables> & ({ variables: GetStepTransitionsByQuestionReviewTaskIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStepTransitionsByQuestionReviewTaskIdQuery, GetStepTransitionsByQuestionReviewTaskIdQueryVariables>(GetStepTransitionsByQuestionReviewTaskIdDocument, options);
      }
export function useGetStepTransitionsByQuestionReviewTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStepTransitionsByQuestionReviewTaskIdQuery, GetStepTransitionsByQuestionReviewTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStepTransitionsByQuestionReviewTaskIdQuery, GetStepTransitionsByQuestionReviewTaskIdQueryVariables>(GetStepTransitionsByQuestionReviewTaskIdDocument, options);
        }
// @ts-ignore
export function useGetStepTransitionsByQuestionReviewTaskIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStepTransitionsByQuestionReviewTaskIdQuery, GetStepTransitionsByQuestionReviewTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetStepTransitionsByQuestionReviewTaskIdQuery, GetStepTransitionsByQuestionReviewTaskIdQueryVariables>;
export function useGetStepTransitionsByQuestionReviewTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStepTransitionsByQuestionReviewTaskIdQuery, GetStepTransitionsByQuestionReviewTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetStepTransitionsByQuestionReviewTaskIdQuery | undefined, GetStepTransitionsByQuestionReviewTaskIdQueryVariables>;
export function useGetStepTransitionsByQuestionReviewTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStepTransitionsByQuestionReviewTaskIdQuery, GetStepTransitionsByQuestionReviewTaskIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStepTransitionsByQuestionReviewTaskIdQuery, GetStepTransitionsByQuestionReviewTaskIdQueryVariables>(GetStepTransitionsByQuestionReviewTaskIdDocument, options);
        }
export type GetStepTransitionsByQuestionReviewTaskIdQueryHookResult = ReturnType<typeof useGetStepTransitionsByQuestionReviewTaskIdQuery>;
export type GetStepTransitionsByQuestionReviewTaskIdLazyQueryHookResult = ReturnType<typeof useGetStepTransitionsByQuestionReviewTaskIdLazyQuery>;
export type GetStepTransitionsByQuestionReviewTaskIdSuspenseQueryHookResult = ReturnType<typeof useGetStepTransitionsByQuestionReviewTaskIdSuspenseQuery>;
export type GetStepTransitionsByQuestionReviewTaskIdQueryResult = Apollo.QueryResult<GetStepTransitionsByQuestionReviewTaskIdQuery, GetStepTransitionsByQuestionReviewTaskIdQueryVariables>;
export const CreateQuestionCommentOnQuestionReviewTaskDocument = gql`
    mutation createQuestionCommentOnQuestionReviewTask($input: CreateOrUpdateQuestionCommentInput!) {
  qctCreateOrUpdateQuestionComment(input: $input) {
    id
    entityType
    entityId
    taskId
    userId
    content
  }
}
    `;
export type CreateQuestionCommentOnQuestionReviewTaskMutationFn = Apollo.MutationFunction<CreateQuestionCommentOnQuestionReviewTaskMutation, CreateQuestionCommentOnQuestionReviewTaskMutationVariables>;

/**
 * __useCreateQuestionCommentOnQuestionReviewTaskMutation__
 *
 * To run a mutation, you first call `useCreateQuestionCommentOnQuestionReviewTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionCommentOnQuestionReviewTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionCommentOnQuestionReviewTaskMutation, { data, loading, error }] = useCreateQuestionCommentOnQuestionReviewTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuestionCommentOnQuestionReviewTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionCommentOnQuestionReviewTaskMutation, CreateQuestionCommentOnQuestionReviewTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionCommentOnQuestionReviewTaskMutation, CreateQuestionCommentOnQuestionReviewTaskMutationVariables>(CreateQuestionCommentOnQuestionReviewTaskDocument, options);
      }
export type CreateQuestionCommentOnQuestionReviewTaskMutationHookResult = ReturnType<typeof useCreateQuestionCommentOnQuestionReviewTaskMutation>;
export type CreateQuestionCommentOnQuestionReviewTaskMutationResult = Apollo.MutationResult<CreateQuestionCommentOnQuestionReviewTaskMutation>;
export type CreateQuestionCommentOnQuestionReviewTaskMutationOptions = Apollo.BaseMutationOptions<CreateQuestionCommentOnQuestionReviewTaskMutation, CreateQuestionCommentOnQuestionReviewTaskMutationVariables>;
export const CreateOrUpdateVerdictOnQuestionReviewTaskDocument = gql`
    mutation createOrUpdateVerdictOnQuestionReviewTask($input: CreateOrUpdateQuestionVerdictInput!) {
  qctCreateOrUpdateQuestionVerdict(input: $input) {
    id
    entityType
    entityId
    taskId
    userId
    verdict
  }
}
    `;
export type CreateOrUpdateVerdictOnQuestionReviewTaskMutationFn = Apollo.MutationFunction<CreateOrUpdateVerdictOnQuestionReviewTaskMutation, CreateOrUpdateVerdictOnQuestionReviewTaskMutationVariables>;

/**
 * __useCreateOrUpdateVerdictOnQuestionReviewTaskMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateVerdictOnQuestionReviewTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateVerdictOnQuestionReviewTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateVerdictOnQuestionReviewTaskMutation, { data, loading, error }] = useCreateOrUpdateVerdictOnQuestionReviewTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateVerdictOnQuestionReviewTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateVerdictOnQuestionReviewTaskMutation, CreateOrUpdateVerdictOnQuestionReviewTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateVerdictOnQuestionReviewTaskMutation, CreateOrUpdateVerdictOnQuestionReviewTaskMutationVariables>(CreateOrUpdateVerdictOnQuestionReviewTaskDocument, options);
      }
export type CreateOrUpdateVerdictOnQuestionReviewTaskMutationHookResult = ReturnType<typeof useCreateOrUpdateVerdictOnQuestionReviewTaskMutation>;
export type CreateOrUpdateVerdictOnQuestionReviewTaskMutationResult = Apollo.MutationResult<CreateOrUpdateVerdictOnQuestionReviewTaskMutation>;
export type CreateOrUpdateVerdictOnQuestionReviewTaskMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateVerdictOnQuestionReviewTaskMutation, CreateOrUpdateVerdictOnQuestionReviewTaskMutationVariables>;
export const CreateQuestionReviewTaskDocument = gql`
    mutation createQuestionReviewTask($input: CreateQuestionReviewTaskInput!) {
  wflCreateQuestionReviewTask(createQuestionReviewTaskInput: $input) {
    task {
      id
    }
    success
    message
    code
    itemSetMismatches {
      id
      refCode
      name
    }
  }
}
    `;
export type CreateQuestionReviewTaskMutationFn = Apollo.MutationFunction<CreateQuestionReviewTaskMutation, CreateQuestionReviewTaskMutationVariables>;

/**
 * __useCreateQuestionReviewTaskMutation__
 *
 * To run a mutation, you first call `useCreateQuestionReviewTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionReviewTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionReviewTaskMutation, { data, loading, error }] = useCreateQuestionReviewTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuestionReviewTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionReviewTaskMutation, CreateQuestionReviewTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionReviewTaskMutation, CreateQuestionReviewTaskMutationVariables>(CreateQuestionReviewTaskDocument, options);
      }
export type CreateQuestionReviewTaskMutationHookResult = ReturnType<typeof useCreateQuestionReviewTaskMutation>;
export type CreateQuestionReviewTaskMutationResult = Apollo.MutationResult<CreateQuestionReviewTaskMutation>;
export type CreateQuestionReviewTaskMutationOptions = Apollo.BaseMutationOptions<CreateQuestionReviewTaskMutation, CreateQuestionReviewTaskMutationVariables>;
export const UpdateQuestionReviewTaskStatusDocument = gql`
    mutation updateQuestionReviewTaskStatus($input: UpdateTaskStatusInput!) {
  wflUpdateTaskStatus(updateTaskStatusInput: $input) {
    task {
      id
    }
  }
}
    `;
export type UpdateQuestionReviewTaskStatusMutationFn = Apollo.MutationFunction<UpdateQuestionReviewTaskStatusMutation, UpdateQuestionReviewTaskStatusMutationVariables>;

/**
 * __useUpdateQuestionReviewTaskStatusMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionReviewTaskStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionReviewTaskStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionReviewTaskStatusMutation, { data, loading, error }] = useUpdateQuestionReviewTaskStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionReviewTaskStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionReviewTaskStatusMutation, UpdateQuestionReviewTaskStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionReviewTaskStatusMutation, UpdateQuestionReviewTaskStatusMutationVariables>(UpdateQuestionReviewTaskStatusDocument, options);
      }
export type UpdateQuestionReviewTaskStatusMutationHookResult = ReturnType<typeof useUpdateQuestionReviewTaskStatusMutation>;
export type UpdateQuestionReviewTaskStatusMutationResult = Apollo.MutationResult<UpdateQuestionReviewTaskStatusMutation>;
export type UpdateQuestionReviewTaskStatusMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionReviewTaskStatusMutation, UpdateQuestionReviewTaskStatusMutationVariables>;
export const UpdateAndCreateQuestionReviewSubtasksDocument = gql`
    mutation updateAndCreateQuestionReviewSubtasks($input: UpdateAndCreateSubtasksInput!) {
  wflUpdateAndCreateSubtasks(updateAndCreateSubtasksInput: $input) {
    subtasks {
      id
    }
  }
}
    `;
export type UpdateAndCreateQuestionReviewSubtasksMutationFn = Apollo.MutationFunction<UpdateAndCreateQuestionReviewSubtasksMutation, UpdateAndCreateQuestionReviewSubtasksMutationVariables>;

/**
 * __useUpdateAndCreateQuestionReviewSubtasksMutation__
 *
 * To run a mutation, you first call `useUpdateAndCreateQuestionReviewSubtasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAndCreateQuestionReviewSubtasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAndCreateQuestionReviewSubtasksMutation, { data, loading, error }] = useUpdateAndCreateQuestionReviewSubtasksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAndCreateQuestionReviewSubtasksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAndCreateQuestionReviewSubtasksMutation, UpdateAndCreateQuestionReviewSubtasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAndCreateQuestionReviewSubtasksMutation, UpdateAndCreateQuestionReviewSubtasksMutationVariables>(UpdateAndCreateQuestionReviewSubtasksDocument, options);
      }
export type UpdateAndCreateQuestionReviewSubtasksMutationHookResult = ReturnType<typeof useUpdateAndCreateQuestionReviewSubtasksMutation>;
export type UpdateAndCreateQuestionReviewSubtasksMutationResult = Apollo.MutationResult<UpdateAndCreateQuestionReviewSubtasksMutation>;
export type UpdateAndCreateQuestionReviewSubtasksMutationOptions = Apollo.BaseMutationOptions<UpdateAndCreateQuestionReviewSubtasksMutation, UpdateAndCreateQuestionReviewSubtasksMutationVariables>;
export const GetTaskQuestionByIdDocument = gql`
    query getTaskQuestionById($qctGetTaskQuestionByIdId: String!, $taskId: String!) {
  qctGetTaskQuestionById(id: $qctGetTaskQuestionByIdId, taskId: $taskId) {
    ...Question
    questionGroup {
      id
      type
      name
      metadata {
        paragraph
      }
    }
  }
}
    ${QuestionFragmentDoc}`;

/**
 * __useGetTaskQuestionByIdQuery__
 *
 * To run a query within a React component, call `useGetTaskQuestionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuestionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuestionByIdQuery({
 *   variables: {
 *      qctGetTaskQuestionByIdId: // value for 'qctGetTaskQuestionByIdId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskQuestionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTaskQuestionByIdQuery, GetTaskQuestionByIdQueryVariables> & ({ variables: GetTaskQuestionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskQuestionByIdQuery, GetTaskQuestionByIdQueryVariables>(GetTaskQuestionByIdDocument, options);
      }
export function useGetTaskQuestionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskQuestionByIdQuery, GetTaskQuestionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskQuestionByIdQuery, GetTaskQuestionByIdQueryVariables>(GetTaskQuestionByIdDocument, options);
        }
// @ts-ignore
export function useGetTaskQuestionByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskQuestionByIdQuery, GetTaskQuestionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskQuestionByIdQuery, GetTaskQuestionByIdQueryVariables>;
export function useGetTaskQuestionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskQuestionByIdQuery, GetTaskQuestionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskQuestionByIdQuery | undefined, GetTaskQuestionByIdQueryVariables>;
export function useGetTaskQuestionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskQuestionByIdQuery, GetTaskQuestionByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskQuestionByIdQuery, GetTaskQuestionByIdQueryVariables>(GetTaskQuestionByIdDocument, options);
        }
export type GetTaskQuestionByIdQueryHookResult = ReturnType<typeof useGetTaskQuestionByIdQuery>;
export type GetTaskQuestionByIdLazyQueryHookResult = ReturnType<typeof useGetTaskQuestionByIdLazyQuery>;
export type GetTaskQuestionByIdSuspenseQueryHookResult = ReturnType<typeof useGetTaskQuestionByIdSuspenseQuery>;
export type GetTaskQuestionByIdQueryResult = Apollo.QueryResult<GetTaskQuestionByIdQuery, GetTaskQuestionByIdQueryVariables>;
export const CreateOrUpdateQuestionVerdictDocument = gql`
    mutation createOrUpdateQuestionVerdict($input: CreateOrUpdateQuestionVerdictInput!) {
  qctCreateOrUpdateQuestionVerdict(input: $input) {
    id
    taskId
  }
}
    `;
export type CreateOrUpdateQuestionVerdictMutationFn = Apollo.MutationFunction<CreateOrUpdateQuestionVerdictMutation, CreateOrUpdateQuestionVerdictMutationVariables>;

/**
 * __useCreateOrUpdateQuestionVerdictMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateQuestionVerdictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateQuestionVerdictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateQuestionVerdictMutation, { data, loading, error }] = useCreateOrUpdateQuestionVerdictMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateQuestionVerdictMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateQuestionVerdictMutation, CreateOrUpdateQuestionVerdictMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateQuestionVerdictMutation, CreateOrUpdateQuestionVerdictMutationVariables>(CreateOrUpdateQuestionVerdictDocument, options);
      }
export type CreateOrUpdateQuestionVerdictMutationHookResult = ReturnType<typeof useCreateOrUpdateQuestionVerdictMutation>;
export type CreateOrUpdateQuestionVerdictMutationResult = Apollo.MutationResult<CreateOrUpdateQuestionVerdictMutation>;
export type CreateOrUpdateQuestionVerdictMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateQuestionVerdictMutation, CreateOrUpdateQuestionVerdictMutationVariables>;
export const CreateOrUpdateQuestionVerdictAndCreateCommentDocument = gql`
    mutation createOrUpdateQuestionVerdictAndCreateComment($verdictInput: CreateOrUpdateQuestionVerdictInput!, $commentInput: CreateOrUpdateQuestionCommentInput!) {
  qctCreateOrUpdateQuestionVerdict(input: $verdictInput) {
    id
    entityId
    taskId
    entityType
  }
  qctCreateOrUpdateQuestionComment(input: $commentInput) {
    id
    entityId
    taskId
    entityType
  }
}
    `;
export type CreateOrUpdateQuestionVerdictAndCreateCommentMutationFn = Apollo.MutationFunction<CreateOrUpdateQuestionVerdictAndCreateCommentMutation, CreateOrUpdateQuestionVerdictAndCreateCommentMutationVariables>;

/**
 * __useCreateOrUpdateQuestionVerdictAndCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateQuestionVerdictAndCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateQuestionVerdictAndCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateQuestionVerdictAndCreateCommentMutation, { data, loading, error }] = useCreateOrUpdateQuestionVerdictAndCreateCommentMutation({
 *   variables: {
 *      verdictInput: // value for 'verdictInput'
 *      commentInput: // value for 'commentInput'
 *   },
 * });
 */
export function useCreateOrUpdateQuestionVerdictAndCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateQuestionVerdictAndCreateCommentMutation, CreateOrUpdateQuestionVerdictAndCreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateQuestionVerdictAndCreateCommentMutation, CreateOrUpdateQuestionVerdictAndCreateCommentMutationVariables>(CreateOrUpdateQuestionVerdictAndCreateCommentDocument, options);
      }
export type CreateOrUpdateQuestionVerdictAndCreateCommentMutationHookResult = ReturnType<typeof useCreateOrUpdateQuestionVerdictAndCreateCommentMutation>;
export type CreateOrUpdateQuestionVerdictAndCreateCommentMutationResult = Apollo.MutationResult<CreateOrUpdateQuestionVerdictAndCreateCommentMutation>;
export type CreateOrUpdateQuestionVerdictAndCreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateQuestionVerdictAndCreateCommentMutation, CreateOrUpdateQuestionVerdictAndCreateCommentMutationVariables>;
export const GetQuestionCommentsAndVerdictByEntityAndTaskIdDocument = gql`
    query getQuestionCommentsAndVerdictByEntityAndTaskId($commentInput: GetQuestionCommentsByEntityAndTaskIdInput!, $verdictInput: GetQuestionVerdictsByEntityAndTaskIdInput!) {
  qctGetQuestionCommentsByEntityAndTaskId(input: $commentInput) {
    id
    entityId
    entityType
    taskId
    userId
    content
  }
  qctGetQuestionVerdictsByEntityAndTaskId(input: $verdictInput) {
    userId
    taskId
    entityId
    entityType
    id
    verdict
  }
}
    `;

/**
 * __useGetQuestionCommentsAndVerdictByEntityAndTaskIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionCommentsAndVerdictByEntityAndTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionCommentsAndVerdictByEntityAndTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionCommentsAndVerdictByEntityAndTaskIdQuery({
 *   variables: {
 *      commentInput: // value for 'commentInput'
 *      verdictInput: // value for 'verdictInput'
 *   },
 * });
 */
export function useGetQuestionCommentsAndVerdictByEntityAndTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionCommentsAndVerdictByEntityAndTaskIdQuery, GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryVariables> & ({ variables: GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionCommentsAndVerdictByEntityAndTaskIdQuery, GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryVariables>(GetQuestionCommentsAndVerdictByEntityAndTaskIdDocument, options);
      }
export function useGetQuestionCommentsAndVerdictByEntityAndTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionCommentsAndVerdictByEntityAndTaskIdQuery, GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionCommentsAndVerdictByEntityAndTaskIdQuery, GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryVariables>(GetQuestionCommentsAndVerdictByEntityAndTaskIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionCommentsAndVerdictByEntityAndTaskIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionCommentsAndVerdictByEntityAndTaskIdQuery, GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionCommentsAndVerdictByEntityAndTaskIdQuery, GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryVariables>;
export function useGetQuestionCommentsAndVerdictByEntityAndTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionCommentsAndVerdictByEntityAndTaskIdQuery, GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionCommentsAndVerdictByEntityAndTaskIdQuery | undefined, GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryVariables>;
export function useGetQuestionCommentsAndVerdictByEntityAndTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionCommentsAndVerdictByEntityAndTaskIdQuery, GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionCommentsAndVerdictByEntityAndTaskIdQuery, GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryVariables>(GetQuestionCommentsAndVerdictByEntityAndTaskIdDocument, options);
        }
export type GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryHookResult = ReturnType<typeof useGetQuestionCommentsAndVerdictByEntityAndTaskIdQuery>;
export type GetQuestionCommentsAndVerdictByEntityAndTaskIdLazyQueryHookResult = ReturnType<typeof useGetQuestionCommentsAndVerdictByEntityAndTaskIdLazyQuery>;
export type GetQuestionCommentsAndVerdictByEntityAndTaskIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionCommentsAndVerdictByEntityAndTaskIdSuspenseQuery>;
export type GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryResult = Apollo.QueryResult<GetQuestionCommentsAndVerdictByEntityAndTaskIdQuery, GetQuestionCommentsAndVerdictByEntityAndTaskIdQueryVariables>;
export const GetQuestionReviewTaskOwnerAssigneeAndTaskByIdDocument = gql`
    query getQuestionReviewTaskOwnerAssigneeAndTaskById($input: GetTaskByIdInput!) {
  wflGetTaskById(getTaskByIdInput: $input) {
    task {
      id
      assigneeId
      ownerId
      currentWorkflowStep {
        code
        stepTransitions {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery, GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryVariables> & ({ variables: GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery, GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryVariables>(GetQuestionReviewTaskOwnerAssigneeAndTaskByIdDocument, options);
      }
export function useGetQuestionReviewTaskOwnerAssigneeAndTaskByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery, GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery, GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryVariables>(GetQuestionReviewTaskOwnerAssigneeAndTaskByIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionReviewTaskOwnerAssigneeAndTaskByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery, GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery, GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryVariables>;
export function useGetQuestionReviewTaskOwnerAssigneeAndTaskByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery, GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery | undefined, GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryVariables>;
export function useGetQuestionReviewTaskOwnerAssigneeAndTaskByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery, GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery, GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryVariables>(GetQuestionReviewTaskOwnerAssigneeAndTaskByIdDocument, options);
        }
export type GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryHookResult = ReturnType<typeof useGetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery>;
export type GetQuestionReviewTaskOwnerAssigneeAndTaskByIdLazyQueryHookResult = ReturnType<typeof useGetQuestionReviewTaskOwnerAssigneeAndTaskByIdLazyQuery>;
export type GetQuestionReviewTaskOwnerAssigneeAndTaskByIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionReviewTaskOwnerAssigneeAndTaskByIdSuspenseQuery>;
export type GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryResult = Apollo.QueryResult<GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQuery, GetQuestionReviewTaskOwnerAssigneeAndTaskByIdQueryVariables>;
export const GetQuestionVerdictsByEntityAndTaskIdDocument = gql`
    query getQuestionVerdictsByEntityAndTaskId($input: GetQuestionVerdictsByEntityAndTaskIdInput!) {
  qctGetQuestionVerdictsByEntityAndTaskId(input: $input) {
    verdict
    userId
    taskId
    id
  }
}
    `;

/**
 * __useGetQuestionVerdictsByEntityAndTaskIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionVerdictsByEntityAndTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionVerdictsByEntityAndTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionVerdictsByEntityAndTaskIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuestionVerdictsByEntityAndTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionVerdictsByEntityAndTaskIdQuery, GetQuestionVerdictsByEntityAndTaskIdQueryVariables> & ({ variables: GetQuestionVerdictsByEntityAndTaskIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionVerdictsByEntityAndTaskIdQuery, GetQuestionVerdictsByEntityAndTaskIdQueryVariables>(GetQuestionVerdictsByEntityAndTaskIdDocument, options);
      }
export function useGetQuestionVerdictsByEntityAndTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionVerdictsByEntityAndTaskIdQuery, GetQuestionVerdictsByEntityAndTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionVerdictsByEntityAndTaskIdQuery, GetQuestionVerdictsByEntityAndTaskIdQueryVariables>(GetQuestionVerdictsByEntityAndTaskIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionVerdictsByEntityAndTaskIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionVerdictsByEntityAndTaskIdQuery, GetQuestionVerdictsByEntityAndTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionVerdictsByEntityAndTaskIdQuery, GetQuestionVerdictsByEntityAndTaskIdQueryVariables>;
export function useGetQuestionVerdictsByEntityAndTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionVerdictsByEntityAndTaskIdQuery, GetQuestionVerdictsByEntityAndTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionVerdictsByEntityAndTaskIdQuery | undefined, GetQuestionVerdictsByEntityAndTaskIdQueryVariables>;
export function useGetQuestionVerdictsByEntityAndTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionVerdictsByEntityAndTaskIdQuery, GetQuestionVerdictsByEntityAndTaskIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionVerdictsByEntityAndTaskIdQuery, GetQuestionVerdictsByEntityAndTaskIdQueryVariables>(GetQuestionVerdictsByEntityAndTaskIdDocument, options);
        }
export type GetQuestionVerdictsByEntityAndTaskIdQueryHookResult = ReturnType<typeof useGetQuestionVerdictsByEntityAndTaskIdQuery>;
export type GetQuestionVerdictsByEntityAndTaskIdLazyQueryHookResult = ReturnType<typeof useGetQuestionVerdictsByEntityAndTaskIdLazyQuery>;
export type GetQuestionVerdictsByEntityAndTaskIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionVerdictsByEntityAndTaskIdSuspenseQuery>;
export type GetQuestionVerdictsByEntityAndTaskIdQueryResult = Apollo.QueryResult<GetQuestionVerdictsByEntityAndTaskIdQuery, GetQuestionVerdictsByEntityAndTaskIdQueryVariables>;
export const GetQuestionCommentsByEntityAndTaskIdDocument = gql`
    query getQuestionCommentsByEntityAndTaskId($input: GetQuestionCommentsByEntityAndTaskIdInput!) {
  qctGetQuestionCommentsByEntityAndTaskId(input: $input) {
    userId
    taskId
    id
    content
  }
}
    `;

/**
 * __useGetQuestionCommentsByEntityAndTaskIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionCommentsByEntityAndTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionCommentsByEntityAndTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionCommentsByEntityAndTaskIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuestionCommentsByEntityAndTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionCommentsByEntityAndTaskIdQuery, GetQuestionCommentsByEntityAndTaskIdQueryVariables> & ({ variables: GetQuestionCommentsByEntityAndTaskIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionCommentsByEntityAndTaskIdQuery, GetQuestionCommentsByEntityAndTaskIdQueryVariables>(GetQuestionCommentsByEntityAndTaskIdDocument, options);
      }
export function useGetQuestionCommentsByEntityAndTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionCommentsByEntityAndTaskIdQuery, GetQuestionCommentsByEntityAndTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionCommentsByEntityAndTaskIdQuery, GetQuestionCommentsByEntityAndTaskIdQueryVariables>(GetQuestionCommentsByEntityAndTaskIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionCommentsByEntityAndTaskIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionCommentsByEntityAndTaskIdQuery, GetQuestionCommentsByEntityAndTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionCommentsByEntityAndTaskIdQuery, GetQuestionCommentsByEntityAndTaskIdQueryVariables>;
export function useGetQuestionCommentsByEntityAndTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionCommentsByEntityAndTaskIdQuery, GetQuestionCommentsByEntityAndTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionCommentsByEntityAndTaskIdQuery | undefined, GetQuestionCommentsByEntityAndTaskIdQueryVariables>;
export function useGetQuestionCommentsByEntityAndTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionCommentsByEntityAndTaskIdQuery, GetQuestionCommentsByEntityAndTaskIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionCommentsByEntityAndTaskIdQuery, GetQuestionCommentsByEntityAndTaskIdQueryVariables>(GetQuestionCommentsByEntityAndTaskIdDocument, options);
        }
export type GetQuestionCommentsByEntityAndTaskIdQueryHookResult = ReturnType<typeof useGetQuestionCommentsByEntityAndTaskIdQuery>;
export type GetQuestionCommentsByEntityAndTaskIdLazyQueryHookResult = ReturnType<typeof useGetQuestionCommentsByEntityAndTaskIdLazyQuery>;
export type GetQuestionCommentsByEntityAndTaskIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionCommentsByEntityAndTaskIdSuspenseQuery>;
export type GetQuestionCommentsByEntityAndTaskIdQueryResult = Apollo.QueryResult<GetQuestionCommentsByEntityAndTaskIdQuery, GetQuestionCommentsByEntityAndTaskIdQueryVariables>;
export const GetQBankStructureLevelsForQuestionReviewDocument = gql`
    query getQBankStructureLevelsForQuestionReview($qBankStructureId: String!, $taskId: String!) {
  qbsGetTaskQBankStructureLevelsByQBankStructureId(
    qBankStructureId: $qBankStructureId
    taskId: $taskId
  ) {
    id
    level
    category
    enabled
  }
}
    `;

/**
 * __useGetQBankStructureLevelsForQuestionReviewQuery__
 *
 * To run a query within a React component, call `useGetQBankStructureLevelsForQuestionReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQBankStructureLevelsForQuestionReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQBankStructureLevelsForQuestionReviewQuery({
 *   variables: {
 *      qBankStructureId: // value for 'qBankStructureId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetQBankStructureLevelsForQuestionReviewQuery(baseOptions: Apollo.QueryHookOptions<GetQBankStructureLevelsForQuestionReviewQuery, GetQBankStructureLevelsForQuestionReviewQueryVariables> & ({ variables: GetQBankStructureLevelsForQuestionReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQBankStructureLevelsForQuestionReviewQuery, GetQBankStructureLevelsForQuestionReviewQueryVariables>(GetQBankStructureLevelsForQuestionReviewDocument, options);
      }
export function useGetQBankStructureLevelsForQuestionReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQBankStructureLevelsForQuestionReviewQuery, GetQBankStructureLevelsForQuestionReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQBankStructureLevelsForQuestionReviewQuery, GetQBankStructureLevelsForQuestionReviewQueryVariables>(GetQBankStructureLevelsForQuestionReviewDocument, options);
        }
// @ts-ignore
export function useGetQBankStructureLevelsForQuestionReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelsForQuestionReviewQuery, GetQBankStructureLevelsForQuestionReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelsForQuestionReviewQuery, GetQBankStructureLevelsForQuestionReviewQueryVariables>;
export function useGetQBankStructureLevelsForQuestionReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelsForQuestionReviewQuery, GetQBankStructureLevelsForQuestionReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelsForQuestionReviewQuery | undefined, GetQBankStructureLevelsForQuestionReviewQueryVariables>;
export function useGetQBankStructureLevelsForQuestionReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelsForQuestionReviewQuery, GetQBankStructureLevelsForQuestionReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQBankStructureLevelsForQuestionReviewQuery, GetQBankStructureLevelsForQuestionReviewQueryVariables>(GetQBankStructureLevelsForQuestionReviewDocument, options);
        }
export type GetQBankStructureLevelsForQuestionReviewQueryHookResult = ReturnType<typeof useGetQBankStructureLevelsForQuestionReviewQuery>;
export type GetQBankStructureLevelsForQuestionReviewLazyQueryHookResult = ReturnType<typeof useGetQBankStructureLevelsForQuestionReviewLazyQuery>;
export type GetQBankStructureLevelsForQuestionReviewSuspenseQueryHookResult = ReturnType<typeof useGetQBankStructureLevelsForQuestionReviewSuspenseQuery>;
export type GetQBankStructureLevelsForQuestionReviewQueryResult = Apollo.QueryResult<GetQBankStructureLevelsForQuestionReviewQuery, GetQBankStructureLevelsForQuestionReviewQueryVariables>;
export const GetQBankStructureLevelItemsForQuestionReviewDocument = gql`
    query getQBankStructureLevelItemsForQuestionReview($qBankStructureId: String!, $taskId: String!) {
  qbsGetTaskQBankStructureLevelItemsByQBankStructureId(
    qBankStructureId: $qBankStructureId
    taskId: $taskId
  ) {
    id
    qBankStructureId
    tagId
    parentLevelItemId
    order
    qBankStructureLevelId
    tag {
      id
      name
    }
  }
}
    `;

/**
 * __useGetQBankStructureLevelItemsForQuestionReviewQuery__
 *
 * To run a query within a React component, call `useGetQBankStructureLevelItemsForQuestionReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQBankStructureLevelItemsForQuestionReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQBankStructureLevelItemsForQuestionReviewQuery({
 *   variables: {
 *      qBankStructureId: // value for 'qBankStructureId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetQBankStructureLevelItemsForQuestionReviewQuery(baseOptions: Apollo.QueryHookOptions<GetQBankStructureLevelItemsForQuestionReviewQuery, GetQBankStructureLevelItemsForQuestionReviewQueryVariables> & ({ variables: GetQBankStructureLevelItemsForQuestionReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQBankStructureLevelItemsForQuestionReviewQuery, GetQBankStructureLevelItemsForQuestionReviewQueryVariables>(GetQBankStructureLevelItemsForQuestionReviewDocument, options);
      }
export function useGetQBankStructureLevelItemsForQuestionReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQBankStructureLevelItemsForQuestionReviewQuery, GetQBankStructureLevelItemsForQuestionReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQBankStructureLevelItemsForQuestionReviewQuery, GetQBankStructureLevelItemsForQuestionReviewQueryVariables>(GetQBankStructureLevelItemsForQuestionReviewDocument, options);
        }
// @ts-ignore
export function useGetQBankStructureLevelItemsForQuestionReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsForQuestionReviewQuery, GetQBankStructureLevelItemsForQuestionReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelItemsForQuestionReviewQuery, GetQBankStructureLevelItemsForQuestionReviewQueryVariables>;
export function useGetQBankStructureLevelItemsForQuestionReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsForQuestionReviewQuery, GetQBankStructureLevelItemsForQuestionReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetQBankStructureLevelItemsForQuestionReviewQuery | undefined, GetQBankStructureLevelItemsForQuestionReviewQueryVariables>;
export function useGetQBankStructureLevelItemsForQuestionReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQBankStructureLevelItemsForQuestionReviewQuery, GetQBankStructureLevelItemsForQuestionReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQBankStructureLevelItemsForQuestionReviewQuery, GetQBankStructureLevelItemsForQuestionReviewQueryVariables>(GetQBankStructureLevelItemsForQuestionReviewDocument, options);
        }
export type GetQBankStructureLevelItemsForQuestionReviewQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsForQuestionReviewQuery>;
export type GetQBankStructureLevelItemsForQuestionReviewLazyQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsForQuestionReviewLazyQuery>;
export type GetQBankStructureLevelItemsForQuestionReviewSuspenseQueryHookResult = ReturnType<typeof useGetQBankStructureLevelItemsForQuestionReviewSuspenseQuery>;
export type GetQBankStructureLevelItemsForQuestionReviewQueryResult = Apollo.QueryResult<GetQBankStructureLevelItemsForQuestionReviewQuery, GetQBankStructureLevelItemsForQuestionReviewQueryVariables>;
export const SubmitQuestionReviewDocument = gql`
    mutation submitQuestionReview($submitQuestionReviewInput: SubmitQuestionReviewInput!) {
  wflSubmitQuestionReview(submitQuestionReviewInput: $submitQuestionReviewInput) {
    success
    message
    code
    missingQuestionVerdictCount
  }
}
    `;
export type SubmitQuestionReviewMutationFn = Apollo.MutationFunction<SubmitQuestionReviewMutation, SubmitQuestionReviewMutationVariables>;

/**
 * __useSubmitQuestionReviewMutation__
 *
 * To run a mutation, you first call `useSubmitQuestionReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitQuestionReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitQuestionReviewMutation, { data, loading, error }] = useSubmitQuestionReviewMutation({
 *   variables: {
 *      submitQuestionReviewInput: // value for 'submitQuestionReviewInput'
 *   },
 * });
 */
export function useSubmitQuestionReviewMutation(baseOptions?: Apollo.MutationHookOptions<SubmitQuestionReviewMutation, SubmitQuestionReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitQuestionReviewMutation, SubmitQuestionReviewMutationVariables>(SubmitQuestionReviewDocument, options);
      }
export type SubmitQuestionReviewMutationHookResult = ReturnType<typeof useSubmitQuestionReviewMutation>;
export type SubmitQuestionReviewMutationResult = Apollo.MutationResult<SubmitQuestionReviewMutation>;
export type SubmitQuestionReviewMutationOptions = Apollo.BaseMutationOptions<SubmitQuestionReviewMutation, SubmitQuestionReviewMutationVariables>;
export const GetTaskQuestionVerdictsDocument = gql`
    query getTaskQuestionVerdicts($input: GetTaskQuestionVerdictsInput!) {
  qctGetTaskQuestionVerdicts(input: $input) {
    id
    entityType
    entityId
    taskId
    userId
    verdict
  }
}
    `;

/**
 * __useGetTaskQuestionVerdictsQuery__
 *
 * To run a query within a React component, call `useGetTaskQuestionVerdictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuestionVerdictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuestionVerdictsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTaskQuestionVerdictsQuery(baseOptions: Apollo.QueryHookOptions<GetTaskQuestionVerdictsQuery, GetTaskQuestionVerdictsQueryVariables> & ({ variables: GetTaskQuestionVerdictsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskQuestionVerdictsQuery, GetTaskQuestionVerdictsQueryVariables>(GetTaskQuestionVerdictsDocument, options);
      }
export function useGetTaskQuestionVerdictsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskQuestionVerdictsQuery, GetTaskQuestionVerdictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskQuestionVerdictsQuery, GetTaskQuestionVerdictsQueryVariables>(GetTaskQuestionVerdictsDocument, options);
        }
// @ts-ignore
export function useGetTaskQuestionVerdictsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskQuestionVerdictsQuery, GetTaskQuestionVerdictsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskQuestionVerdictsQuery, GetTaskQuestionVerdictsQueryVariables>;
export function useGetTaskQuestionVerdictsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskQuestionVerdictsQuery, GetTaskQuestionVerdictsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskQuestionVerdictsQuery | undefined, GetTaskQuestionVerdictsQueryVariables>;
export function useGetTaskQuestionVerdictsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskQuestionVerdictsQuery, GetTaskQuestionVerdictsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskQuestionVerdictsQuery, GetTaskQuestionVerdictsQueryVariables>(GetTaskQuestionVerdictsDocument, options);
        }
export type GetTaskQuestionVerdictsQueryHookResult = ReturnType<typeof useGetTaskQuestionVerdictsQuery>;
export type GetTaskQuestionVerdictsLazyQueryHookResult = ReturnType<typeof useGetTaskQuestionVerdictsLazyQuery>;
export type GetTaskQuestionVerdictsSuspenseQueryHookResult = ReturnType<typeof useGetTaskQuestionVerdictsSuspenseQuery>;
export type GetTaskQuestionVerdictsQueryResult = Apollo.QueryResult<GetTaskQuestionVerdictsQuery, GetTaskQuestionVerdictsQueryVariables>;
export const GetMyTasksDocument = gql`
    query getMyTasks($getMyTasksInput: GetMyTasksInput!) {
  wflGetMyTasks(getMyTasksInput: $getMyTasksInput) {
    tasks {
      id
      assigner {
        firstname
        lastname
        email
      }
      code
      updatedAt
      dueDate
      name
      status
      parentTask {
        id
        name
      }
      currentWorkflowStep {
        workflowCode
        code
        name
      }
    }
    total
  }
}
    `;

/**
 * __useGetMyTasksQuery__
 *
 * To run a query within a React component, call `useGetMyTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTasksQuery({
 *   variables: {
 *      getMyTasksInput: // value for 'getMyTasksInput'
 *   },
 * });
 */
export function useGetMyTasksQuery(baseOptions: Apollo.QueryHookOptions<GetMyTasksQuery, GetMyTasksQueryVariables> & ({ variables: GetMyTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTasksQuery, GetMyTasksQueryVariables>(GetMyTasksDocument, options);
      }
export function useGetMyTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTasksQuery, GetMyTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTasksQuery, GetMyTasksQueryVariables>(GetMyTasksDocument, options);
        }
// @ts-ignore
export function useGetMyTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyTasksQuery, GetMyTasksQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyTasksQuery, GetMyTasksQueryVariables>;
export function useGetMyTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyTasksQuery, GetMyTasksQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyTasksQuery | undefined, GetMyTasksQueryVariables>;
export function useGetMyTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyTasksQuery, GetMyTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyTasksQuery, GetMyTasksQueryVariables>(GetMyTasksDocument, options);
        }
export type GetMyTasksQueryHookResult = ReturnType<typeof useGetMyTasksQuery>;
export type GetMyTasksLazyQueryHookResult = ReturnType<typeof useGetMyTasksLazyQuery>;
export type GetMyTasksSuspenseQueryHookResult = ReturnType<typeof useGetMyTasksSuspenseQuery>;
export type GetMyTasksQueryResult = Apollo.QueryResult<GetMyTasksQuery, GetMyTasksQueryVariables>;
export const CreateTaskAndSubtasksDocument = gql`
    mutation createTaskAndSubtasks($createTaskAndSubtasksInput: CreateTaskAndSubtasksInput!) {
  wflCreateTaskAndSubtasks(
    createTaskAndSubtasksInput: $createTaskAndSubtasksInput
  ) {
    task {
      id
    }
    subtasks {
      id
    }
  }
}
    `;
export type CreateTaskAndSubtasksMutationFn = Apollo.MutationFunction<CreateTaskAndSubtasksMutation, CreateTaskAndSubtasksMutationVariables>;

/**
 * __useCreateTaskAndSubtasksMutation__
 *
 * To run a mutation, you first call `useCreateTaskAndSubtasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskAndSubtasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskAndSubtasksMutation, { data, loading, error }] = useCreateTaskAndSubtasksMutation({
 *   variables: {
 *      createTaskAndSubtasksInput: // value for 'createTaskAndSubtasksInput'
 *   },
 * });
 */
export function useCreateTaskAndSubtasksMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskAndSubtasksMutation, CreateTaskAndSubtasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskAndSubtasksMutation, CreateTaskAndSubtasksMutationVariables>(CreateTaskAndSubtasksDocument, options);
      }
export type CreateTaskAndSubtasksMutationHookResult = ReturnType<typeof useCreateTaskAndSubtasksMutation>;
export type CreateTaskAndSubtasksMutationResult = Apollo.MutationResult<CreateTaskAndSubtasksMutation>;
export type CreateTaskAndSubtasksMutationOptions = Apollo.BaseMutationOptions<CreateTaskAndSubtasksMutation, CreateTaskAndSubtasksMutationVariables>;
export const GetSubTaskByIdDocument = gql`
    query getSubTaskById($getTaskByIdInput: GetTaskByIdInput!) {
  wflGetTaskById(getTaskByIdInput: $getTaskByIdInput) {
    task {
      id
      name
      createdAt
      updatedAt
      dueDate
      code
      status
      assignee {
        id
        firstname
        lastname
      }
      assignedAt
      submittedAt
    }
  }
}
    `;

/**
 * __useGetSubTaskByIdQuery__
 *
 * To run a query within a React component, call `useGetSubTaskByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubTaskByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubTaskByIdQuery({
 *   variables: {
 *      getTaskByIdInput: // value for 'getTaskByIdInput'
 *   },
 * });
 */
export function useGetSubTaskByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSubTaskByIdQuery, GetSubTaskByIdQueryVariables> & ({ variables: GetSubTaskByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubTaskByIdQuery, GetSubTaskByIdQueryVariables>(GetSubTaskByIdDocument, options);
      }
export function useGetSubTaskByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubTaskByIdQuery, GetSubTaskByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubTaskByIdQuery, GetSubTaskByIdQueryVariables>(GetSubTaskByIdDocument, options);
        }
// @ts-ignore
export function useGetSubTaskByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubTaskByIdQuery, GetSubTaskByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubTaskByIdQuery, GetSubTaskByIdQueryVariables>;
export function useGetSubTaskByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubTaskByIdQuery, GetSubTaskByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubTaskByIdQuery | undefined, GetSubTaskByIdQueryVariables>;
export function useGetSubTaskByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubTaskByIdQuery, GetSubTaskByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubTaskByIdQuery, GetSubTaskByIdQueryVariables>(GetSubTaskByIdDocument, options);
        }
export type GetSubTaskByIdQueryHookResult = ReturnType<typeof useGetSubTaskByIdQuery>;
export type GetSubTaskByIdLazyQueryHookResult = ReturnType<typeof useGetSubTaskByIdLazyQuery>;
export type GetSubTaskByIdSuspenseQueryHookResult = ReturnType<typeof useGetSubTaskByIdSuspenseQuery>;
export type GetSubTaskByIdQueryResult = Apollo.QueryResult<GetSubTaskByIdQuery, GetSubTaskByIdQueryVariables>;
export const GetTaskByIdDocument = gql`
    query getTaskById($getTaskByIdInput: GetTaskByIdInput!) {
  wflGetTaskById(getTaskByIdInput: $getTaskByIdInput) {
    task {
      id
      name
      createdAt
      updatedAt
      dueDate
      code
      status
      assignee {
        id
        firstname
        lastname
      }
      ownerId
      assignerId
      metadata {
        ... on TaskMetadataWithExamCourse {
          examCourse {
            id
            code
            examId
            name
            totalQSet
            totalQConfig
          }
        }
      }
      currentWorkflowStep {
        workflowCode
        code
        name
      }
      owner {
        firstname
        lastname
      }
      subtasks {
        assignee {
          id
          firstname
          lastname
        }
        id
        dueDate
        code
        status
        currentWorkflowStep {
          workflowCode
          code
          name
        }
        submittedAt
        metadata {
          ... on TaskMetadataWithQSet {
            qSet {
              id
              code
              qSetGeneratorExecutionResultId
              pAvgValue
              qConfig {
                code
                totalQuestions
                metadata {
                  timeLimit {
                    values {
                      value
                      order
                      qConfigStructureIds
                    }
                  }
                }
              }
              examCourseId
            }
          }
        }
        updatedAt
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetTaskByIdQuery__
 *
 * To run a query within a React component, call `useGetTaskByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskByIdQuery({
 *   variables: {
 *      getTaskByIdInput: // value for 'getTaskByIdInput'
 *   },
 * });
 */
export function useGetTaskByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables> & ({ variables: GetTaskByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskByIdQuery, GetTaskByIdQueryVariables>(GetTaskByIdDocument, options);
      }
export function useGetTaskByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskByIdQuery, GetTaskByIdQueryVariables>(GetTaskByIdDocument, options);
        }
// @ts-ignore
export function useGetTaskByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskByIdQuery, GetTaskByIdQueryVariables>;
export function useGetTaskByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskByIdQuery | undefined, GetTaskByIdQueryVariables>;
export function useGetTaskByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskByIdQuery, GetTaskByIdQueryVariables>(GetTaskByIdDocument, options);
        }
export type GetTaskByIdQueryHookResult = ReturnType<typeof useGetTaskByIdQuery>;
export type GetTaskByIdLazyQueryHookResult = ReturnType<typeof useGetTaskByIdLazyQuery>;
export type GetTaskByIdSuspenseQueryHookResult = ReturnType<typeof useGetTaskByIdSuspenseQuery>;
export type GetTaskByIdQueryResult = Apollo.QueryResult<GetTaskByIdQuery, GetTaskByIdQueryVariables>;
export const SearchOwnedAndAssignedTasksDocument = gql`
    query searchOwnedAndAssignedTasks($searchOwnedAndAssignedTasksInput: SearchOwnedAndAssignedTasksInput!) {
  wflSearchOwnedAndAssignedTasks(
    searchOwnedAndAssignedTasksInput: $searchOwnedAndAssignedTasksInput
  ) {
    tasks {
      id
      assignee {
        firstname
        lastname
        email
      }
      assigner {
        firstname
        lastname
        email
      }
      dueDate
      name
      status
      code
      updatedAt
      taskEntities {
        entityId
        entityType
      }
      parentTask {
        name
      }
      currentWorkflowStep {
        workflowCode
        code
        name
      }
      metadata {
        ... on TaskMetadataWithExamCourse {
          subtaskEntityQuantity
          examCourse {
            code
            name
          }
        }
        ... on TaskMetadataWithQuestionCreation {
          qBankStructure {
            name
            id
            code
          }
          requiredQuestionCount
        }
        ... on TaskMetadataWithReviewQuestion {
          questionQuantity
          qBankStructure {
            code
          }
        }
      }
      subtasks {
        assignee {
          firstname
          lastname
          email
        }
        dueDate
      }
      subtaskCount
    }
    total
  }
}
    `;

/**
 * __useSearchOwnedAndAssignedTasksQuery__
 *
 * To run a query within a React component, call `useSearchOwnedAndAssignedTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOwnedAndAssignedTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOwnedAndAssignedTasksQuery({
 *   variables: {
 *      searchOwnedAndAssignedTasksInput: // value for 'searchOwnedAndAssignedTasksInput'
 *   },
 * });
 */
export function useSearchOwnedAndAssignedTasksQuery(baseOptions: Apollo.QueryHookOptions<SearchOwnedAndAssignedTasksQuery, SearchOwnedAndAssignedTasksQueryVariables> & ({ variables: SearchOwnedAndAssignedTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOwnedAndAssignedTasksQuery, SearchOwnedAndAssignedTasksQueryVariables>(SearchOwnedAndAssignedTasksDocument, options);
      }
export function useSearchOwnedAndAssignedTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOwnedAndAssignedTasksQuery, SearchOwnedAndAssignedTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOwnedAndAssignedTasksQuery, SearchOwnedAndAssignedTasksQueryVariables>(SearchOwnedAndAssignedTasksDocument, options);
        }
// @ts-ignore
export function useSearchOwnedAndAssignedTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchOwnedAndAssignedTasksQuery, SearchOwnedAndAssignedTasksQueryVariables>): Apollo.UseSuspenseQueryResult<SearchOwnedAndAssignedTasksQuery, SearchOwnedAndAssignedTasksQueryVariables>;
export function useSearchOwnedAndAssignedTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOwnedAndAssignedTasksQuery, SearchOwnedAndAssignedTasksQueryVariables>): Apollo.UseSuspenseQueryResult<SearchOwnedAndAssignedTasksQuery | undefined, SearchOwnedAndAssignedTasksQueryVariables>;
export function useSearchOwnedAndAssignedTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOwnedAndAssignedTasksQuery, SearchOwnedAndAssignedTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchOwnedAndAssignedTasksQuery, SearchOwnedAndAssignedTasksQueryVariables>(SearchOwnedAndAssignedTasksDocument, options);
        }
export type SearchOwnedAndAssignedTasksQueryHookResult = ReturnType<typeof useSearchOwnedAndAssignedTasksQuery>;
export type SearchOwnedAndAssignedTasksLazyQueryHookResult = ReturnType<typeof useSearchOwnedAndAssignedTasksLazyQuery>;
export type SearchOwnedAndAssignedTasksSuspenseQueryHookResult = ReturnType<typeof useSearchOwnedAndAssignedTasksSuspenseQuery>;
export type SearchOwnedAndAssignedTasksQueryResult = Apollo.QueryResult<SearchOwnedAndAssignedTasksQuery, SearchOwnedAndAssignedTasksQueryVariables>;
export const UpdateTaskStatusDocument = gql`
    mutation updateTaskStatus($updateTaskStatusInput: UpdateTaskStatusInput!) {
  wflUpdateTaskStatus(updateTaskStatusInput: $updateTaskStatusInput) {
    task {
      id
      status
    }
  }
}
    `;
export type UpdateTaskStatusMutationFn = Apollo.MutationFunction<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables>;

/**
 * __useUpdateTaskStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTaskStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskStatusMutation, { data, loading, error }] = useUpdateTaskStatusMutation({
 *   variables: {
 *      updateTaskStatusInput: // value for 'updateTaskStatusInput'
 *   },
 * });
 */
export function useUpdateTaskStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables>(UpdateTaskStatusDocument, options);
      }
export type UpdateTaskStatusMutationHookResult = ReturnType<typeof useUpdateTaskStatusMutation>;
export type UpdateTaskStatusMutationResult = Apollo.MutationResult<UpdateTaskStatusMutation>;
export type UpdateTaskStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables>;
export const GetStepTransitionsByTaskIdDocument = gql`
    query getStepTransitionsByTaskId($getStepTransitionsByTaskIdInput: GetStepTransitionsByTaskIdInput!) {
  wflGetStepTransitionsByTaskId(
    getStepTransitionsByTaskIdInput: $getStepTransitionsByTaskIdInput
  ) {
    steps {
      id
      name
    }
  }
}
    `;

/**
 * __useGetStepTransitionsByTaskIdQuery__
 *
 * To run a query within a React component, call `useGetStepTransitionsByTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStepTransitionsByTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStepTransitionsByTaskIdQuery({
 *   variables: {
 *      getStepTransitionsByTaskIdInput: // value for 'getStepTransitionsByTaskIdInput'
 *   },
 * });
 */
export function useGetStepTransitionsByTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GetStepTransitionsByTaskIdQuery, GetStepTransitionsByTaskIdQueryVariables> & ({ variables: GetStepTransitionsByTaskIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStepTransitionsByTaskIdQuery, GetStepTransitionsByTaskIdQueryVariables>(GetStepTransitionsByTaskIdDocument, options);
      }
export function useGetStepTransitionsByTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStepTransitionsByTaskIdQuery, GetStepTransitionsByTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStepTransitionsByTaskIdQuery, GetStepTransitionsByTaskIdQueryVariables>(GetStepTransitionsByTaskIdDocument, options);
        }
// @ts-ignore
export function useGetStepTransitionsByTaskIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStepTransitionsByTaskIdQuery, GetStepTransitionsByTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetStepTransitionsByTaskIdQuery, GetStepTransitionsByTaskIdQueryVariables>;
export function useGetStepTransitionsByTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStepTransitionsByTaskIdQuery, GetStepTransitionsByTaskIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetStepTransitionsByTaskIdQuery | undefined, GetStepTransitionsByTaskIdQueryVariables>;
export function useGetStepTransitionsByTaskIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStepTransitionsByTaskIdQuery, GetStepTransitionsByTaskIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStepTransitionsByTaskIdQuery, GetStepTransitionsByTaskIdQueryVariables>(GetStepTransitionsByTaskIdDocument, options);
        }
export type GetStepTransitionsByTaskIdQueryHookResult = ReturnType<typeof useGetStepTransitionsByTaskIdQuery>;
export type GetStepTransitionsByTaskIdLazyQueryHookResult = ReturnType<typeof useGetStepTransitionsByTaskIdLazyQuery>;
export type GetStepTransitionsByTaskIdSuspenseQueryHookResult = ReturnType<typeof useGetStepTransitionsByTaskIdSuspenseQuery>;
export type GetStepTransitionsByTaskIdQueryResult = Apollo.QueryResult<GetStepTransitionsByTaskIdQuery, GetStepTransitionsByTaskIdQueryVariables>;
export const UpdateTaskStatusByIdDocument = gql`
    mutation updateTaskStatusById($updateTaskStatusInput: UpdateTaskStatusInput!) {
  wflUpdateTaskStatus(updateTaskStatusInput: $updateTaskStatusInput) {
    task {
      id
      currentWorkflowStepId
    }
  }
}
    `;
export type UpdateTaskStatusByIdMutationFn = Apollo.MutationFunction<UpdateTaskStatusByIdMutation, UpdateTaskStatusByIdMutationVariables>;

/**
 * __useUpdateTaskStatusByIdMutation__
 *
 * To run a mutation, you first call `useUpdateTaskStatusByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskStatusByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskStatusByIdMutation, { data, loading, error }] = useUpdateTaskStatusByIdMutation({
 *   variables: {
 *      updateTaskStatusInput: // value for 'updateTaskStatusInput'
 *   },
 * });
 */
export function useUpdateTaskStatusByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskStatusByIdMutation, UpdateTaskStatusByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskStatusByIdMutation, UpdateTaskStatusByIdMutationVariables>(UpdateTaskStatusByIdDocument, options);
      }
export type UpdateTaskStatusByIdMutationHookResult = ReturnType<typeof useUpdateTaskStatusByIdMutation>;
export type UpdateTaskStatusByIdMutationResult = Apollo.MutationResult<UpdateTaskStatusByIdMutation>;
export type UpdateTaskStatusByIdMutationOptions = Apollo.BaseMutationOptions<UpdateTaskStatusByIdMutation, UpdateTaskStatusByIdMutationVariables>;
export const GetTaskDueDateByIdDocument = gql`
    query getTaskDueDateById($getTaskByIdInput: GetTaskByIdInput!) {
  wflGetTaskById(getTaskByIdInput: $getTaskByIdInput) {
    task {
      id
      dueDate
    }
  }
}
    `;

/**
 * __useGetTaskDueDateByIdQuery__
 *
 * To run a query within a React component, call `useGetTaskDueDateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskDueDateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskDueDateByIdQuery({
 *   variables: {
 *      getTaskByIdInput: // value for 'getTaskByIdInput'
 *   },
 * });
 */
export function useGetTaskDueDateByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTaskDueDateByIdQuery, GetTaskDueDateByIdQueryVariables> & ({ variables: GetTaskDueDateByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskDueDateByIdQuery, GetTaskDueDateByIdQueryVariables>(GetTaskDueDateByIdDocument, options);
      }
export function useGetTaskDueDateByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskDueDateByIdQuery, GetTaskDueDateByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskDueDateByIdQuery, GetTaskDueDateByIdQueryVariables>(GetTaskDueDateByIdDocument, options);
        }
// @ts-ignore
export function useGetTaskDueDateByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskDueDateByIdQuery, GetTaskDueDateByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskDueDateByIdQuery, GetTaskDueDateByIdQueryVariables>;
export function useGetTaskDueDateByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskDueDateByIdQuery, GetTaskDueDateByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskDueDateByIdQuery | undefined, GetTaskDueDateByIdQueryVariables>;
export function useGetTaskDueDateByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskDueDateByIdQuery, GetTaskDueDateByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskDueDateByIdQuery, GetTaskDueDateByIdQueryVariables>(GetTaskDueDateByIdDocument, options);
        }
export type GetTaskDueDateByIdQueryHookResult = ReturnType<typeof useGetTaskDueDateByIdQuery>;
export type GetTaskDueDateByIdLazyQueryHookResult = ReturnType<typeof useGetTaskDueDateByIdLazyQuery>;
export type GetTaskDueDateByIdSuspenseQueryHookResult = ReturnType<typeof useGetTaskDueDateByIdSuspenseQuery>;
export type GetTaskDueDateByIdQueryResult = Apollo.QueryResult<GetTaskDueDateByIdQuery, GetTaskDueDateByIdQueryVariables>;
export const GetExamCourseCommentsDocument = gql`
    query getExamCourseComments($getExamCourseCommentsInput: GetExamCourseCommentsInput!) {
  excGetExamCourseComments(
    GetExamCourseCommentsInput: $getExamCourseCommentsInput
  ) {
    taskId
    entityId
    entityType
    comments {
      id
      taskId
      userId
      entityId
      entityType
      content
      createdAt
      updatedAt
      user {
        firstname
        lastname
        email
        image
      }
    }
  }
}
    `;

/**
 * __useGetExamCourseCommentsQuery__
 *
 * To run a query within a React component, call `useGetExamCourseCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCourseCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCourseCommentsQuery({
 *   variables: {
 *      getExamCourseCommentsInput: // value for 'getExamCourseCommentsInput'
 *   },
 * });
 */
export function useGetExamCourseCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables> & ({ variables: GetExamCourseCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>(GetExamCourseCommentsDocument, options);
      }
export function useGetExamCourseCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>(GetExamCourseCommentsDocument, options);
        }
// @ts-ignore
export function useGetExamCourseCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>;
export function useGetExamCourseCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetExamCourseCommentsQuery | undefined, GetExamCourseCommentsQueryVariables>;
export function useGetExamCourseCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>(GetExamCourseCommentsDocument, options);
        }
export type GetExamCourseCommentsQueryHookResult = ReturnType<typeof useGetExamCourseCommentsQuery>;
export type GetExamCourseCommentsLazyQueryHookResult = ReturnType<typeof useGetExamCourseCommentsLazyQuery>;
export type GetExamCourseCommentsSuspenseQueryHookResult = ReturnType<typeof useGetExamCourseCommentsSuspenseQuery>;
export type GetExamCourseCommentsQueryResult = Apollo.QueryResult<GetExamCourseCommentsQuery, GetExamCourseCommentsQueryVariables>;
export const SendExamCourseCommentDocument = gql`
    mutation sendExamCourseComment($createExamCourseCommentInput: CreateExamCourseCommentInput!) {
  excCreateExamCourseComment(
    CreateExamCourseCommentInput: $createExamCourseCommentInput
  ) {
    comment {
      id
      taskId
      userId
      entityId
      entityType
      content
      createdAt
      updatedAt
    }
  }
}
    `;
export type SendExamCourseCommentMutationFn = Apollo.MutationFunction<SendExamCourseCommentMutation, SendExamCourseCommentMutationVariables>;

/**
 * __useSendExamCourseCommentMutation__
 *
 * To run a mutation, you first call `useSendExamCourseCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendExamCourseCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendExamCourseCommentMutation, { data, loading, error }] = useSendExamCourseCommentMutation({
 *   variables: {
 *      createExamCourseCommentInput: // value for 'createExamCourseCommentInput'
 *   },
 * });
 */
export function useSendExamCourseCommentMutation(baseOptions?: Apollo.MutationHookOptions<SendExamCourseCommentMutation, SendExamCourseCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendExamCourseCommentMutation, SendExamCourseCommentMutationVariables>(SendExamCourseCommentDocument, options);
      }
export type SendExamCourseCommentMutationHookResult = ReturnType<typeof useSendExamCourseCommentMutation>;
export type SendExamCourseCommentMutationResult = Apollo.MutationResult<SendExamCourseCommentMutation>;
export type SendExamCourseCommentMutationOptions = Apollo.BaseMutationOptions<SendExamCourseCommentMutation, SendExamCourseCommentMutationVariables>;
export const GetTaskCommentsDocument = gql`
    query getTaskComments($getTaskCommentsInputType: GetTaskCommentsInput!) {
  wflGetTaskComments(getTaskCommentsInputType: $getTaskCommentsInputType) {
    taskId
    comments {
      user {
        firstname
        lastname
        email
        image
      }
      id
      taskId
      content
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetTaskCommentsQuery__
 *
 * To run a query within a React component, call `useGetTaskCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskCommentsQuery({
 *   variables: {
 *      getTaskCommentsInputType: // value for 'getTaskCommentsInputType'
 *   },
 * });
 */
export function useGetTaskCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetTaskCommentsQuery, GetTaskCommentsQueryVariables> & ({ variables: GetTaskCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>(GetTaskCommentsDocument, options);
      }
export function useGetTaskCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>(GetTaskCommentsDocument, options);
        }
// @ts-ignore
export function useGetTaskCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>;
export function useGetTaskCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskCommentsQuery | undefined, GetTaskCommentsQueryVariables>;
export function useGetTaskCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>(GetTaskCommentsDocument, options);
        }
export type GetTaskCommentsQueryHookResult = ReturnType<typeof useGetTaskCommentsQuery>;
export type GetTaskCommentsLazyQueryHookResult = ReturnType<typeof useGetTaskCommentsLazyQuery>;
export type GetTaskCommentsSuspenseQueryHookResult = ReturnType<typeof useGetTaskCommentsSuspenseQuery>;
export type GetTaskCommentsQueryResult = Apollo.QueryResult<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>;
export const SendTaskCommentDocument = gql`
    mutation sendTaskComment($createTaskCommentInputType: CreateTaskCommentInput!) {
  wflCreateTaskComment(createTaskCommentInputType: $createTaskCommentInputType) {
    comment {
      user {
        firstname
        lastname
        image
      }
      id
      taskId
      content
      createdAt
      updatedAt
    }
  }
}
    `;
export type SendTaskCommentMutationFn = Apollo.MutationFunction<SendTaskCommentMutation, SendTaskCommentMutationVariables>;

/**
 * __useSendTaskCommentMutation__
 *
 * To run a mutation, you first call `useSendTaskCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTaskCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTaskCommentMutation, { data, loading, error }] = useSendTaskCommentMutation({
 *   variables: {
 *      createTaskCommentInputType: // value for 'createTaskCommentInputType'
 *   },
 * });
 */
export function useSendTaskCommentMutation(baseOptions?: Apollo.MutationHookOptions<SendTaskCommentMutation, SendTaskCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTaskCommentMutation, SendTaskCommentMutationVariables>(SendTaskCommentDocument, options);
      }
export type SendTaskCommentMutationHookResult = ReturnType<typeof useSendTaskCommentMutation>;
export type SendTaskCommentMutationResult = Apollo.MutationResult<SendTaskCommentMutation>;
export type SendTaskCommentMutationOptions = Apollo.BaseMutationOptions<SendTaskCommentMutation, SendTaskCommentMutationVariables>;
export const UpdateSubtaskDocument = gql`
    mutation updateSubtask($updateSubtasksInput: UpdateSubtasksInput!) {
  wflUpdateSubtasks(updateSubtasksInput: $updateSubtasksInput) {
    tasks {
      id
    }
  }
}
    `;
export type UpdateSubtaskMutationFn = Apollo.MutationFunction<UpdateSubtaskMutation, UpdateSubtaskMutationVariables>;

/**
 * __useUpdateSubtaskMutation__
 *
 * To run a mutation, you first call `useUpdateSubtaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubtaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubtaskMutation, { data, loading, error }] = useUpdateSubtaskMutation({
 *   variables: {
 *      updateSubtasksInput: // value for 'updateSubtasksInput'
 *   },
 * });
 */
export function useUpdateSubtaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubtaskMutation, UpdateSubtaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubtaskMutation, UpdateSubtaskMutationVariables>(UpdateSubtaskDocument, options);
      }
export type UpdateSubtaskMutationHookResult = ReturnType<typeof useUpdateSubtaskMutation>;
export type UpdateSubtaskMutationResult = Apollo.MutationResult<UpdateSubtaskMutation>;
export type UpdateSubtaskMutationOptions = Apollo.BaseMutationOptions<UpdateSubtaskMutation, UpdateSubtaskMutationVariables>;
export const UpdateTaskAndSubtasksAndCreateSubtasksDocument = gql`
    mutation updateTaskAndSubtasksAndCreateSubtasks($updateTaskAndSubtasksAndCreateSubtasksInput: UpdateTaskAndSubtasksAndCreateSubtasksInput!) {
  wflUpdateTaskAndSubtasksAndCreateSubtasks(
    updateTaskAndSubtasksAndCreateSubtasksInput: $updateTaskAndSubtasksAndCreateSubtasksInput
  ) {
    task {
      id
    }
  }
}
    `;
export type UpdateTaskAndSubtasksAndCreateSubtasksMutationFn = Apollo.MutationFunction<UpdateTaskAndSubtasksAndCreateSubtasksMutation, UpdateTaskAndSubtasksAndCreateSubtasksMutationVariables>;

/**
 * __useUpdateTaskAndSubtasksAndCreateSubtasksMutation__
 *
 * To run a mutation, you first call `useUpdateTaskAndSubtasksAndCreateSubtasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskAndSubtasksAndCreateSubtasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskAndSubtasksAndCreateSubtasksMutation, { data, loading, error }] = useUpdateTaskAndSubtasksAndCreateSubtasksMutation({
 *   variables: {
 *      updateTaskAndSubtasksAndCreateSubtasksInput: // value for 'updateTaskAndSubtasksAndCreateSubtasksInput'
 *   },
 * });
 */
export function useUpdateTaskAndSubtasksAndCreateSubtasksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskAndSubtasksAndCreateSubtasksMutation, UpdateTaskAndSubtasksAndCreateSubtasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskAndSubtasksAndCreateSubtasksMutation, UpdateTaskAndSubtasksAndCreateSubtasksMutationVariables>(UpdateTaskAndSubtasksAndCreateSubtasksDocument, options);
      }
export type UpdateTaskAndSubtasksAndCreateSubtasksMutationHookResult = ReturnType<typeof useUpdateTaskAndSubtasksAndCreateSubtasksMutation>;
export type UpdateTaskAndSubtasksAndCreateSubtasksMutationResult = Apollo.MutationResult<UpdateTaskAndSubtasksAndCreateSubtasksMutation>;
export type UpdateTaskAndSubtasksAndCreateSubtasksMutationOptions = Apollo.BaseMutationOptions<UpdateTaskAndSubtasksAndCreateSubtasksMutation, UpdateTaskAndSubtasksAndCreateSubtasksMutationVariables>;
export const UpdateAndCreateSubtasksDocument = gql`
    mutation updateAndCreateSubtasks($updateAndCreateSubtasksInput: UpdateAndCreateSubtasksInput!) {
  wflUpdateAndCreateSubtasks(
    updateAndCreateSubtasksInput: $updateAndCreateSubtasksInput
  ) {
    subtasks {
      id
    }
  }
}
    `;
export type UpdateAndCreateSubtasksMutationFn = Apollo.MutationFunction<UpdateAndCreateSubtasksMutation, UpdateAndCreateSubtasksMutationVariables>;

/**
 * __useUpdateAndCreateSubtasksMutation__
 *
 * To run a mutation, you first call `useUpdateAndCreateSubtasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAndCreateSubtasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAndCreateSubtasksMutation, { data, loading, error }] = useUpdateAndCreateSubtasksMutation({
 *   variables: {
 *      updateAndCreateSubtasksInput: // value for 'updateAndCreateSubtasksInput'
 *   },
 * });
 */
export function useUpdateAndCreateSubtasksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAndCreateSubtasksMutation, UpdateAndCreateSubtasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAndCreateSubtasksMutation, UpdateAndCreateSubtasksMutationVariables>(UpdateAndCreateSubtasksDocument, options);
      }
export type UpdateAndCreateSubtasksMutationHookResult = ReturnType<typeof useUpdateAndCreateSubtasksMutation>;
export type UpdateAndCreateSubtasksMutationResult = Apollo.MutationResult<UpdateAndCreateSubtasksMutation>;
export type UpdateAndCreateSubtasksMutationOptions = Apollo.BaseMutationOptions<UpdateAndCreateSubtasksMutation, UpdateAndCreateSubtasksMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation updateTask($updateTaskInput: UpdateTaskInput!) {
  wflUpdateTask(updateTaskInput: $updateTaskInput) {
    task {
      id
    }
  }
}
    `;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      updateTaskInput: // value for 'updateTaskInput'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const UpdateOrCreateExamCourseVerdictDocument = gql`
    mutation updateOrCreateExamCourseVerdict($updateOrCreateExamCourseVerdictInput: UpdateOrCreateExamCourseVerdictInput!) {
  excUpdateOrCreateExamCourseVerdict(
    UpdateOrCreateExamCourseVerdictInput: $updateOrCreateExamCourseVerdictInput
  ) {
    verdict {
      ...ExamCourseVerdictOutput
    }
  }
}
    ${ExamCourseVerdictOutputFragmentDoc}`;
export type UpdateOrCreateExamCourseVerdictMutationFn = Apollo.MutationFunction<UpdateOrCreateExamCourseVerdictMutation, UpdateOrCreateExamCourseVerdictMutationVariables>;

/**
 * __useUpdateOrCreateExamCourseVerdictMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateExamCourseVerdictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateExamCourseVerdictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrCreateExamCourseVerdictMutation, { data, loading, error }] = useUpdateOrCreateExamCourseVerdictMutation({
 *   variables: {
 *      updateOrCreateExamCourseVerdictInput: // value for 'updateOrCreateExamCourseVerdictInput'
 *   },
 * });
 */
export function useUpdateOrCreateExamCourseVerdictMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrCreateExamCourseVerdictMutation, UpdateOrCreateExamCourseVerdictMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrCreateExamCourseVerdictMutation, UpdateOrCreateExamCourseVerdictMutationVariables>(UpdateOrCreateExamCourseVerdictDocument, options);
      }
export type UpdateOrCreateExamCourseVerdictMutationHookResult = ReturnType<typeof useUpdateOrCreateExamCourseVerdictMutation>;
export type UpdateOrCreateExamCourseVerdictMutationResult = Apollo.MutationResult<UpdateOrCreateExamCourseVerdictMutation>;
export type UpdateOrCreateExamCourseVerdictMutationOptions = Apollo.BaseMutationOptions<UpdateOrCreateExamCourseVerdictMutation, UpdateOrCreateExamCourseVerdictMutationVariables>;
export const GetExamCourseVerdictDocument = gql`
    query getExamCourseVerdict($getExamCourseVerdictInput: GetExamCourseVerdictInput!) {
  excGetExamCourseVerdict(GetExamCourseVerdictInput: $getExamCourseVerdictInput) {
    taskId
    entityId
    entityType
    verdict {
      ...ExamCourseVerdictOutput
    }
  }
}
    ${ExamCourseVerdictOutputFragmentDoc}`;

/**
 * __useGetExamCourseVerdictQuery__
 *
 * To run a query within a React component, call `useGetExamCourseVerdictQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCourseVerdictQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCourseVerdictQuery({
 *   variables: {
 *      getExamCourseVerdictInput: // value for 'getExamCourseVerdictInput'
 *   },
 * });
 */
export function useGetExamCourseVerdictQuery(baseOptions: Apollo.QueryHookOptions<GetExamCourseVerdictQuery, GetExamCourseVerdictQueryVariables> & ({ variables: GetExamCourseVerdictQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCourseVerdictQuery, GetExamCourseVerdictQueryVariables>(GetExamCourseVerdictDocument, options);
      }
export function useGetExamCourseVerdictLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCourseVerdictQuery, GetExamCourseVerdictQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCourseVerdictQuery, GetExamCourseVerdictQueryVariables>(GetExamCourseVerdictDocument, options);
        }
// @ts-ignore
export function useGetExamCourseVerdictSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExamCourseVerdictQuery, GetExamCourseVerdictQueryVariables>): Apollo.UseSuspenseQueryResult<GetExamCourseVerdictQuery, GetExamCourseVerdictQueryVariables>;
export function useGetExamCourseVerdictSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCourseVerdictQuery, GetExamCourseVerdictQueryVariables>): Apollo.UseSuspenseQueryResult<GetExamCourseVerdictQuery | undefined, GetExamCourseVerdictQueryVariables>;
export function useGetExamCourseVerdictSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCourseVerdictQuery, GetExamCourseVerdictQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCourseVerdictQuery, GetExamCourseVerdictQueryVariables>(GetExamCourseVerdictDocument, options);
        }
export type GetExamCourseVerdictQueryHookResult = ReturnType<typeof useGetExamCourseVerdictQuery>;
export type GetExamCourseVerdictLazyQueryHookResult = ReturnType<typeof useGetExamCourseVerdictLazyQuery>;
export type GetExamCourseVerdictSuspenseQueryHookResult = ReturnType<typeof useGetExamCourseVerdictSuspenseQuery>;
export type GetExamCourseVerdictQueryResult = Apollo.QueryResult<GetExamCourseVerdictQuery, GetExamCourseVerdictQueryVariables>;
export const GetTaskVerdictDocument = gql`
    query getTaskVerdict($getTaskVerdictInput: GetTaskVerdictInput!) {
  wflGetTaskVerdict(getTaskVerdictInput: $getTaskVerdictInput) {
    verdict
  }
}
    `;

/**
 * __useGetTaskVerdictQuery__
 *
 * To run a query within a React component, call `useGetTaskVerdictQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskVerdictQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskVerdictQuery({
 *   variables: {
 *      getTaskVerdictInput: // value for 'getTaskVerdictInput'
 *   },
 * });
 */
export function useGetTaskVerdictQuery(baseOptions: Apollo.QueryHookOptions<GetTaskVerdictQuery, GetTaskVerdictQueryVariables> & ({ variables: GetTaskVerdictQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskVerdictQuery, GetTaskVerdictQueryVariables>(GetTaskVerdictDocument, options);
      }
export function useGetTaskVerdictLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskVerdictQuery, GetTaskVerdictQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskVerdictQuery, GetTaskVerdictQueryVariables>(GetTaskVerdictDocument, options);
        }
// @ts-ignore
export function useGetTaskVerdictSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskVerdictQuery, GetTaskVerdictQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskVerdictQuery, GetTaskVerdictQueryVariables>;
export function useGetTaskVerdictSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskVerdictQuery, GetTaskVerdictQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskVerdictQuery | undefined, GetTaskVerdictQueryVariables>;
export function useGetTaskVerdictSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskVerdictQuery, GetTaskVerdictQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskVerdictQuery, GetTaskVerdictQueryVariables>(GetTaskVerdictDocument, options);
        }
export type GetTaskVerdictQueryHookResult = ReturnType<typeof useGetTaskVerdictQuery>;
export type GetTaskVerdictLazyQueryHookResult = ReturnType<typeof useGetTaskVerdictLazyQuery>;
export type GetTaskVerdictSuspenseQueryHookResult = ReturnType<typeof useGetTaskVerdictSuspenseQuery>;
export type GetTaskVerdictQueryResult = Apollo.QueryResult<GetTaskVerdictQuery, GetTaskVerdictQueryVariables>;
export const GetQSetTaskReviewResultsVerdictDocument = gql`
    query getQSetTaskReviewResultsVerdict($getQSetTaskReviewResultsInput: GetTaskReviewResultsInput!) {
  wflGetTaskReviewResults(
    getTaskReviewResultsInput: $getQSetTaskReviewResultsInput
  ) {
    taskId
    results {
      verdict {
        id
        taskId
        userId
        entityId
        entityType
        verdict
        createdAt
        updatedAt
      }
      comment {
        id
        taskId
        userId
        entityId
        entityType
        content
        createdAt
        updatedAt
      }
      question {
        id
        qSetId
        questionId
        questionRefCode
        questionGroupId
        questionGroupType
        order
        groupOrder
        score
      }
      totalComments
    }
  }
}
    `;

/**
 * __useGetQSetTaskReviewResultsVerdictQuery__
 *
 * To run a query within a React component, call `useGetQSetTaskReviewResultsVerdictQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQSetTaskReviewResultsVerdictQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQSetTaskReviewResultsVerdictQuery({
 *   variables: {
 *      getQSetTaskReviewResultsInput: // value for 'getQSetTaskReviewResultsInput'
 *   },
 * });
 */
export function useGetQSetTaskReviewResultsVerdictQuery(baseOptions: Apollo.QueryHookOptions<GetQSetTaskReviewResultsVerdictQuery, GetQSetTaskReviewResultsVerdictQueryVariables> & ({ variables: GetQSetTaskReviewResultsVerdictQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQSetTaskReviewResultsVerdictQuery, GetQSetTaskReviewResultsVerdictQueryVariables>(GetQSetTaskReviewResultsVerdictDocument, options);
      }
export function useGetQSetTaskReviewResultsVerdictLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQSetTaskReviewResultsVerdictQuery, GetQSetTaskReviewResultsVerdictQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQSetTaskReviewResultsVerdictQuery, GetQSetTaskReviewResultsVerdictQueryVariables>(GetQSetTaskReviewResultsVerdictDocument, options);
        }
// @ts-ignore
export function useGetQSetTaskReviewResultsVerdictSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQSetTaskReviewResultsVerdictQuery, GetQSetTaskReviewResultsVerdictQueryVariables>): Apollo.UseSuspenseQueryResult<GetQSetTaskReviewResultsVerdictQuery, GetQSetTaskReviewResultsVerdictQueryVariables>;
export function useGetQSetTaskReviewResultsVerdictSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetTaskReviewResultsVerdictQuery, GetQSetTaskReviewResultsVerdictQueryVariables>): Apollo.UseSuspenseQueryResult<GetQSetTaskReviewResultsVerdictQuery | undefined, GetQSetTaskReviewResultsVerdictQueryVariables>;
export function useGetQSetTaskReviewResultsVerdictSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetTaskReviewResultsVerdictQuery, GetQSetTaskReviewResultsVerdictQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQSetTaskReviewResultsVerdictQuery, GetQSetTaskReviewResultsVerdictQueryVariables>(GetQSetTaskReviewResultsVerdictDocument, options);
        }
export type GetQSetTaskReviewResultsVerdictQueryHookResult = ReturnType<typeof useGetQSetTaskReviewResultsVerdictQuery>;
export type GetQSetTaskReviewResultsVerdictLazyQueryHookResult = ReturnType<typeof useGetQSetTaskReviewResultsVerdictLazyQuery>;
export type GetQSetTaskReviewResultsVerdictSuspenseQueryHookResult = ReturnType<typeof useGetQSetTaskReviewResultsVerdictSuspenseQuery>;
export type GetQSetTaskReviewResultsVerdictQueryResult = Apollo.QueryResult<GetQSetTaskReviewResultsVerdictQuery, GetQSetTaskReviewResultsVerdictQueryVariables>;
export const GetQSetTaskReviewSummaryDocument = gql`
    query getQSetTaskReviewSummary($getQSetTaskReviewSummaryInput: GetQSetTaskReviewSummaryInput!) {
  wflGetQSetTaskReviewSummary(
    getQSetTaskReviewSummaryInput: $getQSetTaskReviewSummaryInput
  ) {
    subTaskIds
    results {
      verdicts {
        id
        taskId
        userId
        entityId
        entityType
        verdict
        createdAt
        updatedAt
      }
      totalComments
      question {
        id
        qSetId
        questionId
        questionRefCode
        questionGroupId
        questionGroupType
        order
        groupOrder
        score
      }
      comments {
        id
        taskId
        userId
        entityId
        entityType
        content
        createdAt
        updatedAt
        user {
          id
          firstname
          lastname
        }
      }
    }
  }
}
    `;

/**
 * __useGetQSetTaskReviewSummaryQuery__
 *
 * To run a query within a React component, call `useGetQSetTaskReviewSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQSetTaskReviewSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQSetTaskReviewSummaryQuery({
 *   variables: {
 *      getQSetTaskReviewSummaryInput: // value for 'getQSetTaskReviewSummaryInput'
 *   },
 * });
 */
export function useGetQSetTaskReviewSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetQSetTaskReviewSummaryQuery, GetQSetTaskReviewSummaryQueryVariables> & ({ variables: GetQSetTaskReviewSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQSetTaskReviewSummaryQuery, GetQSetTaskReviewSummaryQueryVariables>(GetQSetTaskReviewSummaryDocument, options);
      }
export function useGetQSetTaskReviewSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQSetTaskReviewSummaryQuery, GetQSetTaskReviewSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQSetTaskReviewSummaryQuery, GetQSetTaskReviewSummaryQueryVariables>(GetQSetTaskReviewSummaryDocument, options);
        }
// @ts-ignore
export function useGetQSetTaskReviewSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQSetTaskReviewSummaryQuery, GetQSetTaskReviewSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetQSetTaskReviewSummaryQuery, GetQSetTaskReviewSummaryQueryVariables>;
export function useGetQSetTaskReviewSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetTaskReviewSummaryQuery, GetQSetTaskReviewSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetQSetTaskReviewSummaryQuery | undefined, GetQSetTaskReviewSummaryQueryVariables>;
export function useGetQSetTaskReviewSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQSetTaskReviewSummaryQuery, GetQSetTaskReviewSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQSetTaskReviewSummaryQuery, GetQSetTaskReviewSummaryQueryVariables>(GetQSetTaskReviewSummaryDocument, options);
        }
export type GetQSetTaskReviewSummaryQueryHookResult = ReturnType<typeof useGetQSetTaskReviewSummaryQuery>;
export type GetQSetTaskReviewSummaryLazyQueryHookResult = ReturnType<typeof useGetQSetTaskReviewSummaryLazyQuery>;
export type GetQSetTaskReviewSummarySuspenseQueryHookResult = ReturnType<typeof useGetQSetTaskReviewSummarySuspenseQuery>;
export type GetQSetTaskReviewSummaryQueryResult = Apollo.QueryResult<GetQSetTaskReviewSummaryQuery, GetQSetTaskReviewSummaryQueryVariables>;
export const SearchTaskReviewedQSetQuestionsDocument = gql`
    query searchTaskReviewedQSetQuestions($input: SearchQSetQuestionsInputWithTaskIdInput!) {
  excSearchTaskQSetQuestions(input: $input) {
    qSetQuestions {
      id
      qSetId
      questionId
      questionGroupId
      questionRefCode
      order
      score
      question {
        id
        tags {
          id
          name
          category
        }
        type
        details
        refCode
        metadata {
          choices {
            label
            order
            value
          }
          reference
        }
        correctAnswer {
          value
        }
        questionGroup {
          type
          size
          metadata {
            paragraph
          }
          refCode
        }
        learningObjectiveStatement {
          tag {
            name
            id
          }
        }
        solution {
          type
          value
        }
      }
    }
  }
}
    `;

/**
 * __useSearchTaskReviewedQSetQuestionsQuery__
 *
 * To run a query within a React component, call `useSearchTaskReviewedQSetQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTaskReviewedQSetQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTaskReviewedQSetQuestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchTaskReviewedQSetQuestionsQuery(baseOptions: Apollo.QueryHookOptions<SearchTaskReviewedQSetQuestionsQuery, SearchTaskReviewedQSetQuestionsQueryVariables> & ({ variables: SearchTaskReviewedQSetQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTaskReviewedQSetQuestionsQuery, SearchTaskReviewedQSetQuestionsQueryVariables>(SearchTaskReviewedQSetQuestionsDocument, options);
      }
export function useSearchTaskReviewedQSetQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTaskReviewedQSetQuestionsQuery, SearchTaskReviewedQSetQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTaskReviewedQSetQuestionsQuery, SearchTaskReviewedQSetQuestionsQueryVariables>(SearchTaskReviewedQSetQuestionsDocument, options);
        }
// @ts-ignore
export function useSearchTaskReviewedQSetQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchTaskReviewedQSetQuestionsQuery, SearchTaskReviewedQSetQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTaskReviewedQSetQuestionsQuery, SearchTaskReviewedQSetQuestionsQueryVariables>;
export function useSearchTaskReviewedQSetQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTaskReviewedQSetQuestionsQuery, SearchTaskReviewedQSetQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTaskReviewedQSetQuestionsQuery | undefined, SearchTaskReviewedQSetQuestionsQueryVariables>;
export function useSearchTaskReviewedQSetQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTaskReviewedQSetQuestionsQuery, SearchTaskReviewedQSetQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTaskReviewedQSetQuestionsQuery, SearchTaskReviewedQSetQuestionsQueryVariables>(SearchTaskReviewedQSetQuestionsDocument, options);
        }
export type SearchTaskReviewedQSetQuestionsQueryHookResult = ReturnType<typeof useSearchTaskReviewedQSetQuestionsQuery>;
export type SearchTaskReviewedQSetQuestionsLazyQueryHookResult = ReturnType<typeof useSearchTaskReviewedQSetQuestionsLazyQuery>;
export type SearchTaskReviewedQSetQuestionsSuspenseQueryHookResult = ReturnType<typeof useSearchTaskReviewedQSetQuestionsSuspenseQuery>;
export type SearchTaskReviewedQSetQuestionsQueryResult = Apollo.QueryResult<SearchTaskReviewedQSetQuestionsQuery, SearchTaskReviewedQSetQuestionsQueryVariables>;
export const GetTasksByEntityWithParentDocument = gql`
    query getTasksByEntityWithParent($getTasksByEntityWithParentInput: GetTasksByEntityInput!) {
  wflGetTasksByEntityWithParent(
    getTasksByEntityWithParentInput: $getTasksByEntityWithParentInput
  ) {
    entityId
    entityType
    tasks {
      id
      name
      owner {
        firstname
        lastname
      }
      assignee {
        id
        firstname
        lastname
      }
      status
      assignedAt
      subtasks {
        id
        ownerId
        assignerId
        assignedAt
        updatedAt
        assignee {
          id
          firstname
          lastname
        }
      }
    }
  }
}
    `;

/**
 * __useGetTasksByEntityWithParentQuery__
 *
 * To run a query within a React component, call `useGetTasksByEntityWithParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksByEntityWithParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksByEntityWithParentQuery({
 *   variables: {
 *      getTasksByEntityWithParentInput: // value for 'getTasksByEntityWithParentInput'
 *   },
 * });
 */
export function useGetTasksByEntityWithParentQuery(baseOptions: Apollo.QueryHookOptions<GetTasksByEntityWithParentQuery, GetTasksByEntityWithParentQueryVariables> & ({ variables: GetTasksByEntityWithParentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksByEntityWithParentQuery, GetTasksByEntityWithParentQueryVariables>(GetTasksByEntityWithParentDocument, options);
      }
export function useGetTasksByEntityWithParentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksByEntityWithParentQuery, GetTasksByEntityWithParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksByEntityWithParentQuery, GetTasksByEntityWithParentQueryVariables>(GetTasksByEntityWithParentDocument, options);
        }
// @ts-ignore
export function useGetTasksByEntityWithParentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTasksByEntityWithParentQuery, GetTasksByEntityWithParentQueryVariables>): Apollo.UseSuspenseQueryResult<GetTasksByEntityWithParentQuery, GetTasksByEntityWithParentQueryVariables>;
export function useGetTasksByEntityWithParentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTasksByEntityWithParentQuery, GetTasksByEntityWithParentQueryVariables>): Apollo.UseSuspenseQueryResult<GetTasksByEntityWithParentQuery | undefined, GetTasksByEntityWithParentQueryVariables>;
export function useGetTasksByEntityWithParentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTasksByEntityWithParentQuery, GetTasksByEntityWithParentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTasksByEntityWithParentQuery, GetTasksByEntityWithParentQueryVariables>(GetTasksByEntityWithParentDocument, options);
        }
export type GetTasksByEntityWithParentQueryHookResult = ReturnType<typeof useGetTasksByEntityWithParentQuery>;
export type GetTasksByEntityWithParentLazyQueryHookResult = ReturnType<typeof useGetTasksByEntityWithParentLazyQuery>;
export type GetTasksByEntityWithParentSuspenseQueryHookResult = ReturnType<typeof useGetTasksByEntityWithParentSuspenseQuery>;
export type GetTasksByEntityWithParentQueryResult = Apollo.QueryResult<GetTasksByEntityWithParentQuery, GetTasksByEntityWithParentQueryVariables>;
export const GetQuestionCreationTaskByIdDocument = gql`
    query getQuestionCreationTaskById($getTaskByIdInput: GetTaskByIdInput!) {
  wflGetTaskById(getTaskByIdInput: $getTaskByIdInput) {
    task {
      id
      name
      createdAt
      updatedAt
      dueDate
      code
      status
      assignee {
        id
        firstname
        lastname
      }
      ownerId
      owner {
        id
        firstname
        lastname
      }
      assignerId
      currentWorkflowStep {
        workflowCode
        code
        name
      }
      taskEntities {
        id
        taskId
        entityId
        entityType
      }
      metadata {
        ... on TaskMetadataWithQuestionCreation {
          details
          qBankStructure {
            name
            id
            code
          }
          questionCreationCount
          requiredQuestionCount
          itemSetCondition {
            size
            needTotal
          }
          itemSetCreation {
            size
            questionGroupId
            questionCreationCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetQuestionCreationTaskByIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionCreationTaskByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionCreationTaskByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionCreationTaskByIdQuery({
 *   variables: {
 *      getTaskByIdInput: // value for 'getTaskByIdInput'
 *   },
 * });
 */
export function useGetQuestionCreationTaskByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionCreationTaskByIdQuery, GetQuestionCreationTaskByIdQueryVariables> & ({ variables: GetQuestionCreationTaskByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionCreationTaskByIdQuery, GetQuestionCreationTaskByIdQueryVariables>(GetQuestionCreationTaskByIdDocument, options);
      }
export function useGetQuestionCreationTaskByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionCreationTaskByIdQuery, GetQuestionCreationTaskByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionCreationTaskByIdQuery, GetQuestionCreationTaskByIdQueryVariables>(GetQuestionCreationTaskByIdDocument, options);
        }
// @ts-ignore
export function useGetQuestionCreationTaskByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionCreationTaskByIdQuery, GetQuestionCreationTaskByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionCreationTaskByIdQuery, GetQuestionCreationTaskByIdQueryVariables>;
export function useGetQuestionCreationTaskByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionCreationTaskByIdQuery, GetQuestionCreationTaskByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionCreationTaskByIdQuery | undefined, GetQuestionCreationTaskByIdQueryVariables>;
export function useGetQuestionCreationTaskByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionCreationTaskByIdQuery, GetQuestionCreationTaskByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionCreationTaskByIdQuery, GetQuestionCreationTaskByIdQueryVariables>(GetQuestionCreationTaskByIdDocument, options);
        }
export type GetQuestionCreationTaskByIdQueryHookResult = ReturnType<typeof useGetQuestionCreationTaskByIdQuery>;
export type GetQuestionCreationTaskByIdLazyQueryHookResult = ReturnType<typeof useGetQuestionCreationTaskByIdLazyQuery>;
export type GetQuestionCreationTaskByIdSuspenseQueryHookResult = ReturnType<typeof useGetQuestionCreationTaskByIdSuspenseQuery>;
export type GetQuestionCreationTaskByIdQueryResult = Apollo.QueryResult<GetQuestionCreationTaskByIdQuery, GetQuestionCreationTaskByIdQueryVariables>;
export const GetTaskCommonInfoDocument = gql`
    query getTaskCommonInfo($getTaskByIdInput: GetTaskByIdInput!) {
  wflGetTaskById(getTaskByIdInput: $getTaskByIdInput) {
    task {
      id
      assignee {
        id
      }
      ownerId
      assignerId
      currentWorkflowStep {
        workflowCode
        code
        name
      }
    }
  }
}
    `;

/**
 * __useGetTaskCommonInfoQuery__
 *
 * To run a query within a React component, call `useGetTaskCommonInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskCommonInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskCommonInfoQuery({
 *   variables: {
 *      getTaskByIdInput: // value for 'getTaskByIdInput'
 *   },
 * });
 */
export function useGetTaskCommonInfoQuery(baseOptions: Apollo.QueryHookOptions<GetTaskCommonInfoQuery, GetTaskCommonInfoQueryVariables> & ({ variables: GetTaskCommonInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskCommonInfoQuery, GetTaskCommonInfoQueryVariables>(GetTaskCommonInfoDocument, options);
      }
export function useGetTaskCommonInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskCommonInfoQuery, GetTaskCommonInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskCommonInfoQuery, GetTaskCommonInfoQueryVariables>(GetTaskCommonInfoDocument, options);
        }
// @ts-ignore
export function useGetTaskCommonInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskCommonInfoQuery, GetTaskCommonInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskCommonInfoQuery, GetTaskCommonInfoQueryVariables>;
export function useGetTaskCommonInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskCommonInfoQuery, GetTaskCommonInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskCommonInfoQuery | undefined, GetTaskCommonInfoQueryVariables>;
export function useGetTaskCommonInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskCommonInfoQuery, GetTaskCommonInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskCommonInfoQuery, GetTaskCommonInfoQueryVariables>(GetTaskCommonInfoDocument, options);
        }
export type GetTaskCommonInfoQueryHookResult = ReturnType<typeof useGetTaskCommonInfoQuery>;
export type GetTaskCommonInfoLazyQueryHookResult = ReturnType<typeof useGetTaskCommonInfoLazyQuery>;
export type GetTaskCommonInfoSuspenseQueryHookResult = ReturnType<typeof useGetTaskCommonInfoSuspenseQuery>;
export type GetTaskCommonInfoQueryResult = Apollo.QueryResult<GetTaskCommonInfoQuery, GetTaskCommonInfoQueryVariables>;
export const GetDownloadSignedUrlForTaskQuestionDocument = gql`
    query getDownloadSignedUrlForTaskQuestion($input: GetDownloadSignedUrlQuestionInput!, $taskId: String!) {
  qctGetDownloadSignedUrlForTaskQuestion(input: $input, taskId: $taskId) {
    signedUrls
  }
}
    `;

/**
 * __useGetDownloadSignedUrlForTaskQuestionQuery__
 *
 * To run a query within a React component, call `useGetDownloadSignedUrlForTaskQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSignedUrlForTaskQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSignedUrlForTaskQuestionQuery({
 *   variables: {
 *      input: // value for 'input'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetDownloadSignedUrlForTaskQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadSignedUrlForTaskQuestionQuery, GetDownloadSignedUrlForTaskQuestionQueryVariables> & ({ variables: GetDownloadSignedUrlForTaskQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadSignedUrlForTaskQuestionQuery, GetDownloadSignedUrlForTaskQuestionQueryVariables>(GetDownloadSignedUrlForTaskQuestionDocument, options);
      }
export function useGetDownloadSignedUrlForTaskQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadSignedUrlForTaskQuestionQuery, GetDownloadSignedUrlForTaskQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadSignedUrlForTaskQuestionQuery, GetDownloadSignedUrlForTaskQuestionQueryVariables>(GetDownloadSignedUrlForTaskQuestionDocument, options);
        }
// @ts-ignore
export function useGetDownloadSignedUrlForTaskQuestionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForTaskQuestionQuery, GetDownloadSignedUrlForTaskQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadSignedUrlForTaskQuestionQuery, GetDownloadSignedUrlForTaskQuestionQueryVariables>;
export function useGetDownloadSignedUrlForTaskQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForTaskQuestionQuery, GetDownloadSignedUrlForTaskQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadSignedUrlForTaskQuestionQuery | undefined, GetDownloadSignedUrlForTaskQuestionQueryVariables>;
export function useGetDownloadSignedUrlForTaskQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForTaskQuestionQuery, GetDownloadSignedUrlForTaskQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadSignedUrlForTaskQuestionQuery, GetDownloadSignedUrlForTaskQuestionQueryVariables>(GetDownloadSignedUrlForTaskQuestionDocument, options);
        }
export type GetDownloadSignedUrlForTaskQuestionQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForTaskQuestionQuery>;
export type GetDownloadSignedUrlForTaskQuestionLazyQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForTaskQuestionLazyQuery>;
export type GetDownloadSignedUrlForTaskQuestionSuspenseQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForTaskQuestionSuspenseQuery>;
export type GetDownloadSignedUrlForTaskQuestionQueryResult = Apollo.QueryResult<GetDownloadSignedUrlForTaskQuestionQuery, GetDownloadSignedUrlForTaskQuestionQueryVariables>;
export const GetUploadSignedUrlForQuestionCreationTaskDocument = gql`
    query getUploadSignedUrlForQuestionCreationTask($input: GetUploadSignedUrlForTaskInput!) {
  wflGetUploadSignedUrlForTask(input: $input) {
    signedUrl
    storageObject {
      fileName
    }
  }
}
    `;

/**
 * __useGetUploadSignedUrlForQuestionCreationTaskQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlForQuestionCreationTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlForQuestionCreationTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlForQuestionCreationTaskQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUploadSignedUrlForQuestionCreationTaskQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlForQuestionCreationTaskQuery, GetUploadSignedUrlForQuestionCreationTaskQueryVariables> & ({ variables: GetUploadSignedUrlForQuestionCreationTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlForQuestionCreationTaskQuery, GetUploadSignedUrlForQuestionCreationTaskQueryVariables>(GetUploadSignedUrlForQuestionCreationTaskDocument, options);
      }
export function useGetUploadSignedUrlForQuestionCreationTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlForQuestionCreationTaskQuery, GetUploadSignedUrlForQuestionCreationTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlForQuestionCreationTaskQuery, GetUploadSignedUrlForQuestionCreationTaskQueryVariables>(GetUploadSignedUrlForQuestionCreationTaskDocument, options);
        }
// @ts-ignore
export function useGetUploadSignedUrlForQuestionCreationTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForQuestionCreationTaskQuery, GetUploadSignedUrlForQuestionCreationTaskQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadSignedUrlForQuestionCreationTaskQuery, GetUploadSignedUrlForQuestionCreationTaskQueryVariables>;
export function useGetUploadSignedUrlForQuestionCreationTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForQuestionCreationTaskQuery, GetUploadSignedUrlForQuestionCreationTaskQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadSignedUrlForQuestionCreationTaskQuery | undefined, GetUploadSignedUrlForQuestionCreationTaskQueryVariables>;
export function useGetUploadSignedUrlForQuestionCreationTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForQuestionCreationTaskQuery, GetUploadSignedUrlForQuestionCreationTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlForQuestionCreationTaskQuery, GetUploadSignedUrlForQuestionCreationTaskQueryVariables>(GetUploadSignedUrlForQuestionCreationTaskDocument, options);
        }
export type GetUploadSignedUrlForQuestionCreationTaskQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForQuestionCreationTaskQuery>;
export type GetUploadSignedUrlForQuestionCreationTaskLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForQuestionCreationTaskLazyQuery>;
export type GetUploadSignedUrlForQuestionCreationTaskSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForQuestionCreationTaskSuspenseQuery>;
export type GetUploadSignedUrlForQuestionCreationTaskQueryResult = Apollo.QueryResult<GetUploadSignedUrlForQuestionCreationTaskQuery, GetUploadSignedUrlForQuestionCreationTaskQueryVariables>;
export const GetUploadSignedUrlForTaskQuestionDocument = gql`
    query getUploadSignedUrlForTaskQuestion($input: GetUploadSignedUrlQuestionInput!, $taskId: String!) {
  qctGetUploadSignedUrlForTaskQuestion(input: $input, taskId: $taskId) {
    signedUrl
    storageObject {
      fileName
    }
  }
}
    `;

/**
 * __useGetUploadSignedUrlForTaskQuestionQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlForTaskQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlForTaskQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlForTaskQuestionQuery({
 *   variables: {
 *      input: // value for 'input'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetUploadSignedUrlForTaskQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlForTaskQuestionQuery, GetUploadSignedUrlForTaskQuestionQueryVariables> & ({ variables: GetUploadSignedUrlForTaskQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlForTaskQuestionQuery, GetUploadSignedUrlForTaskQuestionQueryVariables>(GetUploadSignedUrlForTaskQuestionDocument, options);
      }
export function useGetUploadSignedUrlForTaskQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlForTaskQuestionQuery, GetUploadSignedUrlForTaskQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlForTaskQuestionQuery, GetUploadSignedUrlForTaskQuestionQueryVariables>(GetUploadSignedUrlForTaskQuestionDocument, options);
        }
// @ts-ignore
export function useGetUploadSignedUrlForTaskQuestionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForTaskQuestionQuery, GetUploadSignedUrlForTaskQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadSignedUrlForTaskQuestionQuery, GetUploadSignedUrlForTaskQuestionQueryVariables>;
export function useGetUploadSignedUrlForTaskQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForTaskQuestionQuery, GetUploadSignedUrlForTaskQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadSignedUrlForTaskQuestionQuery | undefined, GetUploadSignedUrlForTaskQuestionQueryVariables>;
export function useGetUploadSignedUrlForTaskQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForTaskQuestionQuery, GetUploadSignedUrlForTaskQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlForTaskQuestionQuery, GetUploadSignedUrlForTaskQuestionQueryVariables>(GetUploadSignedUrlForTaskQuestionDocument, options);
        }
export type GetUploadSignedUrlForTaskQuestionQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForTaskQuestionQuery>;
export type GetUploadSignedUrlForTaskQuestionLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForTaskQuestionLazyQuery>;
export type GetUploadSignedUrlForTaskQuestionSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForTaskQuestionSuspenseQuery>;
export type GetUploadSignedUrlForTaskQuestionQueryResult = Apollo.QueryResult<GetUploadSignedUrlForTaskQuestionQuery, GetUploadSignedUrlForTaskQuestionQueryVariables>;
export const GetDownloadSignedUrlForQuestionCreationTaskDocument = gql`
    query getDownloadSignedUrlForQuestionCreationTask($input: GetDownloadSignedUrlForTaskInput!) {
  wflGetDownloadSignedUrlForTask(input: $input) {
    signedUrls
  }
}
    `;

/**
 * __useGetDownloadSignedUrlForQuestionCreationTaskQuery__
 *
 * To run a query within a React component, call `useGetDownloadSignedUrlForQuestionCreationTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSignedUrlForQuestionCreationTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSignedUrlForQuestionCreationTaskQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDownloadSignedUrlForQuestionCreationTaskQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadSignedUrlForQuestionCreationTaskQuery, GetDownloadSignedUrlForQuestionCreationTaskQueryVariables> & ({ variables: GetDownloadSignedUrlForQuestionCreationTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadSignedUrlForQuestionCreationTaskQuery, GetDownloadSignedUrlForQuestionCreationTaskQueryVariables>(GetDownloadSignedUrlForQuestionCreationTaskDocument, options);
      }
export function useGetDownloadSignedUrlForQuestionCreationTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadSignedUrlForQuestionCreationTaskQuery, GetDownloadSignedUrlForQuestionCreationTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadSignedUrlForQuestionCreationTaskQuery, GetDownloadSignedUrlForQuestionCreationTaskQueryVariables>(GetDownloadSignedUrlForQuestionCreationTaskDocument, options);
        }
// @ts-ignore
export function useGetDownloadSignedUrlForQuestionCreationTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionCreationTaskQuery, GetDownloadSignedUrlForQuestionCreationTaskQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadSignedUrlForQuestionCreationTaskQuery, GetDownloadSignedUrlForQuestionCreationTaskQueryVariables>;
export function useGetDownloadSignedUrlForQuestionCreationTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionCreationTaskQuery, GetDownloadSignedUrlForQuestionCreationTaskQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadSignedUrlForQuestionCreationTaskQuery | undefined, GetDownloadSignedUrlForQuestionCreationTaskQueryVariables>;
export function useGetDownloadSignedUrlForQuestionCreationTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForQuestionCreationTaskQuery, GetDownloadSignedUrlForQuestionCreationTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadSignedUrlForQuestionCreationTaskQuery, GetDownloadSignedUrlForQuestionCreationTaskQueryVariables>(GetDownloadSignedUrlForQuestionCreationTaskDocument, options);
        }
export type GetDownloadSignedUrlForQuestionCreationTaskQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionCreationTaskQuery>;
export type GetDownloadSignedUrlForQuestionCreationTaskLazyQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionCreationTaskLazyQuery>;
export type GetDownloadSignedUrlForQuestionCreationTaskSuspenseQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForQuestionCreationTaskSuspenseQuery>;
export type GetDownloadSignedUrlForQuestionCreationTaskQueryResult = Apollo.QueryResult<GetDownloadSignedUrlForQuestionCreationTaskQuery, GetDownloadSignedUrlForQuestionCreationTaskQueryVariables>;
export const UpdateQuestionCreationTaskDocument = gql`
    mutation updateQuestionCreationTask($updateQuestionCreationTaskInput: UpdateQuestionCreationTaskInput!) {
  wflUpdateQuestionCreationTask(
    updateQuestionCreationTaskInput: $updateQuestionCreationTaskInput
  ) {
    task {
      id
    }
  }
}
    `;
export type UpdateQuestionCreationTaskMutationFn = Apollo.MutationFunction<UpdateQuestionCreationTaskMutation, UpdateQuestionCreationTaskMutationVariables>;

/**
 * __useUpdateQuestionCreationTaskMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionCreationTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionCreationTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionCreationTaskMutation, { data, loading, error }] = useUpdateQuestionCreationTaskMutation({
 *   variables: {
 *      updateQuestionCreationTaskInput: // value for 'updateQuestionCreationTaskInput'
 *   },
 * });
 */
export function useUpdateQuestionCreationTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionCreationTaskMutation, UpdateQuestionCreationTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionCreationTaskMutation, UpdateQuestionCreationTaskMutationVariables>(UpdateQuestionCreationTaskDocument, options);
      }
export type UpdateQuestionCreationTaskMutationHookResult = ReturnType<typeof useUpdateQuestionCreationTaskMutation>;
export type UpdateQuestionCreationTaskMutationResult = Apollo.MutationResult<UpdateQuestionCreationTaskMutation>;
export type UpdateQuestionCreationTaskMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionCreationTaskMutation, UpdateQuestionCreationTaskMutationVariables>;
export const FinishQuestionCreationTaskDocument = gql`
    mutation finishQuestionCreationTask($finishQuestionCreationTaskInput: UpdateTaskStatusInput!) {
  wflUpdateTaskStatus(updateTaskStatusInput: $finishQuestionCreationTaskInput) {
    task {
      id
      status
    }
  }
}
    `;
export type FinishQuestionCreationTaskMutationFn = Apollo.MutationFunction<FinishQuestionCreationTaskMutation, FinishQuestionCreationTaskMutationVariables>;

/**
 * __useFinishQuestionCreationTaskMutation__
 *
 * To run a mutation, you first call `useFinishQuestionCreationTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishQuestionCreationTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishQuestionCreationTaskMutation, { data, loading, error }] = useFinishQuestionCreationTaskMutation({
 *   variables: {
 *      finishQuestionCreationTaskInput: // value for 'finishQuestionCreationTaskInput'
 *   },
 * });
 */
export function useFinishQuestionCreationTaskMutation(baseOptions?: Apollo.MutationHookOptions<FinishQuestionCreationTaskMutation, FinishQuestionCreationTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishQuestionCreationTaskMutation, FinishQuestionCreationTaskMutationVariables>(FinishQuestionCreationTaskDocument, options);
      }
export type FinishQuestionCreationTaskMutationHookResult = ReturnType<typeof useFinishQuestionCreationTaskMutation>;
export type FinishQuestionCreationTaskMutationResult = Apollo.MutationResult<FinishQuestionCreationTaskMutation>;
export type FinishQuestionCreationTaskMutationOptions = Apollo.BaseMutationOptions<FinishQuestionCreationTaskMutation, FinishQuestionCreationTaskMutationVariables>;
export const DeleteSubtaskDocument = gql`
    mutation deleteSubtask($deleteSubtaskInput: DeleteSubtaskInput!) {
  wflDeleteSubtask(deleteSubtaskInput: $deleteSubtaskInput) {
    success
    message
  }
}
    `;
export type DeleteSubtaskMutationFn = Apollo.MutationFunction<DeleteSubtaskMutation, DeleteSubtaskMutationVariables>;

/**
 * __useDeleteSubtaskMutation__
 *
 * To run a mutation, you first call `useDeleteSubtaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubtaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubtaskMutation, { data, loading, error }] = useDeleteSubtaskMutation({
 *   variables: {
 *      deleteSubtaskInput: // value for 'deleteSubtaskInput'
 *   },
 * });
 */
export function useDeleteSubtaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubtaskMutation, DeleteSubtaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubtaskMutation, DeleteSubtaskMutationVariables>(DeleteSubtaskDocument, options);
      }
export type DeleteSubtaskMutationHookResult = ReturnType<typeof useDeleteSubtaskMutation>;
export type DeleteSubtaskMutationResult = Apollo.MutationResult<DeleteSubtaskMutation>;
export type DeleteSubtaskMutationOptions = Apollo.BaseMutationOptions<DeleteSubtaskMutation, DeleteSubtaskMutationVariables>;
export const UpdateDueDateTaskAndSubtasksDocument = gql`
    mutation updateDueDateTaskAndSubtasks($updateDueDateTaskAndSubtasksInput: UpdateDueDateTaskAndSubtasksInput!) {
  wflUpdateDueDateTaskAndSubtasks(
    updateDueDateTaskAndSubtasksInput: $updateDueDateTaskAndSubtasksInput
  ) {
    task {
      id
      dueDate
      subtasks {
        id
        dueDate
      }
    }
  }
}
    `;
export type UpdateDueDateTaskAndSubtasksMutationFn = Apollo.MutationFunction<UpdateDueDateTaskAndSubtasksMutation, UpdateDueDateTaskAndSubtasksMutationVariables>;

/**
 * __useUpdateDueDateTaskAndSubtasksMutation__
 *
 * To run a mutation, you first call `useUpdateDueDateTaskAndSubtasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDueDateTaskAndSubtasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDueDateTaskAndSubtasksMutation, { data, loading, error }] = useUpdateDueDateTaskAndSubtasksMutation({
 *   variables: {
 *      updateDueDateTaskAndSubtasksInput: // value for 'updateDueDateTaskAndSubtasksInput'
 *   },
 * });
 */
export function useUpdateDueDateTaskAndSubtasksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDueDateTaskAndSubtasksMutation, UpdateDueDateTaskAndSubtasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDueDateTaskAndSubtasksMutation, UpdateDueDateTaskAndSubtasksMutationVariables>(UpdateDueDateTaskAndSubtasksDocument, options);
      }
export type UpdateDueDateTaskAndSubtasksMutationHookResult = ReturnType<typeof useUpdateDueDateTaskAndSubtasksMutation>;
export type UpdateDueDateTaskAndSubtasksMutationResult = Apollo.MutationResult<UpdateDueDateTaskAndSubtasksMutation>;
export type UpdateDueDateTaskAndSubtasksMutationOptions = Apollo.BaseMutationOptions<UpdateDueDateTaskAndSubtasksMutation, UpdateDueDateTaskAndSubtasksMutationVariables>;
export const SearchMyTasksDocument = gql`
    query searchMyTasks($searchMyTasksInput: SearchMyTasksInput!) {
  wflSearchMyTasks(searchMyTasksInput: $searchMyTasksInput) {
    total
    tasks {
      subtaskCount
      currentWorkflowStep {
        workflowCode
        code
      }
      status
      code
      name
      id
      dueDate
      completedAt
      subtasks {
        currentWorkflowStep {
          code
        }
        id
      }
      parentTask {
        name
        code
        metadata {
          ... on TaskMetadataWithReviewQuestion {
            questionQuantity
          }
        }
      }
      metadata {
        ... on TaskMetadataWithQuestionCreation {
          requiredQuestionCount
          questionCreationCount
          itemSetCondition {
            size
            needTotal
          }
          itemSetCreation {
            questionCreationCount
            size
            questionGroupId
          }
        }
        ... on TaskMetadataWithReviewQuestion {
          questionQuantity
        }
        ... on TaskMetadataWithQuestionReviewed {
          reviewedQuestionCount
        }
      }
    }
  }
}
    `;

/**
 * __useSearchMyTasksQuery__
 *
 * To run a query within a React component, call `useSearchMyTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMyTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMyTasksQuery({
 *   variables: {
 *      searchMyTasksInput: // value for 'searchMyTasksInput'
 *   },
 * });
 */
export function useSearchMyTasksQuery(baseOptions: Apollo.QueryHookOptions<SearchMyTasksQuery, SearchMyTasksQueryVariables> & ({ variables: SearchMyTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchMyTasksQuery, SearchMyTasksQueryVariables>(SearchMyTasksDocument, options);
      }
export function useSearchMyTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMyTasksQuery, SearchMyTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchMyTasksQuery, SearchMyTasksQueryVariables>(SearchMyTasksDocument, options);
        }
// @ts-ignore
export function useSearchMyTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchMyTasksQuery, SearchMyTasksQueryVariables>): Apollo.UseSuspenseQueryResult<SearchMyTasksQuery, SearchMyTasksQueryVariables>;
export function useSearchMyTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMyTasksQuery, SearchMyTasksQueryVariables>): Apollo.UseSuspenseQueryResult<SearchMyTasksQuery | undefined, SearchMyTasksQueryVariables>;
export function useSearchMyTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMyTasksQuery, SearchMyTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchMyTasksQuery, SearchMyTasksQueryVariables>(SearchMyTasksDocument, options);
        }
export type SearchMyTasksQueryHookResult = ReturnType<typeof useSearchMyTasksQuery>;
export type SearchMyTasksLazyQueryHookResult = ReturnType<typeof useSearchMyTasksLazyQuery>;
export type SearchMyTasksSuspenseQueryHookResult = ReturnType<typeof useSearchMyTasksSuspenseQuery>;
export type SearchMyTasksQueryResult = Apollo.QueryResult<SearchMyTasksQuery, SearchMyTasksQueryVariables>;
export const GetUploadSignedUrlForCreateQuestionCreationTaskDocument = gql`
    query getUploadSignedUrlForCreateQuestionCreationTask($input: GetUploadSignedUrlForQuestionCreationTaskInput!) {
  wflGetUploadSignedUrlForQuestionCreationTask(input: $input) {
    signedUrl
    storageObject {
      provider
      bucket
      key
      fileName
    }
    contentType
  }
}
    `;

/**
 * __useGetUploadSignedUrlForCreateQuestionCreationTaskQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlForCreateQuestionCreationTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlForCreateQuestionCreationTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlForCreateQuestionCreationTaskQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUploadSignedUrlForCreateQuestionCreationTaskQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlForCreateQuestionCreationTaskQuery, GetUploadSignedUrlForCreateQuestionCreationTaskQueryVariables> & ({ variables: GetUploadSignedUrlForCreateQuestionCreationTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlForCreateQuestionCreationTaskQuery, GetUploadSignedUrlForCreateQuestionCreationTaskQueryVariables>(GetUploadSignedUrlForCreateQuestionCreationTaskDocument, options);
      }
export function useGetUploadSignedUrlForCreateQuestionCreationTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlForCreateQuestionCreationTaskQuery, GetUploadSignedUrlForCreateQuestionCreationTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlForCreateQuestionCreationTaskQuery, GetUploadSignedUrlForCreateQuestionCreationTaskQueryVariables>(GetUploadSignedUrlForCreateQuestionCreationTaskDocument, options);
        }
// @ts-ignore
export function useGetUploadSignedUrlForCreateQuestionCreationTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForCreateQuestionCreationTaskQuery, GetUploadSignedUrlForCreateQuestionCreationTaskQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadSignedUrlForCreateQuestionCreationTaskQuery, GetUploadSignedUrlForCreateQuestionCreationTaskQueryVariables>;
export function useGetUploadSignedUrlForCreateQuestionCreationTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForCreateQuestionCreationTaskQuery, GetUploadSignedUrlForCreateQuestionCreationTaskQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadSignedUrlForCreateQuestionCreationTaskQuery | undefined, GetUploadSignedUrlForCreateQuestionCreationTaskQueryVariables>;
export function useGetUploadSignedUrlForCreateQuestionCreationTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForCreateQuestionCreationTaskQuery, GetUploadSignedUrlForCreateQuestionCreationTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlForCreateQuestionCreationTaskQuery, GetUploadSignedUrlForCreateQuestionCreationTaskQueryVariables>(GetUploadSignedUrlForCreateQuestionCreationTaskDocument, options);
        }
export type GetUploadSignedUrlForCreateQuestionCreationTaskQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForCreateQuestionCreationTaskQuery>;
export type GetUploadSignedUrlForCreateQuestionCreationTaskLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForCreateQuestionCreationTaskLazyQuery>;
export type GetUploadSignedUrlForCreateQuestionCreationTaskSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForCreateQuestionCreationTaskSuspenseQuery>;
export type GetUploadSignedUrlForCreateQuestionCreationTaskQueryResult = Apollo.QueryResult<GetUploadSignedUrlForCreateQuestionCreationTaskQuery, GetUploadSignedUrlForCreateQuestionCreationTaskQueryVariables>;
export const CreateQuestionCreationTaskDocument = gql`
    mutation createQuestionCreationTask($createQuestionCreationTaskInput: CreateQuestionCreationTaskInput!) {
  wflCreateQuestionCreationTask(
    createQuestionCreationTaskInput: $createQuestionCreationTaskInput
  ) {
    task {
      id
    }
  }
}
    `;
export type CreateQuestionCreationTaskMutationFn = Apollo.MutationFunction<CreateQuestionCreationTaskMutation, CreateQuestionCreationTaskMutationVariables>;

/**
 * __useCreateQuestionCreationTaskMutation__
 *
 * To run a mutation, you first call `useCreateQuestionCreationTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionCreationTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionCreationTaskMutation, { data, loading, error }] = useCreateQuestionCreationTaskMutation({
 *   variables: {
 *      createQuestionCreationTaskInput: // value for 'createQuestionCreationTaskInput'
 *   },
 * });
 */
export function useCreateQuestionCreationTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionCreationTaskMutation, CreateQuestionCreationTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionCreationTaskMutation, CreateQuestionCreationTaskMutationVariables>(CreateQuestionCreationTaskDocument, options);
      }
export type CreateQuestionCreationTaskMutationHookResult = ReturnType<typeof useCreateQuestionCreationTaskMutation>;
export type CreateQuestionCreationTaskMutationResult = Apollo.MutationResult<CreateQuestionCreationTaskMutation>;
export type CreateQuestionCreationTaskMutationOptions = Apollo.BaseMutationOptions<CreateQuestionCreationTaskMutation, CreateQuestionCreationTaskMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "QConfigStructureCondition": [
      "QConfigStructureConditionMultiTagGroup",
      "QConfigStructureConditionSingleTagGroup"
    ],
    "QConfigStructureConditionObjectType": [
      "QConfigStructureConditionMultiTagGroupObjectType",
      "QConfigStructureConditionSingleTagGroupObjectType"
    ],
    "TaskMetadata": [
      "TaskMetadataWithAdditionalData",
      "TaskMetadataWithExamCourse",
      "TaskMetadataWithQSet",
      "TaskMetadataWithQuestionCreation",
      "TaskMetadataWithQuestionReviewed",
      "TaskMetadataWithReviewQuestion"
    ]
  }
};
      export default result;
    